
/*
 * THIS FILE IS AUTOGENERATED DO NOT EDIT (by schema_gen.js)
 */

export const getMessagesSchemas = () => {
  return [

["CaregiverRecruitmentShowStatus",
{
  "type": "object",
  "properties": {
    "showApplication": {
      "type": "boolean"
    }
  },
  "required": [
    "showApplication"
  ],
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["RecruitmentUploadDoc",
{
  "type": "object",
  "properties": {
    "base64": {
      "type": "string"
    }
  },
  "required": [
    "base64"
  ],
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["RecruitmentUploadDocUrl",
{
  "type": "object",
  "properties": {
    "url": {
      "type": "string"
    }
  },
  "required": [
    "url"
  ],
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverRecruitmentData",
{
  "type": "object",
  "properties": {
    "showApplication": {
      "type": "boolean"
    },
    "applicationData": {
      "anyOf": [
        {
          "type": "array",
          "items": {
            "$ref": "#/definitions/RecruitmentQuestionData"
          }
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "applicationData",
    "showApplication"
  ],
  "definitions": {
    "RecruitmentQuestionData": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/RecruitmentCaregiverApplicationQuestionId"
        },
        "order": {
          "type": "number"
        },
        "questionText": {
          "$ref": "#/definitions/TranslationMapping<string>"
        },
        "possibleAnswers": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<PossibleAnswer[]>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/RecruitmentCaregiverApplicationQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "number"
          ]
        },
        "isMandatory": {
          "type": "boolean"
        },
        "answer": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "number"
              }
            },
            {
              "type": [
                "null",
                "string",
                "number"
              ]
            }
          ]
        },
        "type": {
          "$ref": "#/definitions/RecruitmentQuestionType"
        }
      },
      "required": [
        "answer",
        "id",
        "isMandatory",
        "order",
        "parentAnswer",
        "parentId",
        "possibleAnswers",
        "questionText",
        "type"
      ]
    },
    "RecruitmentCaregiverApplicationQuestionId": {
      "type": "number"
    },
    "TranslationMapping<string>": {
      "type": "object",
      "properties": {
        "Albanian": {
          "type": "string"
        },
        "Arabic": {
          "type": "string"
        },
        "Armenian": {
          "type": "string"
        },
        "Bengali": {
          "type": "string"
        },
        "Bulgarian": {
          "type": "string"
        },
        "Cantonese": {
          "type": "string"
        },
        "Chinese": {
          "type": "string"
        },
        "Creole": {
          "type": "string"
        },
        "Danish": {
          "type": "string"
        },
        "Dutch": {
          "type": "string"
        },
        "English": {
          "type": "string"
        },
        "Estonian": {
          "type": "string"
        },
        "Farsi": {
          "type": "string"
        },
        "Filipino": {
          "type": "string"
        },
        "French": {
          "type": "string"
        },
        "Fukkianese": {
          "type": "string"
        },
        "Fula/Fulani": {
          "type": "string"
        },
        "Fuzhounese": {
          "type": "string"
        },
        "Georgian": {
          "type": "string"
        },
        "German": {
          "type": "string"
        },
        "Ghana": {
          "type": "string"
        },
        "Greek": {
          "type": "string"
        },
        "Hakka": {
          "type": "string"
        },
        "Hebrew": {
          "type": "string"
        },
        "Hindi": {
          "type": "string"
        },
        "Hungarian": {
          "type": "string"
        },
        "Italian": {
          "type": "string"
        },
        "Japanese": {
          "type": "string"
        },
        "Korean": {
          "type": "string"
        },
        "Krio": {
          "type": "string"
        },
        "Kyrgyz": {
          "type": "string"
        },
        "Mandarin": {
          "type": "string"
        },
        "Pashto": {
          "type": "string"
        },
        "Persian": {
          "type": "string"
        },
        "Polish": {
          "type": "string"
        },
        "Portuguese": {
          "type": "string"
        },
        "Punjabi": {
          "type": "string"
        },
        "Romanian": {
          "type": "string"
        },
        "Russian": {
          "type": "string"
        },
        "Shanghainese": {
          "type": "string"
        },
        "Soninke": {
          "type": "string"
        },
        "Spanish": {
          "type": "string"
        },
        "Swahili": {
          "type": "string"
        },
        "Tagalog": {
          "type": "string"
        },
        "Taishanese": {
          "type": "string"
        },
        "Taiwanese": {
          "type": "string"
        },
        "Turkish": {
          "type": "string"
        },
        "Twi": {
          "type": "string"
        },
        "Ukrainian": {
          "type": "string"
        },
        "Urdu": {
          "type": "string"
        },
        "Uzbek": {
          "type": "string"
        },
        "Vietnamese": {
          "type": "string"
        },
        "Yiddish": {
          "type": "string"
        }
      }
    },
    "TranslationMapping<PossibleAnswer[]>": {
      "type": "object",
      "properties": {
        "Albanian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Arabic": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Armenian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Bengali": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Bulgarian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Cantonese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Chinese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Creole": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Danish": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Dutch": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "English": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Estonian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Farsi": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Filipino": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "French": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Fukkianese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Fula/Fulani": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Fuzhounese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Georgian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "German": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Ghana": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Greek": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Hakka": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Hebrew": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Hindi": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Hungarian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Italian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Japanese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Korean": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Krio": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Kyrgyz": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Mandarin": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Pashto": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Persian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Polish": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Portuguese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Punjabi": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Romanian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Russian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Shanghainese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Soninke": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Spanish": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Swahili": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Tagalog": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Taishanese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Taiwanese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Turkish": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Twi": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Ukrainian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Urdu": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Uzbek": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Vietnamese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Yiddish": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        }
      }
    },
    "PossibleAnswer": {
      "type": "object",
      "properties": {
        "id": {
          "type": "number"
        },
        "text": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "text"
      ]
    },
    "RecruitmentQuestionType": {
      "enum": [
        "Checkbox",
        "Document",
        "Email",
        "FullDate",
        "LongText",
        "MonthYearDate",
        "Numeric",
        "Radio",
        "Signature",
        "Text",
        "TitleText"
      ],
      "type": "string"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverNotificationSettings",
{
  "type": "object",
  "properties": {
    "pushNotificationsEnabled": {
      "description": "If this is `false` then absolutely no push notifications will be sent. If\nit is true then the other settings apply",
      "type": "boolean"
    },
    "categories": {
      "$ref": "#/definitions/CaregiverNotificationSettingsCategories"
    }
  },
  "required": [
    "categories",
    "pushNotificationsEnabled"
  ],
  "definitions": {
    "CaregiverNotificationSettingsCategories": {
      "type": "object",
      "properties": {
        "newVisitsAvailable": {
          "type": "boolean"
        },
        "agencyNotifications": {
          "type": "boolean"
        },
        "chatMessages": {
          "type": "boolean"
        },
        "trainingCenterReminders": {
          "type": "boolean"
        },
        "myVisitsChanges": {
          "type": "boolean"
        },
        "myVisitsReminders": {
          "type": "boolean"
        }
      },
      "required": [
        "agencyNotifications",
        "chatMessages",
        "myVisitsChanges",
        "myVisitsReminders",
        "newVisitsAvailable",
        "trainingCenterReminders"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverCreateManualTimeSheetRequest",
{
  "type": "object",
  "properties": {
    "clockInTime": {
      "$ref": "#/definitions/LocalTime"
    },
    "clockOutTime": {
      "$ref": "#/definitions/LocalTime"
    },
    "selectedDutyTasks": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "planOfCareItemId": {
            "$ref": "#/definitions/PlanOfCareItemId"
          },
          "notes": {
            "type": [
              "null",
              "string"
            ]
          }
        },
        "required": [
          "notes",
          "planOfCareItemId"
        ]
      }
    },
    "patientSignature": {
      "type": [
        "null",
        "string"
      ]
    },
    "patientNotSignReason": {
      "type": [
        "null",
        "string"
      ]
    },
    "caregiverSignature": {
      "type": "string"
    }
  },
  "required": [
    "caregiverSignature",
    "clockInTime",
    "clockOutTime",
    "patientNotSignReason",
    "patientSignature",
    "selectedDutyTasks"
  ],
  "definitions": {
    "LocalTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalTime"
    },
    "PlanOfCareItemId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverCreateManualTimeSheetResponse",
{
  "type": "object",
  "properties": {
    "clockInTime": {
      "anyOf": [
        {
          "$ref": "#/definitions/Instant"
        },
        {
          "type": "null"
        }
      ]
    },
    "clockOutTime": {
      "anyOf": [
        {
          "$ref": "#/definitions/Instant"
        },
        {
          "type": "null"
        }
      ]
    },
    "timeSheetSubmittedAt": {
      "anyOf": [
        {
          "$ref": "#/definitions/Instant"
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "clockInTime",
    "clockOutTime",
    "timeSheetSubmittedAt"
  ],
  "definitions": {
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverGetManualTimeSheetResponse",
{
  "type": "object",
  "properties": {
    "clockInTime": {
      "anyOf": [
        {
          "$ref": "#/definitions/LocalTime"
        },
        {
          "type": "null"
        }
      ]
    },
    "clockOutTime": {
      "anyOf": [
        {
          "$ref": "#/definitions/LocalTime"
        },
        {
          "type": "null"
        }
      ]
    },
    "requiredDutyTasks": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/DutySheetTask"
      }
    },
    "selectedDuties": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/SelectedDutySheetTask"
      }
    },
    "patientSignature": {
      "type": [
        "null",
        "string"
      ]
    },
    "caregiverSignature": {
      "type": [
        "null",
        "string"
      ]
    },
    "patientNotSignReason": {
      "type": [
        "null",
        "string"
      ]
    }
  },
  "required": [
    "caregiverSignature",
    "clockInTime",
    "clockOutTime",
    "patientNotSignReason",
    "patientSignature",
    "requiredDutyTasks",
    "selectedDuties"
  ],
  "definitions": {
    "LocalTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalTime"
    },
    "DutySheetTask": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/PlanOfCareItemId"
        },
        "name": {
          "type": "string"
        },
        "code": {
          "type": "string"
        }
      },
      "required": [
        "code",
        "id",
        "name"
      ]
    },
    "PlanOfCareItemId": {
      "type": "number"
    },
    "SelectedDutySheetTask": {
      "type": "object",
      "properties": {
        "planOfCareItemId": {
          "$ref": "#/definitions/PlanOfCareItemId"
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "notes",
        "planOfCareItemId"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverGetSignedPhotoURLError",
{
  "type": "object",
  "properties": {
    "error": {
      "enum": [
        "FORBIDDEN_PATH",
        "UNSUPPORTED_FILE_STORAGE_TYPE",
        "URL_IS_REQUIRED"
      ],
      "type": "string"
    }
  },
  "required": [
    "error"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientDocumentAnswers",
{
  "type": "object",
  "properties": {
    "answers": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/PatientDocumentAnswerObject"
      }
    }
  },
  "required": [
    "answers"
  ],
  "definitions": {
    "PatientDocumentAnswerObject": {
      "type": "object",
      "properties": {
        "questionId": {
          "type": "number"
        },
        "chartRow": {
          "type": [
            "null",
            "number"
          ]
        },
        "answer": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/PatientContractDiagnosisCode"
              }
            },
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/POCItemsDocumentAnswer"
              }
            },
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/PatientMedicationProfileWithDetails"
              }
            },
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "answeredAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "answer",
        "answeredAt",
        "chartRow",
        "questionId"
      ]
    },
    "PatientContractDiagnosisCode": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/PatientContractDiagnosisCodeId"
        },
        "icdCode": {
          "$ref": "#/definitions/ICD10CodeId"
        },
        "formattedDxCode": {
          "type": "string"
        },
        "shortDesc": {
          "type": "string"
        },
        "patientContractId": {
          "$ref": "#/definitions/PatientContractId"
        },
        "startDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "endDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "type": {
          "anyOf": [
            {
              "enum": [
                "PRINCIPAL",
                "SURGICAL"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "isForBilling": {
          "type": "boolean"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "createdBy": {
          "$ref": "#/definitions/UserId"
        },
        "updatedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "updatedBy": {
          "anyOf": [
            {
              "$ref": "#/definitions/UserId"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "createdAt",
        "createdBy",
        "endDate",
        "formattedDxCode",
        "icdCode",
        "id",
        "isForBilling",
        "patientContractId",
        "shortDesc",
        "startDate",
        "type",
        "updatedAt",
        "updatedBy"
      ]
    },
    "PatientContractDiagnosisCodeId": {
      "type": "number"
    },
    "ICD10CodeId": {
      "type": "number"
    },
    "PatientContractId": {
      "type": "number"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "UserId": {
      "type": "number"
    },
    "POCItemsDocumentAnswer": {
      "type": "object",
      "properties": {
        "idx": {
          "type": "number"
        },
        "attributes": {
          "anyOf": [
            {
              "$ref": "#/definitions/TaskWhenToPerform.EveryVisit"
            },
            {
              "$ref": "#/definitions/TaskWhenToPerform.OnDaysOfWeek"
            },
            {
              "$ref": "#/definitions/TaskWhenToPerform.AsRequestedByPatient"
            }
          ]
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "attributes",
        "idx"
      ]
    },
    "TaskWhenToPerform.EveryVisit": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "EveryVisit"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TaskWhenToPerform.OnDaysOfWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "OnDaysOfWeek"
          ]
        },
        "frequency": {
          "$ref": "#/definitions/FrequencyVisitedInAWeekDetails"
        },
        "days": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        }
      },
      "required": [
        "type"
      ]
    },
    "FrequencyVisitedInAWeekDetails": {
      "type": "object",
      "properties": {
        "frequency": {
          "type": [
            "null",
            "number"
          ]
        },
        "visitsInAWeek": {
          "type": [
            "null",
            "number"
          ]
        }
      },
      "required": [
        "frequency",
        "visitsInAWeek"
      ]
    },
    "DayOfWeek": {
      "type": "string",
      "xreviver": "JSJoda.DayOfWeek"
    },
    "TaskWhenToPerform.AsRequestedByPatient": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AsRequestedByPatient"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "PatientMedicationProfileWithDetails": {
      "type": "object",
      "properties": {
        "dose": {
          "type": "string"
        },
        "route": {
          "type": "string"
        },
        "medicationName": {
          "type": "string"
        },
        "id": {
          "$ref": "#/definitions/PatientMedicationProfileId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "medicationId": {
          "$ref": "#/definitions/MedicationId"
        },
        "from": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "until": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "frequency": {
          "type": [
            "null",
            "string"
          ]
        },
        "status": {
          "$ref": "#/definitions/PatientMedicationProfileStatus"
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "dose",
        "frequency",
        "from",
        "id",
        "medicationId",
        "medicationName",
        "notes",
        "patientId",
        "route",
        "status",
        "until"
      ]
    },
    "PatientMedicationProfileId": {
      "type": "number"
    },
    "PatientId": {
      "type": "number"
    },
    "MedicationId": {
      "type": "number"
    },
    "PatientMedicationProfileStatus": {
      "enum": [
        "ACTIVE",
        "DISCONTINUED"
      ],
      "type": "string"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientTaskBroadcastList",
{
  "type": "object",
  "properties": {
    "taskBroadcasts": {
      "type": "array",
      "items": {
        "anyOf": [
          {
            "type": "object",
            "properties": {
              "type": {
                "type": "string",
                "enum": [
                  "Available"
                ]
              },
              "taskInstanceId": {
                "$ref": "#/definitions/PatientTaskInstanceId"
              },
              "patientId": {
                "$ref": "#/definitions/PatientId"
              },
              "patientInitials": {
                "type": "string"
              },
              "certifications": {
                "type": "array",
                "items": {
                  "$ref": "#/definitions/CaregiverCertification"
                }
              },
              "dayTimeParams": {
                "anyOf": [
                  {
                    "type": "array",
                    "items": {
                      "$ref": "#/definitions/DayTimeParam"
                    }
                  },
                  {
                    "type": "null"
                  }
                ]
              },
              "durationMinutes": {
                "type": [
                  "null",
                  "number"
                ]
              },
              "title": {
                "type": "string"
              },
              "patientAddress": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "patientAddressComponents": {
                "anyOf": [
                  {
                    "$ref": "#/definitions/AddressComponents"
                  },
                  {
                    "type": "null"
                  }
                ]
              },
              "patientAge": {
                "type": [
                  "null",
                  "number"
                ]
              },
              "patientGender": {
                "anyOf": [
                  {
                    "enum": [
                      "F",
                      "M"
                    ],
                    "type": "string"
                  },
                  {
                    "type": "null"
                  }
                ]
              },
              "patientName": {
                "type": "string"
              },
              "patientPhoneNumber": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "startDate": {
                "$ref": "#/definitions/LocalDate"
              },
              "dueDate": {
                "$ref": "#/definitions/LocalDate"
              },
              "documents": {
                "type": "array",
                "items": {
                  "anyOf": [
                    {
                      "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegular"
                    },
                    {
                      "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned"
                    },
                    {
                      "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan"
                    }
                  ]
                }
              },
              "hasPlanOfCare": {
                "type": "boolean"
              },
              "createdBy": {
                "$ref": "#/definitions/AgencyMemberId"
              },
              "createdAt": {
                "$ref": "#/definitions/Instant"
              },
              "priority": {
                "type": "number"
              },
              "agency": {
                "$ref": "#/definitions/Agency"
              },
              "viewedAt": {
                "anyOf": [
                  {
                    "$ref": "#/definitions/Instant"
                  },
                  {
                    "type": "null"
                  }
                ]
              },
              "linkedPatientName": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "linkedPatientTaskInstanceId": {
                "anyOf": [
                  {
                    "$ref": "#/definitions/PatientTaskInstanceId"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            },
            "required": [
              "agency",
              "certifications",
              "createdAt",
              "createdBy",
              "dayTimeParams",
              "documents",
              "dueDate",
              "durationMinutes",
              "hasPlanOfCare",
              "linkedPatientName",
              "linkedPatientTaskInstanceId",
              "patientAddress",
              "patientAddressComponents",
              "patientAge",
              "patientGender",
              "patientId",
              "patientInitials",
              "patientName",
              "patientPhoneNumber",
              "priority",
              "startDate",
              "taskInstanceId",
              "title",
              "type",
              "viewedAt"
            ]
          },
          {
            "type": "object",
            "properties": {
              "type": {
                "type": "string",
                "enum": [
                  "Onboarding"
                ]
              },
              "taskInstanceId": {
                "$ref": "#/definitions/PatientTaskInstanceId"
              },
              "patientId": {
                "$ref": "#/definitions/PatientId"
              },
              "patientInitials": {
                "type": "string"
              },
              "certifications": {
                "type": "array",
                "items": {
                  "$ref": "#/definitions/CaregiverCertification"
                }
              },
              "dayTimeParams": {
                "anyOf": [
                  {
                    "type": "array",
                    "items": {
                      "$ref": "#/definitions/DayTimeParam"
                    }
                  },
                  {
                    "type": "null"
                  }
                ]
              },
              "durationMinutes": {
                "type": [
                  "null",
                  "number"
                ]
              },
              "title": {
                "type": "string"
              },
              "patientAddress": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "patientAddressComponents": {
                "anyOf": [
                  {
                    "$ref": "#/definitions/AddressComponents"
                  },
                  {
                    "type": "null"
                  }
                ]
              },
              "patientAge": {
                "type": [
                  "null",
                  "number"
                ]
              },
              "patientGender": {
                "anyOf": [
                  {
                    "enum": [
                      "F",
                      "M"
                    ],
                    "type": "string"
                  },
                  {
                    "type": "null"
                  }
                ]
              },
              "startDate": {
                "$ref": "#/definitions/LocalDate"
              },
              "priority": {
                "type": "number"
              },
              "dueDate": {
                "$ref": "#/definitions/LocalDate"
              },
              "documents": {
                "type": "array",
                "items": {
                  "anyOf": [
                    {
                      "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegular"
                    },
                    {
                      "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned"
                    },
                    {
                      "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan"
                    }
                  ]
                }
              },
              "hasPlanOfCare": {
                "type": "boolean"
              },
              "createdBy": {
                "$ref": "#/definitions/AgencyMemberId"
              },
              "createdAt": {
                "$ref": "#/definitions/Instant"
              },
              "agency": {
                "$ref": "#/definitions/Agency"
              },
              "viewedAt": {
                "anyOf": [
                  {
                    "$ref": "#/definitions/Instant"
                  },
                  {
                    "type": "null"
                  }
                ]
              },
              "linkedPatientName": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "linkedPatientTaskInstanceId": {
                "anyOf": [
                  {
                    "$ref": "#/definitions/PatientTaskInstanceId"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            },
            "required": [
              "agency",
              "certifications",
              "createdAt",
              "createdBy",
              "dayTimeParams",
              "documents",
              "dueDate",
              "durationMinutes",
              "hasPlanOfCare",
              "linkedPatientName",
              "linkedPatientTaskInstanceId",
              "patientAddress",
              "patientAddressComponents",
              "patientAge",
              "patientGender",
              "patientId",
              "patientInitials",
              "priority",
              "startDate",
              "taskInstanceId",
              "title",
              "type",
              "viewedAt"
            ]
          }
        ]
      }
    }
  },
  "required": [
    "taskBroadcasts"
  ],
  "definitions": {
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "DayOfWeek": {
      "type": "string",
      "xreviver": "JSJoda.DayOfWeek"
    },
    "PatientId": {
      "type": "number"
    },
    "PatientTaskInstanceId": {
      "type": "number"
    },
    "CaregiverCertification": {
      "type": "string"
    },
    "DayTimeParam": {
      "type": "object",
      "properties": {
        "dayOfWeek": {
          "$ref": "#/definitions/DayOfWeek"
        },
        "startTime": {
          "$ref": "#/definitions/LocalTime"
        },
        "endTime": {
          "$ref": "#/definitions/LocalTime"
        }
      },
      "required": [
        "dayOfWeek",
        "endTime",
        "startTime"
      ]
    },
    "LocalTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalTime"
    },
    "AddressComponents": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "country": {
          "type": "string"
        },
        "administrativeAreaLevel1": {
          "type": "string"
        },
        "administrativeAreaLevel2": {
          "type": "string"
        },
        "sublocalityLevel1": {
          "type": [
            "null",
            "string"
          ]
        },
        "neighborhood": {
          "type": [
            "null",
            "string"
          ]
        },
        "locality": {
          "type": [
            "null",
            "string"
          ]
        },
        "formatedAddressDetails": {
          "$ref": "#/definitions/FormatedAddressDetails"
        }
      },
      "required": [
        "administrativeAreaLevel1",
        "administrativeAreaLevel2",
        "country",
        "location"
      ]
    },
    "Geo": {
      "type": "object",
      "properties": {
        "lat": {
          "type": "number"
        },
        "lng": {
          "type": "number"
        }
      },
      "required": [
        "lat",
        "lng"
      ]
    },
    "FormatedAddressDetails": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "address1": {
          "type": "string"
        },
        "country": {
          "type": "string"
        },
        "state": {
          "type": "string"
        },
        "county": {
          "type": "string"
        },
        "fullAddress": {
          "type": "string"
        },
        "city": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip5": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip4": {
          "type": [
            "null",
            "string"
          ]
        },
        "street": {
          "type": [
            "null",
            "string"
          ]
        },
        "streetNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "crossStreet": {
          "type": [
            "null",
            "string"
          ]
        },
        "address2": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "address1",
        "country",
        "county",
        "fullAddress",
        "location",
        "state"
      ]
    },
    "PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegular": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PatientTaskInstanceDocumentRegular"
          ]
        },
        "name": {
          "type": "string"
        },
        "completed": {
          "type": "boolean"
        },
        "id": {
          "$ref": "#/definitions/PatientDocumentTypeId"
        },
        "isOpenForResubmission": {
          "type": "boolean"
        },
        "resubmissionReason": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "completed",
        "id",
        "isOpenForResubmission",
        "name",
        "resubmissionReason",
        "type"
      ]
    },
    "PatientDocumentTypeId": {
      "type": "number"
    },
    "PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PatientTaskInstanceDocumentRegularScanned"
          ]
        },
        "name": {
          "type": "string"
        },
        "id": {
          "$ref": "#/definitions/PatientDocumentTypeId"
        },
        "pdfUrl": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name",
        "pdfUrl",
        "type"
      ]
    },
    "PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PatientTaskInstanceDocumentScan"
          ]
        },
        "name": {
          "type": "string"
        },
        "pdfUrl": {
          "type": "string"
        }
      },
      "required": [
        "name",
        "pdfUrl",
        "type"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "Agency": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AgencyId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "name": {
          "type": "string"
        },
        "logoUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "website": {
          "type": [
            "null",
            "string"
          ]
        },
        "address": {
          "type": [
            "null",
            "string"
          ]
        },
        "officePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "organizationType": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumbers": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/AgencyIvrPhoneNumber"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "isMedflytAgency": {
          "type": "boolean"
        }
      },
      "required": [
        "address",
        "createdAt",
        "id",
        "isMedflytAgency",
        "ivrPhoneNumbers",
        "logoUrl",
        "name",
        "officePhone",
        "organizationType",
        "website"
      ]
    },
    "AgencyId": {
      "type": "number"
    },
    "AgencyIvrPhoneNumber": {
      "type": "object",
      "properties": {
        "ivrPhoneNumber": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "description",
        "ivrPhoneNumber"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientTaskInstancesList",
{
  "type": "object",
  "properties": {
    "tasks": {
      "type": "array",
      "items": {
        "anyOf": [
          {
            "$ref": "#/definitions/PatientTaskInstance.COMPLETED"
          },
          {
            "$ref": "#/definitions/PatientTaskInstance.PENDING"
          },
          {
            "$ref": "#/definitions/PatientTaskInstance.SCHEDULED"
          }
        ]
      }
    }
  },
  "required": [
    "tasks"
  ],
  "definitions": {
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "DayOfWeek": {
      "type": "string",
      "xreviver": "JSJoda.DayOfWeek"
    },
    "PatientId": {
      "type": "number"
    },
    "PatientTaskInstanceId": {
      "type": "number"
    },
    "CaregiverCertification": {
      "type": "string"
    },
    "DayTimeParam": {
      "type": "object",
      "properties": {
        "dayOfWeek": {
          "$ref": "#/definitions/DayOfWeek"
        },
        "startTime": {
          "$ref": "#/definitions/LocalTime"
        },
        "endTime": {
          "$ref": "#/definitions/LocalTime"
        }
      },
      "required": [
        "dayOfWeek",
        "endTime",
        "startTime"
      ]
    },
    "LocalTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalTime"
    },
    "AddressComponents": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "country": {
          "type": "string"
        },
        "administrativeAreaLevel1": {
          "type": "string"
        },
        "administrativeAreaLevel2": {
          "type": "string"
        },
        "sublocalityLevel1": {
          "type": [
            "null",
            "string"
          ]
        },
        "neighborhood": {
          "type": [
            "null",
            "string"
          ]
        },
        "locality": {
          "type": [
            "null",
            "string"
          ]
        },
        "formatedAddressDetails": {
          "$ref": "#/definitions/FormatedAddressDetails"
        }
      },
      "required": [
        "administrativeAreaLevel1",
        "administrativeAreaLevel2",
        "country",
        "location"
      ]
    },
    "Geo": {
      "type": "object",
      "properties": {
        "lat": {
          "type": "number"
        },
        "lng": {
          "type": "number"
        }
      },
      "required": [
        "lat",
        "lng"
      ]
    },
    "FormatedAddressDetails": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "address1": {
          "type": "string"
        },
        "country": {
          "type": "string"
        },
        "state": {
          "type": "string"
        },
        "county": {
          "type": "string"
        },
        "fullAddress": {
          "type": "string"
        },
        "city": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip5": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip4": {
          "type": [
            "null",
            "string"
          ]
        },
        "street": {
          "type": [
            "null",
            "string"
          ]
        },
        "streetNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "crossStreet": {
          "type": [
            "null",
            "string"
          ]
        },
        "address2": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "address1",
        "country",
        "county",
        "fullAddress",
        "location",
        "state"
      ]
    },
    "PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegular": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PatientTaskInstanceDocumentRegular"
          ]
        },
        "name": {
          "type": "string"
        },
        "completed": {
          "type": "boolean"
        },
        "id": {
          "$ref": "#/definitions/PatientDocumentTypeId"
        },
        "isOpenForResubmission": {
          "type": "boolean"
        },
        "resubmissionReason": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "completed",
        "id",
        "isOpenForResubmission",
        "name",
        "resubmissionReason",
        "type"
      ]
    },
    "PatientDocumentTypeId": {
      "type": "number"
    },
    "PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PatientTaskInstanceDocumentRegularScanned"
          ]
        },
        "name": {
          "type": "string"
        },
        "id": {
          "$ref": "#/definitions/PatientDocumentTypeId"
        },
        "pdfUrl": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name",
        "pdfUrl",
        "type"
      ]
    },
    "PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PatientTaskInstanceDocumentScan"
          ]
        },
        "name": {
          "type": "string"
        },
        "pdfUrl": {
          "type": "string"
        }
      },
      "required": [
        "name",
        "pdfUrl",
        "type"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "Agency": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AgencyId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "name": {
          "type": "string"
        },
        "logoUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "website": {
          "type": [
            "null",
            "string"
          ]
        },
        "address": {
          "type": [
            "null",
            "string"
          ]
        },
        "officePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "organizationType": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumbers": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/AgencyIvrPhoneNumber"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "isMedflytAgency": {
          "type": "boolean"
        }
      },
      "required": [
        "address",
        "createdAt",
        "id",
        "isMedflytAgency",
        "ivrPhoneNumbers",
        "logoUrl",
        "name",
        "officePhone",
        "organizationType",
        "website"
      ]
    },
    "AgencyId": {
      "type": "number"
    },
    "AgencyIvrPhoneNumber": {
      "type": "object",
      "properties": {
        "ivrPhoneNumber": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "description",
        "ivrPhoneNumber"
      ]
    },
    "PatientTaskInstance.COMPLETED": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "COMPLETED"
          ]
        },
        "completionDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "scheduleDateTime": {
          "$ref": "#/definitions/Instant"
        },
        "dayTimeParams": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/DayTimeParam"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "visitInstance": {
          "anyOf": [
            {
              "$ref": "#/definitions/VisitInstanceDetails"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientConfirmedSchedule": {
          "type": "boolean"
        },
        "id": {
          "$ref": "#/definitions/PatientTaskInstanceId"
        },
        "visitInstanceId": {
          "anyOf": [
            {
              "$ref": "#/definitions/VisitInstanceId"
            },
            {
              "type": "null"
            }
          ]
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        },
        "startDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "dueDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "taskDetails": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientTask.RECURRING"
            },
            {
              "$ref": "#/definitions/PatientTask.SINGLE"
            }
          ]
        },
        "clockInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInLocation": {
          "anyOf": [
            {
              "$ref": "#/definitions/Geo"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutLocation": {
          "anyOf": [
            {
              "$ref": "#/definitions/Geo"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInType": {
          "anyOf": [
            {
              "enum": [
                "IVR",
                "MANUAL",
                "MOBILE",
                "TIME_SHEET"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutType": {
          "anyOf": [
            {
              "enum": [
                "IVR",
                "MANUAL",
                "MOBILE",
                "TIME_SHEET"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "caregiverId",
        "clockInLocation",
        "clockInTime",
        "clockInType",
        "clockOutLocation",
        "clockOutTime",
        "clockOutType",
        "completionDate",
        "dayTimeParams",
        "dueDate",
        "id",
        "patientConfirmedSchedule",
        "scheduleDateTime",
        "startDate",
        "taskDetails",
        "type",
        "visitInstance",
        "visitInstanceId"
      ]
    },
    "VisitInstanceDetails": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "startTimeUTC": {
          "$ref": "#/definitions/Instant"
        },
        "startTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTimeUTC": {
          "$ref": "#/definitions/Instant"
        },
        "endTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "checkInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "checkOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "dutySheetFillPercentage": {
          "type": [
            "null",
            "number"
          ]
        },
        "isCaregiverClockEnabled": {
          "description": "Agency pilot for enabled clock in/out caregivers",
          "type": "boolean"
        },
        "publicVisitDetails": {
          "$ref": "#/definitions/PublicVisitInstanceDetails"
        },
        "confidentialVisitDetails": {
          "$ref": "#/definitions/ConfidentialVisitDetails"
        },
        "visitDocumentsStatus": {
          "$ref": "#/definitions/VisitDocumentsStatus"
        },
        "manualClockTimeEditApproved": {
          "type": "boolean"
        },
        "isDutySheetCompleted": {
          "type": "boolean"
        },
        "timeSheetSubmittedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "timeSheetDeclinedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "timeSheetApprovedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "hasPlanOfCare": {
          "type": "boolean"
        },
        "checkinMaxDistance": {
          "type": [
            "null",
            "number"
          ]
        },
        "requireSelfieOnClockIn": {
          "type": "boolean"
        },
        "requireSelfieOnClockOut": {
          "type": "boolean"
        }
      },
      "required": [
        "checkInTime",
        "checkOutTime",
        "checkinMaxDistance",
        "clockInTime",
        "clockOutTime",
        "confidentialVisitDetails",
        "dutySheetFillPercentage",
        "endTimeLocal",
        "endTimeUTC",
        "hasPlanOfCare",
        "id",
        "isCaregiverClockEnabled",
        "isDutySheetCompleted",
        "manualClockTimeEditApproved",
        "publicVisitDetails",
        "requireSelfieOnClockIn",
        "requireSelfieOnClockOut",
        "startTimeLocal",
        "startTimeUTC",
        "timeSheetApprovedAt",
        "timeSheetDeclinedAt",
        "timeSheetSubmittedAt",
        "visitDocumentsStatus"
      ]
    },
    "VisitInstanceId": {
      "type": "number"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "PublicVisitInstanceDetails": {
      "type": "object",
      "properties": {
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "agency": {
          "$ref": "#/definitions/Agency"
        },
        "isBillingAgency": {
          "type": "boolean"
        },
        "isMedflytAgency": {
          "type": "boolean"
        },
        "startTime": {
          "$ref": "#/definitions/Instant"
        },
        "startTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTime": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        },
        "endTimeLocal": {
          "type": "string",
          "xreviver": "JSJoda.LocalDateTime"
        },
        "isSingleVisit": {
          "description": "Is this a single visit or recurring visit?",
          "type": "boolean"
        },
        "dayTimeParams": {
          "description": "Defines the time slots of the visit over a given week.",
          "anyOf": [
            {
              "$ref": "#/definitions/VisitDayTimeParams"
            },
            {
              "type": "null"
            }
          ]
        },
        "price": {
          "description": "USD, integer cents. \"$10.99\" equals the value 1099",
          "exclusiveMinimum": 0,
          "type": [
            "null",
            "number"
          ]
        },
        "languages": {
          "description": "Must be one of 'Caregiver.ALL_LANGUAGES'",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "generalNotes": {
          "type": "string"
        },
        "location": {
          "$ref": "#/definitions/AddressComponents"
        },
        "timezone": {
          "description": "timezone from the tz database (IANA)",
          "type": "string"
        },
        "createdById": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "createdByFirstName": {
          "type": "string"
        },
        "createdByLastName": {
          "type": "string"
        },
        "flexibleVisitParams": {
          "anyOf": [
            {
              "$ref": "#/definitions/PermanentFlexibleHoursAndDaysPerWeek"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursAndDaysPattern"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursFixedDaysPattern"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursFixedDaysPerWeek"
            },
            {
              "$ref": "#/definitions/PermanentFixedHoursFlexibleDays"
            },
            {
              "$ref": "#/definitions/SingleFlexible"
            },
            {
              "type": "null"
            }
          ]
        },
        "visitLabels": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitLabel"
          }
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientInitials": {
          "type": "string"
        },
        "patientAge": {
          "type": [
            "null",
            "number"
          ]
        },
        "patientGender": {
          "anyOf": [
            {
              "enum": [
                "F",
                "M"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientAllergies": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/Allergy"
          }
        },
        "patientLanguages": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientRequests": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientMedicalNotes": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientTasks": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "certifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverCertification"
          }
        },
        "clockInToleranceMinutes": {
          "type": "number"
        },
        "clockOutToleranceMinutes": {
          "type": "number"
        },
        "staffingPreferences2": {
          "$ref": "#/definitions/VisitStaffingPreferences"
        },
        "patientAdvancedDirectives": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientAdvancedDirective"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "agency",
        "certifications",
        "clockInToleranceMinutes",
        "clockOutToleranceMinutes",
        "createdAt",
        "createdByFirstName",
        "createdById",
        "createdByLastName",
        "dayTimeParams",
        "flexibleVisitParams",
        "generalNotes",
        "isBillingAgency",
        "isMedflytAgency",
        "isSingleVisit",
        "languages",
        "location",
        "patientAdvancedDirectives",
        "patientAge",
        "patientAllergies",
        "patientGender",
        "patientId",
        "patientInitials",
        "patientLanguages",
        "patientMedicalNotes",
        "patientRequests",
        "patientTasks",
        "price",
        "staffingPreferences2",
        "startTime",
        "startTimeLocal",
        "timezone",
        "visitLabels"
      ]
    },
    "VisitDayTimeParams": {
      "type": "object",
      "properties": {
        "dayTimes": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitDayTime"
          }
        }
      },
      "required": [
        "dayTimes"
      ]
    },
    "VisitDayTime": {
      "type": "object",
      "properties": {
        "day": {
          "description": "0 = sunday, 1 = monday, ... , 6 = saturday",
          "type": "integer",
          "minimum": 0,
          "maximum": 6
        },
        "startTime": {
          "$ref": "#/definitions/LocalTime"
        },
        "endTime": {
          "$ref": "#/definitions/LocalTime"
        }
      },
      "required": [
        "day",
        "endTime",
        "startTime"
      ]
    },
    "PermanentFlexibleHoursAndDaysPerWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursAndDaysPerWeek"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "amountOfHoursPerWeek": {
          "type": "number"
        },
        "minHoursPerShift": {
          "type": "number"
        },
        "maxHoursPerShift": {
          "type": "number"
        }
      },
      "required": [
        "amountOfHoursPerWeek",
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "maxHoursPerShift",
        "minHoursPerShift",
        "type"
      ]
    },
    "PermanentFlexibleHoursAndDaysPattern": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursAndDaysPattern"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "flexibleDetails": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "amountOfDays": {
                "type": "number"
              },
              "amountOfHours": {
                "type": "number"
              }
            },
            "required": [
              "amountOfDays",
              "amountOfHours"
            ]
          }
        }
      },
      "required": [
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "flexibleDetails",
        "type"
      ]
    },
    "PermanentFlexibleHoursFixedDaysPattern": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursFixedDaysPattern"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "details": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "day": {
                "$ref": "#/definitions/DayOfWeek"
              },
              "amountOfHours": {
                "type": "number"
              }
            },
            "required": [
              "amountOfHours",
              "day"
            ]
          }
        }
      },
      "required": [
        "details",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "PermanentFlexibleHoursFixedDaysPerWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursFixedDaysPerWeek"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "amountOfHoursPerWeek": {
          "type": "number"
        },
        "days": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "minHoursPerShift": {
          "type": "number"
        },
        "maxHoursPerShift": {
          "type": "number"
        }
      },
      "required": [
        "amountOfHoursPerWeek",
        "days",
        "excludedDaysFromCaregivers",
        "maxHoursPerShift",
        "minHoursPerShift",
        "type"
      ]
    },
    "PermanentFixedHoursFlexibleDays": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFixedHoursFlexibleDays"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "day": {
                "$ref": "#/definitions/DayOfWeek"
              },
              "startTime": {
                "$ref": "#/definitions/LocalTime"
              },
              "endTime": {
                "$ref": "#/definitions/LocalTime"
              }
            },
            "required": [
              "day",
              "endTime",
              "startTime"
            ]
          }
        },
        "amountOfDays": {
          "type": "number"
        }
      },
      "required": [
        "amountOfDays",
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "SingleFlexible": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SingleFlexible"
          ]
        },
        "date": {
          "$ref": "#/definitions/LocalDate"
        },
        "amountOfHours": {
          "type": "number"
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        }
      },
      "required": [
        "amountOfHours",
        "date",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "VisitLabel": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string"
        },
        "color": {
          "type": "string"
        }
      },
      "required": [
        "color",
        "text"
      ]
    },
    "Allergy": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AllergyId"
        },
        "name": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name"
      ]
    },
    "AllergyId": {
      "type": "number"
    },
    "VisitStaffingPreferences": {
      "type": "object",
      "properties": {
        "smoking": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "bedbound": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "cane": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "walker": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "wheelchair": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "kosher": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "halal": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "hoyer": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "pets": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "bedbound",
        "cane",
        "halal",
        "hoyer",
        "kosher",
        "pets",
        "smoking",
        "walker",
        "wheelchair"
      ]
    },
    "PatientAdvancedDirective": {
      "type": "object",
      "properties": {
        "hasDNR": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "hasProxy": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "firstName": {
          "type": [
            "null",
            "string"
          ]
        },
        "lastName": {
          "type": [
            "null",
            "string"
          ]
        },
        "phoneNumber": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "firstName",
        "hasDNR",
        "hasProxy",
        "lastName",
        "phoneNumber"
      ]
    },
    "ConfidentialVisitDetails": {
      "type": "object",
      "properties": {
        "patientName": {
          "type": "string"
        },
        "patientAddress": {
          "type": "string"
        },
        "patientAddress2": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAddressInstructions": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientPhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAlternativePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "caseDetails": {
          "type": "string"
        }
      },
      "required": [
        "caseDetails",
        "patientAddress",
        "patientAddress2",
        "patientAddressInstructions",
        "patientAlternativePhone",
        "patientName",
        "patientPhone"
      ]
    },
    "VisitDocumentsStatus": {
      "type": "object",
      "properties": {
        "total": {
          "type": "number"
        },
        "submitted": {
          "type": "number"
        }
      },
      "required": [
        "submitted",
        "total"
      ]
    },
    "CaregiverId": {
      "type": "number"
    },
    "PatientTask.RECURRING": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "RECURRING"
          ]
        },
        "id": {
          "$ref": "#/definitions/PatientTaskId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientName": {
          "type": "string"
        },
        "patientAge": {
          "type": [
            "null",
            "number"
          ]
        },
        "patientGender": {
          "anyOf": [
            {
              "enum": [
                "F",
                "M"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientInitials": {
          "type": "string"
        },
        "patientMobilePhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientHomePhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAddress": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAddress2": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAddressComponent": {
          "anyOf": [
            {
              "$ref": "#/definitions/AddressComponents"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientAddressInstructions": {
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string"
        },
        "startDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "dueDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "durationMinutes": {
          "type": [
            "null",
            "number"
          ]
        },
        "repeatMonths": {
          "type": "number"
        },
        "hasPlanOfCare": {
          "type": "boolean"
        },
        "planOfCareCompleted": {
          "type": "boolean"
        },
        "documents": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegular"
              },
              {
                "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned"
              },
              {
                "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan"
              }
            ]
          }
        },
        "agencyName": {
          "type": "string"
        },
        "agencyAddress": {
          "type": "string"
        },
        "agencyPhone": {
          "type": "string"
        },
        "linkedPatientName": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedPatientTaskInstanceId": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientTaskInstanceId"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "agencyAddress",
        "agencyName",
        "agencyPhone",
        "documents",
        "dueDate",
        "durationMinutes",
        "hasPlanOfCare",
        "id",
        "linkedPatientName",
        "linkedPatientTaskInstanceId",
        "patientAddress",
        "patientAddress2",
        "patientAddressComponent",
        "patientAddressInstructions",
        "patientAge",
        "patientGender",
        "patientHomePhoneNumber",
        "patientId",
        "patientInitials",
        "patientMobilePhoneNumber",
        "patientName",
        "planOfCareCompleted",
        "repeatMonths",
        "startDate",
        "title",
        "type"
      ]
    },
    "PatientTaskId": {
      "type": "number"
    },
    "PatientTask.SINGLE": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SINGLE"
          ]
        },
        "id": {
          "$ref": "#/definitions/PatientTaskId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientName": {
          "type": "string"
        },
        "patientAge": {
          "type": [
            "null",
            "number"
          ]
        },
        "patientGender": {
          "anyOf": [
            {
              "enum": [
                "F",
                "M"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientInitials": {
          "type": "string"
        },
        "patientAddress": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAddress2": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAddressComponent": {
          "anyOf": [
            {
              "$ref": "#/definitions/AddressComponents"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientAddressInstructions": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientMobilePhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientHomePhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string"
        },
        "startDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "dueDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "durationMinutes": {
          "type": [
            "null",
            "number"
          ]
        },
        "repeatMonths": {
          "type": "null"
        },
        "hasPlanOfCare": {
          "type": "boolean"
        },
        "planOfCareCompleted": {
          "type": "boolean"
        },
        "documents": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegular"
              },
              {
                "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned"
              },
              {
                "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan"
              }
            ]
          }
        },
        "agencyName": {
          "type": "string"
        },
        "agencyAddress": {
          "type": "string"
        },
        "agencyPhone": {
          "type": "string"
        },
        "linkedPatientName": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedPatientTaskInstanceId": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientTaskInstanceId"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "agencyAddress",
        "agencyName",
        "agencyPhone",
        "documents",
        "dueDate",
        "durationMinutes",
        "hasPlanOfCare",
        "id",
        "linkedPatientName",
        "linkedPatientTaskInstanceId",
        "patientAddress",
        "patientAddress2",
        "patientAddressComponent",
        "patientAddressInstructions",
        "patientAge",
        "patientGender",
        "patientHomePhoneNumber",
        "patientId",
        "patientInitials",
        "patientMobilePhoneNumber",
        "patientName",
        "planOfCareCompleted",
        "repeatMonths",
        "startDate",
        "title",
        "type"
      ]
    },
    "PatientTaskInstance.PENDING": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PENDING"
          ]
        },
        "completionDate": {
          "type": "null"
        },
        "scheduleDateTime": {
          "type": "null"
        },
        "dayTimeParams": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/DayTimeParam"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/PatientTaskInstanceId"
        },
        "visitInstanceId": {
          "anyOf": [
            {
              "$ref": "#/definitions/VisitInstanceId"
            },
            {
              "type": "null"
            }
          ]
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        },
        "startDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "dueDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "taskDetails": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientTask.RECURRING"
            },
            {
              "$ref": "#/definitions/PatientTask.SINGLE"
            }
          ]
        },
        "clockInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInLocation": {
          "anyOf": [
            {
              "$ref": "#/definitions/Geo"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutLocation": {
          "anyOf": [
            {
              "$ref": "#/definitions/Geo"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInType": {
          "anyOf": [
            {
              "enum": [
                "IVR",
                "MANUAL",
                "MOBILE",
                "TIME_SHEET"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutType": {
          "anyOf": [
            {
              "enum": [
                "IVR",
                "MANUAL",
                "MOBILE",
                "TIME_SHEET"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "caregiverId",
        "clockInLocation",
        "clockInTime",
        "clockInType",
        "clockOutLocation",
        "clockOutTime",
        "clockOutType",
        "completionDate",
        "dayTimeParams",
        "dueDate",
        "id",
        "scheduleDateTime",
        "startDate",
        "taskDetails",
        "type",
        "visitInstanceId"
      ]
    },
    "PatientTaskInstance.SCHEDULED": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SCHEDULED"
          ]
        },
        "completionDate": {
          "type": "null"
        },
        "scheduleDateTime": {
          "$ref": "#/definitions/Instant"
        },
        "dayTimeParams": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/DayTimeParam"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "visitInstance": {
          "anyOf": [
            {
              "$ref": "#/definitions/VisitInstanceDetails"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientConfirmedSchedule": {
          "type": "boolean"
        },
        "id": {
          "$ref": "#/definitions/PatientTaskInstanceId"
        },
        "visitInstanceId": {
          "anyOf": [
            {
              "$ref": "#/definitions/VisitInstanceId"
            },
            {
              "type": "null"
            }
          ]
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        },
        "startDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "dueDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "taskDetails": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientTask.RECURRING"
            },
            {
              "$ref": "#/definitions/PatientTask.SINGLE"
            }
          ]
        },
        "clockInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInLocation": {
          "anyOf": [
            {
              "$ref": "#/definitions/Geo"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutLocation": {
          "anyOf": [
            {
              "$ref": "#/definitions/Geo"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInType": {
          "anyOf": [
            {
              "enum": [
                "IVR",
                "MANUAL",
                "MOBILE",
                "TIME_SHEET"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutType": {
          "anyOf": [
            {
              "enum": [
                "IVR",
                "MANUAL",
                "MOBILE",
                "TIME_SHEET"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "caregiverId",
        "clockInLocation",
        "clockInTime",
        "clockInType",
        "clockOutLocation",
        "clockOutTime",
        "clockOutType",
        "completionDate",
        "dayTimeParams",
        "dueDate",
        "id",
        "patientConfirmedSchedule",
        "scheduleDateTime",
        "startDate",
        "taskDetails",
        "type",
        "visitInstance",
        "visitInstanceId"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientTaskCompletionDate",
{
  "type": "object",
  "properties": {
    "date": {
      "anyOf": [
        {
          "$ref": "#/definitions/LocalDate"
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "date"
  ],
  "definitions": {
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientTaskDocument",
{
  "type": "object",
  "properties": {
    "document": {
      "$ref": "#/definitions/PatientTaskDocumentObjectPartial"
    }
  },
  "required": [
    "document"
  ],
  "definitions": {
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "PatientTaskDocumentObjectPartial": {
      "type": "object",
      "properties": {
        "id": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientDocumentScheduleId"
            },
            {
              "type": "null"
            }
          ]
        },
        "documentType": {
          "$ref": "#/definitions/PatientDocumentTypeId"
        },
        "title": {
          "type": "string"
        },
        "versionId": {
          "$ref": "#/definitions/PatientDocumentVersionId"
        },
        "patientTaskId": {
          "$ref": "#/definitions/PatientTaskId"
        },
        "patientTaskInstanceId": {
          "$ref": "#/definitions/PatientTaskInstanceId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "submittedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "content": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientDocumentContentItem"
          }
        },
        "answers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientDocumentAnswerObject"
          }
        },
        "pdfUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "isScannable": {
          "type": "boolean"
        },
        "readonly": {
          "type": "boolean"
        }
      },
      "required": [
        "answers",
        "content",
        "createdAt",
        "documentType",
        "id",
        "isScannable",
        "patientTaskId",
        "patientTaskInstanceId",
        "pdfUrl",
        "readonly",
        "submittedAt",
        "title",
        "versionId"
      ]
    },
    "PatientDocumentScheduleId": {
      "type": "number"
    },
    "PatientDocumentTypeId": {
      "type": "number"
    },
    "PatientDocumentVersionId": {
      "type": "number"
    },
    "PatientTaskId": {
      "type": "number"
    },
    "PatientTaskInstanceId": {
      "type": "number"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "PatientDocumentContentItem": {
      "type": "object",
      "properties": {
        "id": {
          "type": "number"
        },
        "mainClass": {
          "type": "string"
        },
        "title": {
          "type": "string"
        },
        "itemType": {
          "$ref": "#/definitions/DocumentItemQuestionType"
        },
        "label": {
          "type": "string"
        },
        "columns": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "array",
                "items": {
                  "$ref": "#/definitions/PatientDocumentContentItem"
                }
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "POCItems": {
          "description": "Used only for document question type \"POC\"",
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientDocumentPOCItem"
          }
        },
        "isRequired": {
          "type": "boolean"
        },
        "parentId": {
          "type": [
            "null",
            "number"
          ]
        },
        "showIfParentEquals": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "ifParentEquals": {
          "type": "string"
        },
        "showOtherOption": {
          "type": "boolean"
        },
        "html": {
          "type": "string"
        },
        "url": {
          "type": [
            "null",
            "string"
          ]
        },
        "days": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "frequencyPerWeek": {
          "type": "number"
        },
        "visitPerWeek": {
          "type": "number"
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentType": {
          "anyOf": [
            {
              "enum": [
                "POC",
                "bigHeader",
                "bloodPressure",
                "bodyDrawing",
                "chart",
                "check",
                "customSignature",
                "date",
                "dropDown",
                "editor",
                "employeeSignature",
                "icd",
                "icdChart",
                "icdCodes",
                "image",
                "medicationProfile",
                "medicationProfileItem",
                "number",
                "patientPhysician",
                "patientSignature",
                "radio",
                "smallHeader",
                "textLong",
                "textShort",
                "time",
                "yesNo"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "cms485QuestionId": {
          "type": "string"
        },
        "oca960questionId": {
          "type": "string"
        },
        "prefilledAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerValues": {
          "type": "array",
          "items": {
            "type": "number"
          }
        },
        "valueGroup": {
          "type": [
            "null",
            "string"
          ]
        },
        "isInValueGroup": {
          "type": "boolean"
        },
        "copyFromOtherDocs": {
          "type": "boolean"
        },
        "allowUnsignedSignature": {
          "type": "boolean"
        },
        "hideNameFieldSignature": {
          "type": "boolean"
        },
        "useForMedication": {
          "type": "boolean"
        },
        "canCopyFromMedication": {
          "type": "boolean"
        },
        "useForDisciplinAndTreatment": {
          "type": "boolean"
        },
        "canCopyFromDisciplinAndTreatment": {
          "type": "boolean"
        },
        "isIcd": {
          "type": "boolean"
        },
        "nursingQuestionLinked": {
          "type": "number"
        },
        "patientMedicationDetails": {
          "$ref": "#/definitions/PatientMedicationProfileWithDetails"
        },
        "vitalMeasuredAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "vitalMethod": {
          "anyOf": [
            {
              "enum": [
                "Axillary",
                "Irregular",
                "Laying",
                "Left Arm",
                "Oral",
                "Rectal",
                "Regular",
                "Remote/Forehead",
                "Right Arm",
                "Sitting",
                "Standing"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "vitalComments": {
          "type": [
            "null",
            "string"
          ]
        },
        "vitalUnit": {
          "anyOf": [
            {
              "enum": [
                "Beats Per Minute",
                "Breaths Per Minute",
                "FAHRENHEIT",
                "mmHg"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "blockOnMobile": {
          "type": "boolean"
        },
        "isVital": {
          "type": "boolean"
        }
      },
      "required": [
        "id",
        "itemType",
        "label",
        "mainClass",
        "parentId",
        "showIfParentEquals",
        "title"
      ]
    },
    "DocumentItemQuestionType": {
      "type": "string"
    },
    "PatientDocumentPOCItem": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "isTitle": {
          "type": "boolean"
        }
      },
      "required": [
        "isTitle",
        "name"
      ]
    },
    "DayOfWeek": {
      "type": "string",
      "xreviver": "JSJoda.DayOfWeek"
    },
    "PatientMedicationProfileWithDetails": {
      "type": "object",
      "properties": {
        "dose": {
          "type": "string"
        },
        "route": {
          "type": "string"
        },
        "medicationName": {
          "type": "string"
        },
        "id": {
          "$ref": "#/definitions/PatientMedicationProfileId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "medicationId": {
          "$ref": "#/definitions/MedicationId"
        },
        "from": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "until": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "frequency": {
          "type": [
            "null",
            "string"
          ]
        },
        "status": {
          "$ref": "#/definitions/PatientMedicationProfileStatus"
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "dose",
        "frequency",
        "from",
        "id",
        "medicationId",
        "medicationName",
        "notes",
        "patientId",
        "route",
        "status",
        "until"
      ]
    },
    "PatientMedicationProfileId": {
      "type": "number"
    },
    "PatientId": {
      "type": "number"
    },
    "MedicationId": {
      "type": "number"
    },
    "PatientMedicationProfileStatus": {
      "enum": [
        "ACTIVE",
        "DISCONTINUED"
      ],
      "type": "string"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "PatientDocumentAnswerObject": {
      "type": "object",
      "properties": {
        "questionId": {
          "type": "number"
        },
        "chartRow": {
          "type": [
            "null",
            "number"
          ]
        },
        "answer": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/PatientContractDiagnosisCode"
              }
            },
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/POCItemsDocumentAnswer"
              }
            },
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/PatientMedicationProfileWithDetails"
              }
            },
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "answeredAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "answer",
        "answeredAt",
        "chartRow",
        "questionId"
      ]
    },
    "PatientContractDiagnosisCode": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/PatientContractDiagnosisCodeId"
        },
        "icdCode": {
          "$ref": "#/definitions/ICD10CodeId"
        },
        "formattedDxCode": {
          "type": "string"
        },
        "shortDesc": {
          "type": "string"
        },
        "patientContractId": {
          "$ref": "#/definitions/PatientContractId"
        },
        "startDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "endDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "type": {
          "anyOf": [
            {
              "enum": [
                "PRINCIPAL",
                "SURGICAL"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "isForBilling": {
          "type": "boolean"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "createdBy": {
          "$ref": "#/definitions/UserId"
        },
        "updatedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "updatedBy": {
          "anyOf": [
            {
              "$ref": "#/definitions/UserId"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "createdAt",
        "createdBy",
        "endDate",
        "formattedDxCode",
        "icdCode",
        "id",
        "isForBilling",
        "patientContractId",
        "shortDesc",
        "startDate",
        "type",
        "updatedAt",
        "updatedBy"
      ]
    },
    "PatientContractDiagnosisCodeId": {
      "type": "number"
    },
    "ICD10CodeId": {
      "type": "number"
    },
    "PatientContractId": {
      "type": "number"
    },
    "UserId": {
      "type": "number"
    },
    "POCItemsDocumentAnswer": {
      "type": "object",
      "properties": {
        "idx": {
          "type": "number"
        },
        "attributes": {
          "anyOf": [
            {
              "$ref": "#/definitions/TaskWhenToPerform.EveryVisit"
            },
            {
              "$ref": "#/definitions/TaskWhenToPerform.OnDaysOfWeek"
            },
            {
              "$ref": "#/definitions/TaskWhenToPerform.AsRequestedByPatient"
            }
          ]
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "attributes",
        "idx"
      ]
    },
    "TaskWhenToPerform.EveryVisit": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "EveryVisit"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TaskWhenToPerform.OnDaysOfWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "OnDaysOfWeek"
          ]
        },
        "frequency": {
          "$ref": "#/definitions/FrequencyVisitedInAWeekDetails"
        },
        "days": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        }
      },
      "required": [
        "type"
      ]
    },
    "FrequencyVisitedInAWeekDetails": {
      "type": "object",
      "properties": {
        "frequency": {
          "type": [
            "null",
            "number"
          ]
        },
        "visitsInAWeek": {
          "type": [
            "null",
            "number"
          ]
        }
      },
      "required": [
        "frequency",
        "visitsInAWeek"
      ]
    },
    "TaskWhenToPerform.AsRequestedByPatient": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AsRequestedByPatient"
          ]
        }
      },
      "required": [
        "type"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientTaskInstance",
{
  "anyOf": [
    {
      "$ref": "#/definitions/PatientTaskInstance.COMPLETED"
    },
    {
      "$ref": "#/definitions/PatientTaskInstance.PENDING"
    },
    {
      "$ref": "#/definitions/PatientTaskInstance.SCHEDULED"
    }
  ],
  "definitions": {
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "PatientDocumentTypeId": {
      "type": "number"
    },
    "PatientTaskId": {
      "type": "number"
    },
    "PatientTaskInstanceId": {
      "type": "number"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "DayOfWeek": {
      "type": "string",
      "xreviver": "JSJoda.DayOfWeek"
    },
    "PatientId": {
      "type": "number"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "PatientTaskInstance.COMPLETED": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "COMPLETED"
          ]
        },
        "completionDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "scheduleDateTime": {
          "$ref": "#/definitions/Instant"
        },
        "dayTimeParams": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/DayTimeParam"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "visitInstance": {
          "anyOf": [
            {
              "$ref": "#/definitions/VisitInstanceDetails"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientConfirmedSchedule": {
          "type": "boolean"
        },
        "id": {
          "$ref": "#/definitions/PatientTaskInstanceId"
        },
        "visitInstanceId": {
          "anyOf": [
            {
              "$ref": "#/definitions/VisitInstanceId"
            },
            {
              "type": "null"
            }
          ]
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        },
        "startDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "dueDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "taskDetails": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientTask.RECURRING"
            },
            {
              "$ref": "#/definitions/PatientTask.SINGLE"
            }
          ]
        },
        "clockInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInLocation": {
          "anyOf": [
            {
              "$ref": "#/definitions/Geo"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutLocation": {
          "anyOf": [
            {
              "$ref": "#/definitions/Geo"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInType": {
          "anyOf": [
            {
              "enum": [
                "IVR",
                "MANUAL",
                "MOBILE",
                "TIME_SHEET"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutType": {
          "anyOf": [
            {
              "enum": [
                "IVR",
                "MANUAL",
                "MOBILE",
                "TIME_SHEET"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "caregiverId",
        "clockInLocation",
        "clockInTime",
        "clockInType",
        "clockOutLocation",
        "clockOutTime",
        "clockOutType",
        "completionDate",
        "dayTimeParams",
        "dueDate",
        "id",
        "patientConfirmedSchedule",
        "scheduleDateTime",
        "startDate",
        "taskDetails",
        "type",
        "visitInstance",
        "visitInstanceId"
      ]
    },
    "DayTimeParam": {
      "type": "object",
      "properties": {
        "dayOfWeek": {
          "$ref": "#/definitions/DayOfWeek"
        },
        "startTime": {
          "$ref": "#/definitions/LocalTime"
        },
        "endTime": {
          "$ref": "#/definitions/LocalTime"
        }
      },
      "required": [
        "dayOfWeek",
        "endTime",
        "startTime"
      ]
    },
    "LocalTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalTime"
    },
    "VisitInstanceDetails": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "startTimeUTC": {
          "$ref": "#/definitions/Instant"
        },
        "startTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTimeUTC": {
          "$ref": "#/definitions/Instant"
        },
        "endTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "checkInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "checkOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "dutySheetFillPercentage": {
          "type": [
            "null",
            "number"
          ]
        },
        "isCaregiverClockEnabled": {
          "description": "Agency pilot for enabled clock in/out caregivers",
          "type": "boolean"
        },
        "publicVisitDetails": {
          "$ref": "#/definitions/PublicVisitInstanceDetails"
        },
        "confidentialVisitDetails": {
          "$ref": "#/definitions/ConfidentialVisitDetails"
        },
        "visitDocumentsStatus": {
          "$ref": "#/definitions/VisitDocumentsStatus"
        },
        "manualClockTimeEditApproved": {
          "type": "boolean"
        },
        "isDutySheetCompleted": {
          "type": "boolean"
        },
        "timeSheetSubmittedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "timeSheetDeclinedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "timeSheetApprovedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "hasPlanOfCare": {
          "type": "boolean"
        },
        "checkinMaxDistance": {
          "type": [
            "null",
            "number"
          ]
        },
        "requireSelfieOnClockIn": {
          "type": "boolean"
        },
        "requireSelfieOnClockOut": {
          "type": "boolean"
        }
      },
      "required": [
        "checkInTime",
        "checkOutTime",
        "checkinMaxDistance",
        "clockInTime",
        "clockOutTime",
        "confidentialVisitDetails",
        "dutySheetFillPercentage",
        "endTimeLocal",
        "endTimeUTC",
        "hasPlanOfCare",
        "id",
        "isCaregiverClockEnabled",
        "isDutySheetCompleted",
        "manualClockTimeEditApproved",
        "publicVisitDetails",
        "requireSelfieOnClockIn",
        "requireSelfieOnClockOut",
        "startTimeLocal",
        "startTimeUTC",
        "timeSheetApprovedAt",
        "timeSheetDeclinedAt",
        "timeSheetSubmittedAt",
        "visitDocumentsStatus"
      ]
    },
    "VisitInstanceId": {
      "type": "number"
    },
    "PublicVisitInstanceDetails": {
      "type": "object",
      "properties": {
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "agency": {
          "$ref": "#/definitions/Agency"
        },
        "isBillingAgency": {
          "type": "boolean"
        },
        "isMedflytAgency": {
          "type": "boolean"
        },
        "startTime": {
          "$ref": "#/definitions/Instant"
        },
        "startTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTime": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        },
        "endTimeLocal": {
          "type": "string",
          "xreviver": "JSJoda.LocalDateTime"
        },
        "isSingleVisit": {
          "description": "Is this a single visit or recurring visit?",
          "type": "boolean"
        },
        "dayTimeParams": {
          "description": "Defines the time slots of the visit over a given week.",
          "anyOf": [
            {
              "$ref": "#/definitions/VisitDayTimeParams"
            },
            {
              "type": "null"
            }
          ]
        },
        "price": {
          "description": "USD, integer cents. \"$10.99\" equals the value 1099",
          "exclusiveMinimum": 0,
          "type": [
            "null",
            "number"
          ]
        },
        "languages": {
          "description": "Must be one of 'Caregiver.ALL_LANGUAGES'",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "generalNotes": {
          "type": "string"
        },
        "location": {
          "$ref": "#/definitions/AddressComponents"
        },
        "timezone": {
          "description": "timezone from the tz database (IANA)",
          "type": "string"
        },
        "createdById": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "createdByFirstName": {
          "type": "string"
        },
        "createdByLastName": {
          "type": "string"
        },
        "flexibleVisitParams": {
          "anyOf": [
            {
              "$ref": "#/definitions/PermanentFlexibleHoursAndDaysPerWeek"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursAndDaysPattern"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursFixedDaysPattern"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursFixedDaysPerWeek"
            },
            {
              "$ref": "#/definitions/PermanentFixedHoursFlexibleDays"
            },
            {
              "$ref": "#/definitions/SingleFlexible"
            },
            {
              "type": "null"
            }
          ]
        },
        "visitLabels": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitLabel"
          }
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientInitials": {
          "type": "string"
        },
        "patientAge": {
          "type": [
            "null",
            "number"
          ]
        },
        "patientGender": {
          "anyOf": [
            {
              "enum": [
                "F",
                "M"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientAllergies": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/Allergy"
          }
        },
        "patientLanguages": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientRequests": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientMedicalNotes": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientTasks": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "certifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverCertification"
          }
        },
        "clockInToleranceMinutes": {
          "type": "number"
        },
        "clockOutToleranceMinutes": {
          "type": "number"
        },
        "staffingPreferences2": {
          "$ref": "#/definitions/VisitStaffingPreferences"
        },
        "patientAdvancedDirectives": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientAdvancedDirective"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "agency",
        "certifications",
        "clockInToleranceMinutes",
        "clockOutToleranceMinutes",
        "createdAt",
        "createdByFirstName",
        "createdById",
        "createdByLastName",
        "dayTimeParams",
        "flexibleVisitParams",
        "generalNotes",
        "isBillingAgency",
        "isMedflytAgency",
        "isSingleVisit",
        "languages",
        "location",
        "patientAdvancedDirectives",
        "patientAge",
        "patientAllergies",
        "patientGender",
        "patientId",
        "patientInitials",
        "patientLanguages",
        "patientMedicalNotes",
        "patientRequests",
        "patientTasks",
        "price",
        "staffingPreferences2",
        "startTime",
        "startTimeLocal",
        "timezone",
        "visitLabels"
      ]
    },
    "Agency": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AgencyId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "name": {
          "type": "string"
        },
        "logoUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "website": {
          "type": [
            "null",
            "string"
          ]
        },
        "address": {
          "type": [
            "null",
            "string"
          ]
        },
        "officePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "organizationType": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumbers": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/AgencyIvrPhoneNumber"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "isMedflytAgency": {
          "type": "boolean"
        }
      },
      "required": [
        "address",
        "createdAt",
        "id",
        "isMedflytAgency",
        "ivrPhoneNumbers",
        "logoUrl",
        "name",
        "officePhone",
        "organizationType",
        "website"
      ]
    },
    "AgencyId": {
      "type": "number"
    },
    "AgencyIvrPhoneNumber": {
      "type": "object",
      "properties": {
        "ivrPhoneNumber": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "description",
        "ivrPhoneNumber"
      ]
    },
    "VisitDayTimeParams": {
      "type": "object",
      "properties": {
        "dayTimes": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitDayTime"
          }
        }
      },
      "required": [
        "dayTimes"
      ]
    },
    "VisitDayTime": {
      "type": "object",
      "properties": {
        "day": {
          "description": "0 = sunday, 1 = monday, ... , 6 = saturday",
          "type": "integer",
          "minimum": 0,
          "maximum": 6
        },
        "startTime": {
          "$ref": "#/definitions/LocalTime"
        },
        "endTime": {
          "$ref": "#/definitions/LocalTime"
        }
      },
      "required": [
        "day",
        "endTime",
        "startTime"
      ]
    },
    "AddressComponents": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "country": {
          "type": "string"
        },
        "administrativeAreaLevel1": {
          "type": "string"
        },
        "administrativeAreaLevel2": {
          "type": "string"
        },
        "sublocalityLevel1": {
          "type": [
            "null",
            "string"
          ]
        },
        "neighborhood": {
          "type": [
            "null",
            "string"
          ]
        },
        "locality": {
          "type": [
            "null",
            "string"
          ]
        },
        "formatedAddressDetails": {
          "$ref": "#/definitions/FormatedAddressDetails"
        }
      },
      "required": [
        "administrativeAreaLevel1",
        "administrativeAreaLevel2",
        "country",
        "location"
      ]
    },
    "Geo": {
      "type": "object",
      "properties": {
        "lat": {
          "type": "number"
        },
        "lng": {
          "type": "number"
        }
      },
      "required": [
        "lat",
        "lng"
      ]
    },
    "FormatedAddressDetails": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "address1": {
          "type": "string"
        },
        "country": {
          "type": "string"
        },
        "state": {
          "type": "string"
        },
        "county": {
          "type": "string"
        },
        "fullAddress": {
          "type": "string"
        },
        "city": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip5": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip4": {
          "type": [
            "null",
            "string"
          ]
        },
        "street": {
          "type": [
            "null",
            "string"
          ]
        },
        "streetNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "crossStreet": {
          "type": [
            "null",
            "string"
          ]
        },
        "address2": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "address1",
        "country",
        "county",
        "fullAddress",
        "location",
        "state"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "PermanentFlexibleHoursAndDaysPerWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursAndDaysPerWeek"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "amountOfHoursPerWeek": {
          "type": "number"
        },
        "minHoursPerShift": {
          "type": "number"
        },
        "maxHoursPerShift": {
          "type": "number"
        }
      },
      "required": [
        "amountOfHoursPerWeek",
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "maxHoursPerShift",
        "minHoursPerShift",
        "type"
      ]
    },
    "PermanentFlexibleHoursAndDaysPattern": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursAndDaysPattern"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "flexibleDetails": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "amountOfDays": {
                "type": "number"
              },
              "amountOfHours": {
                "type": "number"
              }
            },
            "required": [
              "amountOfDays",
              "amountOfHours"
            ]
          }
        }
      },
      "required": [
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "flexibleDetails",
        "type"
      ]
    },
    "PermanentFlexibleHoursFixedDaysPattern": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursFixedDaysPattern"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "details": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "day": {
                "$ref": "#/definitions/DayOfWeek"
              },
              "amountOfHours": {
                "type": "number"
              }
            },
            "required": [
              "amountOfHours",
              "day"
            ]
          }
        }
      },
      "required": [
        "details",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "PermanentFlexibleHoursFixedDaysPerWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursFixedDaysPerWeek"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "amountOfHoursPerWeek": {
          "type": "number"
        },
        "days": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "minHoursPerShift": {
          "type": "number"
        },
        "maxHoursPerShift": {
          "type": "number"
        }
      },
      "required": [
        "amountOfHoursPerWeek",
        "days",
        "excludedDaysFromCaregivers",
        "maxHoursPerShift",
        "minHoursPerShift",
        "type"
      ]
    },
    "PermanentFixedHoursFlexibleDays": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFixedHoursFlexibleDays"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "day": {
                "$ref": "#/definitions/DayOfWeek"
              },
              "startTime": {
                "$ref": "#/definitions/LocalTime"
              },
              "endTime": {
                "$ref": "#/definitions/LocalTime"
              }
            },
            "required": [
              "day",
              "endTime",
              "startTime"
            ]
          }
        },
        "amountOfDays": {
          "type": "number"
        }
      },
      "required": [
        "amountOfDays",
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "SingleFlexible": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SingleFlexible"
          ]
        },
        "date": {
          "$ref": "#/definitions/LocalDate"
        },
        "amountOfHours": {
          "type": "number"
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        }
      },
      "required": [
        "amountOfHours",
        "date",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "VisitLabel": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string"
        },
        "color": {
          "type": "string"
        }
      },
      "required": [
        "color",
        "text"
      ]
    },
    "Allergy": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AllergyId"
        },
        "name": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name"
      ]
    },
    "AllergyId": {
      "type": "number"
    },
    "CaregiverCertification": {
      "type": "string"
    },
    "VisitStaffingPreferences": {
      "type": "object",
      "properties": {
        "smoking": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "bedbound": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "cane": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "walker": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "wheelchair": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "kosher": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "halal": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "hoyer": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "pets": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "bedbound",
        "cane",
        "halal",
        "hoyer",
        "kosher",
        "pets",
        "smoking",
        "walker",
        "wheelchair"
      ]
    },
    "PatientAdvancedDirective": {
      "type": "object",
      "properties": {
        "hasDNR": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "hasProxy": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "firstName": {
          "type": [
            "null",
            "string"
          ]
        },
        "lastName": {
          "type": [
            "null",
            "string"
          ]
        },
        "phoneNumber": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "firstName",
        "hasDNR",
        "hasProxy",
        "lastName",
        "phoneNumber"
      ]
    },
    "ConfidentialVisitDetails": {
      "type": "object",
      "properties": {
        "patientName": {
          "type": "string"
        },
        "patientAddress": {
          "type": "string"
        },
        "patientAddress2": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAddressInstructions": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientPhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAlternativePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "caseDetails": {
          "type": "string"
        }
      },
      "required": [
        "caseDetails",
        "patientAddress",
        "patientAddress2",
        "patientAddressInstructions",
        "patientAlternativePhone",
        "patientName",
        "patientPhone"
      ]
    },
    "VisitDocumentsStatus": {
      "type": "object",
      "properties": {
        "total": {
          "type": "number"
        },
        "submitted": {
          "type": "number"
        }
      },
      "required": [
        "submitted",
        "total"
      ]
    },
    "CaregiverId": {
      "type": "number"
    },
    "PatientTask.RECURRING": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "RECURRING"
          ]
        },
        "id": {
          "$ref": "#/definitions/PatientTaskId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientName": {
          "type": "string"
        },
        "patientAge": {
          "type": [
            "null",
            "number"
          ]
        },
        "patientGender": {
          "anyOf": [
            {
              "enum": [
                "F",
                "M"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientInitials": {
          "type": "string"
        },
        "patientMobilePhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientHomePhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAddress": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAddress2": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAddressComponent": {
          "anyOf": [
            {
              "$ref": "#/definitions/AddressComponents"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientAddressInstructions": {
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string"
        },
        "startDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "dueDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "durationMinutes": {
          "type": [
            "null",
            "number"
          ]
        },
        "repeatMonths": {
          "type": "number"
        },
        "hasPlanOfCare": {
          "type": "boolean"
        },
        "planOfCareCompleted": {
          "type": "boolean"
        },
        "documents": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegular"
              },
              {
                "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned"
              },
              {
                "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan"
              }
            ]
          }
        },
        "agencyName": {
          "type": "string"
        },
        "agencyAddress": {
          "type": "string"
        },
        "agencyPhone": {
          "type": "string"
        },
        "linkedPatientName": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedPatientTaskInstanceId": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientTaskInstanceId"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "agencyAddress",
        "agencyName",
        "agencyPhone",
        "documents",
        "dueDate",
        "durationMinutes",
        "hasPlanOfCare",
        "id",
        "linkedPatientName",
        "linkedPatientTaskInstanceId",
        "patientAddress",
        "patientAddress2",
        "patientAddressComponent",
        "patientAddressInstructions",
        "patientAge",
        "patientGender",
        "patientHomePhoneNumber",
        "patientId",
        "patientInitials",
        "patientMobilePhoneNumber",
        "patientName",
        "planOfCareCompleted",
        "repeatMonths",
        "startDate",
        "title",
        "type"
      ]
    },
    "PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegular": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PatientTaskInstanceDocumentRegular"
          ]
        },
        "name": {
          "type": "string"
        },
        "completed": {
          "type": "boolean"
        },
        "id": {
          "$ref": "#/definitions/PatientDocumentTypeId"
        },
        "isOpenForResubmission": {
          "type": "boolean"
        },
        "resubmissionReason": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "completed",
        "id",
        "isOpenForResubmission",
        "name",
        "resubmissionReason",
        "type"
      ]
    },
    "PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PatientTaskInstanceDocumentRegularScanned"
          ]
        },
        "name": {
          "type": "string"
        },
        "id": {
          "$ref": "#/definitions/PatientDocumentTypeId"
        },
        "pdfUrl": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name",
        "pdfUrl",
        "type"
      ]
    },
    "PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PatientTaskInstanceDocumentScan"
          ]
        },
        "name": {
          "type": "string"
        },
        "pdfUrl": {
          "type": "string"
        }
      },
      "required": [
        "name",
        "pdfUrl",
        "type"
      ]
    },
    "PatientTask.SINGLE": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SINGLE"
          ]
        },
        "id": {
          "$ref": "#/definitions/PatientTaskId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientName": {
          "type": "string"
        },
        "patientAge": {
          "type": [
            "null",
            "number"
          ]
        },
        "patientGender": {
          "anyOf": [
            {
              "enum": [
                "F",
                "M"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientInitials": {
          "type": "string"
        },
        "patientAddress": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAddress2": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAddressComponent": {
          "anyOf": [
            {
              "$ref": "#/definitions/AddressComponents"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientAddressInstructions": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientMobilePhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientHomePhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string"
        },
        "startDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "dueDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "durationMinutes": {
          "type": [
            "null",
            "number"
          ]
        },
        "repeatMonths": {
          "type": "null"
        },
        "hasPlanOfCare": {
          "type": "boolean"
        },
        "planOfCareCompleted": {
          "type": "boolean"
        },
        "documents": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegular"
              },
              {
                "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentRegularScanned"
              },
              {
                "$ref": "#/definitions/PatientTaskInstanceDocument.PatientTaskInstanceDocumentScan"
              }
            ]
          }
        },
        "agencyName": {
          "type": "string"
        },
        "agencyAddress": {
          "type": "string"
        },
        "agencyPhone": {
          "type": "string"
        },
        "linkedPatientName": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedPatientTaskInstanceId": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientTaskInstanceId"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "agencyAddress",
        "agencyName",
        "agencyPhone",
        "documents",
        "dueDate",
        "durationMinutes",
        "hasPlanOfCare",
        "id",
        "linkedPatientName",
        "linkedPatientTaskInstanceId",
        "patientAddress",
        "patientAddress2",
        "patientAddressComponent",
        "patientAddressInstructions",
        "patientAge",
        "patientGender",
        "patientHomePhoneNumber",
        "patientId",
        "patientInitials",
        "patientMobilePhoneNumber",
        "patientName",
        "planOfCareCompleted",
        "repeatMonths",
        "startDate",
        "title",
        "type"
      ]
    },
    "PatientTaskInstance.PENDING": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PENDING"
          ]
        },
        "completionDate": {
          "type": "null"
        },
        "scheduleDateTime": {
          "type": "null"
        },
        "dayTimeParams": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/DayTimeParam"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/PatientTaskInstanceId"
        },
        "visitInstanceId": {
          "anyOf": [
            {
              "$ref": "#/definitions/VisitInstanceId"
            },
            {
              "type": "null"
            }
          ]
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        },
        "startDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "dueDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "taskDetails": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientTask.RECURRING"
            },
            {
              "$ref": "#/definitions/PatientTask.SINGLE"
            }
          ]
        },
        "clockInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInLocation": {
          "anyOf": [
            {
              "$ref": "#/definitions/Geo"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutLocation": {
          "anyOf": [
            {
              "$ref": "#/definitions/Geo"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInType": {
          "anyOf": [
            {
              "enum": [
                "IVR",
                "MANUAL",
                "MOBILE",
                "TIME_SHEET"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutType": {
          "anyOf": [
            {
              "enum": [
                "IVR",
                "MANUAL",
                "MOBILE",
                "TIME_SHEET"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "caregiverId",
        "clockInLocation",
        "clockInTime",
        "clockInType",
        "clockOutLocation",
        "clockOutTime",
        "clockOutType",
        "completionDate",
        "dayTimeParams",
        "dueDate",
        "id",
        "scheduleDateTime",
        "startDate",
        "taskDetails",
        "type",
        "visitInstanceId"
      ]
    },
    "PatientTaskInstance.SCHEDULED": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SCHEDULED"
          ]
        },
        "completionDate": {
          "type": "null"
        },
        "scheduleDateTime": {
          "$ref": "#/definitions/Instant"
        },
        "dayTimeParams": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/DayTimeParam"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "visitInstance": {
          "anyOf": [
            {
              "$ref": "#/definitions/VisitInstanceDetails"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientConfirmedSchedule": {
          "type": "boolean"
        },
        "id": {
          "$ref": "#/definitions/PatientTaskInstanceId"
        },
        "visitInstanceId": {
          "anyOf": [
            {
              "$ref": "#/definitions/VisitInstanceId"
            },
            {
              "type": "null"
            }
          ]
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        },
        "startDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "dueDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "taskDetails": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientTask.RECURRING"
            },
            {
              "$ref": "#/definitions/PatientTask.SINGLE"
            }
          ]
        },
        "clockInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInLocation": {
          "anyOf": [
            {
              "$ref": "#/definitions/Geo"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutLocation": {
          "anyOf": [
            {
              "$ref": "#/definitions/Geo"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInType": {
          "anyOf": [
            {
              "enum": [
                "IVR",
                "MANUAL",
                "MOBILE",
                "TIME_SHEET"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutType": {
          "anyOf": [
            {
              "enum": [
                "IVR",
                "MANUAL",
                "MOBILE",
                "TIME_SHEET"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "caregiverId",
        "clockInLocation",
        "clockInTime",
        "clockInType",
        "clockOutLocation",
        "clockOutTime",
        "clockOutType",
        "completionDate",
        "dayTimeParams",
        "dueDate",
        "id",
        "patientConfirmedSchedule",
        "scheduleDateTime",
        "startDate",
        "taskDetails",
        "type",
        "visitInstance",
        "visitInstanceId"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientDetailDataRes",
{
  "type": "object",
  "properties": {
    "data": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/PatientDetailData"
      }
    }
  },
  "required": [
    "data"
  ],
  "definitions": {
    "PatientDetailData": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string"
        },
        "icon": {
          "type": "string"
        },
        "data": {},
        "sections": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientDetailData"
          }
        }
      },
      "required": [
        "title"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverVisitEditRequestList",
{
  "description": "API payload from server containing all rescheduling requests for a given caregiver",
  "type": "object",
  "properties": {
    "requests": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverVisitEditRequest"
      }
    }
  },
  "required": [
    "requests"
  ],
  "definitions": {
    "CaregiverVisitEditRequest": {
      "description": "A single rescheduling request of a caregiver that exists",
      "type": "object",
      "properties": {
        "visitId": {
          "anyOf": [
            {
              "$ref": "#/definitions/VisitBroadcastId"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientName": {
          "type": "string"
        },
        "patientAddress": {
          "type": "string"
        },
        "scheduledVisitDetails": {
          "$ref": "#/definitions/VisitEditRequestDetails"
        },
        "editRequestParams": {
          "$ref": "#/definitions/ScheduledVisitEditParams"
        }
      },
      "required": [
        "editRequestParams",
        "patientAddress",
        "patientName",
        "scheduledVisitDetails",
        "visitId"
      ]
    },
    "VisitBroadcastId": {
      "type": "number"
    },
    "VisitEditRequestDetails": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "scheduledStartTime": {
          "type": "string"
        },
        "scheduledEndTime": {
          "type": "string"
        },
        "scheduledStartTimeUTC": {
          "$ref": "#/definitions/Instant"
        },
        "scheduledStartTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "scheduledEndTimeUTC": {
          "$ref": "#/definitions/Instant"
        },
        "scheduledEndTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "isCheckedIn": {
          "type": "boolean"
        },
        "isCheckedOut": {
          "type": "boolean"
        },
        "checkInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "checkOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "visitId": {
          "anyOf": [
            {
              "$ref": "#/definitions/VisitBroadcastId"
            },
            {
              "type": "null"
            }
          ]
        },
        "dutySheetFillPercentage": {
          "type": [
            "null",
            "number"
          ]
        }
      },
      "required": [
        "checkInTime",
        "checkOutTime",
        "dutySheetFillPercentage",
        "id",
        "isCheckedIn",
        "isCheckedOut",
        "scheduledEndTime",
        "scheduledEndTimeLocal",
        "scheduledEndTimeUTC",
        "scheduledStartTime",
        "scheduledStartTimeLocal",
        "scheduledStartTimeUTC",
        "visitId"
      ]
    },
    "VisitInstanceId": {
      "type": "number"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "ScheduledVisitEditParams": {
      "description": "The full request that's attached to each scheduled visit",
      "type": "object",
      "properties": {
        "requestId": {
          "$ref": "#/definitions/ScheduledVisitEditRequestId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "requestParams": {
          "description": "The changes to a scheduled visit that a caregiver wants",
          "anyOf": [
            {
              "$ref": "#/definitions/ScheduledVisitEditRequestParams.Cancel"
            },
            {
              "$ref": "#/definitions/ScheduledVisitEditRequestParams.Reschedule"
            }
          ]
        },
        "response": {
          "anyOf": [
            {
              "$ref": "#/definitions/ScheduledVisitRequestResponse"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "createdAt",
        "requestId",
        "requestParams",
        "response"
      ]
    },
    "ScheduledVisitEditRequestId": {
      "type": "number"
    },
    "ScheduledVisitEditRequestParams.Cancel": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CANCEL"
          ]
        },
        "message": {
          "type": "string"
        }
      },
      "required": [
        "message",
        "type"
      ]
    },
    "ScheduledVisitEditRequestParams.Reschedule": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "RESCHEDULE"
          ]
        },
        "startTime": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTime": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "message": {
          "type": "string"
        }
      },
      "required": [
        "endTime",
        "message",
        "startTime",
        "type"
      ]
    },
    "ScheduledVisitRequestResponse": {
      "description": "Coordinator's response(approval/rejection) to a reschedule request",
      "type": "object",
      "properties": {
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "params": {
          "$ref": "#/definitions/ScheduledVisitRequestResponseParams"
        }
      },
      "required": [
        "createdAt",
        "params"
      ]
    },
    "ScheduledVisitRequestResponseParams": {
      "description": "The coordinators response to a rescheduling request",
      "type": "object",
      "properties": {
        "message": {
          "type": "string"
        },
        "approved": {
          "type": "boolean"
        }
      },
      "required": [
        "approved",
        "message"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverVisitBroadcastList",
{
  "type": "object",
  "properties": {
    "visitBroadcasts": {
      "type": "array",
      "items": {
        "anyOf": [
          {
            "$ref": "#/definitions/CaregiverVisitBroadcastTypes.Available"
          },
          {
            "$ref": "#/definitions/CaregiverVisitBroadcastTypes.Onboarding"
          }
        ]
      }
    }
  },
  "required": [
    "visitBroadcasts"
  ],
  "definitions": {
    "VisitBroadcastId": {
      "type": "number"
    },
    "VisitInstanceId": {
      "type": "number"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "CaregiverVisitBroadcastTypes.Available": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Available"
          ]
        },
        "id": {
          "$ref": "#/definitions/VisitBroadcastId"
        },
        "publicVisitBroadcastDetails": {
          "anyOf": [
            {
              "$ref": "#/definitions/PublicVisitBroadcastDetailsTypes.Pattern"
            },
            {
              "$ref": "#/definitions/PublicVisitBroadcastDetailsTypes.Singles"
            },
            {
              "$ref": "#/definitions/PublicVisitBroadcastDetailsTypes.FlexiblePattern"
            }
          ]
        },
        "caregiverVisitEngagementDetails": {
          "$ref": "#/definitions/CaregiverVisitBroadcastEngagementDetails"
        }
      },
      "required": [
        "caregiverVisitEngagementDetails",
        "id",
        "publicVisitBroadcastDetails",
        "type"
      ]
    },
    "PublicVisitBroadcastDetailsTypes.Pattern": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Pattern"
          ]
        },
        "weeklyPattern": {
          "$ref": "#/definitions/BroadcastPattern"
        },
        "visitInstances": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "date": {
                "$ref": "#/definitions/VisitDatesParams"
              },
              "visitInstanceId": {
                "$ref": "#/definitions/VisitInstanceId"
              }
            },
            "required": [
              "date",
              "visitInstanceId"
            ]
          }
        },
        "id": {
          "$ref": "#/definitions/VisitBroadcastId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "agency": {
          "$ref": "#/definitions/Agency"
        },
        "startTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "languages": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "generalNotes": {
          "type": "string"
        },
        "location": {
          "$ref": "#/definitions/AddressComponents"
        },
        "price": {
          "type": [
            "null",
            "number"
          ]
        },
        "timezone": {
          "description": "timezone from the tz database (IANA)",
          "type": "string"
        },
        "createdByFirstName": {
          "type": "string"
        },
        "createdByLastName": {
          "type": "string"
        },
        "visitLabels": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitLabelText"
          }
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientFirstName": {
          "type": "string"
        },
        "patientIsActive": {
          "type": "boolean"
        },
        "patientAge": {
          "type": [
            "null",
            "number"
          ]
        },
        "patientInitials": {
          "type": "string"
        },
        "patientGender": {
          "anyOf": [
            {
              "enum": [
                "F",
                "M"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientAllergies": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/Allergy"
          }
        },
        "patientMedicalNotes": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientLanguages": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientRequests": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientTasks": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "createdById": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "certifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverCertification"
          }
        },
        "hideEndDateFromCaregiver": {
          "type": "boolean"
        },
        "staffingPreferences2": {
          "$ref": "#/definitions/VisitStaffingPreferences"
        },
        "patientAvailability": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/PatientVisitTimeFramesByDay"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "allowMultipleCaregivers": {
          "type": "boolean"
        },
        "visitInfo": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "nearLocationDisplay": {
          "type": [
            "null",
            "string"
          ]
        },
        "preferenceMismatchReasons": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "days_availability"
            ]
          }
        }
      },
      "required": [
        "agency",
        "allowMultipleCaregivers",
        "certifications",
        "createdAt",
        "createdByFirstName",
        "createdById",
        "createdByLastName",
        "endTimeLocal",
        "generalNotes",
        "hideEndDateFromCaregiver",
        "id",
        "languages",
        "location",
        "nearLocationDisplay",
        "patientAge",
        "patientAllergies",
        "patientAvailability",
        "patientFirstName",
        "patientGender",
        "patientId",
        "patientInitials",
        "patientIsActive",
        "patientLanguages",
        "patientMedicalNotes",
        "patientRequests",
        "patientTasks",
        "preferenceMismatchReasons",
        "price",
        "staffingPreferences2",
        "startTimeLocal",
        "timezone",
        "type",
        "visitInfo",
        "visitInstances",
        "visitLabels",
        "weeklyPattern"
      ]
    },
    "BroadcastPattern": {
      "type": "object",
      "properties": {
        "excludes": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitDatesParamsExtended"
          }
        },
        "daysOfWeek": {
          "$ref": "#/definitions/VisitBroacastDayOfWeekPattern"
        }
      },
      "required": [
        "daysOfWeek",
        "excludes"
      ]
    },
    "VisitDatesParamsExtended": {
      "type": "object",
      "properties": {
        "visitInstanceId": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "startDateTimeUtc": {
          "$ref": "#/definitions/Instant"
        },
        "endDateTimeUtc": {
          "$ref": "#/definitions/Instant"
        },
        "startLocalDateTime": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endLocalDateTime": {
          "$ref": "#/definitions/LocalDateTime"
        }
      },
      "required": [
        "endDateTimeUtc",
        "endLocalDateTime",
        "startDateTimeUtc",
        "startLocalDateTime",
        "visitInstanceId"
      ]
    },
    "VisitBroacastDayOfWeekPattern": {
      "type": "object",
      "properties": {
        "SUNDAY": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeekPatternShift"
          }
        },
        "MONDAY": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeekPatternShift"
          }
        },
        "TUESDAY": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeekPatternShift"
          }
        },
        "WEDNESDAY": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeekPatternShift"
          }
        },
        "THURSDAY": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeekPatternShift"
          }
        },
        "FRIDAY": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeekPatternShift"
          }
        },
        "SATURDAY": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeekPatternShift"
          }
        }
      }
    },
    "DayOfWeekPatternShift": {
      "type": "object",
      "properties": {
        "startAt": {
          "$ref": "#/definitions/LocalTime"
        },
        "endAt": {
          "$ref": "#/definitions/LocalTime"
        }
      },
      "required": [
        "endAt",
        "startAt"
      ]
    },
    "LocalTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalTime"
    },
    "VisitDatesParams": {
      "type": "object",
      "properties": {
        "startDateTime": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endDateTime": {
          "$ref": "#/definitions/LocalDateTime"
        }
      },
      "required": [
        "endDateTime",
        "startDateTime"
      ]
    },
    "Agency": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AgencyId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "name": {
          "type": "string"
        },
        "logoUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "website": {
          "type": [
            "null",
            "string"
          ]
        },
        "address": {
          "type": [
            "null",
            "string"
          ]
        },
        "officePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "organizationType": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumbers": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/AgencyIvrPhoneNumber"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "isMedflytAgency": {
          "type": "boolean"
        }
      },
      "required": [
        "address",
        "createdAt",
        "id",
        "isMedflytAgency",
        "ivrPhoneNumbers",
        "logoUrl",
        "name",
        "officePhone",
        "organizationType",
        "website"
      ]
    },
    "AgencyId": {
      "type": "number"
    },
    "AgencyIvrPhoneNumber": {
      "type": "object",
      "properties": {
        "ivrPhoneNumber": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "description",
        "ivrPhoneNumber"
      ]
    },
    "AddressComponents": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "country": {
          "type": "string"
        },
        "administrativeAreaLevel1": {
          "type": "string"
        },
        "administrativeAreaLevel2": {
          "type": "string"
        },
        "sublocalityLevel1": {
          "type": [
            "null",
            "string"
          ]
        },
        "neighborhood": {
          "type": [
            "null",
            "string"
          ]
        },
        "locality": {
          "type": [
            "null",
            "string"
          ]
        },
        "formatedAddressDetails": {
          "$ref": "#/definitions/FormatedAddressDetails"
        }
      },
      "required": [
        "administrativeAreaLevel1",
        "administrativeAreaLevel2",
        "country",
        "location"
      ]
    },
    "Geo": {
      "type": "object",
      "properties": {
        "lat": {
          "type": "number"
        },
        "lng": {
          "type": "number"
        }
      },
      "required": [
        "lat",
        "lng"
      ]
    },
    "FormatedAddressDetails": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "address1": {
          "type": "string"
        },
        "country": {
          "type": "string"
        },
        "state": {
          "type": "string"
        },
        "county": {
          "type": "string"
        },
        "fullAddress": {
          "type": "string"
        },
        "city": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip5": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip4": {
          "type": [
            "null",
            "string"
          ]
        },
        "street": {
          "type": [
            "null",
            "string"
          ]
        },
        "streetNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "crossStreet": {
          "type": [
            "null",
            "string"
          ]
        },
        "address2": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "address1",
        "country",
        "county",
        "fullAddress",
        "location",
        "state"
      ]
    },
    "VisitLabelText": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string"
        },
        "color": {
          "type": "string"
        }
      },
      "required": [
        "color",
        "text"
      ]
    },
    "PatientId": {
      "type": "number"
    },
    "Allergy": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AllergyId"
        },
        "name": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name"
      ]
    },
    "AllergyId": {
      "type": "number"
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "CaregiverCertification": {
      "type": "string"
    },
    "VisitStaffingPreferences": {
      "type": "object",
      "properties": {
        "smoking": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "bedbound": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "cane": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "walker": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "wheelchair": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "kosher": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "halal": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "hoyer": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "pets": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "bedbound",
        "cane",
        "halal",
        "hoyer",
        "kosher",
        "pets",
        "smoking",
        "walker",
        "wheelchair"
      ]
    },
    "PatientVisitTimeFramesByDay": {
      "type": "object",
      "properties": {
        "day": {
          "$ref": "#/definitions/DayOfWeek"
        },
        "timeframes": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientTimeFrames"
          }
        }
      },
      "required": [
        "day",
        "timeframes"
      ]
    },
    "DayOfWeek": {
      "type": "string",
      "xreviver": "JSJoda.DayOfWeek"
    },
    "PatientTimeFrames": {
      "type": "object",
      "properties": {
        "startTime": {
          "type": "number"
        },
        "endTime": {
          "type": "number"
        }
      },
      "required": [
        "endTime",
        "startTime"
      ]
    },
    "PublicVisitBroadcastDetailsTypes.Singles": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Singles"
          ]
        },
        "visitInstances": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "date": {
                "$ref": "#/definitions/VisitDatesParams"
              },
              "visitInstanceId": {
                "$ref": "#/definitions/VisitInstanceId"
              }
            },
            "required": [
              "date",
              "visitInstanceId"
            ]
          }
        },
        "id": {
          "$ref": "#/definitions/VisitBroadcastId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "agency": {
          "$ref": "#/definitions/Agency"
        },
        "startTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "languages": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "generalNotes": {
          "type": "string"
        },
        "location": {
          "$ref": "#/definitions/AddressComponents"
        },
        "price": {
          "type": [
            "null",
            "number"
          ]
        },
        "timezone": {
          "description": "timezone from the tz database (IANA)",
          "type": "string"
        },
        "createdByFirstName": {
          "type": "string"
        },
        "createdByLastName": {
          "type": "string"
        },
        "visitLabels": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitLabelText"
          }
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientFirstName": {
          "type": "string"
        },
        "patientIsActive": {
          "type": "boolean"
        },
        "patientAge": {
          "type": [
            "null",
            "number"
          ]
        },
        "patientInitials": {
          "type": "string"
        },
        "patientGender": {
          "anyOf": [
            {
              "enum": [
                "F",
                "M"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientAllergies": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/Allergy"
          }
        },
        "patientMedicalNotes": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientLanguages": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientRequests": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientTasks": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "createdById": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "certifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverCertification"
          }
        },
        "hideEndDateFromCaregiver": {
          "type": "boolean"
        },
        "staffingPreferences2": {
          "$ref": "#/definitions/VisitStaffingPreferences"
        },
        "patientAvailability": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/PatientVisitTimeFramesByDay"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "allowMultipleCaregivers": {
          "type": "boolean"
        },
        "visitInfo": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "nearLocationDisplay": {
          "type": [
            "null",
            "string"
          ]
        },
        "preferenceMismatchReasons": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "days_availability"
            ]
          }
        }
      },
      "required": [
        "agency",
        "allowMultipleCaregivers",
        "certifications",
        "createdAt",
        "createdByFirstName",
        "createdById",
        "createdByLastName",
        "endTimeLocal",
        "generalNotes",
        "hideEndDateFromCaregiver",
        "id",
        "languages",
        "location",
        "nearLocationDisplay",
        "patientAge",
        "patientAllergies",
        "patientAvailability",
        "patientFirstName",
        "patientGender",
        "patientId",
        "patientInitials",
        "patientIsActive",
        "patientLanguages",
        "patientMedicalNotes",
        "patientRequests",
        "patientTasks",
        "preferenceMismatchReasons",
        "price",
        "staffingPreferences2",
        "startTimeLocal",
        "timezone",
        "type",
        "visitInfo",
        "visitInstances",
        "visitLabels"
      ]
    },
    "PublicVisitBroadcastDetailsTypes.FlexiblePattern": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "FlexiblePattern"
          ]
        },
        "flexibleVisitParams": {
          "anyOf": [
            {
              "$ref": "#/definitions/PermanentFlexibleHoursAndDaysPerWeek"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursAndDaysPattern"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursFixedDaysPattern"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursFixedDaysPerWeek"
            },
            {
              "$ref": "#/definitions/PermanentFixedHoursFlexibleDays"
            },
            {
              "$ref": "#/definitions/SingleFlexible"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/VisitBroadcastId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "agency": {
          "$ref": "#/definitions/Agency"
        },
        "startTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "languages": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "generalNotes": {
          "type": "string"
        },
        "location": {
          "$ref": "#/definitions/AddressComponents"
        },
        "price": {
          "type": [
            "null",
            "number"
          ]
        },
        "timezone": {
          "description": "timezone from the tz database (IANA)",
          "type": "string"
        },
        "createdByFirstName": {
          "type": "string"
        },
        "createdByLastName": {
          "type": "string"
        },
        "visitLabels": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitLabelText"
          }
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientFirstName": {
          "type": "string"
        },
        "patientIsActive": {
          "type": "boolean"
        },
        "patientAge": {
          "type": [
            "null",
            "number"
          ]
        },
        "patientInitials": {
          "type": "string"
        },
        "patientGender": {
          "anyOf": [
            {
              "enum": [
                "F",
                "M"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientAllergies": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/Allergy"
          }
        },
        "patientMedicalNotes": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientLanguages": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientRequests": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientTasks": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "createdById": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "certifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverCertification"
          }
        },
        "hideEndDateFromCaregiver": {
          "type": "boolean"
        },
        "staffingPreferences2": {
          "$ref": "#/definitions/VisitStaffingPreferences"
        },
        "patientAvailability": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/PatientVisitTimeFramesByDay"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "allowMultipleCaregivers": {
          "type": "boolean"
        },
        "visitInfo": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "nearLocationDisplay": {
          "type": [
            "null",
            "string"
          ]
        },
        "preferenceMismatchReasons": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "days_availability"
            ]
          }
        }
      },
      "required": [
        "agency",
        "allowMultipleCaregivers",
        "certifications",
        "createdAt",
        "createdByFirstName",
        "createdById",
        "createdByLastName",
        "endTimeLocal",
        "flexibleVisitParams",
        "generalNotes",
        "hideEndDateFromCaregiver",
        "id",
        "languages",
        "location",
        "nearLocationDisplay",
        "patientAge",
        "patientAllergies",
        "patientAvailability",
        "patientFirstName",
        "patientGender",
        "patientId",
        "patientInitials",
        "patientIsActive",
        "patientLanguages",
        "patientMedicalNotes",
        "patientRequests",
        "patientTasks",
        "preferenceMismatchReasons",
        "price",
        "staffingPreferences2",
        "startTimeLocal",
        "timezone",
        "type",
        "visitInfo",
        "visitLabels"
      ]
    },
    "PermanentFlexibleHoursAndDaysPerWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursAndDaysPerWeek"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "amountOfHoursPerWeek": {
          "type": "number"
        },
        "minHoursPerShift": {
          "type": "number"
        },
        "maxHoursPerShift": {
          "type": "number"
        }
      },
      "required": [
        "amountOfHoursPerWeek",
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "maxHoursPerShift",
        "minHoursPerShift",
        "type"
      ]
    },
    "PermanentFlexibleHoursAndDaysPattern": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursAndDaysPattern"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "flexibleDetails": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "amountOfDays": {
                "type": "number"
              },
              "amountOfHours": {
                "type": "number"
              }
            },
            "required": [
              "amountOfDays",
              "amountOfHours"
            ]
          }
        }
      },
      "required": [
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "flexibleDetails",
        "type"
      ]
    },
    "PermanentFlexibleHoursFixedDaysPattern": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursFixedDaysPattern"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "details": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "day": {
                "$ref": "#/definitions/DayOfWeek"
              },
              "amountOfHours": {
                "type": "number"
              }
            },
            "required": [
              "amountOfHours",
              "day"
            ]
          }
        }
      },
      "required": [
        "details",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "PermanentFlexibleHoursFixedDaysPerWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursFixedDaysPerWeek"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "amountOfHoursPerWeek": {
          "type": "number"
        },
        "days": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "minHoursPerShift": {
          "type": "number"
        },
        "maxHoursPerShift": {
          "type": "number"
        }
      },
      "required": [
        "amountOfHoursPerWeek",
        "days",
        "excludedDaysFromCaregivers",
        "maxHoursPerShift",
        "minHoursPerShift",
        "type"
      ]
    },
    "PermanentFixedHoursFlexibleDays": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFixedHoursFlexibleDays"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "day": {
                "$ref": "#/definitions/DayOfWeek"
              },
              "startTime": {
                "$ref": "#/definitions/LocalTime"
              },
              "endTime": {
                "$ref": "#/definitions/LocalTime"
              }
            },
            "required": [
              "day",
              "endTime",
              "startTime"
            ]
          }
        },
        "amountOfDays": {
          "type": "number"
        }
      },
      "required": [
        "amountOfDays",
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "SingleFlexible": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SingleFlexible"
          ]
        },
        "date": {
          "$ref": "#/definitions/LocalDate"
        },
        "amountOfHours": {
          "type": "number"
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        }
      },
      "required": [
        "amountOfHours",
        "date",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "CaregiverVisitBroadcastEngagementDetails": {
      "type": "object",
      "properties": {
        "viewed": {
          "description": "Has the caregiver viewed this visit yet (or is it new)",
          "type": "boolean"
        },
        "requested": {
          "description": "Has the caregiver requested this visit",
          "type": "boolean"
        },
        "moreDetailsViewed": {
          "type": "boolean"
        },
        "flexibleVisitTimeRequest": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/CaregiverFlexibleVisitRequestParams"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "requestedInstances": {
          "description": "For multishift change.",
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/VisitInstanceId"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "rejectedInstances": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/VisitInstanceId"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "pendingConfirmationInstances": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/CaregiverPendingConfirmationInstance"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "pendingConfirmationUntil": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "pendingConfirmationConfirmedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "pendingConfirmationShifts": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/CaregiverFlexibleVisitRequestParams"
              }
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "flexibleVisitTimeRequest",
        "moreDetailsViewed",
        "rejectedInstances",
        "requested",
        "requestedInstances",
        "viewed"
      ]
    },
    "CaregiverFlexibleVisitRequestParams": {
      "type": "object",
      "properties": {
        "day": {
          "$ref": "#/definitions/DayOfWeek"
        },
        "startTime": {
          "$ref": "#/definitions/LocalTime"
        },
        "endTime": {
          "$ref": "#/definitions/LocalTime"
        }
      },
      "required": [
        "day",
        "endTime",
        "startTime"
      ]
    },
    "CaregiverPendingConfirmationInstance": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "startTime": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTime": {
          "$ref": "#/definitions/LocalDateTime"
        }
      },
      "required": [
        "endTime",
        "id",
        "startTime"
      ]
    },
    "CaregiverVisitBroadcastTypes.Onboarding": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Onboarding"
          ]
        },
        "id": {
          "$ref": "#/definitions/OnboardingVisitId"
        },
        "publicVisitBroadcastDetails": {
          "anyOf": [
            {
              "$ref": "#/definitions/PublicOnboardingVisitDetailsTypes.Pattern"
            },
            {
              "$ref": "#/definitions/PublicOnboardingVisitDetailsTypes.Singles"
            }
          ]
        },
        "caregiverVisitEngagementDetails": {
          "$ref": "#/definitions/CaregiverOnboardingVisitEngagementDetails"
        }
      },
      "required": [
        "caregiverVisitEngagementDetails",
        "id",
        "publicVisitBroadcastDetails",
        "type"
      ]
    },
    "OnboardingVisitId": {
      "type": "number"
    },
    "PublicOnboardingVisitDetailsTypes.Pattern": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Pattern"
          ]
        },
        "weeklyPattern": {
          "$ref": "#/definitions/BroadcastPattern"
        },
        "id": {
          "$ref": "#/definitions/OnboardingVisitId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "agency": {
          "$ref": "#/definitions/Agency"
        },
        "startTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "languages": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "generalNotes": {
          "type": "string"
        },
        "location": {
          "$ref": "#/definitions/AddressComponents"
        },
        "price": {
          "type": [
            "null",
            "number"
          ]
        },
        "timezone": {
          "description": "timezone from the tz database (IANA)",
          "type": "string"
        },
        "createdByFirstName": {
          "type": "string"
        },
        "createdByLastName": {
          "type": "string"
        },
        "visitLabels": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitLabelText"
          }
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientFirstName": {
          "type": "string"
        },
        "patientIsActive": {
          "type": "boolean"
        },
        "patientAge": {
          "type": [
            "null",
            "number"
          ]
        },
        "patientInitials": {
          "type": "string"
        },
        "patientGender": {
          "anyOf": [
            {
              "enum": [
                "F",
                "M"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientAllergies": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/Allergy"
          }
        },
        "patientMedicalNotes": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientLanguages": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientRequests": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientTasks": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "createdById": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "certifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverCertification"
          }
        },
        "hideEndDateFromCaregiver": {
          "type": "boolean"
        },
        "visitInstances": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "date": {
                "$ref": "#/definitions/VisitDatesParams"
              },
              "visitInstanceId": {
                "$ref": "#/definitions/OnboardingVisitInstanceId"
              }
            },
            "required": [
              "date",
              "visitInstanceId"
            ]
          }
        },
        "staffingPreferences": {
          "$ref": "#/definitions/VisitStaffingPreferences"
        },
        "patientAvailability": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/PatientVisitTimeFramesByDay"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "visitInfo": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "nearLocationDisplay": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "agency",
        "certifications",
        "createdAt",
        "createdByFirstName",
        "createdById",
        "createdByLastName",
        "endTimeLocal",
        "generalNotes",
        "hideEndDateFromCaregiver",
        "id",
        "languages",
        "location",
        "nearLocationDisplay",
        "patientAge",
        "patientAllergies",
        "patientAvailability",
        "patientFirstName",
        "patientGender",
        "patientId",
        "patientInitials",
        "patientIsActive",
        "patientLanguages",
        "patientMedicalNotes",
        "patientRequests",
        "patientTasks",
        "price",
        "staffingPreferences",
        "startTimeLocal",
        "timezone",
        "type",
        "visitInfo",
        "visitInstances",
        "visitLabels",
        "weeklyPattern"
      ]
    },
    "OnboardingVisitInstanceId": {
      "type": "number"
    },
    "PublicOnboardingVisitDetailsTypes.Singles": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Singles"
          ]
        },
        "id": {
          "$ref": "#/definitions/OnboardingVisitId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "agency": {
          "$ref": "#/definitions/Agency"
        },
        "startTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "languages": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "generalNotes": {
          "type": "string"
        },
        "location": {
          "$ref": "#/definitions/AddressComponents"
        },
        "price": {
          "type": [
            "null",
            "number"
          ]
        },
        "timezone": {
          "description": "timezone from the tz database (IANA)",
          "type": "string"
        },
        "createdByFirstName": {
          "type": "string"
        },
        "createdByLastName": {
          "type": "string"
        },
        "visitLabels": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitLabelText"
          }
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientFirstName": {
          "type": "string"
        },
        "patientIsActive": {
          "type": "boolean"
        },
        "patientAge": {
          "type": [
            "null",
            "number"
          ]
        },
        "patientInitials": {
          "type": "string"
        },
        "patientGender": {
          "anyOf": [
            {
              "enum": [
                "F",
                "M"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientAllergies": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/Allergy"
          }
        },
        "patientMedicalNotes": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientLanguages": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientRequests": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientTasks": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "createdById": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "certifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverCertification"
          }
        },
        "hideEndDateFromCaregiver": {
          "type": "boolean"
        },
        "visitInstances": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "date": {
                "$ref": "#/definitions/VisitDatesParams"
              },
              "visitInstanceId": {
                "$ref": "#/definitions/OnboardingVisitInstanceId"
              }
            },
            "required": [
              "date",
              "visitInstanceId"
            ]
          }
        },
        "staffingPreferences": {
          "$ref": "#/definitions/VisitStaffingPreferences"
        },
        "patientAvailability": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/PatientVisitTimeFramesByDay"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "visitInfo": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "nearLocationDisplay": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "agency",
        "certifications",
        "createdAt",
        "createdByFirstName",
        "createdById",
        "createdByLastName",
        "endTimeLocal",
        "generalNotes",
        "hideEndDateFromCaregiver",
        "id",
        "languages",
        "location",
        "nearLocationDisplay",
        "patientAge",
        "patientAllergies",
        "patientAvailability",
        "patientFirstName",
        "patientGender",
        "patientId",
        "patientInitials",
        "patientIsActive",
        "patientLanguages",
        "patientMedicalNotes",
        "patientRequests",
        "patientTasks",
        "price",
        "staffingPreferences",
        "startTimeLocal",
        "timezone",
        "type",
        "visitInfo",
        "visitInstances",
        "visitLabels"
      ]
    },
    "CaregiverOnboardingVisitEngagementDetails": {
      "type": "object",
      "properties": {
        "viewed": {
          "description": "Has the caregiver viewed this visit yet (or is it new)",
          "type": "boolean"
        },
        "requested": {
          "description": "Has the caregiver requested this visit",
          "type": "boolean"
        },
        "moreDetailsViewed": {
          "type": "boolean"
        },
        "requestedInstances": {
          "description": "For multishift change.",
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/OnboardingVisitInstanceId"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "rejectedInstances": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/OnboardingVisitInstanceId"
              }
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "moreDetailsViewed",
        "rejectedInstances",
        "requested",
        "requestedInstances",
        "viewed"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["ScheduledVisitEditRequestParams",
{
  "anyOf": [
    {
      "$ref": "#/definitions/ScheduledVisitEditRequestParams.Cancel"
    },
    {
      "$ref": "#/definitions/ScheduledVisitEditRequestParams.Reschedule"
    }
  ],
  "definitions": {
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "ScheduledVisitEditRequestParams.Cancel": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CANCEL"
          ]
        },
        "message": {
          "type": "string"
        }
      },
      "required": [
        "message",
        "type"
      ]
    },
    "ScheduledVisitEditRequestParams.Reschedule": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "RESCHEDULE"
          ]
        },
        "startTime": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTime": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "message": {
          "type": "string"
        }
      },
      "required": [
        "endTime",
        "message",
        "startTime",
        "type"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["DutySheetListForDay",
{
  "type": "object",
  "properties": {
    "list": {
      "anyOf": [
        {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DutySheetItem"
          }
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "list"
  ],
  "definitions": {
    "DutySheetItem": {
      "type": "object",
      "properties": {
        "item": {
          "$ref": "#/definitions/POCItem"
        },
        "asRequestedByPatient": {
          "type": "boolean"
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        },
        "completed": {
          "anyOf": [
            {
              "$ref": "#/definitions/DutySheetItemAnswer"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "asRequestedByPatient",
        "completed",
        "item",
        "notes"
      ]
    },
    "POCItem": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/PlanOfCareItemId"
        },
        "label": {
          "type": "string"
        },
        "section": {
          "type": "string"
        },
        "code": {
          "type": "string"
        },
        "type": {
          "$ref": "#/definitions/POCAnswerType"
        },
        "orderInSection": {
          "type": "number"
        }
      },
      "required": [
        "code",
        "id",
        "label",
        "orderInSection",
        "section",
        "type"
      ]
    },
    "PlanOfCareItemId": {
      "type": "number"
    },
    "POCAnswerType": {
      "enum": [
        "Attribute",
        "Predefined",
        "Task"
      ],
      "type": "string"
    },
    "DutySheetItemAnswer": {
      "type": "object",
      "properties": {
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "notes"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PassportDocumentCreateResponse",
{
  "type": "object",
  "properties": {
    "id": {
      "$ref": "#/definitions/CaregiverDocumentUploadId"
    }
  },
  "required": [
    "id"
  ],
  "definitions": {
    "CaregiverDocumentUploadId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PlanOfCareResponse",
{
  "type": "object",
  "properties": {
    "planOfCareWithAnswers": {
      "anyOf": [
        {
          "$ref": "#/definitions/PlanOfCareWithAnswers"
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "planOfCareWithAnswers"
  ],
  "definitions": {
    "PlanOfCareWithAnswers": {
      "type": "object",
      "properties": {
        "poc": {
          "$ref": "#/definitions/PlanOfCare"
        },
        "planOfCareType": {
          "type": "object",
          "properties": {
            "showPatientSignature": {
              "type": "boolean"
            }
          },
          "required": [
            "showPatientSignature"
          ]
        },
        "docItems": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientDocumentContentItem"
          }
        },
        "planOfCareItems": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/POCItem"
          }
        },
        "patientUnsignedReason": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "docItems",
        "planOfCareItems",
        "planOfCareType",
        "poc"
      ]
    },
    "PlanOfCare": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/PlanOfCareId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "createdBy": {
          "$ref": "#/definitions/CaregiverId"
        },
        "patientSignature": {
          "anyOf": [
            {
              "$ref": "#/definitions/PlanOfCareSignature"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientUnsignedReason": {
          "type": [
            "null",
            "string"
          ]
        },
        "caregiverSignature": {
          "anyOf": [
            {
              "$ref": "#/definitions/PlanOfCareSignature"
            },
            {
              "type": "null"
            }
          ]
        },
        "submittedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "caregiverSignature",
        "createdAt",
        "createdBy",
        "id",
        "patientSignature",
        "submittedAt"
      ]
    },
    "PlanOfCareId": {
      "type": "number"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "CaregiverId": {
      "type": "number"
    },
    "PlanOfCareSignature": {
      "type": "object",
      "properties": {
        "data": {
          "type": "string"
        },
        "signedAt": {
          "$ref": "#/definitions/Instant"
        },
        "unsignedResaon": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "data",
        "signedAt"
      ]
    },
    "PatientDocumentContentItem": {
      "type": "object",
      "properties": {
        "id": {
          "type": "number"
        },
        "mainClass": {
          "type": "string"
        },
        "title": {
          "type": "string"
        },
        "itemType": {
          "$ref": "#/definitions/DocumentItemQuestionType"
        },
        "label": {
          "type": "string"
        },
        "columns": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "array",
                "items": {
                  "$ref": "#/definitions/PatientDocumentContentItem"
                }
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "POCItems": {
          "description": "Used only for document question type \"POC\"",
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientDocumentPOCItem"
          }
        },
        "isRequired": {
          "type": "boolean"
        },
        "parentId": {
          "type": [
            "null",
            "number"
          ]
        },
        "showIfParentEquals": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "ifParentEquals": {
          "type": "string"
        },
        "showOtherOption": {
          "type": "boolean"
        },
        "html": {
          "type": "string"
        },
        "url": {
          "type": [
            "null",
            "string"
          ]
        },
        "days": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "frequencyPerWeek": {
          "type": "number"
        },
        "visitPerWeek": {
          "type": "number"
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentType": {
          "anyOf": [
            {
              "enum": [
                "POC",
                "bigHeader",
                "bloodPressure",
                "bodyDrawing",
                "chart",
                "check",
                "customSignature",
                "date",
                "dropDown",
                "editor",
                "employeeSignature",
                "icd",
                "icdChart",
                "icdCodes",
                "image",
                "medicationProfile",
                "medicationProfileItem",
                "number",
                "patientPhysician",
                "patientSignature",
                "radio",
                "smallHeader",
                "textLong",
                "textShort",
                "time",
                "yesNo"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "cms485QuestionId": {
          "type": "string"
        },
        "oca960questionId": {
          "type": "string"
        },
        "prefilledAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerValues": {
          "type": "array",
          "items": {
            "type": "number"
          }
        },
        "valueGroup": {
          "type": [
            "null",
            "string"
          ]
        },
        "isInValueGroup": {
          "type": "boolean"
        },
        "copyFromOtherDocs": {
          "type": "boolean"
        },
        "allowUnsignedSignature": {
          "type": "boolean"
        },
        "hideNameFieldSignature": {
          "type": "boolean"
        },
        "useForMedication": {
          "type": "boolean"
        },
        "canCopyFromMedication": {
          "type": "boolean"
        },
        "useForDisciplinAndTreatment": {
          "type": "boolean"
        },
        "canCopyFromDisciplinAndTreatment": {
          "type": "boolean"
        },
        "isIcd": {
          "type": "boolean"
        },
        "nursingQuestionLinked": {
          "type": "number"
        },
        "patientMedicationDetails": {
          "$ref": "#/definitions/PatientMedicationProfileWithDetails"
        },
        "vitalMeasuredAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "vitalMethod": {
          "anyOf": [
            {
              "enum": [
                "Axillary",
                "Irregular",
                "Laying",
                "Left Arm",
                "Oral",
                "Rectal",
                "Regular",
                "Remote/Forehead",
                "Right Arm",
                "Sitting",
                "Standing"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "vitalComments": {
          "type": [
            "null",
            "string"
          ]
        },
        "vitalUnit": {
          "anyOf": [
            {
              "enum": [
                "Beats Per Minute",
                "Breaths Per Minute",
                "FAHRENHEIT",
                "mmHg"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "blockOnMobile": {
          "type": "boolean"
        },
        "isVital": {
          "type": "boolean"
        }
      },
      "required": [
        "id",
        "itemType",
        "label",
        "mainClass",
        "parentId",
        "showIfParentEquals",
        "title"
      ]
    },
    "DocumentItemQuestionType": {
      "type": "string"
    },
    "PatientDocumentPOCItem": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "isTitle": {
          "type": "boolean"
        }
      },
      "required": [
        "isTitle",
        "name"
      ]
    },
    "DayOfWeek": {
      "type": "string",
      "xreviver": "JSJoda.DayOfWeek"
    },
    "PatientMedicationProfileWithDetails": {
      "type": "object",
      "properties": {
        "dose": {
          "type": "string"
        },
        "route": {
          "type": "string"
        },
        "medicationName": {
          "type": "string"
        },
        "id": {
          "$ref": "#/definitions/PatientMedicationProfileId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "medicationId": {
          "$ref": "#/definitions/MedicationId"
        },
        "from": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "until": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "frequency": {
          "type": [
            "null",
            "string"
          ]
        },
        "status": {
          "$ref": "#/definitions/PatientMedicationProfileStatus"
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "dose",
        "frequency",
        "from",
        "id",
        "medicationId",
        "medicationName",
        "notes",
        "patientId",
        "route",
        "status",
        "until"
      ]
    },
    "PatientMedicationProfileId": {
      "type": "number"
    },
    "PatientId": {
      "type": "number"
    },
    "MedicationId": {
      "type": "number"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "PatientMedicationProfileStatus": {
      "enum": [
        "ACTIVE",
        "DISCONTINUED"
      ],
      "type": "string"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "POCItem": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/PlanOfCareItemId"
        },
        "label": {
          "type": "string"
        },
        "section": {
          "type": "string"
        },
        "code": {
          "type": "string"
        },
        "type": {
          "$ref": "#/definitions/POCAnswerType"
        },
        "orderInSection": {
          "type": "number"
        }
      },
      "required": [
        "code",
        "id",
        "label",
        "orderInSection",
        "section",
        "type"
      ]
    },
    "PlanOfCareItemId": {
      "type": "number"
    },
    "POCAnswerType": {
      "enum": [
        "Attribute",
        "Predefined",
        "Task"
      ],
      "type": "string"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["NullablePromoPopover",
{
  "type": "object",
  "properties": {
    "popover": {
      "anyOf": [
        {
          "$ref": "#/definitions/PromoHTMLPopover"
        },
        {
          "$ref": "#/definitions/PromoComponentPopover"
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "popover"
  ],
  "definitions": {
    "PromoHTMLPopover": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "HTML"
          ]
        },
        "localStorageKey": {
          "type": "string"
        },
        "maxDisplayAmount": {
          "type": "number"
        },
        "htmlContent": {
          "type": "string"
        }
      },
      "required": [
        "htmlContent",
        "localStorageKey",
        "maxDisplayAmount",
        "type"
      ]
    },
    "PromoComponentPopover": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "COMPONENT"
          ]
        },
        "localStorageKey": {
          "type": "string"
        },
        "maxDisplayAmount": {
          "type": "number"
        },
        "component": {
          "type": "string"
        }
      },
      "required": [
        "component",
        "localStorageKey",
        "maxDisplayAmount",
        "type"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["Any",
{
  "type": "object",
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverPatientDocumentResponse",
{
  "type": "object",
  "properties": {
    "documents": {
      "type": "array",
      "items": {
        "anyOf": [
          {
            "$ref": "#/definitions/CaregiverPatientDocument.Unanswered"
          },
          {
            "$ref": "#/definitions/CaregiverPatientDocument.Answered"
          },
          {
            "$ref": "#/definitions/CaregiverPatientDocument.Scanned"
          },
          {
            "$ref": "#/definitions/CaregiverPatientDocument.ManualSubmission"
          }
        ]
      }
    },
    "freeScans": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverPatientDocument.FreeScan"
      }
    }
  },
  "required": [
    "documents",
    "freeScans"
  ],
  "definitions": {
    "CaregiverPatientDocument.Unanswered": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Unanswered"
          ]
        },
        "visitInstanceId": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "documentTypeId": {
          "$ref": "#/definitions/PatientDocumentTypeId"
        },
        "title": {
          "type": "string"
        },
        "versionId": {
          "$ref": "#/definitions/PatientDocumentVersionId"
        },
        "content": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientDocumentContentItem"
          }
        },
        "isScannable": {
          "type": "boolean"
        }
      },
      "required": [
        "content",
        "documentTypeId",
        "isScannable",
        "title",
        "type",
        "versionId",
        "visitInstanceId"
      ]
    },
    "VisitInstanceId": {
      "type": "number"
    },
    "PatientDocumentTypeId": {
      "type": "number"
    },
    "PatientDocumentVersionId": {
      "type": "number"
    },
    "PatientDocumentContentItem": {
      "type": "object",
      "properties": {
        "id": {
          "type": "number"
        },
        "mainClass": {
          "type": "string"
        },
        "title": {
          "type": "string"
        },
        "itemType": {
          "$ref": "#/definitions/DocumentItemQuestionType"
        },
        "label": {
          "type": "string"
        },
        "columns": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "array",
                "items": {
                  "$ref": "#/definitions/PatientDocumentContentItem"
                }
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "POCItems": {
          "description": "Used only for document question type \"POC\"",
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientDocumentPOCItem"
          }
        },
        "isRequired": {
          "type": "boolean"
        },
        "parentId": {
          "type": [
            "null",
            "number"
          ]
        },
        "showIfParentEquals": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "ifParentEquals": {
          "type": "string"
        },
        "showOtherOption": {
          "type": "boolean"
        },
        "html": {
          "type": "string"
        },
        "url": {
          "type": [
            "null",
            "string"
          ]
        },
        "days": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "frequencyPerWeek": {
          "type": "number"
        },
        "visitPerWeek": {
          "type": "number"
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentType": {
          "anyOf": [
            {
              "enum": [
                "POC",
                "bigHeader",
                "bloodPressure",
                "bodyDrawing",
                "chart",
                "check",
                "customSignature",
                "date",
                "dropDown",
                "editor",
                "employeeSignature",
                "icd",
                "icdChart",
                "icdCodes",
                "image",
                "medicationProfile",
                "medicationProfileItem",
                "number",
                "patientPhysician",
                "patientSignature",
                "radio",
                "smallHeader",
                "textLong",
                "textShort",
                "time",
                "yesNo"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "cms485QuestionId": {
          "type": "string"
        },
        "oca960questionId": {
          "type": "string"
        },
        "prefilledAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerValues": {
          "type": "array",
          "items": {
            "type": "number"
          }
        },
        "valueGroup": {
          "type": [
            "null",
            "string"
          ]
        },
        "isInValueGroup": {
          "type": "boolean"
        },
        "copyFromOtherDocs": {
          "type": "boolean"
        },
        "allowUnsignedSignature": {
          "type": "boolean"
        },
        "hideNameFieldSignature": {
          "type": "boolean"
        },
        "useForMedication": {
          "type": "boolean"
        },
        "canCopyFromMedication": {
          "type": "boolean"
        },
        "useForDisciplinAndTreatment": {
          "type": "boolean"
        },
        "canCopyFromDisciplinAndTreatment": {
          "type": "boolean"
        },
        "isIcd": {
          "type": "boolean"
        },
        "nursingQuestionLinked": {
          "type": "number"
        },
        "patientMedicationDetails": {
          "$ref": "#/definitions/PatientMedicationProfileWithDetails"
        },
        "vitalMeasuredAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "vitalMethod": {
          "anyOf": [
            {
              "enum": [
                "Axillary",
                "Irregular",
                "Laying",
                "Left Arm",
                "Oral",
                "Rectal",
                "Regular",
                "Remote/Forehead",
                "Right Arm",
                "Sitting",
                "Standing"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "vitalComments": {
          "type": [
            "null",
            "string"
          ]
        },
        "vitalUnit": {
          "anyOf": [
            {
              "enum": [
                "Beats Per Minute",
                "Breaths Per Minute",
                "FAHRENHEIT",
                "mmHg"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "blockOnMobile": {
          "type": "boolean"
        },
        "isVital": {
          "type": "boolean"
        }
      },
      "required": [
        "id",
        "itemType",
        "label",
        "mainClass",
        "parentId",
        "showIfParentEquals",
        "title"
      ]
    },
    "DocumentItemQuestionType": {
      "type": "string"
    },
    "PatientDocumentPOCItem": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "isTitle": {
          "type": "boolean"
        }
      },
      "required": [
        "isTitle",
        "name"
      ]
    },
    "DayOfWeek": {
      "type": "string",
      "xreviver": "JSJoda.DayOfWeek"
    },
    "PatientMedicationProfileWithDetails": {
      "type": "object",
      "properties": {
        "dose": {
          "type": "string"
        },
        "route": {
          "type": "string"
        },
        "medicationName": {
          "type": "string"
        },
        "id": {
          "$ref": "#/definitions/PatientMedicationProfileId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "medicationId": {
          "$ref": "#/definitions/MedicationId"
        },
        "from": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "until": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "frequency": {
          "type": [
            "null",
            "string"
          ]
        },
        "status": {
          "$ref": "#/definitions/PatientMedicationProfileStatus"
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "dose",
        "frequency",
        "from",
        "id",
        "medicationId",
        "medicationName",
        "notes",
        "patientId",
        "route",
        "status",
        "until"
      ]
    },
    "PatientMedicationProfileId": {
      "type": "number"
    },
    "PatientId": {
      "type": "number"
    },
    "MedicationId": {
      "type": "number"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "PatientMedicationProfileStatus": {
      "enum": [
        "ACTIVE",
        "DISCONTINUED"
      ],
      "type": "string"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "CaregiverPatientDocument.Answered": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Answered"
          ]
        },
        "id": {
          "$ref": "#/definitions/PatientDocumentScheduleId"
        },
        "visitInstanceId": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "documentTypeId": {
          "$ref": "#/definitions/PatientDocumentTypeId"
        },
        "title": {
          "type": "string"
        },
        "versionId": {
          "$ref": "#/definitions/PatientDocumentVersionId"
        },
        "content": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientDocumentContentItem"
          }
        },
        "answers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientDocumentAnswerObject"
          }
        },
        "submittedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "isScannable": {
          "type": "boolean"
        }
      },
      "required": [
        "answers",
        "content",
        "documentTypeId",
        "id",
        "isScannable",
        "submittedAt",
        "title",
        "type",
        "versionId",
        "visitInstanceId"
      ]
    },
    "PatientDocumentScheduleId": {
      "type": "number"
    },
    "PatientDocumentAnswerObject": {
      "type": "object",
      "properties": {
        "questionId": {
          "type": "number"
        },
        "chartRow": {
          "type": [
            "null",
            "number"
          ]
        },
        "answer": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/PatientContractDiagnosisCode"
              }
            },
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/POCItemsDocumentAnswer"
              }
            },
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/PatientMedicationProfileWithDetails"
              }
            },
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "answeredAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "answer",
        "answeredAt",
        "chartRow",
        "questionId"
      ]
    },
    "PatientContractDiagnosisCode": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/PatientContractDiagnosisCodeId"
        },
        "icdCode": {
          "$ref": "#/definitions/ICD10CodeId"
        },
        "formattedDxCode": {
          "type": "string"
        },
        "shortDesc": {
          "type": "string"
        },
        "patientContractId": {
          "$ref": "#/definitions/PatientContractId"
        },
        "startDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "endDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "type": {
          "anyOf": [
            {
              "enum": [
                "PRINCIPAL",
                "SURGICAL"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "isForBilling": {
          "type": "boolean"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "createdBy": {
          "$ref": "#/definitions/UserId"
        },
        "updatedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "updatedBy": {
          "anyOf": [
            {
              "$ref": "#/definitions/UserId"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "createdAt",
        "createdBy",
        "endDate",
        "formattedDxCode",
        "icdCode",
        "id",
        "isForBilling",
        "patientContractId",
        "shortDesc",
        "startDate",
        "type",
        "updatedAt",
        "updatedBy"
      ]
    },
    "PatientContractDiagnosisCodeId": {
      "type": "number"
    },
    "ICD10CodeId": {
      "type": "number"
    },
    "PatientContractId": {
      "type": "number"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "UserId": {
      "type": "number"
    },
    "POCItemsDocumentAnswer": {
      "type": "object",
      "properties": {
        "idx": {
          "type": "number"
        },
        "attributes": {
          "anyOf": [
            {
              "$ref": "#/definitions/TaskWhenToPerform.EveryVisit"
            },
            {
              "$ref": "#/definitions/TaskWhenToPerform.OnDaysOfWeek"
            },
            {
              "$ref": "#/definitions/TaskWhenToPerform.AsRequestedByPatient"
            }
          ]
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "attributes",
        "idx"
      ]
    },
    "TaskWhenToPerform.EveryVisit": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "EveryVisit"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TaskWhenToPerform.OnDaysOfWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "OnDaysOfWeek"
          ]
        },
        "frequency": {
          "$ref": "#/definitions/FrequencyVisitedInAWeekDetails"
        },
        "days": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        }
      },
      "required": [
        "type"
      ]
    },
    "FrequencyVisitedInAWeekDetails": {
      "type": "object",
      "properties": {
        "frequency": {
          "type": [
            "null",
            "number"
          ]
        },
        "visitsInAWeek": {
          "type": [
            "null",
            "number"
          ]
        }
      },
      "required": [
        "frequency",
        "visitsInAWeek"
      ]
    },
    "TaskWhenToPerform.AsRequestedByPatient": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AsRequestedByPatient"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "CaregiverPatientDocument.Scanned": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Scanned"
          ]
        },
        "id": {
          "$ref": "#/definitions/PatientDocumentScheduleId"
        },
        "visitInstanceId": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "documentTypeId": {
          "$ref": "#/definitions/PatientDocumentTypeId"
        },
        "title": {
          "type": "string"
        },
        "pdfUrl": {
          "type": "string"
        },
        "submittedAt": {
          "$ref": "#/definitions/Instant"
        },
        "isScannable": {
          "type": "boolean",
          "enum": [
            true
          ]
        }
      },
      "required": [
        "documentTypeId",
        "id",
        "isScannable",
        "pdfUrl",
        "submittedAt",
        "title",
        "type",
        "visitInstanceId"
      ]
    },
    "CaregiverPatientDocument.ManualSubmission": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "ManualSubmission"
          ]
        },
        "id": {
          "$ref": "#/definitions/PatientDocumentScheduleId"
        },
        "visitInstanceId": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "documentTypeId": {
          "$ref": "#/definitions/PatientDocumentTypeId"
        },
        "title": {
          "type": "string"
        },
        "versionId": {
          "$ref": "#/definitions/PatientDocumentVersionId"
        },
        "content": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientDocumentContentItem"
          }
        },
        "pdfUrl": {
          "type": "string",
          "enum": [
            "MANUAL_SUBMISSION_STRING"
          ]
        },
        "submittedAt": {
          "$ref": "#/definitions/Instant"
        },
        "isScannable": {
          "type": "boolean",
          "enum": [
            false
          ]
        }
      },
      "required": [
        "content",
        "documentTypeId",
        "id",
        "isScannable",
        "pdfUrl",
        "submittedAt",
        "title",
        "type",
        "versionId",
        "visitInstanceId"
      ]
    },
    "CaregiverPatientDocument.FreeScan": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "FreeScan"
          ]
        },
        "id": {
          "$ref": "#/definitions/PatientDocumentScheduleId"
        },
        "visitInstanceId": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "title": {
          "type": "string"
        },
        "pdfUrl": {
          "type": "string"
        },
        "submittedAt": {
          "$ref": "#/definitions/Instant"
        },
        "isScannable": {
          "type": "boolean",
          "enum": [
            false
          ]
        }
      },
      "required": [
        "id",
        "isScannable",
        "pdfUrl",
        "submittedAt",
        "title",
        "type",
        "visitInstanceId"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["BankAccountNamesResponse",
{
  "type": "object",
  "properties": {
    "banks": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/BankAccountName"
      }
    }
  },
  "required": [
    "banks"
  ],
  "definitions": {
    "BankAccountName": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/InstaPayBankId"
        },
        "name": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name"
      ]
    },
    "InstaPayBankId": {
      "format": "InstaPayBankId",
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverPatientsResponse",
{
  "type": "object",
  "properties": {
    "patients": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverPatientResponse"
      }
    }
  },
  "required": [
    "patients"
  ],
  "definitions": {
    "CaregiverPatientResponse": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/PatientId"
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "firstName": {
          "type": "string"
        },
        "lastName": {
          "type": "string"
        },
        "ssn": {
          "type": [
            "null",
            "string"
          ]
        },
        "gender": {
          "type": [
            "null",
            "string"
          ]
        },
        "address": {
          "type": [
            "null",
            "string"
          ]
        },
        "address2": {
          "type": [
            "null",
            "string"
          ]
        },
        "addressComponents": {
          "anyOf": [
            {
              "$ref": "#/definitions/AddressComponents"
            },
            {
              "type": "null"
            }
          ]
        },
        "dateOfBirth": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "homePhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobilePhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "phone3": {
          "type": [
            "null",
            "string"
          ]
        },
        "phone4": {
          "type": [
            "null",
            "string"
          ]
        },
        "generalNotes": {
          "type": [
            "null",
            "string"
          ]
        },
        "medicalNotes": {
          "type": [
            "null",
            "string"
          ]
        },
        "priorityCode": {
          "type": [
            "null",
            "number"
          ]
        },
        "mobilityStatus": {
          "type": [
            "null",
            "string"
          ]
        },
        "evacuationLocation": {
          "type": [
            "null",
            "string"
          ]
        },
        "evacuationZone": {
          "type": [
            "null",
            "string"
          ]
        },
        "electricEquipmentDependency": {
          "type": [
            "null",
            "string"
          ]
        },
        "latestVitals": {
          "$ref": "#/definitions/CaregiverPatientLatestVitals"
        },
        "emergencyContact": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/PatientEmergencyContact"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "advancedDirectives": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientAdvancedDirective"
            },
            {
              "type": "null"
            }
          ]
        },
        "medications": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/PatientMedicationProfileWithDetails"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "allergies": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/Allergy"
              }
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "address",
        "address2",
        "addressComponents",
        "advancedDirectives",
        "agencyId",
        "allergies",
        "dateOfBirth",
        "electricEquipmentDependency",
        "emergencyContact",
        "evacuationLocation",
        "evacuationZone",
        "firstName",
        "gender",
        "generalNotes",
        "homePhoneNumber",
        "id",
        "lastName",
        "latestVitals",
        "medicalNotes",
        "medications",
        "mobilePhoneNumber",
        "mobilityStatus",
        "phone3",
        "phone4",
        "priorityCode",
        "ssn"
      ]
    },
    "PatientId": {
      "type": "number"
    },
    "AgencyId": {
      "type": "number"
    },
    "AddressComponents": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "country": {
          "type": "string"
        },
        "administrativeAreaLevel1": {
          "type": "string"
        },
        "administrativeAreaLevel2": {
          "type": "string"
        },
        "sublocalityLevel1": {
          "type": [
            "null",
            "string"
          ]
        },
        "neighborhood": {
          "type": [
            "null",
            "string"
          ]
        },
        "locality": {
          "type": [
            "null",
            "string"
          ]
        },
        "formatedAddressDetails": {
          "$ref": "#/definitions/FormatedAddressDetails"
        }
      },
      "required": [
        "administrativeAreaLevel1",
        "administrativeAreaLevel2",
        "country",
        "location"
      ]
    },
    "Geo": {
      "type": "object",
      "properties": {
        "lat": {
          "type": "number"
        },
        "lng": {
          "type": "number"
        }
      },
      "required": [
        "lat",
        "lng"
      ]
    },
    "FormatedAddressDetails": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "address1": {
          "type": "string"
        },
        "country": {
          "type": "string"
        },
        "state": {
          "type": "string"
        },
        "county": {
          "type": "string"
        },
        "fullAddress": {
          "type": "string"
        },
        "city": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip5": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip4": {
          "type": [
            "null",
            "string"
          ]
        },
        "street": {
          "type": [
            "null",
            "string"
          ]
        },
        "streetNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "crossStreet": {
          "type": [
            "null",
            "string"
          ]
        },
        "address2": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "address1",
        "country",
        "county",
        "fullAddress",
        "location",
        "state"
      ]
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "CaregiverPatientLatestVitals": {
      "type": "object",
      "properties": {
        "bloodPressure": {
          "anyOf": [
            {
              "$ref": "#/definitions/VitalExtraDetailsWithAnswer"
            },
            {
              "type": "null"
            }
          ]
        },
        "pulseRate": {
          "anyOf": [
            {
              "$ref": "#/definitions/VitalExtraDetailsWithAnswer"
            },
            {
              "type": "null"
            }
          ]
        },
        "respirationRate": {
          "anyOf": [
            {
              "$ref": "#/definitions/VitalExtraDetailsWithAnswer"
            },
            {
              "type": "null"
            }
          ]
        },
        "bodyTemperature": {
          "anyOf": [
            {
              "$ref": "#/definitions/VitalExtraDetailsWithAnswer"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "bloodPressure",
        "bodyTemperature",
        "pulseRate",
        "respirationRate"
      ]
    },
    "VitalExtraDetailsWithAnswer": {
      "type": "object",
      "properties": {
        "answer": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "measuredAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "method": {
          "anyOf": [
            {
              "enum": [
                "Axillary",
                "Irregular",
                "Laying",
                "Left Arm",
                "Oral",
                "Rectal",
                "Regular",
                "Remote/Forehead",
                "Right Arm",
                "Sitting",
                "Standing"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "comments": {
          "type": [
            "null",
            "string"
          ]
        },
        "unit": {
          "anyOf": [
            {
              "enum": [
                "Beats Per Minute",
                "Breaths Per Minute",
                "FAHRENHEIT",
                "mmHg"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "answer",
        "comments",
        "measuredAt",
        "method",
        "unit"
      ]
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "PatientEmergencyContact": {
      "type": "object",
      "properties": {
        "firstName": {
          "type": "string"
        },
        "lastName": {
          "type": "string"
        },
        "relationship": {
          "type": "string"
        },
        "livesWithPatient": {
          "type": "boolean"
        },
        "emergencyPhoneNumber1": {
          "type": "string"
        },
        "emergencyPhoneNumber2": {
          "type": "string"
        },
        "address": {
          "type": "string"
        }
      },
      "required": [
        "address",
        "emergencyPhoneNumber1",
        "emergencyPhoneNumber2",
        "firstName",
        "lastName",
        "livesWithPatient",
        "relationship"
      ]
    },
    "PatientAdvancedDirective": {
      "type": "object",
      "properties": {
        "hasDNR": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "hasProxy": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "firstName": {
          "type": [
            "null",
            "string"
          ]
        },
        "lastName": {
          "type": [
            "null",
            "string"
          ]
        },
        "phoneNumber": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "firstName",
        "hasDNR",
        "hasProxy",
        "lastName",
        "phoneNumber"
      ]
    },
    "PatientMedicationProfileWithDetails": {
      "type": "object",
      "properties": {
        "dose": {
          "type": "string"
        },
        "route": {
          "type": "string"
        },
        "medicationName": {
          "type": "string"
        },
        "id": {
          "$ref": "#/definitions/PatientMedicationProfileId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "medicationId": {
          "$ref": "#/definitions/MedicationId"
        },
        "from": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "until": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "frequency": {
          "type": [
            "null",
            "string"
          ]
        },
        "status": {
          "$ref": "#/definitions/PatientMedicationProfileStatus"
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "dose",
        "frequency",
        "from",
        "id",
        "medicationId",
        "medicationName",
        "notes",
        "patientId",
        "route",
        "status",
        "until"
      ]
    },
    "PatientMedicationProfileId": {
      "type": "number"
    },
    "MedicationId": {
      "type": "number"
    },
    "PatientMedicationProfileStatus": {
      "enum": [
        "ACTIVE",
        "DISCONTINUED"
      ],
      "type": "string"
    },
    "Allergy": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AllergyId"
        },
        "name": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name"
      ]
    },
    "AllergyId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["AgencyDocuments",
{
  "type": "object",
  "properties": {
    "documents": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/AgencyDocument"
      }
    }
  },
  "required": [
    "documents"
  ],
  "definitions": {
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "AgencyDocument": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CaregiverDocumentUploadId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        },
        "fileUrl": {
          "type": "string"
        },
        "docTypeId": {
          "$ref": "#/definitions/CaregiverDocumentTypeId"
        },
        "expiryDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "removedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "caregiverId",
        "createdAt",
        "docTypeId",
        "expiryDate",
        "fileUrl",
        "id",
        "removedAt"
      ]
    },
    "CaregiverDocumentUploadId": {
      "type": "number"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "CaregiverId": {
      "type": "number"
    },
    "CaregiverDocumentTypeId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["AgencyDocumentType",
{
  "type": "object",
  "properties": {
    "id": {
      "$ref": "#/definitions/CaregiverDocumentTypeId"
    },
    "isExpires": {
      "type": "boolean"
    },
    "documentName": {
      "$ref": "#/definitions/TranslationMapping<string>"
    },
    "createdAt": {
      "$ref": "#/definitions/Instant"
    },
    "removedAt": {
      "anyOf": [
        {
          "$ref": "#/definitions/Instant"
        },
        {
          "type": "null"
        }
      ]
    },
    "expiryDays": {
      "type": [
        "null",
        "number"
      ]
    },
    "passportCategoryType": {
      "type": "string",
      "enum": [
        "AGENCY_CATEGORY"
      ]
    }
  },
  "required": [
    "createdAt",
    "documentName",
    "expiryDays",
    "id",
    "isExpires",
    "passportCategoryType",
    "removedAt"
  ],
  "definitions": {
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "CaregiverDocumentTypeId": {
      "type": "number"
    },
    "TranslationMapping<string>": {
      "type": "object",
      "properties": {
        "Albanian": {
          "type": "string"
        },
        "Arabic": {
          "type": "string"
        },
        "Armenian": {
          "type": "string"
        },
        "Bengali": {
          "type": "string"
        },
        "Bulgarian": {
          "type": "string"
        },
        "Cantonese": {
          "type": "string"
        },
        "Chinese": {
          "type": "string"
        },
        "Creole": {
          "type": "string"
        },
        "Danish": {
          "type": "string"
        },
        "Dutch": {
          "type": "string"
        },
        "English": {
          "type": "string"
        },
        "Estonian": {
          "type": "string"
        },
        "Farsi": {
          "type": "string"
        },
        "Filipino": {
          "type": "string"
        },
        "French": {
          "type": "string"
        },
        "Fukkianese": {
          "type": "string"
        },
        "Fula/Fulani": {
          "type": "string"
        },
        "Fuzhounese": {
          "type": "string"
        },
        "Georgian": {
          "type": "string"
        },
        "German": {
          "type": "string"
        },
        "Ghana": {
          "type": "string"
        },
        "Greek": {
          "type": "string"
        },
        "Hakka": {
          "type": "string"
        },
        "Hebrew": {
          "type": "string"
        },
        "Hindi": {
          "type": "string"
        },
        "Hungarian": {
          "type": "string"
        },
        "Italian": {
          "type": "string"
        },
        "Japanese": {
          "type": "string"
        },
        "Korean": {
          "type": "string"
        },
        "Krio": {
          "type": "string"
        },
        "Kyrgyz": {
          "type": "string"
        },
        "Mandarin": {
          "type": "string"
        },
        "Pashto": {
          "type": "string"
        },
        "Persian": {
          "type": "string"
        },
        "Polish": {
          "type": "string"
        },
        "Portuguese": {
          "type": "string"
        },
        "Punjabi": {
          "type": "string"
        },
        "Romanian": {
          "type": "string"
        },
        "Russian": {
          "type": "string"
        },
        "Shanghainese": {
          "type": "string"
        },
        "Soninke": {
          "type": "string"
        },
        "Spanish": {
          "type": "string"
        },
        "Swahili": {
          "type": "string"
        },
        "Tagalog": {
          "type": "string"
        },
        "Taishanese": {
          "type": "string"
        },
        "Taiwanese": {
          "type": "string"
        },
        "Turkish": {
          "type": "string"
        },
        "Twi": {
          "type": "string"
        },
        "Ukrainian": {
          "type": "string"
        },
        "Urdu": {
          "type": "string"
        },
        "Uzbek": {
          "type": "string"
        },
        "Vietnamese": {
          "type": "string"
        },
        "Yiddish": {
          "type": "string"
        }
      }
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverUpdatedCaregiverPayload",
{
  "type": "object",
  "properties": {
    "caregiverId": {
      "$ref": "#/definitions/CaregiverId"
    },
    "caregiverData": {
      "$ref": "#/definitions/CaregiverMobile"
    }
  },
  "required": [
    "caregiverData",
    "caregiverId"
  ],
  "definitions": {
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "CaregiverId": {
      "type": "number"
    },
    "CaregiverMobile": {
      "type": "object",
      "properties": {
        "agenciesCaregiverCertifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/AgencyCaregiverCertifications"
          }
        },
        "agenciesCaregiverHireDates": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/AgencyCaregiverHireDate"
          }
        },
        "isCaregiverOfMedFlyt": {
          "type": "boolean"
        },
        "shouldShowMyAgencies": {
          "type": "boolean"
        },
        "shouldShowCaregiverRating": {
          "type": "boolean"
        },
        "shouldShowNewChat": {
          "type": "boolean"
        },
        "shouldShowVirtualIdCard": {
          "type": "boolean"
        },
        "shouldShowComplianceBanner": {
          "type": "boolean"
        },
        "shouldShowMainV2Screen": {
          "type": "boolean"
        },
        "canChatWithOtherAgencies": {
          "type": "boolean"
        },
        "shouldShowMyMedflyCompliance": {
          "type": "boolean"
        },
        "shouldShowMyStaffingPreferences": {
          "type": "boolean"
        },
        "shouldShowCareMoments": {
          "type": "boolean"
        },
        "shouldShowRaffle": {
          "type": "boolean"
        },
        "isInstapayVisible": {
          "type": "boolean"
        },
        "isInstapayAvailable": {
          "type": "boolean"
        },
        "points": {
          "type": "number"
        },
        "raffle": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "shiftsPerToken": {
                  "type": "number"
                },
                "shiftsToNextToken": {
                  "type": "number"
                },
                "tokens": {
                  "type": "number"
                },
                "prize": {
                  "type": "string"
                },
                "daysLeft": {
                  "type": "number"
                },
                "progressPercentage": {
                  "type": "number"
                }
              },
              "required": [
                "daysLeft",
                "prize",
                "progressPercentage",
                "shiftsPerToken",
                "shiftsToNextToken",
                "tokens"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/CaregiverId"
        },
        "status": {
          "$ref": "#/definitions/CaregiverStatus"
        },
        "caregiverCode": {
          "type": [
            "null",
            "string"
          ]
        },
        "caregiverBranch": {
          "type": [
            "null",
            "string"
          ]
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "birthDateDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "phoneNumber": {
          "type": "string"
        },
        "phoneNumbers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverPhoneNumber"
          }
        },
        "homePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "firstName": {
          "type": "string"
        },
        "middleName": {
          "type": [
            "null",
            "string"
          ]
        },
        "lastName": {
          "type": "string"
        },
        "gender": {
          "description": "\"M\", \"F\"",
          "type": "string"
        },
        "languages": {
          "description": "Each element must be one of 'Caregiver.ALL_LANGUAGES'",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "address": {
          "type": "string"
        },
        "addressGeoLocation": {
          "$ref": "#/definitions/Geo"
        },
        "certifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverCertification"
          }
        },
        "photoUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "installedUserAgent": {
          "type": [
            "null",
            "string"
          ]
        },
        "appInstalledDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "appInstalled": {
          "type": "boolean"
        },
        "online": {
          "description": "Is the caregiver's app currently open",
          "type": "boolean"
        },
        "lastSeen": {
          "description": "When was the last time the caregiver was online?",
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "isFullTime": {
          "type": "boolean"
        }
      },
      "required": [
        "address",
        "addressGeoLocation",
        "agenciesCaregiverCertifications",
        "agenciesCaregiverHireDates",
        "appInstalled",
        "appInstalledDate",
        "birthDateDate",
        "canChatWithOtherAgencies",
        "caregiverCode",
        "certifications",
        "createdAt",
        "firstName",
        "gender",
        "homePhone",
        "id",
        "installedUserAgent",
        "isCaregiverOfMedFlyt",
        "isFullTime",
        "isInstapayAvailable",
        "isInstapayVisible",
        "languages",
        "lastName",
        "lastSeen",
        "middleName",
        "online",
        "phoneNumber",
        "phoneNumbers",
        "photoUrl",
        "points",
        "raffle",
        "shouldShowCareMoments",
        "shouldShowCaregiverRating",
        "shouldShowComplianceBanner",
        "shouldShowMainV2Screen",
        "shouldShowMyAgencies",
        "shouldShowMyMedflyCompliance",
        "shouldShowMyStaffingPreferences",
        "shouldShowNewChat",
        "shouldShowRaffle",
        "shouldShowVirtualIdCard",
        "status"
      ]
    },
    "AgencyCaregiverCertifications": {
      "type": "object",
      "properties": {
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "agencyName": {
          "type": "string"
        },
        "certifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverCertification"
          }
        },
        "isOnboardingAgency": {
          "type": "boolean"
        }
      },
      "required": [
        "agencyId",
        "agencyName",
        "certifications",
        "isOnboardingAgency"
      ]
    },
    "AgencyId": {
      "type": "number"
    },
    "CaregiverCertification": {
      "type": "string"
    },
    "AgencyCaregiverHireDate": {
      "type": "object",
      "properties": {
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "agencyName": {
          "type": "string"
        },
        "hireDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "agencyId",
        "agencyName",
        "hireDate"
      ]
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "CaregiverStatus": {
      "description": "The status of a Caregiver within a specific Agency",
      "enum": [
        "ACTIVE",
        "JOIN_REQUEST",
        "ON_HOLD",
        "ON_LEAVE",
        "PENDING",
        "QUIT",
        "REJECTED",
        "SUSPENDED",
        "TERMINATED"
      ],
      "type": "string"
    },
    "CaregiverPhoneNumber": {
      "type": "object",
      "properties": {
        "phoneNumber": {
          "type": "string"
        },
        "type": {
          "type": "string"
        }
      },
      "required": [
        "phoneNumber",
        "type"
      ]
    },
    "Geo": {
      "type": "object",
      "properties": {
        "lat": {
          "type": "number"
        },
        "lng": {
          "type": "number"
        }
      },
      "required": [
        "lat",
        "lng"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["Caregiver",
{
  "type": "object",
  "properties": {
    "id": {
      "$ref": "#/definitions/CaregiverId"
    },
    "status": {
      "$ref": "#/definitions/CaregiverStatus"
    },
    "caregiverCode": {
      "type": [
        "null",
        "string"
      ]
    },
    "caregiverBranch": {
      "type": [
        "null",
        "string"
      ]
    },
    "createdAt": {
      "$ref": "#/definitions/Instant"
    },
    "birthDateDate": {
      "anyOf": [
        {
          "$ref": "#/definitions/LocalDate"
        },
        {
          "type": "null"
        }
      ]
    },
    "phoneNumber": {
      "type": "string"
    },
    "phoneNumbers": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverPhoneNumber"
      }
    },
    "homePhone": {
      "type": [
        "null",
        "string"
      ]
    },
    "firstName": {
      "type": "string"
    },
    "middleName": {
      "type": [
        "null",
        "string"
      ]
    },
    "lastName": {
      "type": "string"
    },
    "gender": {
      "description": "\"M\", \"F\"",
      "type": "string"
    },
    "languages": {
      "description": "Each element must be one of 'Caregiver.ALL_LANGUAGES'",
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "address": {
      "type": "string"
    },
    "addressGeoLocation": {
      "$ref": "#/definitions/Geo"
    },
    "certifications": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverCertification"
      }
    },
    "photoUrl": {
      "type": [
        "null",
        "string"
      ]
    },
    "installedUserAgent": {
      "type": [
        "null",
        "string"
      ]
    },
    "appInstalledDate": {
      "anyOf": [
        {
          "$ref": "#/definitions/Instant"
        },
        {
          "type": "null"
        }
      ]
    },
    "appInstalled": {
      "type": "boolean"
    },
    "online": {
      "description": "Is the caregiver's app currently open",
      "type": "boolean"
    },
    "lastSeen": {
      "description": "When was the last time the caregiver was online?",
      "anyOf": [
        {
          "$ref": "#/definitions/Instant"
        },
        {
          "type": "null"
        }
      ]
    },
    "isFullTime": {
      "type": "boolean"
    }
  },
  "required": [
    "address",
    "addressGeoLocation",
    "appInstalled",
    "appInstalledDate",
    "birthDateDate",
    "caregiverCode",
    "certifications",
    "createdAt",
    "firstName",
    "gender",
    "homePhone",
    "id",
    "installedUserAgent",
    "isFullTime",
    "languages",
    "lastName",
    "lastSeen",
    "middleName",
    "online",
    "phoneNumber",
    "phoneNumbers",
    "photoUrl",
    "status"
  ],
  "definitions": {
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "CaregiverId": {
      "type": "number"
    },
    "CaregiverCertification": {
      "type": "string"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "CaregiverStatus": {
      "description": "The status of a Caregiver within a specific Agency",
      "enum": [
        "ACTIVE",
        "JOIN_REQUEST",
        "ON_HOLD",
        "ON_LEAVE",
        "PENDING",
        "QUIT",
        "REJECTED",
        "SUSPENDED",
        "TERMINATED"
      ],
      "type": "string"
    },
    "CaregiverPhoneNumber": {
      "type": "object",
      "properties": {
        "phoneNumber": {
          "type": "string"
        },
        "type": {
          "type": "string"
        }
      },
      "required": [
        "phoneNumber",
        "type"
      ]
    },
    "Geo": {
      "type": "object",
      "properties": {
        "lat": {
          "type": "number"
        },
        "lng": {
          "type": "number"
        }
      },
      "required": [
        "lat",
        "lng"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverAgencyMembers",
{
  "type": "object",
  "properties": {
    "agencies": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverAgency"
      }
    }
  },
  "required": [
    "agencies"
  ],
  "definitions": {
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "CaregiverStatus": {
      "description": "The status of a Caregiver within a specific Agency",
      "enum": [
        "ACTIVE",
        "JOIN_REQUEST",
        "ON_HOLD",
        "ON_LEAVE",
        "PENDING",
        "QUIT",
        "REJECTED",
        "SUSPENDED",
        "TERMINATED"
      ],
      "type": "string"
    },
    "CaregiverAgency": {
      "type": "object",
      "properties": {
        "agency": {
          "$ref": "#/definitions/AgencyWithIsChatOnly"
        },
        "status": {
          "$ref": "#/definitions/CaregiverStatus"
        },
        "agencyMembers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/AgencyMember"
          }
        }
      },
      "required": [
        "agency",
        "agencyMembers",
        "status"
      ]
    },
    "AgencyWithIsChatOnly": {
      "type": "object",
      "properties": {
        "isChatOnly": {
          "type": "boolean"
        },
        "defaultAgencyMemberForChat": {
          "anyOf": [
            {
              "$ref": "#/definitions/AgencyMemberId"
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/AgencyId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "name": {
          "type": "string"
        },
        "logoUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "website": {
          "type": [
            "null",
            "string"
          ]
        },
        "address": {
          "type": [
            "null",
            "string"
          ]
        },
        "officePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "organizationType": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumbers": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/AgencyIvrPhoneNumber"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "isMedflytAgency": {
          "type": "boolean"
        }
      },
      "required": [
        "address",
        "createdAt",
        "defaultAgencyMemberForChat",
        "id",
        "isChatOnly",
        "isMedflytAgency",
        "ivrPhoneNumbers",
        "logoUrl",
        "name",
        "officePhone",
        "organizationType",
        "website"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "AgencyId": {
      "type": "number"
    },
    "AgencyIvrPhoneNumber": {
      "type": "object",
      "properties": {
        "ivrPhoneNumber": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "description",
        "ivrPhoneNumber"
      ]
    },
    "AgencyMember": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "agencyAdmin": {
          "type": "boolean"
        },
        "jobTitle": {
          "type": "string"
        },
        "email": {
          "type": [
            "null",
            "string"
          ]
        },
        "firstName": {
          "type": "string"
        },
        "lastName": {
          "type": "string"
        },
        "photoUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "status": {
          "enum": [
            "Active",
            "Inactive",
            "Invited"
          ],
          "type": "string"
        }
      },
      "required": [
        "agencyAdmin",
        "createdAt",
        "email",
        "firstName",
        "id",
        "jobTitle",
        "lastName",
        "photoUrl",
        "status"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverMobile",
{
  "type": "object",
  "properties": {
    "agenciesCaregiverCertifications": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/AgencyCaregiverCertifications"
      }
    },
    "agenciesCaregiverHireDates": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/AgencyCaregiverHireDate"
      }
    },
    "isCaregiverOfMedFlyt": {
      "type": "boolean"
    },
    "shouldShowMyAgencies": {
      "type": "boolean"
    },
    "shouldShowCaregiverRating": {
      "type": "boolean"
    },
    "shouldShowNewChat": {
      "type": "boolean"
    },
    "shouldShowVirtualIdCard": {
      "type": "boolean"
    },
    "shouldShowComplianceBanner": {
      "type": "boolean"
    },
    "shouldShowMainV2Screen": {
      "type": "boolean"
    },
    "canChatWithOtherAgencies": {
      "type": "boolean"
    },
    "shouldShowMyMedflyCompliance": {
      "type": "boolean"
    },
    "shouldShowMyStaffingPreferences": {
      "type": "boolean"
    },
    "shouldShowCareMoments": {
      "type": "boolean"
    },
    "shouldShowRaffle": {
      "type": "boolean"
    },
    "isInstapayVisible": {
      "type": "boolean"
    },
    "isInstapayAvailable": {
      "type": "boolean"
    },
    "points": {
      "type": "number"
    },
    "raffle": {
      "anyOf": [
        {
          "type": "object",
          "properties": {
            "shiftsPerToken": {
              "type": "number"
            },
            "shiftsToNextToken": {
              "type": "number"
            },
            "tokens": {
              "type": "number"
            },
            "prize": {
              "type": "string"
            },
            "daysLeft": {
              "type": "number"
            },
            "progressPercentage": {
              "type": "number"
            }
          },
          "required": [
            "daysLeft",
            "prize",
            "progressPercentage",
            "shiftsPerToken",
            "shiftsToNextToken",
            "tokens"
          ]
        },
        {
          "type": "null"
        }
      ]
    },
    "id": {
      "$ref": "#/definitions/CaregiverId"
    },
    "status": {
      "$ref": "#/definitions/CaregiverStatus"
    },
    "caregiverCode": {
      "type": [
        "null",
        "string"
      ]
    },
    "caregiverBranch": {
      "type": [
        "null",
        "string"
      ]
    },
    "createdAt": {
      "$ref": "#/definitions/Instant"
    },
    "birthDateDate": {
      "anyOf": [
        {
          "$ref": "#/definitions/LocalDate"
        },
        {
          "type": "null"
        }
      ]
    },
    "phoneNumber": {
      "type": "string"
    },
    "phoneNumbers": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverPhoneNumber"
      }
    },
    "homePhone": {
      "type": [
        "null",
        "string"
      ]
    },
    "firstName": {
      "type": "string"
    },
    "middleName": {
      "type": [
        "null",
        "string"
      ]
    },
    "lastName": {
      "type": "string"
    },
    "gender": {
      "description": "\"M\", \"F\"",
      "type": "string"
    },
    "languages": {
      "description": "Each element must be one of 'Caregiver.ALL_LANGUAGES'",
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "address": {
      "type": "string"
    },
    "addressGeoLocation": {
      "$ref": "#/definitions/Geo"
    },
    "certifications": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverCertification"
      }
    },
    "photoUrl": {
      "type": [
        "null",
        "string"
      ]
    },
    "installedUserAgent": {
      "type": [
        "null",
        "string"
      ]
    },
    "appInstalledDate": {
      "anyOf": [
        {
          "$ref": "#/definitions/Instant"
        },
        {
          "type": "null"
        }
      ]
    },
    "appInstalled": {
      "type": "boolean"
    },
    "online": {
      "description": "Is the caregiver's app currently open",
      "type": "boolean"
    },
    "lastSeen": {
      "description": "When was the last time the caregiver was online?",
      "anyOf": [
        {
          "$ref": "#/definitions/Instant"
        },
        {
          "type": "null"
        }
      ]
    },
    "isFullTime": {
      "type": "boolean"
    }
  },
  "required": [
    "address",
    "addressGeoLocation",
    "agenciesCaregiverCertifications",
    "agenciesCaregiverHireDates",
    "appInstalled",
    "appInstalledDate",
    "birthDateDate",
    "canChatWithOtherAgencies",
    "caregiverCode",
    "certifications",
    "createdAt",
    "firstName",
    "gender",
    "homePhone",
    "id",
    "installedUserAgent",
    "isCaregiverOfMedFlyt",
    "isFullTime",
    "isInstapayAvailable",
    "isInstapayVisible",
    "languages",
    "lastName",
    "lastSeen",
    "middleName",
    "online",
    "phoneNumber",
    "phoneNumbers",
    "photoUrl",
    "points",
    "raffle",
    "shouldShowCareMoments",
    "shouldShowCaregiverRating",
    "shouldShowComplianceBanner",
    "shouldShowMainV2Screen",
    "shouldShowMyAgencies",
    "shouldShowMyMedflyCompliance",
    "shouldShowMyStaffingPreferences",
    "shouldShowNewChat",
    "shouldShowRaffle",
    "shouldShowVirtualIdCard",
    "status"
  ],
  "definitions": {
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "CaregiverStatus": {
      "description": "The status of a Caregiver within a specific Agency",
      "enum": [
        "ACTIVE",
        "JOIN_REQUEST",
        "ON_HOLD",
        "ON_LEAVE",
        "PENDING",
        "QUIT",
        "REJECTED",
        "SUSPENDED",
        "TERMINATED"
      ],
      "type": "string"
    },
    "AgencyId": {
      "type": "number"
    },
    "AgencyCaregiverCertifications": {
      "type": "object",
      "properties": {
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "agencyName": {
          "type": "string"
        },
        "certifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverCertification"
          }
        },
        "isOnboardingAgency": {
          "type": "boolean"
        }
      },
      "required": [
        "agencyId",
        "agencyName",
        "certifications",
        "isOnboardingAgency"
      ]
    },
    "CaregiverCertification": {
      "type": "string"
    },
    "AgencyCaregiverHireDate": {
      "type": "object",
      "properties": {
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "agencyName": {
          "type": "string"
        },
        "hireDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "agencyId",
        "agencyName",
        "hireDate"
      ]
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "CaregiverId": {
      "type": "number"
    },
    "CaregiverPhoneNumber": {
      "type": "object",
      "properties": {
        "phoneNumber": {
          "type": "string"
        },
        "type": {
          "type": "string"
        }
      },
      "required": [
        "phoneNumber",
        "type"
      ]
    },
    "Geo": {
      "type": "object",
      "properties": {
        "lat": {
          "type": "number"
        },
        "lng": {
          "type": "number"
        }
      },
      "required": [
        "lat",
        "lng"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverScore",
{
  "type": "object",
  "properties": {
    "photoUrl": {
      "type": [
        "null",
        "string"
      ]
    },
    "firstName": {
      "type": "string"
    },
    "lastName": {
      "type": "string"
    },
    "score": {
      "type": "number"
    }
  },
  "required": [
    "firstName",
    "lastName",
    "photoUrl",
    "score"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverScores",
{
  "type": "object",
  "properties": {
    "scores": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverScore"
      }
    }
  },
  "required": [
    "scores"
  ],
  "definitions": {
    "CaregiverScore": {
      "type": "object",
      "properties": {
        "photoUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "firstName": {
          "type": "string"
        },
        "lastName": {
          "type": "string"
        },
        "score": {
          "type": "number"
        }
      },
      "required": [
        "firstName",
        "lastName",
        "photoUrl",
        "score"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["ChatRoom",
{
  "type": "object",
  "properties": {
    "id": {
      "$ref": "#/definitions/ChatRoomId"
    },
    "chatRoomType": {
      "anyOf": [
        {
          "$ref": "#/definitions/ChatRoomType.CaregiverVisitChat"
        },
        {
          "$ref": "#/definitions/ChatRoomType.AgencyCaregiverChat"
        },
        {
          "$ref": "#/definitions/ChatRoomType.AgencyMemberCaregiverChat"
        },
        {
          "$ref": "#/definitions/ChatRoomType.CaregiverPatientChat"
        }
      ]
    },
    "members": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/ChatRoomMember"
      }
    },
    "messages": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/ChatRoomMessage"
      }
    }
  },
  "required": [
    "chatRoomType",
    "id",
    "members",
    "messages"
  ],
  "definitions": {
    "ChatRoomId": {
      "type": "number"
    },
    "ChatRoomType.CaregiverVisitChat": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CaregiverVisitChat"
          ]
        },
        "visitId": {
          "$ref": "#/definitions/VisitBroadcastId"
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        }
      },
      "required": [
        "caregiverId",
        "type",
        "visitId"
      ]
    },
    "VisitBroadcastId": {
      "type": "number"
    },
    "CaregiverId": {
      "type": "number"
    },
    "ChatRoomType.AgencyCaregiverChat": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AgencyCaregiverChat"
          ]
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        },
        "department": {
          "$ref": "#/definitions/Department"
        }
      },
      "required": [
        "agencyId",
        "caregiverId",
        "department",
        "type"
      ]
    },
    "AgencyId": {
      "type": "number"
    },
    "Department": {
      "description": "The status of a Caregiver within a specific Agency",
      "enum": [
        "HR",
        "STAFFING"
      ],
      "type": "string"
    },
    "ChatRoomType.AgencyMemberCaregiverChat": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AgencyMemberCaregiverChat"
          ]
        },
        "agencyMemberId": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        }
      },
      "required": [
        "agencyId",
        "agencyMemberId",
        "caregiverId",
        "type"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "ChatRoomType.CaregiverPatientChat": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CaregiverPatientChat"
          ]
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientName": {
          "type": "string"
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        }
      },
      "required": [
        "agencyId",
        "caregiverId",
        "patientId",
        "patientName",
        "type"
      ]
    },
    "PatientId": {
      "type": "number"
    },
    "ChatRoomMember": {
      "type": "object",
      "properties": {
        "user": {
          "anyOf": [
            {
              "$ref": "#/definitions/ChatRoomUser.Caregiver"
            },
            {
              "$ref": "#/definitions/ChatRoomUser.AgencyMember"
            }
          ]
        },
        "lastViewed": {
          "$ref": "#/definitions/Instant",
          "description": "Will be equal to the value of the \"createdAt\" field of the latest\nChatMessage that was viewed."
        }
      },
      "required": [
        "lastViewed",
        "user"
      ]
    },
    "ChatRoomUser.Caregiver": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Caregiver"
          ]
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        }
      },
      "required": [
        "caregiverId",
        "type"
      ]
    },
    "ChatRoomUser.AgencyMember": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AgencyMember"
          ]
        },
        "agencyMemberId": {
          "$ref": "#/definitions/AgencyMemberId"
        }
      },
      "required": [
        "agencyMemberId",
        "type"
      ]
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "ChatRoomMessage": {
      "type": "object",
      "properties": {
        "createdAt": {
          "$ref": "#/definitions/Instant",
          "description": "When was this message sent"
        },
        "requestId": {
          "description": "Can be used by the client to hide/merge a message that is queued for sending,\nto prevent it from being displayed twice.",
          "type": "string"
        },
        "user": {
          "anyOf": [
            {
              "$ref": "#/definitions/ChatRoomUser.Caregiver"
            },
            {
              "$ref": "#/definitions/ChatRoomUser.AgencyMember"
            }
          ]
        },
        "payload": {
          "anyOf": [
            {
              "$ref": "#/definitions/ChatPayload.Message"
            },
            {
              "$ref": "#/definitions/ChatPayload.Image"
            }
          ]
        }
      },
      "required": [
        "createdAt",
        "payload",
        "requestId",
        "user"
      ]
    },
    "ChatPayload.Message": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Message"
          ]
        },
        "message": {
          "type": "string"
        },
        "images": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "message",
        "type"
      ]
    },
    "ChatPayload.Image": {
      "description": "(For future use...)",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Image"
          ]
        },
        "imageUrl": {
          "type": "string"
        }
      },
      "required": [
        "imageUrl",
        "type"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["ChatRoomList",
{
  "type": "object",
  "properties": {
    "chatRooms": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/ChatRoom"
      }
    }
  },
  "required": [
    "chatRooms"
  ],
  "definitions": {
    "ChatRoomId": {
      "type": "number"
    },
    "ChatRoomType.CaregiverVisitChat": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CaregiverVisitChat"
          ]
        },
        "visitId": {
          "$ref": "#/definitions/VisitBroadcastId"
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        }
      },
      "required": [
        "caregiverId",
        "type",
        "visitId"
      ]
    },
    "VisitBroadcastId": {
      "type": "number"
    },
    "CaregiverId": {
      "type": "number"
    },
    "ChatRoomType.AgencyCaregiverChat": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AgencyCaregiverChat"
          ]
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        },
        "department": {
          "$ref": "#/definitions/Department"
        }
      },
      "required": [
        "agencyId",
        "caregiverId",
        "department",
        "type"
      ]
    },
    "AgencyId": {
      "type": "number"
    },
    "Department": {
      "description": "The status of a Caregiver within a specific Agency",
      "enum": [
        "HR",
        "STAFFING"
      ],
      "type": "string"
    },
    "ChatRoomType.AgencyMemberCaregiverChat": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AgencyMemberCaregiverChat"
          ]
        },
        "agencyMemberId": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        }
      },
      "required": [
        "agencyId",
        "agencyMemberId",
        "caregiverId",
        "type"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "ChatRoomType.CaregiverPatientChat": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CaregiverPatientChat"
          ]
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientName": {
          "type": "string"
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        }
      },
      "required": [
        "agencyId",
        "caregiverId",
        "patientId",
        "patientName",
        "type"
      ]
    },
    "PatientId": {
      "type": "number"
    },
    "ChatRoomMember": {
      "type": "object",
      "properties": {
        "user": {
          "anyOf": [
            {
              "$ref": "#/definitions/ChatRoomUser.Caregiver"
            },
            {
              "$ref": "#/definitions/ChatRoomUser.AgencyMember"
            }
          ]
        },
        "lastViewed": {
          "$ref": "#/definitions/Instant",
          "description": "Will be equal to the value of the \"createdAt\" field of the latest\nChatMessage that was viewed."
        }
      },
      "required": [
        "lastViewed",
        "user"
      ]
    },
    "ChatRoomUser.Caregiver": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Caregiver"
          ]
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        }
      },
      "required": [
        "caregiverId",
        "type"
      ]
    },
    "ChatRoomUser.AgencyMember": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AgencyMember"
          ]
        },
        "agencyMemberId": {
          "$ref": "#/definitions/AgencyMemberId"
        }
      },
      "required": [
        "agencyMemberId",
        "type"
      ]
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "ChatRoomMessage": {
      "type": "object",
      "properties": {
        "createdAt": {
          "$ref": "#/definitions/Instant",
          "description": "When was this message sent"
        },
        "requestId": {
          "description": "Can be used by the client to hide/merge a message that is queued for sending,\nto prevent it from being displayed twice.",
          "type": "string"
        },
        "user": {
          "anyOf": [
            {
              "$ref": "#/definitions/ChatRoomUser.Caregiver"
            },
            {
              "$ref": "#/definitions/ChatRoomUser.AgencyMember"
            }
          ]
        },
        "payload": {
          "anyOf": [
            {
              "$ref": "#/definitions/ChatPayload.Message"
            },
            {
              "$ref": "#/definitions/ChatPayload.Image"
            }
          ]
        }
      },
      "required": [
        "createdAt",
        "payload",
        "requestId",
        "user"
      ]
    },
    "ChatPayload.Message": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Message"
          ]
        },
        "message": {
          "type": "string"
        },
        "images": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "message",
        "type"
      ]
    },
    "ChatPayload.Image": {
      "description": "(For future use...)",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Image"
          ]
        },
        "imageUrl": {
          "type": "string"
        }
      },
      "required": [
        "imageUrl",
        "type"
      ]
    },
    "ChatRoom": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/ChatRoomId"
        },
        "chatRoomType": {
          "anyOf": [
            {
              "$ref": "#/definitions/ChatRoomType.CaregiverVisitChat"
            },
            {
              "$ref": "#/definitions/ChatRoomType.AgencyCaregiverChat"
            },
            {
              "$ref": "#/definitions/ChatRoomType.AgencyMemberCaregiverChat"
            },
            {
              "$ref": "#/definitions/ChatRoomType.CaregiverPatientChat"
            }
          ]
        },
        "members": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/ChatRoomMember"
          }
        },
        "messages": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/ChatRoomMessage"
          }
        }
      },
      "required": [
        "chatRoomType",
        "id",
        "members",
        "messages"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["ChatRoomUpdatedCaregiverPayload",
{
  "type": "object",
  "properties": {
    "chatRoomId": {
      "$ref": "#/definitions/ChatRoomId"
    },
    "chatRoomData": {
      "$ref": "#/definitions/ChatRoom"
    }
  },
  "required": [
    "chatRoomData",
    "chatRoomId"
  ],
  "definitions": {
    "ChatRoomId": {
      "type": "number"
    },
    "ChatRoomType.CaregiverVisitChat": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CaregiverVisitChat"
          ]
        },
        "visitId": {
          "$ref": "#/definitions/VisitBroadcastId"
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        }
      },
      "required": [
        "caregiverId",
        "type",
        "visitId"
      ]
    },
    "VisitBroadcastId": {
      "type": "number"
    },
    "CaregiverId": {
      "type": "number"
    },
    "ChatRoomType.AgencyCaregiverChat": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AgencyCaregiverChat"
          ]
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        },
        "department": {
          "$ref": "#/definitions/Department"
        }
      },
      "required": [
        "agencyId",
        "caregiverId",
        "department",
        "type"
      ]
    },
    "AgencyId": {
      "type": "number"
    },
    "Department": {
      "description": "The status of a Caregiver within a specific Agency",
      "enum": [
        "HR",
        "STAFFING"
      ],
      "type": "string"
    },
    "ChatRoomType.AgencyMemberCaregiverChat": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AgencyMemberCaregiverChat"
          ]
        },
        "agencyMemberId": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        }
      },
      "required": [
        "agencyId",
        "agencyMemberId",
        "caregiverId",
        "type"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "ChatRoomType.CaregiverPatientChat": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CaregiverPatientChat"
          ]
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientName": {
          "type": "string"
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        }
      },
      "required": [
        "agencyId",
        "caregiverId",
        "patientId",
        "patientName",
        "type"
      ]
    },
    "PatientId": {
      "type": "number"
    },
    "ChatRoomMember": {
      "type": "object",
      "properties": {
        "user": {
          "anyOf": [
            {
              "$ref": "#/definitions/ChatRoomUser.Caregiver"
            },
            {
              "$ref": "#/definitions/ChatRoomUser.AgencyMember"
            }
          ]
        },
        "lastViewed": {
          "$ref": "#/definitions/Instant",
          "description": "Will be equal to the value of the \"createdAt\" field of the latest\nChatMessage that was viewed."
        }
      },
      "required": [
        "lastViewed",
        "user"
      ]
    },
    "ChatRoomUser.Caregiver": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Caregiver"
          ]
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        }
      },
      "required": [
        "caregiverId",
        "type"
      ]
    },
    "ChatRoomUser.AgencyMember": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AgencyMember"
          ]
        },
        "agencyMemberId": {
          "$ref": "#/definitions/AgencyMemberId"
        }
      },
      "required": [
        "agencyMemberId",
        "type"
      ]
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "ChatRoomMessage": {
      "type": "object",
      "properties": {
        "createdAt": {
          "$ref": "#/definitions/Instant",
          "description": "When was this message sent"
        },
        "requestId": {
          "description": "Can be used by the client to hide/merge a message that is queued for sending,\nto prevent it from being displayed twice.",
          "type": "string"
        },
        "user": {
          "anyOf": [
            {
              "$ref": "#/definitions/ChatRoomUser.Caregiver"
            },
            {
              "$ref": "#/definitions/ChatRoomUser.AgencyMember"
            }
          ]
        },
        "payload": {
          "anyOf": [
            {
              "$ref": "#/definitions/ChatPayload.Message"
            },
            {
              "$ref": "#/definitions/ChatPayload.Image"
            }
          ]
        }
      },
      "required": [
        "createdAt",
        "payload",
        "requestId",
        "user"
      ]
    },
    "ChatPayload.Message": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Message"
          ]
        },
        "message": {
          "type": "string"
        },
        "images": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "message",
        "type"
      ]
    },
    "ChatPayload.Image": {
      "description": "(For future use...)",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Image"
          ]
        },
        "imageUrl": {
          "type": "string"
        }
      },
      "required": [
        "imageUrl",
        "type"
      ]
    },
    "ChatRoom": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/ChatRoomId"
        },
        "chatRoomType": {
          "anyOf": [
            {
              "$ref": "#/definitions/ChatRoomType.CaregiverVisitChat"
            },
            {
              "$ref": "#/definitions/ChatRoomType.AgencyCaregiverChat"
            },
            {
              "$ref": "#/definitions/ChatRoomType.AgencyMemberCaregiverChat"
            },
            {
              "$ref": "#/definitions/ChatRoomType.CaregiverPatientChat"
            }
          ]
        },
        "members": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/ChatRoomMember"
          }
        },
        "messages": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/ChatRoomMessage"
          }
        }
      },
      "required": [
        "chatRoomType",
        "id",
        "members",
        "messages"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["ClockedInStatus",
{
  "type": "object",
  "properties": {
    "status": {
      "anyOf": [
        {
          "$ref": "#/definitions/ClockedInStatusDetails"
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "status"
  ],
  "definitions": {
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "ClockedInStatusDetails": {
      "type": "object",
      "properties": {
        "visitInstanceId": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "clockedInAt": {
          "$ref": "#/definitions/Instant"
        },
        "clockInTime": {
          "$ref": "#/definitions/LocalDateTime"
        }
      },
      "required": [
        "clockInTime",
        "clockedInAt",
        "visitInstanceId"
      ]
    },
    "VisitInstanceId": {
      "type": "number"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["ConvertImportedVisit",
{
  "type": "object",
  "properties": {
    "success": {
      "type": "boolean"
    },
    "candidatePatientAddresses": {
      "type": "array",
      "items": {
        "type": "string"
      }
    }
  },
  "required": [
    "candidatePatientAddresses",
    "success"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["ConfirmedPending",
{
  "type": "object",
  "properties": {
    "pendingCaregiversCount": {
      "type": "number"
    },
    "assignedWithOvertime": {
      "type": "boolean"
    }
  },
  "required": [
    "assignedWithOvertime",
    "pendingCaregiversCount"
  ],
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["NotificationSettings",
{
  "type": "object",
  "properties": {
    "receiveVisitNotifications": {
      "type": "boolean"
    }
  },
  "required": [
    "receiveVisitNotifications"
  ],
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["NullableCaregiverAvailability",
{
  "description": "nullable wrapper for CaregiverAvailability",
  "type": "object",
  "properties": {
    "caregiverAvailability": {
      "anyOf": [
        {
          "$ref": "#/definitions/CaregiverAvailability"
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "caregiverAvailability"
  ],
  "definitions": {
    "CaregiverAvailability": {
      "description": "when is the caregiver available, and to which visits",
      "type": "object",
      "properties": {
        "dayAvailabilities": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayAvailability"
          }
        },
        "maxDistance": {
          "description": "in miles",
          "type": "number"
        },
        "minDuration": {
          "description": "in hours",
          "type": "number"
        },
        "maxDuration": {
          "description": "in hours",
          "type": "number"
        }
      },
      "required": [
        "dayAvailabilities",
        "maxDistance",
        "maxDuration",
        "minDuration"
      ]
    },
    "DayAvailability": {
      "description": "when is the caregiver available during each day",
      "type": "object",
      "properties": {
        "day": {
          "description": "0 = sunday, 1 = monday, ... , 6 = saturday",
          "type": "integer",
          "minimum": 0,
          "maximum": 6
        },
        "startHour": {
          "description": "24-hour time",
          "minimum": 0,
          "maximum": 24,
          "type": "number"
        },
        "endHour": {
          "description": "24-hour time",
          "minimum": 0,
          "maximum": 24,
          "type": "number"
        },
        "busyAllDay": {
          "type": "boolean"
        }
      },
      "required": [
        "busyAllDay",
        "day",
        "endHour",
        "startHour"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["NursingQuestionVBPList",
{
  "type": "object",
  "properties": {
    "questions": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/NursingQuestionVBPWithAnswer"
      }
    }
  },
  "required": [
    "questions"
  ],
  "definitions": {
    "NursingQuestionVBPWithAnswer": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/NursingQuestionId"
        },
        "answerType": {
          "$ref": "#/definitions/NursingQuestionAnswerType"
        },
        "name": {
          "type": "string"
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/NursingQuestionPossibleAnswer"
          }
        },
        "answerDetails": {
          "anyOf": [
            {
              "$ref": "#/definitions/NursingQuestionVBPAnswer"
            },
            {
              "type": "null"
            }
          ]
        },
        "iconUrl": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "answerDetails",
        "answerType",
        "iconUrl",
        "id",
        "name",
        "possibleAnswers"
      ]
    },
    "NursingQuestionId": {
      "type": "number"
    },
    "NursingQuestionAnswerType": {
      "enum": [
        "bloodPressure",
        "check",
        "date",
        "dropDown",
        "number",
        "radio",
        "textLong",
        "textShort",
        "time",
        "yesNo"
      ],
      "type": "string"
    },
    "NursingQuestionPossibleAnswer": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string"
        },
        "alertText": {
          "type": "string"
        },
        "isTriggeringAlert": {
          "type": "boolean"
        }
      },
      "required": [
        "isTriggeringAlert",
        "text"
      ]
    },
    "NursingQuestionVBPAnswer": {
      "type": "object",
      "properties": {
        "nursingQuestionId": {
          "$ref": "#/definitions/NursingQuestionId"
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        },
        "riskLevel": {
          "type": [
            "null",
            "number"
          ]
        }
      },
      "required": [
        "answer",
        "notes",
        "nursingQuestionId",
        "riskLevel"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PushNotificationInfoList",
{
  "type": "object",
  "properties": {
    "pushNotificationInfos": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/PushNotificationInfo"
      }
    }
  },
  "required": [
    "pushNotificationInfos"
  ],
  "definitions": {
    "PushNotificationInfo": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CaregiverNotificationId"
        },
        "pushNotification": {
          "anyOf": [
            {
              "$ref": "#/definitions/NotificationData.CaregiverStatusChanged"
            },
            {
              "$ref": "#/definitions/NotificationData.AgencyMemberChatMessage"
            },
            {
              "$ref": "#/definitions/NotificationData.VisitChatMessage"
            },
            {
              "$ref": "#/definitions/NotificationData.VisitStartingSoonReminder"
            },
            {
              "$ref": "#/definitions/NotificationData.VisitNotification"
            },
            {
              "$ref": "#/definitions/NotificationData.PatientChatMessage"
            },
            {
              "$ref": "#/definitions/NotificationData.VisitInstanceNotification"
            },
            {
              "$ref": "#/definitions/NotificationData.VisitAssignmentNotification"
            },
            {
              "$ref": "#/definitions/NotificationData.VisitCancelNotification"
            },
            {
              "$ref": "#/definitions/NotificationData.ClusterNotification"
            },
            {
              "$ref": "#/definitions/NotificationData.AvailabilityAnomalyNotification"
            },
            {
              "$ref": "#/definitions/NotificationData.OrientationVideoReminderNotification"
            },
            {
              "$ref": "#/definitions/NotificationData.ComplianceProblemNotification"
            },
            {
              "$ref": "#/definitions/NotificationData.VisitAwaitingPatientContact"
            },
            {
              "$ref": "#/definitions/NotificationData.CaregiverGotRecruited"
            },
            {
              "$ref": "#/definitions/NotificationData.RecruitmentApplicationReminder"
            },
            {
              "$ref": "#/definitions/NotificationData.CaregiverMissingDocumentReminder"
            },
            {
              "$ref": "#/definitions/NotificationData.PatientDocumentUnsubmittedRemainder"
            },
            {
              "$ref": "#/definitions/NotificationData.Covid19TrainingReminder"
            },
            {
              "$ref": "#/definitions/NotificationData.Covid19ScreeningReminder"
            },
            {
              "$ref": "#/definitions/NotificationData.Covid19VisitScreeningReminder"
            },
            {
              "$ref": "#/definitions/NotificationData.CaregiverPassportDocumentVerificationStatusChanged"
            },
            {
              "$ref": "#/definitions/NotificationData.ConvertImportedVisitRequestResult"
            },
            {
              "$ref": "#/definitions/NotificationData.PatientTaskNotification"
            },
            {
              "$ref": "#/definitions/NotificationData.CaregiverInactiveFor3Weeks"
            },
            {
              "$ref": "#/definitions/NotificationData.FormsAwaitingSubmissionTask"
            },
            {
              "$ref": "#/definitions/NotificationData.TaskWasntScheduled"
            },
            {
              "$ref": "#/definitions/NotificationData.MissedClockIn"
            },
            {
              "$ref": "#/definitions/NotificationData.MissedClockOut"
            },
            {
              "$ref": "#/definitions/NotificationData.FormsAwaitingSubmissionVisit"
            },
            {
              "$ref": "#/definitions/NotificationData.ExpiredComplianceItem"
            },
            {
              "$ref": "#/definitions/NotificationData.AboutToExpireComplianceItem"
            },
            {
              "$ref": "#/definitions/NotificationData.CaregiverVisitNotSeen"
            },
            {
              "$ref": "#/definitions/NotificationData.PatientOnVacation"
            },
            {
              "$ref": "#/definitions/NotificationData.DutySheetSubmissionReminder"
            },
            {
              "$ref": "#/definitions/NotificationData.OnboardingReminder"
            },
            {
              "$ref": "#/definitions/NotificationData.NewOnboardingVisits"
            },
            {
              "$ref": "#/definitions/NotificationData.OnboardingDocumentNotification"
            },
            {
              "$ref": "#/definitions/NotificationData.CommCenterTicketMessage"
            },
            {
              "$ref": "#/definitions/NotificationData.OnboardingCaregiverEngagements"
            },
            {
              "$ref": "#/definitions/NotificationData.OnboardingCaregiverEngagements2"
            },
            {
              "$ref": "#/definitions/NotificationData.GeneralVisitAssignmentNotification"
            },
            {
              "$ref": "#/definitions/NotificationData.InstaPayFailureNotification"
            },
            {
              "$ref": "#/definitions/NotificationData.VisitBroadcastStoppedByAgencyMember"
            },
            {
              "$ref": "#/definitions/NotificationData.FlexibleVisitBroadcastDetailsChanged"
            },
            {
              "$ref": "#/definitions/NotificationData.CareMomentsCaregiverRankAdjusted"
            },
            {
              "$ref": "#/definitions/NotificationData.RaffleEngagement"
            }
          ]
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "viewed": {
          "type": "boolean"
        },
        "clicked": {
          "type": "boolean"
        },
        "notificationText": {
          "type": "string"
        }
      },
      "required": [
        "clicked",
        "createdAt",
        "id",
        "notificationText",
        "pushNotification",
        "viewed"
      ]
    },
    "CaregiverNotificationId": {
      "type": "number"
    },
    "NotificationData.CaregiverStatusChanged": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CAREGIVER_STATUS_CHANGED"
          ]
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        }
      },
      "required": [
        "agencyId",
        "type"
      ]
    },
    "AgencyId": {
      "type": "number"
    },
    "NotificationData.AgencyMemberChatMessage": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AGENCY_MEMBER_CHAT_MESSAGE"
          ]
        },
        "chatRoomId": {
          "$ref": "#/definitions/ChatRoomId"
        }
      },
      "required": [
        "chatRoomId",
        "type"
      ]
    },
    "ChatRoomId": {
      "type": "number"
    },
    "NotificationData.VisitChatMessage": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "VISIT_CHAT_MESSAGE"
          ]
        },
        "visitId": {
          "$ref": "#/definitions/VisitBroadcastId"
        }
      },
      "required": [
        "type",
        "visitId"
      ]
    },
    "VisitBroadcastId": {
      "type": "number"
    },
    "NotificationData.VisitStartingSoonReminder": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "VISIT_STARTING_SOON_REMINDER"
          ]
        },
        "visitId": {
          "$ref": "#/definitions/VisitBroadcastId"
        }
      },
      "required": [
        "type",
        "visitId"
      ]
    },
    "NotificationData.VisitNotification": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "VISIT_NOTIFICATION"
          ]
        },
        "visitId": {
          "$ref": "#/definitions/VisitBroadcastId"
        },
        "date": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "type",
        "visitId"
      ]
    },
    "NotificationData.PatientChatMessage": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PATIENT_CHAT_MESSAGE"
          ]
        },
        "chatRoomId": {
          "$ref": "#/definitions/ChatRoomId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        }
      },
      "required": [
        "chatRoomId",
        "patientId",
        "type"
      ]
    },
    "PatientId": {
      "type": "number"
    },
    "NotificationData.VisitInstanceNotification": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "VISIT_INSTANCE_NOTIFICATION"
          ]
        },
        "visitInstanceId": {
          "$ref": "#/definitions/VisitInstanceId"
        }
      },
      "required": [
        "type",
        "visitInstanceId"
      ]
    },
    "VisitInstanceId": {
      "type": "number"
    },
    "NotificationData.VisitAssignmentNotification": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "VISIT_ASSIGNMENT_NOTIFICATION"
          ]
        },
        "visitId": {
          "$ref": "#/definitions/VisitBroadcastId"
        }
      },
      "required": [
        "type",
        "visitId"
      ]
    },
    "NotificationData.VisitCancelNotification": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "VISIT_CANCEL_NOTIFICATION"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.ClusterNotification": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "NEW_CLUSTER_NOTIFICATION"
          ]
        },
        "clusterId": {
          "$ref": "#/definitions/ClusterId"
        }
      },
      "required": [
        "clusterId",
        "type"
      ]
    },
    "ClusterId": {
      "type": "number"
    },
    "NotificationData.AvailabilityAnomalyNotification": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AVAILABILITY_ANOMALY_NOTIFICATION"
          ]
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        }
      },
      "required": [
        "agencyId",
        "type"
      ]
    },
    "NotificationData.OrientationVideoReminderNotification": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "ORIENTATION_VIDEO_REMINDER_NOTIFICATION"
          ]
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        }
      },
      "required": [
        "agencyId",
        "type"
      ]
    },
    "NotificationData.ComplianceProblemNotification": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "COMPLIANCE_PROBLEM_NOTIFICATION"
          ]
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "complianceItem": {
          "$ref": "#/definitions/CaregiverDocumentTypeId"
        }
      },
      "required": [
        "agencyId",
        "complianceItem",
        "type"
      ]
    },
    "CaregiverDocumentTypeId": {
      "type": "number"
    },
    "NotificationData.VisitAwaitingPatientContact": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "VISIT_AWAITING_PATIENT_CONTACT"
          ]
        },
        "visitId": {
          "$ref": "#/definitions/VisitBroadcastId"
        }
      },
      "required": [
        "type",
        "visitId"
      ]
    },
    "NotificationData.CaregiverGotRecruited": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CAREGIVER_GOT_RECRUITED"
          ]
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        }
      },
      "required": [
        "agencyId",
        "type"
      ]
    },
    "NotificationData.RecruitmentApplicationReminder": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "RECRUITMENT_APPLICATION_REMINDER_NOTIFICATION"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.CaregiverMissingDocumentReminder": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CAREGIVER_MISSING_DOCUMENTS_REMINDER"
          ]
        },
        "scheduledVisitId": {
          "$ref": "#/definitions/VisitInstanceId"
        }
      },
      "required": [
        "scheduledVisitId",
        "type"
      ]
    },
    "NotificationData.PatientDocumentUnsubmittedRemainder": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PATIENT_DOCUMENT_UNSUBMITTED_REMINDER_NOTIFICATION"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.Covid19TrainingReminder": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "COVID_19_TRAINING_REMINDER"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.Covid19ScreeningReminder": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "COVID_19_SCREENING_REMINDER"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.Covid19VisitScreeningReminder": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "COVID_19_VISIT_SCREENING_REMINDER"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.CaregiverPassportDocumentVerificationStatusChanged": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CAREGIVER_PASSPORT_DOCUMENT_VERIFICATION_STATUS_CHANGED"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.ConvertImportedVisitRequestResult": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CONVERT_IMPORTED_VISIT_REQUEST_RESULT"
          ]
        },
        "success": {
          "type": "boolean"
        },
        "possiblePatients": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientId"
          }
        },
        "multipleCandidates": {
          "type": "boolean"
        },
        "noImportedVisit": {
          "type": "boolean"
        },
        "noCaregiver": {
          "type": "boolean"
        },
        "agencyId": {
          "anyOf": [
            {
              "$ref": "#/definitions/AgencyId"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "agencyId",
        "multipleCandidates",
        "noCaregiver",
        "noImportedVisit",
        "possiblePatients",
        "success",
        "type"
      ]
    },
    "NotificationData.PatientTaskNotification": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PATIENT_TASK_NOTIFICATION"
          ]
        },
        "patientTaskInstanceId": {
          "$ref": "#/definitions/PatientTaskInstanceId"
        }
      },
      "required": [
        "patientTaskInstanceId",
        "type"
      ]
    },
    "PatientTaskInstanceId": {
      "type": "number"
    },
    "NotificationData.CaregiverInactiveFor3Weeks": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CAREGIVER_INACTIVE_FOR_3_WEEKS"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.FormsAwaitingSubmissionTask": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "FORMS_AWAITING_SUBMISSION_TASK"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.TaskWasntScheduled": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "TASK_WASNT_SCHEDULED"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.MissedClockIn": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "MISSED_CLOCK_IN"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.MissedClockOut": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "MISSED_CLOCK_OUT"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.FormsAwaitingSubmissionVisit": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "FORMS_AWAITING_SUBMISSION_VISIT"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.ExpiredComplianceItem": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "EXPIRED_COMPLIANCE_ITEM"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.AboutToExpireComplianceItem": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "ABOUT_TO_EXPIRE_COMPLIANCE_ITEM"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.CaregiverVisitNotSeen": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CAREGIVER_VISIT_NOT_SEEN"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.PatientOnVacation": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PATIENT_ON_VACATION"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.DutySheetSubmissionReminder": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "DUTY_SHEET_SUBMISSION_REMINDER"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.OnboardingReminder": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "ONBOARDING_REMINDER"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.NewOnboardingVisits": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "NEW_ONBOARDING_VISITS"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.OnboardingDocumentNotification": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "ONBOARDING_DOCUMENT_NOTIFICATION"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.CommCenterTicketMessage": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "COMM_CENTER_TICKET_MESSAGE"
          ]
        },
        "ticketId": {
          "$ref": "#/definitions/CommCenterTicketId"
        }
      },
      "required": [
        "ticketId",
        "type"
      ]
    },
    "CommCenterTicketId": {
      "type": "number"
    },
    "NotificationData.OnboardingCaregiverEngagements": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "ONBOARDING_CAREGIVER_ENGAGEMENTS"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.OnboardingCaregiverEngagements2": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "ONBOARDING_CAREGIVER_ENGAGEMENTS2"
          ]
        },
        "payload": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "ACTIVE_NOT_REQUESTED_CASES"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "DID_NOT_COMPLETE_I9_SECTION"
                  ]
                },
                "sectionId": {
                  "$ref": "#/definitions/HRSectionId"
                },
                "subsectionId": {
                  "$ref": "#/definitions/HRSubSectionId"
                }
              },
              "required": [
                "sectionId",
                "subsectionId",
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "DOCUMENTS_APPROVED_MISSING_ORIENTATION"
                  ]
                },
                "bundleDueDateId": {
                  "$ref": "#/definitions/TrainingCenterBundleDueDateId"
                }
              },
              "required": [
                "bundleDueDateId",
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "DOCUMENTS_PENDING_MISSING_ORIENTATION"
                  ]
                },
                "bundleDueDateId": {
                  "$ref": "#/definitions/TrainingCenterBundleDueDateId"
                }
              },
              "required": [
                "bundleDueDateId",
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "FILE_APPROVED_MISSING_QUESTIONS"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "FIRST_REQUESTED_CASE_RECURRING"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "FIRST_REQUESTED_CASE_SCHEDULED"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "HAS_MEDICALS_UPLOADED_NONE"
                  ]
                },
                "sectionId": {
                  "$ref": "#/definitions/HRSectionId"
                },
                "subsectionId": {
                  "$ref": "#/definitions/HRSubSectionId"
                },
                "questionId": {
                  "$ref": "#/definitions/HRQuestionId"
                }
              },
              "required": [
                "questionId",
                "sectionId",
                "subsectionId",
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "ITEM_IS_REJECTED"
                  ]
                },
                "sectionId": {
                  "$ref": "#/definitions/HRSectionId"
                },
                "subsectionId": {
                  "$ref": "#/definitions/HRSubSectionId"
                },
                "questionId": {
                  "$ref": "#/definitions/HRQuestionId"
                }
              },
              "required": [
                "questionId",
                "sectionId",
                "subsectionId",
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "PROFILE_CREATED_APP_NOT_INSTALLED"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "PROFILE_CREATED_HAS_ANSWERS_NO_DOCS"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "PROFILE_CREATED_HAS_ANSWERS_SOME_DOCS"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "PROFILE_CREATED_NO_ANSWERS_AND_DOCS"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "FIRST_REQUESTED_CASE_ACCEPTED_BY_AGENCY"
                  ]
                },
                "visitInstanceId": {
                  "$ref": "#/definitions/VisitInstanceId"
                }
              },
              "required": [
                "type",
                "visitInstanceId"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "DID_NOT_COMPLETE_ONBOARDING2_RECURRING"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "DID_NOT_COMPLETE_ONBOARDING2_SCHEDULED"
                  ]
                }
              },
              "required": [
                "type"
              ]
            }
          ]
        }
      },
      "required": [
        "payload",
        "type"
      ]
    },
    "HRSectionId": {
      "type": "number"
    },
    "HRSubSectionId": {
      "type": "number"
    },
    "TrainingCenterBundleDueDateId": {
      "type": "number"
    },
    "HRQuestionId": {
      "type": "number"
    },
    "NotificationData.GeneralVisitAssignmentNotification": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GENERAL_VISIT_ASSIGNMENT_NOTIFICATION"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.InstaPayFailureNotification": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "INSTA_PAY_FAILURE_NOTIFICATION"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.VisitBroadcastStoppedByAgencyMember": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "VISIT_BROADCAST_STOPPED_BY_AGENCY_MEMBER"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "NotificationData.FlexibleVisitBroadcastDetailsChanged": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "FLEXIBLE_VISIT_BROADCAST_DETAILS_CHANGED"
          ]
        },
        "visitId": {
          "$ref": "#/definitions/VisitBroadcastId"
        }
      },
      "required": [
        "type",
        "visitId"
      ]
    },
    "NotificationData.CareMomentsCaregiverRankAdjusted": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "CARE_MOMENTS_CAREGIVER_RANK_ADJUSTED"
          ]
        },
        "payload": {
          "$ref": "#/definitions/CareMomentsCaregiverRankAdjustedPayload"
        }
      },
      "required": [
        "payload",
        "type"
      ]
    },
    "CareMomentsCaregiverRankAdjustedPayload": {
      "type": "object",
      "properties": {
        "adjustment": {
          "type": "object",
          "properties": {
            "id": {
              "$ref": "#/definitions/CareMomentsAdjustmentId"
            }
          },
          "required": [
            "id"
          ]
        }
      },
      "required": [
        "adjustment"
      ]
    },
    "CareMomentsAdjustmentId": {
      "format": "CareMomentsAdjustmentId",
      "type": "number"
    },
    "NotificationData.RaffleEngagement": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "RAFFLE_ENGAGEMENT"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverAssignedVisits",
{
  "description": "API payload from server containing all scheduled visits for a given visit",
  "type": "object",
  "properties": {
    "visitInstances": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/VisitInstanceDetails"
      }
    },
    "importedVisits": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverImportedVisitDetails"
      }
    }
  },
  "required": [
    "importedVisits",
    "visitInstances"
  ],
  "definitions": {
    "AgencyId": {
      "type": "number"
    },
    "PatientId": {
      "type": "number"
    },
    "VisitInstanceId": {
      "type": "number"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "VisitInstanceDetails": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "startTimeUTC": {
          "$ref": "#/definitions/Instant"
        },
        "startTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTimeUTC": {
          "$ref": "#/definitions/Instant"
        },
        "endTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "checkInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "checkOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "dutySheetFillPercentage": {
          "type": [
            "null",
            "number"
          ]
        },
        "isCaregiverClockEnabled": {
          "description": "Agency pilot for enabled clock in/out caregivers",
          "type": "boolean"
        },
        "publicVisitDetails": {
          "$ref": "#/definitions/PublicVisitInstanceDetails"
        },
        "confidentialVisitDetails": {
          "$ref": "#/definitions/ConfidentialVisitDetails"
        },
        "visitDocumentsStatus": {
          "$ref": "#/definitions/VisitDocumentsStatus"
        },
        "manualClockTimeEditApproved": {
          "type": "boolean"
        },
        "isDutySheetCompleted": {
          "type": "boolean"
        },
        "timeSheetSubmittedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "timeSheetDeclinedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "timeSheetApprovedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "hasPlanOfCare": {
          "type": "boolean"
        },
        "checkinMaxDistance": {
          "type": [
            "null",
            "number"
          ]
        },
        "requireSelfieOnClockIn": {
          "type": "boolean"
        },
        "requireSelfieOnClockOut": {
          "type": "boolean"
        }
      },
      "required": [
        "checkInTime",
        "checkOutTime",
        "checkinMaxDistance",
        "clockInTime",
        "clockOutTime",
        "confidentialVisitDetails",
        "dutySheetFillPercentage",
        "endTimeLocal",
        "endTimeUTC",
        "hasPlanOfCare",
        "id",
        "isCaregiverClockEnabled",
        "isDutySheetCompleted",
        "manualClockTimeEditApproved",
        "publicVisitDetails",
        "requireSelfieOnClockIn",
        "requireSelfieOnClockOut",
        "startTimeLocal",
        "startTimeUTC",
        "timeSheetApprovedAt",
        "timeSheetDeclinedAt",
        "timeSheetSubmittedAt",
        "visitDocumentsStatus"
      ]
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "PublicVisitInstanceDetails": {
      "type": "object",
      "properties": {
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "agency": {
          "$ref": "#/definitions/Agency"
        },
        "isBillingAgency": {
          "type": "boolean"
        },
        "isMedflytAgency": {
          "type": "boolean"
        },
        "startTime": {
          "$ref": "#/definitions/Instant"
        },
        "startTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTime": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        },
        "endTimeLocal": {
          "type": "string",
          "xreviver": "JSJoda.LocalDateTime"
        },
        "isSingleVisit": {
          "description": "Is this a single visit or recurring visit?",
          "type": "boolean"
        },
        "dayTimeParams": {
          "description": "Defines the time slots of the visit over a given week.",
          "anyOf": [
            {
              "$ref": "#/definitions/VisitDayTimeParams"
            },
            {
              "type": "null"
            }
          ]
        },
        "price": {
          "description": "USD, integer cents. \"$10.99\" equals the value 1099",
          "exclusiveMinimum": 0,
          "type": [
            "null",
            "number"
          ]
        },
        "languages": {
          "description": "Must be one of 'Caregiver.ALL_LANGUAGES'",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "generalNotes": {
          "type": "string"
        },
        "location": {
          "$ref": "#/definitions/AddressComponents"
        },
        "timezone": {
          "description": "timezone from the tz database (IANA)",
          "type": "string"
        },
        "createdById": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "createdByFirstName": {
          "type": "string"
        },
        "createdByLastName": {
          "type": "string"
        },
        "flexibleVisitParams": {
          "anyOf": [
            {
              "$ref": "#/definitions/PermanentFlexibleHoursAndDaysPerWeek"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursAndDaysPattern"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursFixedDaysPattern"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursFixedDaysPerWeek"
            },
            {
              "$ref": "#/definitions/PermanentFixedHoursFlexibleDays"
            },
            {
              "$ref": "#/definitions/SingleFlexible"
            },
            {
              "type": "null"
            }
          ]
        },
        "visitLabels": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitLabel"
          }
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientInitials": {
          "type": "string"
        },
        "patientAge": {
          "type": [
            "null",
            "number"
          ]
        },
        "patientGender": {
          "anyOf": [
            {
              "enum": [
                "F",
                "M"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientAllergies": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/Allergy"
          }
        },
        "patientLanguages": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientRequests": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientMedicalNotes": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientTasks": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "certifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverCertification"
          }
        },
        "clockInToleranceMinutes": {
          "type": "number"
        },
        "clockOutToleranceMinutes": {
          "type": "number"
        },
        "staffingPreferences2": {
          "$ref": "#/definitions/VisitStaffingPreferences"
        },
        "patientAdvancedDirectives": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientAdvancedDirective"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "agency",
        "certifications",
        "clockInToleranceMinutes",
        "clockOutToleranceMinutes",
        "createdAt",
        "createdByFirstName",
        "createdById",
        "createdByLastName",
        "dayTimeParams",
        "flexibleVisitParams",
        "generalNotes",
        "isBillingAgency",
        "isMedflytAgency",
        "isSingleVisit",
        "languages",
        "location",
        "patientAdvancedDirectives",
        "patientAge",
        "patientAllergies",
        "patientGender",
        "patientId",
        "patientInitials",
        "patientLanguages",
        "patientMedicalNotes",
        "patientRequests",
        "patientTasks",
        "price",
        "staffingPreferences2",
        "startTime",
        "startTimeLocal",
        "timezone",
        "visitLabels"
      ]
    },
    "Agency": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AgencyId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "name": {
          "type": "string"
        },
        "logoUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "website": {
          "type": [
            "null",
            "string"
          ]
        },
        "address": {
          "type": [
            "null",
            "string"
          ]
        },
        "officePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "organizationType": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumbers": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/AgencyIvrPhoneNumber"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "isMedflytAgency": {
          "type": "boolean"
        }
      },
      "required": [
        "address",
        "createdAt",
        "id",
        "isMedflytAgency",
        "ivrPhoneNumbers",
        "logoUrl",
        "name",
        "officePhone",
        "organizationType",
        "website"
      ]
    },
    "AgencyIvrPhoneNumber": {
      "type": "object",
      "properties": {
        "ivrPhoneNumber": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "description",
        "ivrPhoneNumber"
      ]
    },
    "VisitDayTimeParams": {
      "type": "object",
      "properties": {
        "dayTimes": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitDayTime"
          }
        }
      },
      "required": [
        "dayTimes"
      ]
    },
    "VisitDayTime": {
      "type": "object",
      "properties": {
        "day": {
          "description": "0 = sunday, 1 = monday, ... , 6 = saturday",
          "type": "integer",
          "minimum": 0,
          "maximum": 6
        },
        "startTime": {
          "$ref": "#/definitions/LocalTime"
        },
        "endTime": {
          "$ref": "#/definitions/LocalTime"
        }
      },
      "required": [
        "day",
        "endTime",
        "startTime"
      ]
    },
    "LocalTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalTime"
    },
    "AddressComponents": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "country": {
          "type": "string"
        },
        "administrativeAreaLevel1": {
          "type": "string"
        },
        "administrativeAreaLevel2": {
          "type": "string"
        },
        "sublocalityLevel1": {
          "type": [
            "null",
            "string"
          ]
        },
        "neighborhood": {
          "type": [
            "null",
            "string"
          ]
        },
        "locality": {
          "type": [
            "null",
            "string"
          ]
        },
        "formatedAddressDetails": {
          "$ref": "#/definitions/FormatedAddressDetails"
        }
      },
      "required": [
        "administrativeAreaLevel1",
        "administrativeAreaLevel2",
        "country",
        "location"
      ]
    },
    "Geo": {
      "type": "object",
      "properties": {
        "lat": {
          "type": "number"
        },
        "lng": {
          "type": "number"
        }
      },
      "required": [
        "lat",
        "lng"
      ]
    },
    "FormatedAddressDetails": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "address1": {
          "type": "string"
        },
        "country": {
          "type": "string"
        },
        "state": {
          "type": "string"
        },
        "county": {
          "type": "string"
        },
        "fullAddress": {
          "type": "string"
        },
        "city": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip5": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip4": {
          "type": [
            "null",
            "string"
          ]
        },
        "street": {
          "type": [
            "null",
            "string"
          ]
        },
        "streetNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "crossStreet": {
          "type": [
            "null",
            "string"
          ]
        },
        "address2": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "address1",
        "country",
        "county",
        "fullAddress",
        "location",
        "state"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "PermanentFlexibleHoursAndDaysPerWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursAndDaysPerWeek"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "amountOfHoursPerWeek": {
          "type": "number"
        },
        "minHoursPerShift": {
          "type": "number"
        },
        "maxHoursPerShift": {
          "type": "number"
        }
      },
      "required": [
        "amountOfHoursPerWeek",
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "maxHoursPerShift",
        "minHoursPerShift",
        "type"
      ]
    },
    "DayOfWeek": {
      "type": "string",
      "xreviver": "JSJoda.DayOfWeek"
    },
    "PermanentFlexibleHoursAndDaysPattern": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursAndDaysPattern"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "flexibleDetails": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "amountOfDays": {
                "type": "number"
              },
              "amountOfHours": {
                "type": "number"
              }
            },
            "required": [
              "amountOfDays",
              "amountOfHours"
            ]
          }
        }
      },
      "required": [
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "flexibleDetails",
        "type"
      ]
    },
    "PermanentFlexibleHoursFixedDaysPattern": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursFixedDaysPattern"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "details": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "day": {
                "$ref": "#/definitions/DayOfWeek"
              },
              "amountOfHours": {
                "type": "number"
              }
            },
            "required": [
              "amountOfHours",
              "day"
            ]
          }
        }
      },
      "required": [
        "details",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "PermanentFlexibleHoursFixedDaysPerWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursFixedDaysPerWeek"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "amountOfHoursPerWeek": {
          "type": "number"
        },
        "days": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "minHoursPerShift": {
          "type": "number"
        },
        "maxHoursPerShift": {
          "type": "number"
        }
      },
      "required": [
        "amountOfHoursPerWeek",
        "days",
        "excludedDaysFromCaregivers",
        "maxHoursPerShift",
        "minHoursPerShift",
        "type"
      ]
    },
    "PermanentFixedHoursFlexibleDays": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFixedHoursFlexibleDays"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "day": {
                "$ref": "#/definitions/DayOfWeek"
              },
              "startTime": {
                "$ref": "#/definitions/LocalTime"
              },
              "endTime": {
                "$ref": "#/definitions/LocalTime"
              }
            },
            "required": [
              "day",
              "endTime",
              "startTime"
            ]
          }
        },
        "amountOfDays": {
          "type": "number"
        }
      },
      "required": [
        "amountOfDays",
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "SingleFlexible": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SingleFlexible"
          ]
        },
        "date": {
          "$ref": "#/definitions/LocalDate"
        },
        "amountOfHours": {
          "type": "number"
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        }
      },
      "required": [
        "amountOfHours",
        "date",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "VisitLabel": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string"
        },
        "color": {
          "type": "string"
        }
      },
      "required": [
        "color",
        "text"
      ]
    },
    "Allergy": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AllergyId"
        },
        "name": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name"
      ]
    },
    "AllergyId": {
      "type": "number"
    },
    "CaregiverCertification": {
      "type": "string"
    },
    "VisitStaffingPreferences": {
      "type": "object",
      "properties": {
        "smoking": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "bedbound": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "cane": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "walker": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "wheelchair": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "kosher": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "halal": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "hoyer": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "pets": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "bedbound",
        "cane",
        "halal",
        "hoyer",
        "kosher",
        "pets",
        "smoking",
        "walker",
        "wheelchair"
      ]
    },
    "PatientAdvancedDirective": {
      "type": "object",
      "properties": {
        "hasDNR": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "hasProxy": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "firstName": {
          "type": [
            "null",
            "string"
          ]
        },
        "lastName": {
          "type": [
            "null",
            "string"
          ]
        },
        "phoneNumber": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "firstName",
        "hasDNR",
        "hasProxy",
        "lastName",
        "phoneNumber"
      ]
    },
    "ConfidentialVisitDetails": {
      "type": "object",
      "properties": {
        "patientName": {
          "type": "string"
        },
        "patientAddress": {
          "type": "string"
        },
        "patientAddress2": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAddressInstructions": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientPhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAlternativePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "caseDetails": {
          "type": "string"
        }
      },
      "required": [
        "caseDetails",
        "patientAddress",
        "patientAddress2",
        "patientAddressInstructions",
        "patientAlternativePhone",
        "patientName",
        "patientPhone"
      ]
    },
    "VisitDocumentsStatus": {
      "type": "object",
      "properties": {
        "total": {
          "type": "number"
        },
        "submitted": {
          "type": "number"
        }
      },
      "required": [
        "submitted",
        "total"
      ]
    },
    "CaregiverImportedVisitDetails": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/ImportedVisitId"
        },
        "agencyName": {
          "type": "string"
        },
        "patientName": {
          "type": "string"
        },
        "timezone": {
          "type": "string"
        },
        "startTimeUTC": {
          "$ref": "#/definitions/Instant"
        },
        "endTimeUTC": {
          "$ref": "#/definitions/Instant"
        },
        "startTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "agencyMemberId": {
          "anyOf": [
            {
              "$ref": "#/definitions/AgencyMemberId"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "agencyMemberId",
        "agencyName",
        "endTimeLocal",
        "endTimeUTC",
        "id",
        "patientName",
        "startTimeLocal",
        "startTimeUTC",
        "timezone"
      ]
    },
    "ImportedVisitId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["SimplifiedAgencies",
{
  "type": "object",
  "properties": {
    "agencyId": {
      "$ref": "#/definitions/AgencyId"
    },
    "name": {
      "type": "string"
    },
    "logoUrl": {
      "type": [
        "null",
        "string"
      ]
    },
    "address": {
      "type": [
        "null",
        "string"
      ]
    },
    "officePhone": {
      "type": [
        "null",
        "string"
      ]
    },
    "status": {
      "type": [
        "null",
        "string"
      ]
    }
  },
  "required": [
    "address",
    "agencyId",
    "logoUrl",
    "name",
    "officePhone",
    "status"
  ],
  "definitions": {
    "AgencyId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientDocumentAnswerObject",
{
  "type": "object",
  "properties": {
    "questionId": {
      "type": "number"
    },
    "chartRow": {
      "type": [
        "null",
        "number"
      ]
    },
    "answer": {
      "anyOf": [
        {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientContractDiagnosisCode"
          }
        },
        {
          "type": "array",
          "items": {
            "$ref": "#/definitions/POCItemsDocumentAnswer"
          }
        },
        {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientMedicationProfileWithDetails"
          }
        },
        {
          "type": [
            "null",
            "string"
          ]
        }
      ]
    },
    "answeredAt": {
      "anyOf": [
        {
          "$ref": "#/definitions/Instant"
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "answer",
    "answeredAt",
    "chartRow",
    "questionId"
  ],
  "definitions": {
    "PatientContractDiagnosisCode": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/PatientContractDiagnosisCodeId"
        },
        "icdCode": {
          "$ref": "#/definitions/ICD10CodeId"
        },
        "formattedDxCode": {
          "type": "string"
        },
        "shortDesc": {
          "type": "string"
        },
        "patientContractId": {
          "$ref": "#/definitions/PatientContractId"
        },
        "startDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "endDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "type": {
          "anyOf": [
            {
              "enum": [
                "PRINCIPAL",
                "SURGICAL"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "isForBilling": {
          "type": "boolean"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "createdBy": {
          "$ref": "#/definitions/UserId"
        },
        "updatedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "updatedBy": {
          "anyOf": [
            {
              "$ref": "#/definitions/UserId"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "createdAt",
        "createdBy",
        "endDate",
        "formattedDxCode",
        "icdCode",
        "id",
        "isForBilling",
        "patientContractId",
        "shortDesc",
        "startDate",
        "type",
        "updatedAt",
        "updatedBy"
      ]
    },
    "PatientContractDiagnosisCodeId": {
      "type": "number"
    },
    "ICD10CodeId": {
      "type": "number"
    },
    "PatientContractId": {
      "type": "number"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "UserId": {
      "type": "number"
    },
    "POCItemsDocumentAnswer": {
      "type": "object",
      "properties": {
        "idx": {
          "type": "number"
        },
        "attributes": {
          "anyOf": [
            {
              "$ref": "#/definitions/TaskWhenToPerform.EveryVisit"
            },
            {
              "$ref": "#/definitions/TaskWhenToPerform.OnDaysOfWeek"
            },
            {
              "$ref": "#/definitions/TaskWhenToPerform.AsRequestedByPatient"
            }
          ]
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "attributes",
        "idx"
      ]
    },
    "TaskWhenToPerform.EveryVisit": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "EveryVisit"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TaskWhenToPerform.OnDaysOfWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "OnDaysOfWeek"
          ]
        },
        "frequency": {
          "$ref": "#/definitions/FrequencyVisitedInAWeekDetails"
        },
        "days": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        }
      },
      "required": [
        "type"
      ]
    },
    "FrequencyVisitedInAWeekDetails": {
      "type": "object",
      "properties": {
        "frequency": {
          "type": [
            "null",
            "number"
          ]
        },
        "visitsInAWeek": {
          "type": [
            "null",
            "number"
          ]
        }
      },
      "required": [
        "frequency",
        "visitsInAWeek"
      ]
    },
    "DayOfWeek": {
      "type": "string",
      "xreviver": "JSJoda.DayOfWeek"
    },
    "TaskWhenToPerform.AsRequestedByPatient": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AsRequestedByPatient"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "PatientMedicationProfileWithDetails": {
      "type": "object",
      "properties": {
        "dose": {
          "type": "string"
        },
        "route": {
          "type": "string"
        },
        "medicationName": {
          "type": "string"
        },
        "id": {
          "$ref": "#/definitions/PatientMedicationProfileId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "medicationId": {
          "$ref": "#/definitions/MedicationId"
        },
        "from": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "until": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "frequency": {
          "type": [
            "null",
            "string"
          ]
        },
        "status": {
          "$ref": "#/definitions/PatientMedicationProfileStatus"
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "dose",
        "frequency",
        "from",
        "id",
        "medicationId",
        "medicationName",
        "notes",
        "patientId",
        "route",
        "status",
        "until"
      ]
    },
    "PatientMedicationProfileId": {
      "type": "number"
    },
    "PatientId": {
      "type": "number"
    },
    "MedicationId": {
      "type": "number"
    },
    "PatientMedicationProfileStatus": {
      "enum": [
        "ACTIVE",
        "DISCONTINUED"
      ],
      "type": "string"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientDocumentCopyExported",
{
  "type": "object",
  "properties": {
    "exportedDocumentTypeId": {
      "$ref": "#/definitions/PatientDocumentTypeId"
    },
    "exportedQuestionId": {
      "type": "number"
    },
    "answer": {
      "anyOf": [
        {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientContractDiagnosisCode"
          }
        },
        {
          "type": "array",
          "items": {
            "$ref": "#/definitions/POCItemsDocumentAnswer"
          }
        },
        {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PatientMedicationProfileWithDetails"
          }
        },
        {
          "type": [
            "null",
            "string"
          ]
        }
      ]
    },
    "questionId": {
      "type": "number"
    },
    "chartRow": {
      "type": [
        "null",
        "number"
      ]
    },
    "createdAt": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "vitalExtraDetails": {
      "$ref": "#/definitions/VitalExtraDetails"
    }
  },
  "required": [
    "answer",
    "chartRow",
    "exportedDocumentTypeId",
    "exportedQuestionId",
    "questionId"
  ],
  "definitions": {
    "PatientContractDiagnosisCode": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/PatientContractDiagnosisCodeId"
        },
        "icdCode": {
          "$ref": "#/definitions/ICD10CodeId"
        },
        "formattedDxCode": {
          "type": "string"
        },
        "shortDesc": {
          "type": "string"
        },
        "patientContractId": {
          "$ref": "#/definitions/PatientContractId"
        },
        "startDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "endDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "type": {
          "anyOf": [
            {
              "enum": [
                "PRINCIPAL",
                "SURGICAL"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "isForBilling": {
          "type": "boolean"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "createdBy": {
          "$ref": "#/definitions/UserId"
        },
        "updatedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "updatedBy": {
          "anyOf": [
            {
              "$ref": "#/definitions/UserId"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "createdAt",
        "createdBy",
        "endDate",
        "formattedDxCode",
        "icdCode",
        "id",
        "isForBilling",
        "patientContractId",
        "shortDesc",
        "startDate",
        "type",
        "updatedAt",
        "updatedBy"
      ]
    },
    "PatientContractDiagnosisCodeId": {
      "type": "number"
    },
    "ICD10CodeId": {
      "type": "number"
    },
    "PatientContractId": {
      "type": "number"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "UserId": {
      "type": "number"
    },
    "POCItemsDocumentAnswer": {
      "type": "object",
      "properties": {
        "idx": {
          "type": "number"
        },
        "attributes": {
          "anyOf": [
            {
              "$ref": "#/definitions/TaskWhenToPerform.EveryVisit"
            },
            {
              "$ref": "#/definitions/TaskWhenToPerform.OnDaysOfWeek"
            },
            {
              "$ref": "#/definitions/TaskWhenToPerform.AsRequestedByPatient"
            }
          ]
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "attributes",
        "idx"
      ]
    },
    "TaskWhenToPerform.EveryVisit": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "EveryVisit"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TaskWhenToPerform.OnDaysOfWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "OnDaysOfWeek"
          ]
        },
        "frequency": {
          "$ref": "#/definitions/FrequencyVisitedInAWeekDetails"
        },
        "days": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        }
      },
      "required": [
        "type"
      ]
    },
    "FrequencyVisitedInAWeekDetails": {
      "type": "object",
      "properties": {
        "frequency": {
          "type": [
            "null",
            "number"
          ]
        },
        "visitsInAWeek": {
          "type": [
            "null",
            "number"
          ]
        }
      },
      "required": [
        "frequency",
        "visitsInAWeek"
      ]
    },
    "DayOfWeek": {
      "type": "string",
      "xreviver": "JSJoda.DayOfWeek"
    },
    "TaskWhenToPerform.AsRequestedByPatient": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AsRequestedByPatient"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "PatientMedicationProfileWithDetails": {
      "type": "object",
      "properties": {
        "dose": {
          "type": "string"
        },
        "route": {
          "type": "string"
        },
        "medicationName": {
          "type": "string"
        },
        "id": {
          "$ref": "#/definitions/PatientMedicationProfileId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "medicationId": {
          "$ref": "#/definitions/MedicationId"
        },
        "from": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "until": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "frequency": {
          "type": [
            "null",
            "string"
          ]
        },
        "status": {
          "$ref": "#/definitions/PatientMedicationProfileStatus"
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "dose",
        "frequency",
        "from",
        "id",
        "medicationId",
        "medicationName",
        "notes",
        "patientId",
        "route",
        "status",
        "until"
      ]
    },
    "PatientMedicationProfileId": {
      "type": "number"
    },
    "PatientId": {
      "type": "number"
    },
    "MedicationId": {
      "type": "number"
    },
    "PatientMedicationProfileStatus": {
      "enum": [
        "ACTIVE",
        "DISCONTINUED"
      ],
      "type": "string"
    },
    "PatientDocumentTypeId": {
      "type": "number"
    },
    "VitalExtraDetails": {
      "type": "object",
      "properties": {
        "measuredAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "method": {
          "anyOf": [
            {
              "enum": [
                "Axillary",
                "Irregular",
                "Laying",
                "Left Arm",
                "Oral",
                "Rectal",
                "Regular",
                "Remote/Forehead",
                "Right Arm",
                "Sitting",
                "Standing"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "comments": {
          "type": [
            "null",
            "string"
          ]
        },
        "unit": {
          "anyOf": [
            {
              "enum": [
                "Beats Per Minute",
                "Breaths Per Minute",
                "FAHRENHEIT",
                "mmHg"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "comments",
        "measuredAt",
        "method",
        "unit"
      ]
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverUploadPhotoResponse",
{
  "type": "object",
  "properties": {
    "photos": {
      "type": "array",
      "items": {
        "type": "string"
      }
    }
  },
  "required": [
    "photos"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverUploadDocumentsResponse",
{
  "type": "object",
  "properties": {
    "documents": {
      "type": "array",
      "items": {
        "type": "string"
      }
    }
  },
  "required": [
    "documents"
  ],
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverUploadedDocuments",
{
  "type": "object",
  "properties": {
    "documents": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverUploadedDocument"
      }
    }
  },
  "required": [
    "documents"
  ],
  "definitions": {
    "CaregiverUploadedDocument": {
      "type": "object",
      "properties": {
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "caregiver": {
          "$ref": "#/definitions/CaregiverId"
        },
        "fileUrl": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "caregiver",
        "createdAt",
        "fileUrl"
      ]
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "CaregiverId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverUploadedDocumentsByCategory",
{
  "type": "object",
  "properties": {
    "categories": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverUploadedDocumentsInCategory"
      }
    }
  },
  "required": [
    "categories"
  ],
  "definitions": {
    "CaregiverUploadedDocumentsInCategory": {
      "type": "object",
      "properties": {
        "category": {
          "type": "number"
        },
        "types": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverUploadedDocumentsInDocType"
          }
        }
      },
      "required": [
        "category",
        "types"
      ]
    },
    "CaregiverUploadedDocumentsInDocType": {
      "type": "object",
      "properties": {
        "docType": {
          "type": "number"
        },
        "count": {
          "type": "number"
        }
      },
      "required": [
        "count",
        "docType"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["UploadDocumentCategories",
{
  "type": "object",
  "properties": {
    "categories": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/UploadDocumentCategory"
      }
    }
  },
  "required": [
    "categories"
  ],
  "definitions": {
    "UploadDocumentCategory": {
      "type": "object",
      "properties": {
        "id": {
          "type": "number"
        },
        "name": {
          "type": [
            "null",
            "string"
          ]
        },
        "types": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/UploadDocumentType"
          }
        }
      },
      "required": [
        "id",
        "name",
        "types"
      ]
    },
    "UploadDocumentType": {
      "type": "object",
      "properties": {
        "id": {
          "type": "number"
        },
        "name": {
          "type": "string"
        },
        "count": {
          "type": "number"
        }
      },
      "required": [
        "id",
        "name"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PassportDocumentCategories",
{
  "type": "object",
  "properties": {
    "categories": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/PassportDocumentCategory"
      }
    },
    "agencies": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/AgencyDocumentCategory"
      }
    }
  },
  "required": [
    "agencies",
    "categories"
  ],
  "definitions": {
    "PassportDocumentCategory": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/PassportCategoryId"
        },
        "name": {
          "$ref": "#/definitions/TranslationMapping<string>"
        },
        "documents": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PassportDocumentTypeWithVerificationStatus"
          }
        }
      },
      "required": [
        "documents",
        "id",
        "name"
      ]
    },
    "PassportCategoryId": {
      "type": "number"
    },
    "TranslationMapping<string>": {
      "type": "object",
      "properties": {
        "Albanian": {
          "type": "string"
        },
        "Arabic": {
          "type": "string"
        },
        "Armenian": {
          "type": "string"
        },
        "Bengali": {
          "type": "string"
        },
        "Bulgarian": {
          "type": "string"
        },
        "Cantonese": {
          "type": "string"
        },
        "Chinese": {
          "type": "string"
        },
        "Creole": {
          "type": "string"
        },
        "Danish": {
          "type": "string"
        },
        "Dutch": {
          "type": "string"
        },
        "English": {
          "type": "string"
        },
        "Estonian": {
          "type": "string"
        },
        "Farsi": {
          "type": "string"
        },
        "Filipino": {
          "type": "string"
        },
        "French": {
          "type": "string"
        },
        "Fukkianese": {
          "type": "string"
        },
        "Fula/Fulani": {
          "type": "string"
        },
        "Fuzhounese": {
          "type": "string"
        },
        "Georgian": {
          "type": "string"
        },
        "German": {
          "type": "string"
        },
        "Ghana": {
          "type": "string"
        },
        "Greek": {
          "type": "string"
        },
        "Hakka": {
          "type": "string"
        },
        "Hebrew": {
          "type": "string"
        },
        "Hindi": {
          "type": "string"
        },
        "Hungarian": {
          "type": "string"
        },
        "Italian": {
          "type": "string"
        },
        "Japanese": {
          "type": "string"
        },
        "Korean": {
          "type": "string"
        },
        "Krio": {
          "type": "string"
        },
        "Kyrgyz": {
          "type": "string"
        },
        "Mandarin": {
          "type": "string"
        },
        "Pashto": {
          "type": "string"
        },
        "Persian": {
          "type": "string"
        },
        "Polish": {
          "type": "string"
        },
        "Portuguese": {
          "type": "string"
        },
        "Punjabi": {
          "type": "string"
        },
        "Romanian": {
          "type": "string"
        },
        "Russian": {
          "type": "string"
        },
        "Shanghainese": {
          "type": "string"
        },
        "Soninke": {
          "type": "string"
        },
        "Spanish": {
          "type": "string"
        },
        "Swahili": {
          "type": "string"
        },
        "Tagalog": {
          "type": "string"
        },
        "Taishanese": {
          "type": "string"
        },
        "Taiwanese": {
          "type": "string"
        },
        "Turkish": {
          "type": "string"
        },
        "Twi": {
          "type": "string"
        },
        "Ukrainian": {
          "type": "string"
        },
        "Urdu": {
          "type": "string"
        },
        "Uzbek": {
          "type": "string"
        },
        "Vietnamese": {
          "type": "string"
        },
        "Yiddish": {
          "type": "string"
        }
      }
    },
    "PassportDocumentTypeWithVerificationStatus": {
      "type": "object",
      "properties": {
        "expiryDays": {
          "type": [
            "null",
            "number"
          ]
        },
        "verificationStatus": {
          "anyOf": [
            {
              "enum": [
                "APPROVED",
                "DECLINED",
                "PENDING"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/CaregiverDocumentTypeId"
        },
        "isExpires": {
          "type": "boolean"
        },
        "documentName": {
          "$ref": "#/definitions/TranslationMapping<string>"
        },
        "categoryId": {
          "type": "number"
        },
        "categoryName": {
          "$ref": "#/definitions/TranslationMapping<string>"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "removedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "passportCategoryType": {
          "type": "string",
          "enum": [
            "PASSPORT_CATEGORY"
          ]
        }
      },
      "required": [
        "categoryId",
        "categoryName",
        "createdAt",
        "documentName",
        "expiryDays",
        "id",
        "isExpires",
        "passportCategoryType",
        "removedAt",
        "verificationStatus"
      ]
    },
    "CaregiverDocumentTypeId": {
      "type": "number"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "AgencyDocumentCategory": {
      "type": "object",
      "properties": {
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "agencyName": {
          "type": "string"
        },
        "documents": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/AgencyDocumentType"
          }
        }
      },
      "required": [
        "agencyId",
        "agencyName",
        "documents"
      ]
    },
    "AgencyId": {
      "type": "number"
    },
    "AgencyDocumentType": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CaregiverDocumentTypeId"
        },
        "isExpires": {
          "type": "boolean"
        },
        "documentName": {
          "$ref": "#/definitions/TranslationMapping<string>"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "removedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "expiryDays": {
          "type": [
            "null",
            "number"
          ]
        },
        "passportCategoryType": {
          "type": "string",
          "enum": [
            "AGENCY_CATEGORY"
          ]
        }
      },
      "required": [
        "createdAt",
        "documentName",
        "expiryDays",
        "id",
        "isExpires",
        "passportCategoryType",
        "removedAt"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PassportDocumentTypes",
{
  "type": "object",
  "properties": {
    "documents": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/PassportDocumentType"
      }
    }
  },
  "required": [
    "documents"
  ],
  "definitions": {
    "TranslationMapping<string>": {
      "type": "object",
      "properties": {
        "Albanian": {
          "type": "string"
        },
        "Arabic": {
          "type": "string"
        },
        "Armenian": {
          "type": "string"
        },
        "Bengali": {
          "type": "string"
        },
        "Bulgarian": {
          "type": "string"
        },
        "Cantonese": {
          "type": "string"
        },
        "Chinese": {
          "type": "string"
        },
        "Creole": {
          "type": "string"
        },
        "Danish": {
          "type": "string"
        },
        "Dutch": {
          "type": "string"
        },
        "English": {
          "type": "string"
        },
        "Estonian": {
          "type": "string"
        },
        "Farsi": {
          "type": "string"
        },
        "Filipino": {
          "type": "string"
        },
        "French": {
          "type": "string"
        },
        "Fukkianese": {
          "type": "string"
        },
        "Fula/Fulani": {
          "type": "string"
        },
        "Fuzhounese": {
          "type": "string"
        },
        "Georgian": {
          "type": "string"
        },
        "German": {
          "type": "string"
        },
        "Ghana": {
          "type": "string"
        },
        "Greek": {
          "type": "string"
        },
        "Hakka": {
          "type": "string"
        },
        "Hebrew": {
          "type": "string"
        },
        "Hindi": {
          "type": "string"
        },
        "Hungarian": {
          "type": "string"
        },
        "Italian": {
          "type": "string"
        },
        "Japanese": {
          "type": "string"
        },
        "Korean": {
          "type": "string"
        },
        "Krio": {
          "type": "string"
        },
        "Kyrgyz": {
          "type": "string"
        },
        "Mandarin": {
          "type": "string"
        },
        "Pashto": {
          "type": "string"
        },
        "Persian": {
          "type": "string"
        },
        "Polish": {
          "type": "string"
        },
        "Portuguese": {
          "type": "string"
        },
        "Punjabi": {
          "type": "string"
        },
        "Romanian": {
          "type": "string"
        },
        "Russian": {
          "type": "string"
        },
        "Shanghainese": {
          "type": "string"
        },
        "Soninke": {
          "type": "string"
        },
        "Spanish": {
          "type": "string"
        },
        "Swahili": {
          "type": "string"
        },
        "Tagalog": {
          "type": "string"
        },
        "Taishanese": {
          "type": "string"
        },
        "Taiwanese": {
          "type": "string"
        },
        "Turkish": {
          "type": "string"
        },
        "Twi": {
          "type": "string"
        },
        "Ukrainian": {
          "type": "string"
        },
        "Urdu": {
          "type": "string"
        },
        "Uzbek": {
          "type": "string"
        },
        "Vietnamese": {
          "type": "string"
        },
        "Yiddish": {
          "type": "string"
        }
      }
    },
    "CaregiverDocumentTypeId": {
      "type": "number"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "PassportDocumentType": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CaregiverDocumentTypeId"
        },
        "isExpires": {
          "type": "boolean"
        },
        "documentName": {
          "$ref": "#/definitions/TranslationMapping<string>"
        },
        "categoryId": {
          "type": "number"
        },
        "categoryName": {
          "$ref": "#/definitions/TranslationMapping<string>"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "removedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "passportCategoryType": {
          "type": "string",
          "enum": [
            "PASSPORT_CATEGORY"
          ]
        }
      },
      "required": [
        "categoryId",
        "categoryName",
        "createdAt",
        "documentName",
        "id",
        "isExpires",
        "passportCategoryType",
        "removedAt"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PassportDocuments",
{
  "type": "object",
  "properties": {
    "documents": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/PassportDocument"
      }
    }
  },
  "required": [
    "documents"
  ],
  "definitions": {
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "PassportDocument": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CaregiverDocumentUploadId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        },
        "fileUrl": {
          "type": "string"
        },
        "docTypeId": {
          "$ref": "#/definitions/PassportDocumentTypesId"
        },
        "expiryDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "removedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "status": {
          "$ref": "#/definitions/PassportDocumentVerificationStatus"
        },
        "approvedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "approvedAt",
        "caregiverId",
        "createdAt",
        "docTypeId",
        "expiryDate",
        "fileUrl",
        "id",
        "removedAt",
        "status"
      ]
    },
    "CaregiverDocumentUploadId": {
      "type": "number"
    },
    "CaregiverId": {
      "type": "number"
    },
    "PassportDocumentTypesId": {
      "type": "number"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "PassportDocumentVerificationStatus": {
      "enum": [
        "APPROVED",
        "DECLINED",
        "PENDING"
      ],
      "type": "string"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientDocumentAnswerToCopy",
{
  "type": "object",
  "properties": {
    "textToUse": {
      "type": "string"
    },
    "dateUpdated": {
      "$ref": "#/definitions/Instant"
    }
  },
  "required": [
    "dateUpdated",
    "textToUse"
  ],
  "definitions": {
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientDocumentAnswersToCopy",
{
  "type": "object",
  "properties": {
    "patientDocumentAnswersToCopy": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/PatientDocumentAnswerToCopy"
      }
    }
  },
  "required": [
    "patientDocumentAnswersToCopy"
  ],
  "definitions": {
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "PatientDocumentAnswerToCopy": {
      "type": "object",
      "properties": {
        "textToUse": {
          "type": "string"
        },
        "dateUpdated": {
          "$ref": "#/definitions/Instant"
        }
      },
      "required": [
        "dateUpdated",
        "textToUse"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["Icd10Codes",
{
  "type": "object",
  "properties": {
    "codes": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/Icd10Code"
      }
    }
  },
  "required": [
    "codes"
  ],
  "definitions": {
    "Icd10Code": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/ICD10CodeId"
        },
        "dxCode": {
          "type": "string"
        },
        "formattedDxCode": {
          "type": "string"
        },
        "shortDesc": {
          "type": "string"
        },
        "longDesc": {
          "type": "string"
        }
      },
      "required": [
        "dxCode",
        "formattedDxCode",
        "id",
        "longDesc",
        "shortDesc"
      ]
    },
    "ICD10CodeId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["InstaPayVisitsData",
{
  "type": "object",
  "properties": {
    "overview": {
      "type": "object",
      "properties": {
        "eligibleBalance": {
          "type": "number"
        },
        "totalPayroll": {
          "type": "number"
        }
      },
      "required": [
        "eligibleBalance",
        "totalPayroll"
      ]
    },
    "totalVisits": {
      "type": "number"
    },
    "totalHours": {
      "type": "string"
    },
    "bankInformation": {
      "anyOf": [
        {
          "$ref": "#/definitions/CaregiverBankInformationWithEmail"
        },
        {
          "type": "null"
        }
      ]
    },
    "prevWeek": {
      "$ref": "#/definitions/LocalDate"
    },
    "nextWeek": {
      "$ref": "#/definitions/LocalDate"
    },
    "visits": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/InstaPayVisit"
      }
    }
  },
  "required": [
    "bankInformation",
    "nextWeek",
    "overview",
    "prevWeek",
    "totalHours",
    "totalVisits",
    "visits"
  ],
  "definitions": {
    "CaregiverBankInformationWithEmail": {
      "type": "object",
      "properties": {
        "email": {
          "type": [
            "null",
            "string"
          ]
        },
        "routingNumber": {
          "type": "string"
        },
        "accountNumber": {
          "type": "string"
        },
        "bankAccountTypeId": {
          "$ref": "#/definitions/InstaPayBankAccountTypeId"
        },
        "bankId": {
          "$ref": "#/definitions/InstaPayBankId"
        },
        "hasAgreedToTerms": {
          "type": "boolean"
        }
      },
      "required": [
        "accountNumber",
        "bankAccountTypeId",
        "bankId",
        "email",
        "hasAgreedToTerms",
        "routingNumber"
      ]
    },
    "InstaPayBankAccountTypeId": {
      "format": "InstaPayBankAccountTypeId",
      "type": "number"
    },
    "InstaPayBankId": {
      "format": "InstaPayBankId",
      "type": "number"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "InstaPayVisit": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "startTime": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTime": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "clockInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "payRate": {
          "type": [
            "null",
            "number"
          ]
        },
        "totalAmount": {
          "type": "number"
        },
        "duration": {
          "type": "string"
        },
        "status": {
          "anyOf": [
            {
              "$ref": "#/definitions/PaidVisitStatus"
            },
            {
              "$ref": "#/definitions/MissingClockTimesStatus"
            },
            {
              "$ref": "#/definitions/PendingIssuesVisitStatus"
            },
            {
              "$ref": "#/definitions/EligibleInstaPayVisitStatus"
            },
            {
              "$ref": "#/definitions/RegularPayInstaPayVisitStatus"
            },
            {
              "$ref": "#/definitions/VisitNotCompletedInstaPayVisitStatus"
            },
            {
              "$ref": "#/definitions/InstaPayInProgressVisitStatus"
            },
            {
              "$ref": "#/definitions/InstaPayTechnicalIssueStatus"
            }
          ]
        }
      },
      "required": [
        "clockInTime",
        "clockOutTime",
        "duration",
        "endTime",
        "id",
        "payRate",
        "startTime",
        "status",
        "totalAmount"
      ]
    },
    "VisitInstanceId": {
      "type": "number"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "PaidVisitStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Paid"
          ]
        },
        "amount": {
          "type": "number"
        },
        "paidAt": {
          "$ref": "#/definitions/LocalDate"
        }
      },
      "required": [
        "amount",
        "paidAt",
        "type"
      ]
    },
    "MissingClockTimesStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "MissingClockTimes"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "PendingIssuesVisitStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PendingIssues"
          ]
        },
        "earlyOrLateClockTimes": {
          "type": "boolean"
        },
        "clockTimesNotMobile": {
          "type": "boolean"
        },
        "visitTooShort": {
          "type": "boolean"
        },
        "missingPersonalCareDuty": {
          "type": "boolean"
        },
        "insufficientDuties": {
          "type": "boolean"
        },
        "outOfRange": {
          "type": "boolean"
        },
        "caregiverOverlap": {
          "type": "boolean"
        },
        "agencyIssues": {
          "type": "boolean"
        }
      },
      "required": [
        "agencyIssues",
        "caregiverOverlap",
        "clockTimesNotMobile",
        "earlyOrLateClockTimes",
        "insufficientDuties",
        "missingPersonalCareDuty",
        "outOfRange",
        "type",
        "visitTooShort"
      ]
    },
    "EligibleInstaPayVisitStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "EligibleInstaPay"
          ]
        },
        "eligibleAmount": {
          "type": "number"
        }
      },
      "required": [
        "eligibleAmount",
        "type"
      ]
    },
    "RegularPayInstaPayVisitStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "RegularPay"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "VisitNotCompletedInstaPayVisitStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "VisitNotCompleted"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "InstaPayInProgressVisitStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "InstaPayInProgress"
          ]
        },
        "requestedAt": {
          "$ref": "#/definitions/Instant"
        }
      },
      "required": [
        "requestedAt",
        "type"
      ]
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "InstaPayTechnicalIssueStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "TechnicalIssue"
          ]
        }
      },
      "required": [
        "type"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["EligibleInstaPayVisitsData",
{
  "type": "object",
  "properties": {
    "balance": {
      "type": "number"
    },
    "totalVisits": {
      "type": "number"
    },
    "totalHours": {
      "type": "string"
    },
    "bankInformation": {
      "anyOf": [
        {
          "$ref": "#/definitions/CaregiverBankInformationWithEmail"
        },
        {
          "type": "null"
        }
      ]
    },
    "visits": {
      "type": "array",
      "items": {
        "allOf": [
          {
            "$ref": "#/definitions/InstaPayVisit"
          },
          {
            "type": "object",
            "properties": {
              "status": {
                "$ref": "#/definitions/EligibleInstaPayVisitStatus"
              }
            },
            "required": [
              "status"
            ]
          }
        ]
      }
    }
  },
  "required": [
    "balance",
    "bankInformation",
    "totalHours",
    "totalVisits",
    "visits"
  ],
  "definitions": {
    "CaregiverBankInformationWithEmail": {
      "type": "object",
      "properties": {
        "email": {
          "type": [
            "null",
            "string"
          ]
        },
        "routingNumber": {
          "type": "string"
        },
        "accountNumber": {
          "type": "string"
        },
        "bankAccountTypeId": {
          "$ref": "#/definitions/InstaPayBankAccountTypeId"
        },
        "bankId": {
          "$ref": "#/definitions/InstaPayBankId"
        },
        "hasAgreedToTerms": {
          "type": "boolean"
        }
      },
      "required": [
        "accountNumber",
        "bankAccountTypeId",
        "bankId",
        "email",
        "hasAgreedToTerms",
        "routingNumber"
      ]
    },
    "InstaPayBankAccountTypeId": {
      "format": "InstaPayBankAccountTypeId",
      "type": "number"
    },
    "InstaPayBankId": {
      "format": "InstaPayBankId",
      "type": "number"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "InstaPayVisit": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "startTime": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTime": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "clockInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "payRate": {
          "type": [
            "null",
            "number"
          ]
        },
        "totalAmount": {
          "type": "number"
        },
        "duration": {
          "type": "string"
        },
        "status": {
          "anyOf": [
            {
              "$ref": "#/definitions/PaidVisitStatus"
            },
            {
              "$ref": "#/definitions/MissingClockTimesStatus"
            },
            {
              "$ref": "#/definitions/PendingIssuesVisitStatus"
            },
            {
              "$ref": "#/definitions/EligibleInstaPayVisitStatus"
            },
            {
              "$ref": "#/definitions/RegularPayInstaPayVisitStatus"
            },
            {
              "$ref": "#/definitions/VisitNotCompletedInstaPayVisitStatus"
            },
            {
              "$ref": "#/definitions/InstaPayInProgressVisitStatus"
            },
            {
              "$ref": "#/definitions/InstaPayTechnicalIssueStatus"
            }
          ]
        }
      },
      "required": [
        "clockInTime",
        "clockOutTime",
        "duration",
        "endTime",
        "id",
        "payRate",
        "startTime",
        "status",
        "totalAmount"
      ]
    },
    "VisitInstanceId": {
      "type": "number"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "PaidVisitStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Paid"
          ]
        },
        "amount": {
          "type": "number"
        },
        "paidAt": {
          "$ref": "#/definitions/LocalDate"
        }
      },
      "required": [
        "amount",
        "paidAt",
        "type"
      ]
    },
    "MissingClockTimesStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "MissingClockTimes"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "PendingIssuesVisitStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PendingIssues"
          ]
        },
        "earlyOrLateClockTimes": {
          "type": "boolean"
        },
        "clockTimesNotMobile": {
          "type": "boolean"
        },
        "visitTooShort": {
          "type": "boolean"
        },
        "missingPersonalCareDuty": {
          "type": "boolean"
        },
        "insufficientDuties": {
          "type": "boolean"
        },
        "outOfRange": {
          "type": "boolean"
        },
        "caregiverOverlap": {
          "type": "boolean"
        },
        "agencyIssues": {
          "type": "boolean"
        }
      },
      "required": [
        "agencyIssues",
        "caregiverOverlap",
        "clockTimesNotMobile",
        "earlyOrLateClockTimes",
        "insufficientDuties",
        "missingPersonalCareDuty",
        "outOfRange",
        "type",
        "visitTooShort"
      ]
    },
    "EligibleInstaPayVisitStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "EligibleInstaPay"
          ]
        },
        "eligibleAmount": {
          "type": "number"
        }
      },
      "required": [
        "eligibleAmount",
        "type"
      ]
    },
    "RegularPayInstaPayVisitStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "RegularPay"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "VisitNotCompletedInstaPayVisitStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "VisitNotCompleted"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "InstaPayInProgressVisitStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "InstaPayInProgress"
          ]
        },
        "requestedAt": {
          "$ref": "#/definitions/Instant"
        }
      },
      "required": [
        "requestedAt",
        "type"
      ]
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "InstaPayTechnicalIssueStatus": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "TechnicalIssue"
          ]
        }
      },
      "required": [
        "type"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["ResceduleVisitInstanceDetails",
{
  "type": "object",
  "properties": {
    "dayTimeParams": {
      "anyOf": [
        {
          "$ref": "#/definitions/VisitDayTimeParams"
        },
        {
          "type": "null"
        }
      ]
    },
    "duration": {
      "type": "number"
    },
    "startTimeLocal": {
      "$ref": "#/definitions/LocalDateTime"
    },
    "endTimeLocal": {
      "$ref": "#/definitions/LocalDateTime"
    }
  },
  "required": [
    "dayTimeParams",
    "duration",
    "endTimeLocal",
    "startTimeLocal"
  ],
  "definitions": {
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "VisitDayTimeParams": {
      "type": "object",
      "properties": {
        "dayTimes": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitDayTime"
          }
        }
      },
      "required": [
        "dayTimes"
      ]
    },
    "VisitDayTime": {
      "type": "object",
      "properties": {
        "day": {
          "description": "0 = sunday, 1 = monday, ... , 6 = saturday",
          "type": "integer",
          "minimum": 0,
          "maximum": 6
        },
        "startTime": {
          "$ref": "#/definitions/LocalTime"
        },
        "endTime": {
          "$ref": "#/definitions/LocalTime"
        }
      },
      "required": [
        "day",
        "endTime",
        "startTime"
      ]
    },
    "LocalTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalTime"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["RNVisitRequestParams",
{
  "type": "object",
  "properties": {
    "startTime": {
      "$ref": "#/definitions/LocalDateTime"
    },
    "endTime": {
      "$ref": "#/definitions/LocalDateTime"
    }
  },
  "required": [
    "endTime",
    "startTime"
  ],
  "definitions": {
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CoronaReportAllQuestionsResponse",
{
  "type": "object",
  "properties": {
    "caregiverQuestions": {
      "anyOf": [
        {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CoronaReportQuestionResponseLabelJsonb"
          }
        },
        {
          "type": "null"
        }
      ]
    },
    "patientQuestions": {
      "anyOf": [
        {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CoronaReportQuestionResponseLabelJsonb"
          }
        },
        {
          "type": "null"
        }
      ]
    },
    "shouldPopup": {
      "type": "boolean"
    }
  },
  "required": [
    "caregiverQuestions",
    "patientQuestions",
    "shouldPopup"
  ],
  "definitions": {
    "CoronaReportQuestionResponseLabelJsonb": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CoronaReportQuestionId"
        },
        "label": {
          "$ref": "#/definitions/TranslationMapping<string>"
        },
        "order": {
          "type": "number"
        },
        "type": {
          "$ref": "#/definitions/CoronaReportQuestionType"
        },
        "inputType": {
          "$ref": "#/definitions/CoronaReportQuestionInputType"
        },
        "answers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CoronaReportAnswerLabelJsonb"
          }
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/CoronaReportQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "showIfParentAnswerId": {
          "anyOf": [
            {
              "$ref": "#/definitions/CoronaReportAnswerId"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "answers",
        "id",
        "inputType",
        "label",
        "order",
        "parentId",
        "showIfParentAnswerId",
        "type"
      ]
    },
    "CoronaReportQuestionId": {
      "type": "number"
    },
    "TranslationMapping<string>": {
      "type": "object",
      "properties": {
        "Albanian": {
          "type": "string"
        },
        "Arabic": {
          "type": "string"
        },
        "Armenian": {
          "type": "string"
        },
        "Bengali": {
          "type": "string"
        },
        "Bulgarian": {
          "type": "string"
        },
        "Cantonese": {
          "type": "string"
        },
        "Chinese": {
          "type": "string"
        },
        "Creole": {
          "type": "string"
        },
        "Danish": {
          "type": "string"
        },
        "Dutch": {
          "type": "string"
        },
        "English": {
          "type": "string"
        },
        "Estonian": {
          "type": "string"
        },
        "Farsi": {
          "type": "string"
        },
        "Filipino": {
          "type": "string"
        },
        "French": {
          "type": "string"
        },
        "Fukkianese": {
          "type": "string"
        },
        "Fula/Fulani": {
          "type": "string"
        },
        "Fuzhounese": {
          "type": "string"
        },
        "Georgian": {
          "type": "string"
        },
        "German": {
          "type": "string"
        },
        "Ghana": {
          "type": "string"
        },
        "Greek": {
          "type": "string"
        },
        "Hakka": {
          "type": "string"
        },
        "Hebrew": {
          "type": "string"
        },
        "Hindi": {
          "type": "string"
        },
        "Hungarian": {
          "type": "string"
        },
        "Italian": {
          "type": "string"
        },
        "Japanese": {
          "type": "string"
        },
        "Korean": {
          "type": "string"
        },
        "Krio": {
          "type": "string"
        },
        "Kyrgyz": {
          "type": "string"
        },
        "Mandarin": {
          "type": "string"
        },
        "Pashto": {
          "type": "string"
        },
        "Persian": {
          "type": "string"
        },
        "Polish": {
          "type": "string"
        },
        "Portuguese": {
          "type": "string"
        },
        "Punjabi": {
          "type": "string"
        },
        "Romanian": {
          "type": "string"
        },
        "Russian": {
          "type": "string"
        },
        "Shanghainese": {
          "type": "string"
        },
        "Soninke": {
          "type": "string"
        },
        "Spanish": {
          "type": "string"
        },
        "Swahili": {
          "type": "string"
        },
        "Tagalog": {
          "type": "string"
        },
        "Taishanese": {
          "type": "string"
        },
        "Taiwanese": {
          "type": "string"
        },
        "Turkish": {
          "type": "string"
        },
        "Twi": {
          "type": "string"
        },
        "Ukrainian": {
          "type": "string"
        },
        "Urdu": {
          "type": "string"
        },
        "Uzbek": {
          "type": "string"
        },
        "Vietnamese": {
          "type": "string"
        },
        "Yiddish": {
          "type": "string"
        }
      }
    },
    "CoronaReportQuestionType": {
      "enum": [
        "CAREGIVER",
        "PATIENT"
      ],
      "type": "string"
    },
    "CoronaReportQuestionInputType": {
      "enum": [
        "NUMBER",
        "RADIO",
        "TEXT"
      ],
      "type": "string"
    },
    "CoronaReportAnswerLabelJsonb": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CoronaReportAnswerId"
        },
        "questionId": {
          "$ref": "#/definitions/CoronaReportQuestionId"
        },
        "label": {
          "$ref": "#/definitions/TranslationMapping<string>"
        },
        "inRisk": {
          "type": "boolean"
        }
      },
      "required": [
        "id",
        "inRisk",
        "label",
        "questionId"
      ]
    },
    "CoronaReportAnswerId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CoronaReportAgencyMemberChatPerson",
{
  "type": "object",
  "properties": {
    "agencyMemberId": {
      "anyOf": [
        {
          "$ref": "#/definitions/AgencyMemberId"
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "agencyMemberId"
  ],
  "definitions": {
    "AgencyMemberId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CoronaReportSubmitParams",
{
  "type": "object",
  "properties": {
    "answers": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "questionId": {
            "$ref": "#/definitions/CoronaReportQuestionId"
          },
          "answerId": {
            "anyOf": [
              {
                "$ref": "#/definitions/CoronaReportAnswerId"
              },
              {
                "type": "null"
              }
            ]
          },
          "answerFreeText": {
            "type": [
              "null",
              "string"
            ]
          }
        },
        "required": [
          "answerFreeText",
          "answerId",
          "questionId"
        ]
      }
    },
    "patientName": {
      "type": [
        "null",
        "string"
      ]
    },
    "patientAgencyId": {
      "anyOf": [
        {
          "$ref": "#/definitions/AgencyId"
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "answers",
    "patientAgencyId",
    "patientName"
  ],
  "definitions": {
    "CoronaReportQuestionId": {
      "type": "number"
    },
    "CoronaReportAnswerId": {
      "type": "number"
    },
    "AgencyId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverTrainingCenterBundles",
{
  "type": "object",
  "properties": {
    "bundles": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/TrainingCenterCaregiverBundle"
      }
    }
  },
  "required": [
    "bundles"
  ],
  "definitions": {
    "AgencyId": {
      "type": "number"
    },
    "TrainingCenterCaregiverBundle": {
      "type": "object",
      "properties": {
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "bundleId": {
          "$ref": "#/definitions/TrainingCenterBundleId"
        },
        "bundleDueDateId": {
          "$ref": "#/definitions/TrainingCenterBundleDueDateId"
        },
        "bundleDueDateYear": {
          "type": "number"
        },
        "visibleDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "completionDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "complianceDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "bundleParams": {
          "$ref": "#/definitions/TrainingCenterBundleParams"
        },
        "bundleDisplayData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterDisplayData>"
          }
        },
        "completionCertificate": {
          "anyOf": [
            {
              "$ref": "#/definitions/TrainingCenterBundleCertificate"
            },
            {
              "type": "null"
            }
          ]
        },
        "bundleItems": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterBundleItem"
          }
        },
        "showDuration": {
          "type": "boolean"
        }
      },
      "required": [
        "agencyId",
        "bundleDisplayData",
        "bundleDueDateId",
        "bundleDueDateYear",
        "bundleId",
        "bundleItems",
        "bundleParams",
        "completionCertificate",
        "completionDate",
        "complianceDate",
        "showDuration",
        "visibleDate"
      ]
    },
    "TrainingCenterBundleId": {
      "type": "number"
    },
    "TrainingCenterBundleDueDateId": {
      "type": "number"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "TrainingCenterBundleParams": {
      "type": "object",
      "properties": {
        "chatAgencyMemberId": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "signingAgencyMemberId": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "signingAgencyMemberTitle": {
          "type": "string"
        },
        "enforceWatchOrder": {
          "type": "boolean"
        },
        "requiredForBillingCompliance": {
          "type": "boolean"
        },
        "canWatchDuringVisitShift": {
          "type": "boolean"
        },
        "showBundleAfterDueDate": {
          "type": "boolean"
        },
        "caregiverCertifications": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "isOrientation": {
          "type": "boolean"
        }
      },
      "required": [
        "canWatchDuringVisitShift",
        "caregiverCertifications",
        "chatAgencyMemberId",
        "enforceWatchOrder",
        "isOrientation",
        "requiredForBillingCompliance",
        "showBundleAfterDueDate",
        "signingAgencyMemberId",
        "signingAgencyMemberTitle"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "TrainingCenterTranslated<TrainingCenterDisplayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterDisplayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterDisplayLanguage": {
      "type": "string"
    },
    "TrainingCenterDisplayData": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string"
        },
        "thumbnailUrl": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "thumbnailUrl",
        "title"
      ]
    },
    "TrainingCenterBundleCertificate": {
      "type": "object",
      "properties": {
        "createdAt": {
          "$ref": "#/definitions/Instant"
        }
      },
      "required": [
        "createdAt"
      ]
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "TrainingCenterBundleItem": {
      "type": "object",
      "properties": {
        "bundleItemId": {
          "$ref": "#/definitions/TrainingCenterBundleItemId"
        },
        "timeForCertificateMinutes": {
          "type": [
            "null",
            "number"
          ]
        },
        "media": {
          "anyOf": [
            {
              "$ref": "#/definitions/TrainingCenterBundleItemMedia.Video"
            },
            {
              "$ref": "#/definitions/TrainingCenterBundleItemMedia.PDF"
            },
            {
              "$ref": "#/definitions/TrainingCenterBundleItemMedia.TestOnly"
            }
          ]
        },
        "itemCompleted": {
          "type": "boolean"
        },
        "itemExempt": {
          "type": "boolean"
        },
        "caregiverSignatureDataURL": {
          "type": [
            "null",
            "string"
          ]
        },
        "testUnlocked": {
          "description": "The test becomes unlocked when the caregiver has watched enough of the\ntraining material (e.g. Video, PDF...)",
          "type": "boolean"
        },
        "testNumAttempts": {
          "description": "How many attempts has this caregiver submitted the test. If this is\nequal to or greater than `testMaxAttemptsAllowed` then the test\nquestions should be grayed out.",
          "type": "number"
        },
        "testParams": {
          "$ref": "#/definitions/TrainingCenterTestParams"
        },
        "displayData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterBundleItemDisplayData>"
          }
        },
        "currentTestQuestions": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterCaregiverTestQuestion"
          }
        },
        "fullDescriptions": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterBundleItemFullDescription"
          }
        }
      },
      "required": [
        "bundleItemId",
        "caregiverSignatureDataURL",
        "currentTestQuestions",
        "displayData",
        "fullDescriptions",
        "itemCompleted",
        "itemExempt",
        "media",
        "testNumAttempts",
        "testParams",
        "testUnlocked",
        "timeForCertificateMinutes"
      ]
    },
    "TrainingCenterBundleItemId": {
      "type": "number"
    },
    "TrainingCenterBundleItemMedia.Video": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Video"
          ]
        },
        "requiredWatchTimePercent": {
          "type": "number"
        },
        "source": {
          "$ref": "#/definitions/TrainingCenterBundleVideoSource"
        },
        "engagementQuestions": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterBundleItemVideoEngagementQuestion"
          }
        },
        "mediaOverlays": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterBundleItemVideoMediaOverlay"
          }
        },
        "videoInfo": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterVideoInfo>"
          }
        },
        "videoSubtitles": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterVideoSubtitles>"
          }
        },
        "videoWatchData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterCaregiverVideoWatchData>"
          }
        }
      },
      "required": [
        "engagementQuestions",
        "mediaOverlays",
        "requiredWatchTimePercent",
        "source",
        "type",
        "videoInfo",
        "videoSubtitles",
        "videoWatchData"
      ]
    },
    "TrainingCenterBundleVideoSource": {
      "enum": [
        "VIDEO_URL",
        "YOUTUBE"
      ],
      "type": "string"
    },
    "TrainingCenterBundleItemVideoEngagementQuestion": {
      "type": "object",
      "properties": {
        "questionId": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoEngmtQuestionId"
        },
        "atSecond": {
          "type": "number"
        },
        "duration": {
          "type": "number"
        },
        "displayData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterBundleItemVideoEngagementQuestionDisplayData>"
          }
        }
      },
      "required": [
        "atSecond",
        "displayData",
        "duration",
        "questionId"
      ]
    },
    "TrainingCenterBundleItemVideoEngmtQuestionId": {
      "type": "number"
    },
    "TrainingCenterTranslated<TrainingCenterBundleItemVideoEngagementQuestionDisplayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoEngagementQuestionDisplayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterBundleItemVideoEngagementQuestionDisplayData": {
      "type": "object",
      "properties": {
        "questionText": {
          "type": "string"
        },
        "questionAnswers": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "questionAnswers",
        "questionText"
      ]
    },
    "TrainingCenterBundleItemVideoMediaOverlay": {
      "type": "object",
      "properties": {
        "itemId": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoMediaOverlayId"
        },
        "atSecond": {
          "type": "number"
        },
        "duration": {
          "type": "number"
        },
        "position": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoMediaOverlayPosition"
        },
        "overlayData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterBundleItemVideoMediaOverlayData>"
          }
        }
      },
      "required": [
        "atSecond",
        "duration",
        "itemId",
        "overlayData",
        "position"
      ]
    },
    "TrainingCenterBundleItemVideoMediaOverlayId": {
      "type": "number"
    },
    "TrainingCenterBundleItemVideoMediaOverlayPosition": {
      "enum": [
        "BOTTOM",
        "CENTER",
        "TOP"
      ],
      "type": "string"
    },
    "TrainingCenterTranslated<TrainingCenterBundleItemVideoMediaOverlayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoMediaOverlayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterBundleItemVideoMediaOverlayData": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "imageUrl": {
          "type": "string"
        },
        "imageFileKey": {
          "type": "string"
        },
        "imageWidth": {
          "type": "number"
        }
      }
    },
    "TrainingCenterTranslated<TrainingCenterVideoInfo>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterVideoInfo"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterVideoInfo": {
      "type": "object",
      "properties": {
        "videoUrl": {
          "type": "string"
        },
        "thumbnailUrl": {
          "type": "string"
        },
        "videoLengthSeconds": {
          "type": "number"
        },
        "videoDimensions": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoDimensions"
        }
      },
      "required": [
        "thumbnailUrl",
        "videoDimensions",
        "videoLengthSeconds",
        "videoUrl"
      ]
    },
    "TrainingCenterBundleItemVideoDimensions": {
      "type": "object",
      "properties": {
        "width": {
          "type": [
            "null",
            "number"
          ]
        },
        "height": {
          "type": [
            "null",
            "number"
          ]
        }
      },
      "required": [
        "height",
        "width"
      ]
    },
    "TrainingCenterTranslated<TrainingCenterVideoSubtitles>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterVideoSubtitles"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterVideoSubtitles": {
      "type": "object",
      "properties": {
        "subtitlesUrl": {
          "type": "string"
        }
      },
      "required": [
        "subtitlesUrl"
      ]
    },
    "TrainingCenterTranslated<TrainingCenterCaregiverVideoWatchData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterCaregiverVideoWatchData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterCaregiverVideoWatchData": {
      "type": "object",
      "properties": {
        "totalSecondsWatched": {
          "type": "number"
        },
        "watchedSegments": {
          "description": "Array of segments that were watched: `[startSecond, endSecond]`",
          "type": "array",
          "items": {
            "type": "array",
            "items": [
              {
                "type": "number"
              },
              {
                "type": "number"
              }
            ],
            "minItems": 2,
            "additionalItems": {
              "anyOf": [
                {
                  "type": "number"
                },
                {
                  "type": "number"
                }
              ]
            }
          }
        }
      },
      "required": [
        "totalSecondsWatched",
        "watchedSegments"
      ]
    },
    "TrainingCenterBundleItemMedia.PDF": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PDF"
          ]
        },
        "requiredViewTimeMinutes": {
          "type": "number"
        },
        "pdfFileDownloadable": {
          "type": "boolean"
        },
        "pdfInfo": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterPDFInfo>"
          }
        },
        "pdfWatchData": {
          "$ref": "#/definitions/TrainingCenterCaregiverPDFWatchData"
        }
      },
      "required": [
        "pdfFileDownloadable",
        "pdfInfo",
        "pdfWatchData",
        "requiredViewTimeMinutes",
        "type"
      ]
    },
    "TrainingCenterTranslated<TrainingCenterPDFInfo>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterPDFInfo"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterPDFInfo": {
      "type": "object",
      "properties": {
        "pdfUrl": {
          "type": "string"
        }
      },
      "required": [
        "pdfUrl"
      ]
    },
    "TrainingCenterCaregiverPDFWatchData": {
      "type": "object",
      "properties": {
        "totalSecondsWatched": {
          "type": "number"
        }
      },
      "required": [
        "totalSecondsWatched"
      ]
    },
    "TrainingCenterBundleItemMedia.TestOnly": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "TestOnly"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TrainingCenterTestParams": {
      "type": "object",
      "properties": {
        "versionNum": {
          "type": "number"
        },
        "maxWrongAnswers": {
          "description": "How many wrong answers are allowed to still pass the test",
          "type": "number"
        },
        "showWrongAnswers": {
          "description": "If the caregiver failed the test, should we show her which answers she\ngot wrong?",
          "type": "boolean"
        },
        "testMaxAttemptsAllowed": {
          "description": "How many total attempts are allowed for this test?",
          "type": "number"
        }
      },
      "required": [
        "maxWrongAnswers",
        "showWrongAnswers",
        "testMaxAttemptsAllowed",
        "versionNum"
      ]
    },
    "TrainingCenterTranslated<TrainingCenterBundleItemDisplayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterBundleItemDisplayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterBundleItemDisplayData": {
      "type": "object",
      "properties": {
        "title": {
          "type": [
            "null",
            "string"
          ]
        },
        "label": {
          "type": [
            "null",
            "string"
          ]
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "sectionHeader": {
          "type": [
            "null",
            "string"
          ]
        },
        "sectionDescription": {
          "type": [
            "null",
            "string"
          ]
        },
        "testSuccessMessage": {
          "type": [
            "null",
            "string"
          ]
        },
        "testFailMessage": {
          "type": [
            "null",
            "string"
          ]
        },
        "testRetryMessage": {
          "type": [
            "null",
            "string"
          ]
        },
        "thumbnailUrl": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "description",
        "label",
        "sectionDescription",
        "sectionHeader",
        "testFailMessage",
        "testRetryMessage",
        "testSuccessMessage",
        "thumbnailUrl",
        "title"
      ]
    },
    "TrainingCenterCaregiverTestQuestion": {
      "type": "object",
      "properties": {
        "questionId": {
          "$ref": "#/definitions/TrainingCenterBundleItemTestQuestionId"
        },
        "displayData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterTestQuestionDisplayData>"
          }
        },
        "markedAnswer": {
          "description": "The currently selected answer, or the submitted answer from the last\nsubmitted test",
          "type": [
            "null",
            "number"
          ]
        },
        "markedAnswerCorrect": {
          "description": "The marked answer is known to be the correct answer (its value is 0 and\nwas submitted as a test)",
          "type": "boolean"
        },
        "incorrectlyGuessedAnswers": {
          "description": "Submitted answers that were incorrect (from all previous test\nsubmissions)",
          "type": "array",
          "items": {
            "type": "number"
          }
        }
      },
      "required": [
        "displayData",
        "incorrectlyGuessedAnswers",
        "markedAnswer",
        "markedAnswerCorrect",
        "questionId"
      ]
    },
    "TrainingCenterBundleItemTestQuestionId": {
      "type": "number"
    },
    "TrainingCenterTranslated<TrainingCenterTestQuestionDisplayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterTestQuestionDisplayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterTestQuestionDisplayData": {
      "type": "object",
      "properties": {
        "questionText": {
          "type": "string"
        },
        "questionAnswers": {
          "description": "The first answer is always the correct answer",
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "questionAnswers",
        "questionText"
      ]
    },
    "TrainingCenterBundleItemFullDescription": {
      "type": "object",
      "properties": {
        "itemId": {
          "$ref": "#/definitions/TrainingCenterBundleItemFullDescriptionId"
        },
        "fullDescriptionData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterBundleItemFullDescriptionData>"
          }
        }
      },
      "required": [
        "fullDescriptionData",
        "itemId"
      ]
    },
    "TrainingCenterBundleItemFullDescriptionId": {
      "type": "number"
    },
    "TrainingCenterTranslated<TrainingCenterBundleItemFullDescriptionData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterBundleItemFullDescriptionData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterBundleItemFullDescriptionData": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string"
        },
        "subtitle": {
          "type": "string"
        },
        "text": {
          "type": "string"
        },
        "imageUrl": {
          "type": "string"
        },
        "imageDescription": {
          "type": "string"
        },
        "imageFileKey": {
          "type": "string"
        },
        "speechFiles": {
          "type": "object",
          "properties": {
            "titleSpeechAudioFileUrl": {
              "type": "string"
            },
            "titleSpeechMarksFileUrl": {
              "type": "string"
            },
            "subtitleSpeechAudioFileUrl": {
              "type": "string"
            },
            "subtitleSpeechMarksFileUrl": {
              "type": "string"
            },
            "textSpeechAudioFileUrl": {
              "type": "string"
            },
            "textSpeechMarksFileUrl": {
              "type": "string"
            }
          }
        }
      },
      "required": [
        "speechFiles"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverSurveyQuestionsList",
{
  "type": "object",
  "properties": {
    "questions": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverSurveyQuestionWithPossibleAnswers"
      }
    }
  },
  "required": [
    "questions"
  ],
  "definitions": {
    "CaregiverSurveyQuestionWithPossibleAnswers": {
      "type": "object",
      "properties": {
        "possibleAnswers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverSurveyQuestionAnswer"
          }
        },
        "id": {
          "$ref": "#/definitions/CaregiverSurveyQuestionId"
        },
        "title": {
          "$ref": "#/definitions/TranslationMapping<string>"
        },
        "isMulti": {
          "type": "boolean"
        },
        "order": {
          "type": "number"
        }
      },
      "required": [
        "id",
        "isMulti",
        "order",
        "possibleAnswers",
        "title"
      ]
    },
    "CaregiverSurveyQuestionAnswer": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CaregiverSurveyQuestionAnswerId"
        },
        "text": {
          "$ref": "#/definitions/TranslationMapping<string>"
        },
        "order": {
          "type": "number"
        }
      },
      "required": [
        "id",
        "order",
        "text"
      ]
    },
    "CaregiverSurveyQuestionAnswerId": {
      "type": "number"
    },
    "TranslationMapping<string>": {
      "type": "object",
      "properties": {
        "Albanian": {
          "type": "string"
        },
        "Arabic": {
          "type": "string"
        },
        "Armenian": {
          "type": "string"
        },
        "Bengali": {
          "type": "string"
        },
        "Bulgarian": {
          "type": "string"
        },
        "Cantonese": {
          "type": "string"
        },
        "Chinese": {
          "type": "string"
        },
        "Creole": {
          "type": "string"
        },
        "Danish": {
          "type": "string"
        },
        "Dutch": {
          "type": "string"
        },
        "English": {
          "type": "string"
        },
        "Estonian": {
          "type": "string"
        },
        "Farsi": {
          "type": "string"
        },
        "Filipino": {
          "type": "string"
        },
        "French": {
          "type": "string"
        },
        "Fukkianese": {
          "type": "string"
        },
        "Fula/Fulani": {
          "type": "string"
        },
        "Fuzhounese": {
          "type": "string"
        },
        "Georgian": {
          "type": "string"
        },
        "German": {
          "type": "string"
        },
        "Ghana": {
          "type": "string"
        },
        "Greek": {
          "type": "string"
        },
        "Hakka": {
          "type": "string"
        },
        "Hebrew": {
          "type": "string"
        },
        "Hindi": {
          "type": "string"
        },
        "Hungarian": {
          "type": "string"
        },
        "Italian": {
          "type": "string"
        },
        "Japanese": {
          "type": "string"
        },
        "Korean": {
          "type": "string"
        },
        "Krio": {
          "type": "string"
        },
        "Kyrgyz": {
          "type": "string"
        },
        "Mandarin": {
          "type": "string"
        },
        "Pashto": {
          "type": "string"
        },
        "Persian": {
          "type": "string"
        },
        "Polish": {
          "type": "string"
        },
        "Portuguese": {
          "type": "string"
        },
        "Punjabi": {
          "type": "string"
        },
        "Romanian": {
          "type": "string"
        },
        "Russian": {
          "type": "string"
        },
        "Shanghainese": {
          "type": "string"
        },
        "Soninke": {
          "type": "string"
        },
        "Spanish": {
          "type": "string"
        },
        "Swahili": {
          "type": "string"
        },
        "Tagalog": {
          "type": "string"
        },
        "Taishanese": {
          "type": "string"
        },
        "Taiwanese": {
          "type": "string"
        },
        "Turkish": {
          "type": "string"
        },
        "Twi": {
          "type": "string"
        },
        "Ukrainian": {
          "type": "string"
        },
        "Urdu": {
          "type": "string"
        },
        "Uzbek": {
          "type": "string"
        },
        "Vietnamese": {
          "type": "string"
        },
        "Yiddish": {
          "type": "string"
        }
      }
    },
    "CaregiverSurveyQuestionId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["TrainingCenterCaregiverSubmitTestResult",
{
  "anyOf": [
    {
      "$ref": "#/definitions/TrainingCenterCaregiverSubmitTestResult.NotFound"
    },
    {
      "$ref": "#/definitions/TrainingCenterCaregiverSubmitTestResult.BundleNotVisibleToCaregiver"
    },
    {
      "$ref": "#/definitions/TrainingCenterCaregiverSubmitTestResult.OutdatedTestVersion"
    },
    {
      "$ref": "#/definitions/TrainingCenterCaregiverSubmitTestResult.AlreadyCompletedBundleItem"
    },
    {
      "$ref": "#/definitions/TrainingCenterCaregiverSubmitTestResult.ExemptFromBundleItem"
    },
    {
      "$ref": "#/definitions/TrainingCenterCaregiverSubmitTestResult.TooManyFailedAttempts"
    },
    {
      "$ref": "#/definitions/TrainingCenterCaregiverSubmitTestResult.TestNotUnlocked"
    },
    {
      "$ref": "#/definitions/TrainingCenterCaregiverSubmitTestResult.QuestionAnswersInvalid"
    },
    {
      "$ref": "#/definitions/TrainingCenterCaregiverSubmitTestResult.Success"
    }
  ],
  "definitions": {
    "TrainingCenterCaregiverSubmitTestResult.NotFound": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "NotFound"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TrainingCenterCaregiverSubmitTestResult.BundleNotVisibleToCaregiver": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "BundleNotVisibleToCaregiver"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TrainingCenterCaregiverSubmitTestResult.OutdatedTestVersion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "OutdatedTestVersion"
          ]
        },
        "submittedTestVersionNum": {
          "type": "number"
        },
        "currentTestVersionNum": {
          "type": "number"
        }
      },
      "required": [
        "currentTestVersionNum",
        "submittedTestVersionNum",
        "type"
      ]
    },
    "TrainingCenterCaregiverSubmitTestResult.AlreadyCompletedBundleItem": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AlreadyCompletedBundleItem"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TrainingCenterCaregiverSubmitTestResult.ExemptFromBundleItem": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "ExemptFromBundleItem"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TrainingCenterCaregiverSubmitTestResult.TooManyFailedAttempts": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "TooManyFailedAttempts"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TrainingCenterCaregiverSubmitTestResult.TestNotUnlocked": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "TestNotUnlocked"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TrainingCenterCaregiverSubmitTestResult.QuestionAnswersInvalid": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "QuestionAnswersInvalid"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TrainingCenterCaregiverSubmitTestResult.Success": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Success"
          ]
        },
        "passedTest": {
          "type": "boolean"
        },
        "bundle": {
          "$ref": "#/definitions/TrainingCenterCaregiverBundle"
        }
      },
      "required": [
        "bundle",
        "passedTest",
        "type"
      ]
    },
    "TrainingCenterCaregiverBundle": {
      "type": "object",
      "properties": {
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "bundleId": {
          "$ref": "#/definitions/TrainingCenterBundleId"
        },
        "bundleDueDateId": {
          "$ref": "#/definitions/TrainingCenterBundleDueDateId"
        },
        "bundleDueDateYear": {
          "type": "number"
        },
        "visibleDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "completionDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "complianceDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "bundleParams": {
          "$ref": "#/definitions/TrainingCenterBundleParams"
        },
        "bundleDisplayData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterDisplayData>"
          }
        },
        "completionCertificate": {
          "anyOf": [
            {
              "$ref": "#/definitions/TrainingCenterBundleCertificate"
            },
            {
              "type": "null"
            }
          ]
        },
        "bundleItems": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterBundleItem"
          }
        },
        "showDuration": {
          "type": "boolean"
        }
      },
      "required": [
        "agencyId",
        "bundleDisplayData",
        "bundleDueDateId",
        "bundleDueDateYear",
        "bundleId",
        "bundleItems",
        "bundleParams",
        "completionCertificate",
        "completionDate",
        "complianceDate",
        "showDuration",
        "visibleDate"
      ]
    },
    "AgencyId": {
      "type": "number"
    },
    "TrainingCenterBundleId": {
      "type": "number"
    },
    "TrainingCenterBundleDueDateId": {
      "type": "number"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "TrainingCenterBundleParams": {
      "type": "object",
      "properties": {
        "chatAgencyMemberId": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "signingAgencyMemberId": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "signingAgencyMemberTitle": {
          "type": "string"
        },
        "enforceWatchOrder": {
          "type": "boolean"
        },
        "requiredForBillingCompliance": {
          "type": "boolean"
        },
        "canWatchDuringVisitShift": {
          "type": "boolean"
        },
        "showBundleAfterDueDate": {
          "type": "boolean"
        },
        "caregiverCertifications": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "isOrientation": {
          "type": "boolean"
        }
      },
      "required": [
        "canWatchDuringVisitShift",
        "caregiverCertifications",
        "chatAgencyMemberId",
        "enforceWatchOrder",
        "isOrientation",
        "requiredForBillingCompliance",
        "showBundleAfterDueDate",
        "signingAgencyMemberId",
        "signingAgencyMemberTitle"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "TrainingCenterTranslated<TrainingCenterDisplayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterDisplayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterDisplayLanguage": {
      "type": "string"
    },
    "TrainingCenterDisplayData": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string"
        },
        "thumbnailUrl": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "thumbnailUrl",
        "title"
      ]
    },
    "TrainingCenterBundleCertificate": {
      "type": "object",
      "properties": {
        "createdAt": {
          "$ref": "#/definitions/Instant"
        }
      },
      "required": [
        "createdAt"
      ]
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "TrainingCenterBundleItem": {
      "type": "object",
      "properties": {
        "bundleItemId": {
          "$ref": "#/definitions/TrainingCenterBundleItemId"
        },
        "timeForCertificateMinutes": {
          "type": [
            "null",
            "number"
          ]
        },
        "media": {
          "anyOf": [
            {
              "$ref": "#/definitions/TrainingCenterBundleItemMedia.Video"
            },
            {
              "$ref": "#/definitions/TrainingCenterBundleItemMedia.PDF"
            },
            {
              "$ref": "#/definitions/TrainingCenterBundleItemMedia.TestOnly"
            }
          ]
        },
        "itemCompleted": {
          "type": "boolean"
        },
        "itemExempt": {
          "type": "boolean"
        },
        "caregiverSignatureDataURL": {
          "type": [
            "null",
            "string"
          ]
        },
        "testUnlocked": {
          "description": "The test becomes unlocked when the caregiver has watched enough of the\ntraining material (e.g. Video, PDF...)",
          "type": "boolean"
        },
        "testNumAttempts": {
          "description": "How many attempts has this caregiver submitted the test. If this is\nequal to or greater than `testMaxAttemptsAllowed` then the test\nquestions should be grayed out.",
          "type": "number"
        },
        "testParams": {
          "$ref": "#/definitions/TrainingCenterTestParams"
        },
        "displayData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterBundleItemDisplayData>"
          }
        },
        "currentTestQuestions": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterCaregiverTestQuestion"
          }
        },
        "fullDescriptions": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterBundleItemFullDescription"
          }
        }
      },
      "required": [
        "bundleItemId",
        "caregiverSignatureDataURL",
        "currentTestQuestions",
        "displayData",
        "fullDescriptions",
        "itemCompleted",
        "itemExempt",
        "media",
        "testNumAttempts",
        "testParams",
        "testUnlocked",
        "timeForCertificateMinutes"
      ]
    },
    "TrainingCenterBundleItemId": {
      "type": "number"
    },
    "TrainingCenterBundleItemMedia.Video": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Video"
          ]
        },
        "requiredWatchTimePercent": {
          "type": "number"
        },
        "source": {
          "$ref": "#/definitions/TrainingCenterBundleVideoSource"
        },
        "engagementQuestions": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterBundleItemVideoEngagementQuestion"
          }
        },
        "mediaOverlays": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterBundleItemVideoMediaOverlay"
          }
        },
        "videoInfo": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterVideoInfo>"
          }
        },
        "videoSubtitles": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterVideoSubtitles>"
          }
        },
        "videoWatchData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterCaregiverVideoWatchData>"
          }
        }
      },
      "required": [
        "engagementQuestions",
        "mediaOverlays",
        "requiredWatchTimePercent",
        "source",
        "type",
        "videoInfo",
        "videoSubtitles",
        "videoWatchData"
      ]
    },
    "TrainingCenterBundleVideoSource": {
      "enum": [
        "VIDEO_URL",
        "YOUTUBE"
      ],
      "type": "string"
    },
    "TrainingCenterBundleItemVideoEngagementQuestion": {
      "type": "object",
      "properties": {
        "questionId": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoEngmtQuestionId"
        },
        "atSecond": {
          "type": "number"
        },
        "duration": {
          "type": "number"
        },
        "displayData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterBundleItemVideoEngagementQuestionDisplayData>"
          }
        }
      },
      "required": [
        "atSecond",
        "displayData",
        "duration",
        "questionId"
      ]
    },
    "TrainingCenterBundleItemVideoEngmtQuestionId": {
      "type": "number"
    },
    "TrainingCenterTranslated<TrainingCenterBundleItemVideoEngagementQuestionDisplayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoEngagementQuestionDisplayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterBundleItemVideoEngagementQuestionDisplayData": {
      "type": "object",
      "properties": {
        "questionText": {
          "type": "string"
        },
        "questionAnswers": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "questionAnswers",
        "questionText"
      ]
    },
    "TrainingCenterBundleItemVideoMediaOverlay": {
      "type": "object",
      "properties": {
        "itemId": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoMediaOverlayId"
        },
        "atSecond": {
          "type": "number"
        },
        "duration": {
          "type": "number"
        },
        "position": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoMediaOverlayPosition"
        },
        "overlayData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterBundleItemVideoMediaOverlayData>"
          }
        }
      },
      "required": [
        "atSecond",
        "duration",
        "itemId",
        "overlayData",
        "position"
      ]
    },
    "TrainingCenterBundleItemVideoMediaOverlayId": {
      "type": "number"
    },
    "TrainingCenterBundleItemVideoMediaOverlayPosition": {
      "enum": [
        "BOTTOM",
        "CENTER",
        "TOP"
      ],
      "type": "string"
    },
    "TrainingCenterTranslated<TrainingCenterBundleItemVideoMediaOverlayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoMediaOverlayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterBundleItemVideoMediaOverlayData": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "imageUrl": {
          "type": "string"
        },
        "imageFileKey": {
          "type": "string"
        },
        "imageWidth": {
          "type": "number"
        }
      }
    },
    "TrainingCenterTranslated<TrainingCenterVideoInfo>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterVideoInfo"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterVideoInfo": {
      "type": "object",
      "properties": {
        "videoUrl": {
          "type": "string"
        },
        "thumbnailUrl": {
          "type": "string"
        },
        "videoLengthSeconds": {
          "type": "number"
        },
        "videoDimensions": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoDimensions"
        }
      },
      "required": [
        "thumbnailUrl",
        "videoDimensions",
        "videoLengthSeconds",
        "videoUrl"
      ]
    },
    "TrainingCenterBundleItemVideoDimensions": {
      "type": "object",
      "properties": {
        "width": {
          "type": [
            "null",
            "number"
          ]
        },
        "height": {
          "type": [
            "null",
            "number"
          ]
        }
      },
      "required": [
        "height",
        "width"
      ]
    },
    "TrainingCenterTranslated<TrainingCenterVideoSubtitles>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterVideoSubtitles"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterVideoSubtitles": {
      "type": "object",
      "properties": {
        "subtitlesUrl": {
          "type": "string"
        }
      },
      "required": [
        "subtitlesUrl"
      ]
    },
    "TrainingCenterTranslated<TrainingCenterCaregiverVideoWatchData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterCaregiverVideoWatchData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterCaregiverVideoWatchData": {
      "type": "object",
      "properties": {
        "totalSecondsWatched": {
          "type": "number"
        },
        "watchedSegments": {
          "description": "Array of segments that were watched: `[startSecond, endSecond]`",
          "type": "array",
          "items": {
            "type": "array",
            "items": [
              {
                "type": "number"
              },
              {
                "type": "number"
              }
            ],
            "minItems": 2,
            "additionalItems": {
              "anyOf": [
                {
                  "type": "number"
                },
                {
                  "type": "number"
                }
              ]
            }
          }
        }
      },
      "required": [
        "totalSecondsWatched",
        "watchedSegments"
      ]
    },
    "TrainingCenterBundleItemMedia.PDF": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PDF"
          ]
        },
        "requiredViewTimeMinutes": {
          "type": "number"
        },
        "pdfFileDownloadable": {
          "type": "boolean"
        },
        "pdfInfo": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterPDFInfo>"
          }
        },
        "pdfWatchData": {
          "$ref": "#/definitions/TrainingCenterCaregiverPDFWatchData"
        }
      },
      "required": [
        "pdfFileDownloadable",
        "pdfInfo",
        "pdfWatchData",
        "requiredViewTimeMinutes",
        "type"
      ]
    },
    "TrainingCenterTranslated<TrainingCenterPDFInfo>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterPDFInfo"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterPDFInfo": {
      "type": "object",
      "properties": {
        "pdfUrl": {
          "type": "string"
        }
      },
      "required": [
        "pdfUrl"
      ]
    },
    "TrainingCenterCaregiverPDFWatchData": {
      "type": "object",
      "properties": {
        "totalSecondsWatched": {
          "type": "number"
        }
      },
      "required": [
        "totalSecondsWatched"
      ]
    },
    "TrainingCenterBundleItemMedia.TestOnly": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "TestOnly"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TrainingCenterTestParams": {
      "type": "object",
      "properties": {
        "versionNum": {
          "type": "number"
        },
        "maxWrongAnswers": {
          "description": "How many wrong answers are allowed to still pass the test",
          "type": "number"
        },
        "showWrongAnswers": {
          "description": "If the caregiver failed the test, should we show her which answers she\ngot wrong?",
          "type": "boolean"
        },
        "testMaxAttemptsAllowed": {
          "description": "How many total attempts are allowed for this test?",
          "type": "number"
        }
      },
      "required": [
        "maxWrongAnswers",
        "showWrongAnswers",
        "testMaxAttemptsAllowed",
        "versionNum"
      ]
    },
    "TrainingCenterTranslated<TrainingCenterBundleItemDisplayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterBundleItemDisplayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterBundleItemDisplayData": {
      "type": "object",
      "properties": {
        "title": {
          "type": [
            "null",
            "string"
          ]
        },
        "label": {
          "type": [
            "null",
            "string"
          ]
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "sectionHeader": {
          "type": [
            "null",
            "string"
          ]
        },
        "sectionDescription": {
          "type": [
            "null",
            "string"
          ]
        },
        "testSuccessMessage": {
          "type": [
            "null",
            "string"
          ]
        },
        "testFailMessage": {
          "type": [
            "null",
            "string"
          ]
        },
        "testRetryMessage": {
          "type": [
            "null",
            "string"
          ]
        },
        "thumbnailUrl": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "description",
        "label",
        "sectionDescription",
        "sectionHeader",
        "testFailMessage",
        "testRetryMessage",
        "testSuccessMessage",
        "thumbnailUrl",
        "title"
      ]
    },
    "TrainingCenterCaregiverTestQuestion": {
      "type": "object",
      "properties": {
        "questionId": {
          "$ref": "#/definitions/TrainingCenterBundleItemTestQuestionId"
        },
        "displayData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterTestQuestionDisplayData>"
          }
        },
        "markedAnswer": {
          "description": "The currently selected answer, or the submitted answer from the last\nsubmitted test",
          "type": [
            "null",
            "number"
          ]
        },
        "markedAnswerCorrect": {
          "description": "The marked answer is known to be the correct answer (its value is 0 and\nwas submitted as a test)",
          "type": "boolean"
        },
        "incorrectlyGuessedAnswers": {
          "description": "Submitted answers that were incorrect (from all previous test\nsubmissions)",
          "type": "array",
          "items": {
            "type": "number"
          }
        }
      },
      "required": [
        "displayData",
        "incorrectlyGuessedAnswers",
        "markedAnswer",
        "markedAnswerCorrect",
        "questionId"
      ]
    },
    "TrainingCenterBundleItemTestQuestionId": {
      "type": "number"
    },
    "TrainingCenterTranslated<TrainingCenterTestQuestionDisplayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterTestQuestionDisplayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterTestQuestionDisplayData": {
      "type": "object",
      "properties": {
        "questionText": {
          "type": "string"
        },
        "questionAnswers": {
          "description": "The first answer is always the correct answer",
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "questionAnswers",
        "questionText"
      ]
    },
    "TrainingCenterBundleItemFullDescription": {
      "type": "object",
      "properties": {
        "itemId": {
          "$ref": "#/definitions/TrainingCenterBundleItemFullDescriptionId"
        },
        "fullDescriptionData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterBundleItemFullDescriptionData>"
          }
        }
      },
      "required": [
        "fullDescriptionData",
        "itemId"
      ]
    },
    "TrainingCenterBundleItemFullDescriptionId": {
      "type": "number"
    },
    "TrainingCenterTranslated<TrainingCenterBundleItemFullDescriptionData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterBundleItemFullDescriptionData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterBundleItemFullDescriptionData": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string"
        },
        "subtitle": {
          "type": "string"
        },
        "text": {
          "type": "string"
        },
        "imageUrl": {
          "type": "string"
        },
        "imageDescription": {
          "type": "string"
        },
        "imageFileKey": {
          "type": "string"
        },
        "speechFiles": {
          "type": "object",
          "properties": {
            "titleSpeechAudioFileUrl": {
              "type": "string"
            },
            "titleSpeechMarksFileUrl": {
              "type": "string"
            },
            "subtitleSpeechAudioFileUrl": {
              "type": "string"
            },
            "subtitleSpeechMarksFileUrl": {
              "type": "string"
            },
            "textSpeechAudioFileUrl": {
              "type": "string"
            },
            "textSpeechMarksFileUrl": {
              "type": "string"
            }
          }
        }
      },
      "required": [
        "speechFiles"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["TrainingCenterCaregiverVideoWatchData",
{
  "type": "object",
  "properties": {
    "totalSecondsWatched": {
      "type": "number"
    },
    "watchedSegments": {
      "description": "Array of segments that were watched: `[startSecond, endSecond]`",
      "type": "array",
      "items": {
        "type": "array",
        "items": [
          {
            "type": "number"
          },
          {
            "type": "number"
          }
        ],
        "minItems": 2,
        "additionalItems": {
          "anyOf": [
            {
              "type": "number"
            },
            {
              "type": "number"
            }
          ]
        }
      }
    }
  },
  "required": [
    "totalSecondsWatched",
    "watchedSegments"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["TrainingCenterCaregiverBundle",
{
  "type": "object",
  "properties": {
    "agencyId": {
      "$ref": "#/definitions/AgencyId"
    },
    "bundleId": {
      "$ref": "#/definitions/TrainingCenterBundleId"
    },
    "bundleDueDateId": {
      "$ref": "#/definitions/TrainingCenterBundleDueDateId"
    },
    "bundleDueDateYear": {
      "type": "number"
    },
    "visibleDate": {
      "$ref": "#/definitions/LocalDate"
    },
    "completionDate": {
      "$ref": "#/definitions/LocalDate"
    },
    "complianceDate": {
      "$ref": "#/definitions/LocalDate"
    },
    "bundleParams": {
      "$ref": "#/definitions/TrainingCenterBundleParams"
    },
    "bundleDisplayData": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterDisplayData>"
      }
    },
    "completionCertificate": {
      "anyOf": [
        {
          "$ref": "#/definitions/TrainingCenterBundleCertificate"
        },
        {
          "type": "null"
        }
      ]
    },
    "bundleItems": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/TrainingCenterBundleItem"
      }
    },
    "showDuration": {
      "type": "boolean"
    }
  },
  "required": [
    "agencyId",
    "bundleDisplayData",
    "bundleDueDateId",
    "bundleDueDateYear",
    "bundleId",
    "bundleItems",
    "bundleParams",
    "completionCertificate",
    "completionDate",
    "complianceDate",
    "showDuration",
    "visibleDate"
  ],
  "definitions": {
    "AgencyId": {
      "type": "number"
    },
    "TrainingCenterBundleId": {
      "type": "number"
    },
    "TrainingCenterBundleDueDateId": {
      "type": "number"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "TrainingCenterBundleParams": {
      "type": "object",
      "properties": {
        "chatAgencyMemberId": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "signingAgencyMemberId": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "signingAgencyMemberTitle": {
          "type": "string"
        },
        "enforceWatchOrder": {
          "type": "boolean"
        },
        "requiredForBillingCompliance": {
          "type": "boolean"
        },
        "canWatchDuringVisitShift": {
          "type": "boolean"
        },
        "showBundleAfterDueDate": {
          "type": "boolean"
        },
        "caregiverCertifications": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "isOrientation": {
          "type": "boolean"
        }
      },
      "required": [
        "canWatchDuringVisitShift",
        "caregiverCertifications",
        "chatAgencyMemberId",
        "enforceWatchOrder",
        "isOrientation",
        "requiredForBillingCompliance",
        "showBundleAfterDueDate",
        "signingAgencyMemberId",
        "signingAgencyMemberTitle"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "TrainingCenterTranslated<TrainingCenterDisplayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterDisplayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterDisplayLanguage": {
      "type": "string"
    },
    "TrainingCenterDisplayData": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string"
        },
        "thumbnailUrl": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "thumbnailUrl",
        "title"
      ]
    },
    "TrainingCenterBundleCertificate": {
      "type": "object",
      "properties": {
        "createdAt": {
          "$ref": "#/definitions/Instant"
        }
      },
      "required": [
        "createdAt"
      ]
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "TrainingCenterBundleItem": {
      "type": "object",
      "properties": {
        "bundleItemId": {
          "$ref": "#/definitions/TrainingCenterBundleItemId"
        },
        "timeForCertificateMinutes": {
          "type": [
            "null",
            "number"
          ]
        },
        "media": {
          "anyOf": [
            {
              "$ref": "#/definitions/TrainingCenterBundleItemMedia.Video"
            },
            {
              "$ref": "#/definitions/TrainingCenterBundleItemMedia.PDF"
            },
            {
              "$ref": "#/definitions/TrainingCenterBundleItemMedia.TestOnly"
            }
          ]
        },
        "itemCompleted": {
          "type": "boolean"
        },
        "itemExempt": {
          "type": "boolean"
        },
        "caregiverSignatureDataURL": {
          "type": [
            "null",
            "string"
          ]
        },
        "testUnlocked": {
          "description": "The test becomes unlocked when the caregiver has watched enough of the\ntraining material (e.g. Video, PDF...)",
          "type": "boolean"
        },
        "testNumAttempts": {
          "description": "How many attempts has this caregiver submitted the test. If this is\nequal to or greater than `testMaxAttemptsAllowed` then the test\nquestions should be grayed out.",
          "type": "number"
        },
        "testParams": {
          "$ref": "#/definitions/TrainingCenterTestParams"
        },
        "displayData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterBundleItemDisplayData>"
          }
        },
        "currentTestQuestions": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterCaregiverTestQuestion"
          }
        },
        "fullDescriptions": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterBundleItemFullDescription"
          }
        }
      },
      "required": [
        "bundleItemId",
        "caregiverSignatureDataURL",
        "currentTestQuestions",
        "displayData",
        "fullDescriptions",
        "itemCompleted",
        "itemExempt",
        "media",
        "testNumAttempts",
        "testParams",
        "testUnlocked",
        "timeForCertificateMinutes"
      ]
    },
    "TrainingCenterBundleItemId": {
      "type": "number"
    },
    "TrainingCenterBundleItemMedia.Video": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Video"
          ]
        },
        "requiredWatchTimePercent": {
          "type": "number"
        },
        "source": {
          "$ref": "#/definitions/TrainingCenterBundleVideoSource"
        },
        "engagementQuestions": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterBundleItemVideoEngagementQuestion"
          }
        },
        "mediaOverlays": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterBundleItemVideoMediaOverlay"
          }
        },
        "videoInfo": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterVideoInfo>"
          }
        },
        "videoSubtitles": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterVideoSubtitles>"
          }
        },
        "videoWatchData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterCaregiverVideoWatchData>"
          }
        }
      },
      "required": [
        "engagementQuestions",
        "mediaOverlays",
        "requiredWatchTimePercent",
        "source",
        "type",
        "videoInfo",
        "videoSubtitles",
        "videoWatchData"
      ]
    },
    "TrainingCenterBundleVideoSource": {
      "enum": [
        "VIDEO_URL",
        "YOUTUBE"
      ],
      "type": "string"
    },
    "TrainingCenterBundleItemVideoEngagementQuestion": {
      "type": "object",
      "properties": {
        "questionId": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoEngmtQuestionId"
        },
        "atSecond": {
          "type": "number"
        },
        "duration": {
          "type": "number"
        },
        "displayData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterBundleItemVideoEngagementQuestionDisplayData>"
          }
        }
      },
      "required": [
        "atSecond",
        "displayData",
        "duration",
        "questionId"
      ]
    },
    "TrainingCenterBundleItemVideoEngmtQuestionId": {
      "type": "number"
    },
    "TrainingCenterTranslated<TrainingCenterBundleItemVideoEngagementQuestionDisplayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoEngagementQuestionDisplayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterBundleItemVideoEngagementQuestionDisplayData": {
      "type": "object",
      "properties": {
        "questionText": {
          "type": "string"
        },
        "questionAnswers": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "questionAnswers",
        "questionText"
      ]
    },
    "TrainingCenterBundleItemVideoMediaOverlay": {
      "type": "object",
      "properties": {
        "itemId": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoMediaOverlayId"
        },
        "atSecond": {
          "type": "number"
        },
        "duration": {
          "type": "number"
        },
        "position": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoMediaOverlayPosition"
        },
        "overlayData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterBundleItemVideoMediaOverlayData>"
          }
        }
      },
      "required": [
        "atSecond",
        "duration",
        "itemId",
        "overlayData",
        "position"
      ]
    },
    "TrainingCenterBundleItemVideoMediaOverlayId": {
      "type": "number"
    },
    "TrainingCenterBundleItemVideoMediaOverlayPosition": {
      "enum": [
        "BOTTOM",
        "CENTER",
        "TOP"
      ],
      "type": "string"
    },
    "TrainingCenterTranslated<TrainingCenterBundleItemVideoMediaOverlayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoMediaOverlayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterBundleItemVideoMediaOverlayData": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "imageUrl": {
          "type": "string"
        },
        "imageFileKey": {
          "type": "string"
        },
        "imageWidth": {
          "type": "number"
        }
      }
    },
    "TrainingCenterTranslated<TrainingCenterVideoInfo>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterVideoInfo"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterVideoInfo": {
      "type": "object",
      "properties": {
        "videoUrl": {
          "type": "string"
        },
        "thumbnailUrl": {
          "type": "string"
        },
        "videoLengthSeconds": {
          "type": "number"
        },
        "videoDimensions": {
          "$ref": "#/definitions/TrainingCenterBundleItemVideoDimensions"
        }
      },
      "required": [
        "thumbnailUrl",
        "videoDimensions",
        "videoLengthSeconds",
        "videoUrl"
      ]
    },
    "TrainingCenterBundleItemVideoDimensions": {
      "type": "object",
      "properties": {
        "width": {
          "type": [
            "null",
            "number"
          ]
        },
        "height": {
          "type": [
            "null",
            "number"
          ]
        }
      },
      "required": [
        "height",
        "width"
      ]
    },
    "TrainingCenterTranslated<TrainingCenterVideoSubtitles>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterVideoSubtitles"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterVideoSubtitles": {
      "type": "object",
      "properties": {
        "subtitlesUrl": {
          "type": "string"
        }
      },
      "required": [
        "subtitlesUrl"
      ]
    },
    "TrainingCenterTranslated<TrainingCenterCaregiverVideoWatchData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterCaregiverVideoWatchData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterCaregiverVideoWatchData": {
      "type": "object",
      "properties": {
        "totalSecondsWatched": {
          "type": "number"
        },
        "watchedSegments": {
          "description": "Array of segments that were watched: `[startSecond, endSecond]`",
          "type": "array",
          "items": {
            "type": "array",
            "items": [
              {
                "type": "number"
              },
              {
                "type": "number"
              }
            ],
            "minItems": 2,
            "additionalItems": {
              "anyOf": [
                {
                  "type": "number"
                },
                {
                  "type": "number"
                }
              ]
            }
          }
        }
      },
      "required": [
        "totalSecondsWatched",
        "watchedSegments"
      ]
    },
    "TrainingCenterBundleItemMedia.PDF": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PDF"
          ]
        },
        "requiredViewTimeMinutes": {
          "type": "number"
        },
        "pdfFileDownloadable": {
          "type": "boolean"
        },
        "pdfInfo": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterPDFInfo>"
          }
        },
        "pdfWatchData": {
          "$ref": "#/definitions/TrainingCenterCaregiverPDFWatchData"
        }
      },
      "required": [
        "pdfFileDownloadable",
        "pdfInfo",
        "pdfWatchData",
        "requiredViewTimeMinutes",
        "type"
      ]
    },
    "TrainingCenterTranslated<TrainingCenterPDFInfo>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterPDFInfo"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterPDFInfo": {
      "type": "object",
      "properties": {
        "pdfUrl": {
          "type": "string"
        }
      },
      "required": [
        "pdfUrl"
      ]
    },
    "TrainingCenterCaregiverPDFWatchData": {
      "type": "object",
      "properties": {
        "totalSecondsWatched": {
          "type": "number"
        }
      },
      "required": [
        "totalSecondsWatched"
      ]
    },
    "TrainingCenterBundleItemMedia.TestOnly": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "TestOnly"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "TrainingCenterTestParams": {
      "type": "object",
      "properties": {
        "versionNum": {
          "type": "number"
        },
        "maxWrongAnswers": {
          "description": "How many wrong answers are allowed to still pass the test",
          "type": "number"
        },
        "showWrongAnswers": {
          "description": "If the caregiver failed the test, should we show her which answers she\ngot wrong?",
          "type": "boolean"
        },
        "testMaxAttemptsAllowed": {
          "description": "How many total attempts are allowed for this test?",
          "type": "number"
        }
      },
      "required": [
        "maxWrongAnswers",
        "showWrongAnswers",
        "testMaxAttemptsAllowed",
        "versionNum"
      ]
    },
    "TrainingCenterTranslated<TrainingCenterBundleItemDisplayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterBundleItemDisplayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterBundleItemDisplayData": {
      "type": "object",
      "properties": {
        "title": {
          "type": [
            "null",
            "string"
          ]
        },
        "label": {
          "type": [
            "null",
            "string"
          ]
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "sectionHeader": {
          "type": [
            "null",
            "string"
          ]
        },
        "sectionDescription": {
          "type": [
            "null",
            "string"
          ]
        },
        "testSuccessMessage": {
          "type": [
            "null",
            "string"
          ]
        },
        "testFailMessage": {
          "type": [
            "null",
            "string"
          ]
        },
        "testRetryMessage": {
          "type": [
            "null",
            "string"
          ]
        },
        "thumbnailUrl": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "description",
        "label",
        "sectionDescription",
        "sectionHeader",
        "testFailMessage",
        "testRetryMessage",
        "testSuccessMessage",
        "thumbnailUrl",
        "title"
      ]
    },
    "TrainingCenterCaregiverTestQuestion": {
      "type": "object",
      "properties": {
        "questionId": {
          "$ref": "#/definitions/TrainingCenterBundleItemTestQuestionId"
        },
        "displayData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterTestQuestionDisplayData>"
          }
        },
        "markedAnswer": {
          "description": "The currently selected answer, or the submitted answer from the last\nsubmitted test",
          "type": [
            "null",
            "number"
          ]
        },
        "markedAnswerCorrect": {
          "description": "The marked answer is known to be the correct answer (its value is 0 and\nwas submitted as a test)",
          "type": "boolean"
        },
        "incorrectlyGuessedAnswers": {
          "description": "Submitted answers that were incorrect (from all previous test\nsubmissions)",
          "type": "array",
          "items": {
            "type": "number"
          }
        }
      },
      "required": [
        "displayData",
        "incorrectlyGuessedAnswers",
        "markedAnswer",
        "markedAnswerCorrect",
        "questionId"
      ]
    },
    "TrainingCenterBundleItemTestQuestionId": {
      "type": "number"
    },
    "TrainingCenterTranslated<TrainingCenterTestQuestionDisplayData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterTestQuestionDisplayData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterTestQuestionDisplayData": {
      "type": "object",
      "properties": {
        "questionText": {
          "type": "string"
        },
        "questionAnswers": {
          "description": "The first answer is always the correct answer",
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "questionAnswers",
        "questionText"
      ]
    },
    "TrainingCenterBundleItemFullDescription": {
      "type": "object",
      "properties": {
        "itemId": {
          "$ref": "#/definitions/TrainingCenterBundleItemFullDescriptionId"
        },
        "fullDescriptionData": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/TrainingCenterTranslated<TrainingCenterBundleItemFullDescriptionData>"
          }
        }
      },
      "required": [
        "fullDescriptionData",
        "itemId"
      ]
    },
    "TrainingCenterBundleItemFullDescriptionId": {
      "type": "number"
    },
    "TrainingCenterTranslated<TrainingCenterBundleItemFullDescriptionData>": {
      "type": "object",
      "properties": {
        "language": {
          "$ref": "#/definitions/TrainingCenterDisplayLanguage"
        },
        "data": {
          "$ref": "#/definitions/TrainingCenterBundleItemFullDescriptionData"
        }
      },
      "required": [
        "data",
        "language"
      ]
    },
    "TrainingCenterBundleItemFullDescriptionData": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string"
        },
        "subtitle": {
          "type": "string"
        },
        "text": {
          "type": "string"
        },
        "imageUrl": {
          "type": "string"
        },
        "imageDescription": {
          "type": "string"
        },
        "imageFileKey": {
          "type": "string"
        },
        "speechFiles": {
          "type": "object",
          "properties": {
            "titleSpeechAudioFileUrl": {
              "type": "string"
            },
            "titleSpeechMarksFileUrl": {
              "type": "string"
            },
            "subtitleSpeechAudioFileUrl": {
              "type": "string"
            },
            "subtitleSpeechMarksFileUrl": {
              "type": "string"
            },
            "textSpeechAudioFileUrl": {
              "type": "string"
            },
            "textSpeechMarksFileUrl": {
              "type": "string"
            }
          }
        }
      },
      "required": [
        "speechFiles"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["BundleOfficeInfo",
{
  "type": "object",
  "properties": {
    "offices": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/OfficeInfo"
      }
    }
  },
  "required": [
    "offices"
  ],
  "definitions": {
    "OfficeInfo": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/OfficeId"
        },
        "name": {
          "type": "string"
        },
        "phoneNumber": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "id",
        "name",
        "phoneNumber"
      ]
    },
    "OfficeId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["TrainingCenterCaregiverPDFWatchData",
{
  "type": "object",
  "properties": {
    "totalSecondsWatched": {
      "type": "number"
    }
  },
  "required": [
    "totalSecondsWatched"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["TrainingCenterCaregiverCertificatePdf",
{
  "type": "object",
  "properties": {
    "url": {
      "type": "string"
    }
  },
  "required": [
    "url"
  ],
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["MedicationProfileSearchResponse",
{
  "type": "object",
  "properties": {
    "medications": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/Medication"
      }
    }
  },
  "required": [
    "medications"
  ],
  "definitions": {
    "Medication": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/MedicationId"
        },
        "fullName": {
          "type": "string"
        },
        "brandName": {
          "type": [
            "null",
            "string"
          ]
        },
        "displayName": {
          "type": "string"
        },
        "route": {
          "type": "string"
        },
        "dose": {
          "type": "string"
        }
      },
      "required": [
        "brandName",
        "displayName",
        "dose",
        "fullName",
        "id",
        "route"
      ]
    },
    "MedicationId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientMedicationProfile",
{
  "type": "object",
  "properties": {
    "medications": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/PatientMedicationProfileWithDetails"
      }
    }
  },
  "required": [
    "medications"
  ],
  "definitions": {
    "MedicationId": {
      "type": "number"
    },
    "PatientMedicationProfileWithDetails": {
      "type": "object",
      "properties": {
        "dose": {
          "type": "string"
        },
        "route": {
          "type": "string"
        },
        "medicationName": {
          "type": "string"
        },
        "id": {
          "$ref": "#/definitions/PatientMedicationProfileId"
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "medicationId": {
          "$ref": "#/definitions/MedicationId"
        },
        "from": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "until": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "frequency": {
          "type": [
            "null",
            "string"
          ]
        },
        "status": {
          "$ref": "#/definitions/PatientMedicationProfileStatus"
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "dose",
        "frequency",
        "from",
        "id",
        "medicationId",
        "medicationName",
        "notes",
        "patientId",
        "route",
        "status",
        "until"
      ]
    },
    "PatientMedicationProfileId": {
      "type": "number"
    },
    "PatientId": {
      "type": "number"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "PatientMedicationProfileStatus": {
      "enum": [
        "ACTIVE",
        "DISCONTINUED"
      ],
      "type": "string"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientMedicationProfileItem",
{
  "type": "object",
  "properties": {
    "id": {
      "$ref": "#/definitions/PatientMedicationProfileId"
    },
    "patientId": {
      "$ref": "#/definitions/PatientId"
    },
    "medicationId": {
      "$ref": "#/definitions/MedicationId"
    },
    "from": {
      "anyOf": [
        {
          "$ref": "#/definitions/LocalDate"
        },
        {
          "type": "null"
        }
      ]
    },
    "until": {
      "anyOf": [
        {
          "$ref": "#/definitions/LocalDate"
        },
        {
          "type": "null"
        }
      ]
    },
    "frequency": {
      "type": [
        "null",
        "string"
      ]
    },
    "status": {
      "$ref": "#/definitions/PatientMedicationProfileStatus"
    },
    "notes": {
      "type": [
        "null",
        "string"
      ]
    }
  },
  "required": [
    "frequency",
    "from",
    "id",
    "medicationId",
    "notes",
    "patientId",
    "status",
    "until"
  ],
  "definitions": {
    "MedicationId": {
      "type": "number"
    },
    "PatientMedicationProfileId": {
      "type": "number"
    },
    "PatientId": {
      "type": "number"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "PatientMedicationProfileStatus": {
      "enum": [
        "ACTIVE",
        "DISCONTINUED"
      ],
      "type": "string"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientMedicationProfileText",
{
  "type": "object",
  "properties": {
    "medicationProfileText": {
      "type": [
        "null",
        "string"
      ]
    }
  },
  "required": [
    "medicationProfileText"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["VBPItemsForVisit",
{
  "type": "object",
  "properties": {
    "vpbItems": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/VBPItemWithAnswer"
      }
    }
  },
  "required": [
    "vpbItems"
  ],
  "definitions": {
    "VBPItemWithAnswer": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/VBPItemId"
        },
        "name": {
          "type": "string"
        },
        "section": {
          "type": [
            "null",
            "string"
          ]
        },
        "possibleAnswers": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "answerDetails": {
          "anyOf": [
            {
              "$ref": "#/definitions/VBPItemAnswer"
            },
            {
              "type": "null"
            }
          ]
        },
        "iconUrl": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "answerDetails",
        "iconUrl",
        "id",
        "name",
        "possibleAnswers",
        "section"
      ]
    },
    "VBPItemId": {
      "type": "number"
    },
    "VBPItemAnswer": {
      "type": "object",
      "properties": {
        "vbpItemId": {
          "$ref": "#/definitions/VBPItemId"
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        },
        "date": {
          "$ref": "#/definitions/LocalDate"
        },
        "riskLevel": {
          "type": [
            "null",
            "number"
          ]
        }
      },
      "required": [
        "answer",
        "date",
        "notes",
        "riskLevel",
        "vbpItemId"
      ]
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientContractDiagnosisCodes",
{
  "type": "object",
  "properties": {
    "patientContractDiagnosisCodes": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/PatientContractDiagnosisCode"
      }
    },
    "createdId": {
      "type": "number"
    }
  },
  "required": [
    "patientContractDiagnosisCodes"
  ],
  "definitions": {
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "PatientContractDiagnosisCode": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/PatientContractDiagnosisCodeId"
        },
        "icdCode": {
          "$ref": "#/definitions/ICD10CodeId"
        },
        "formattedDxCode": {
          "type": "string"
        },
        "shortDesc": {
          "type": "string"
        },
        "patientContractId": {
          "$ref": "#/definitions/PatientContractId"
        },
        "startDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "endDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "type": {
          "anyOf": [
            {
              "enum": [
                "PRINCIPAL",
                "SURGICAL"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "isForBilling": {
          "type": "boolean"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "createdBy": {
          "$ref": "#/definitions/UserId"
        },
        "updatedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "updatedBy": {
          "anyOf": [
            {
              "$ref": "#/definitions/UserId"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "createdAt",
        "createdBy",
        "endDate",
        "formattedDxCode",
        "icdCode",
        "id",
        "isForBilling",
        "patientContractId",
        "shortDesc",
        "startDate",
        "type",
        "updatedAt",
        "updatedBy"
      ]
    },
    "PatientContractDiagnosisCodeId": {
      "type": "number"
    },
    "ICD10CodeId": {
      "type": "number"
    },
    "PatientContractId": {
      "type": "number"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "UserId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientDocumentsPdfUrl",
{
  "type": "object",
  "properties": {
    "url": {
      "type": "string"
    }
  },
  "required": [
    "url"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["EditTaskInstanceScheduleTimeResponse",
{
  "type": "object",
  "properties": {
    "visitInstance": {
      "$ref": "#/definitions/VisitInstanceDetails"
    }
  },
  "required": [
    "visitInstance"
  ],
  "definitions": {
    "VisitInstanceDetails": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/VisitInstanceId"
        },
        "startTimeUTC": {
          "$ref": "#/definitions/Instant"
        },
        "startTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTimeUTC": {
          "$ref": "#/definitions/Instant"
        },
        "endTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "checkInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "checkOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockInTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "clockOutTime": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDateTime"
            },
            {
              "type": "null"
            }
          ]
        },
        "dutySheetFillPercentage": {
          "type": [
            "null",
            "number"
          ]
        },
        "isCaregiverClockEnabled": {
          "description": "Agency pilot for enabled clock in/out caregivers",
          "type": "boolean"
        },
        "publicVisitDetails": {
          "$ref": "#/definitions/PublicVisitInstanceDetails"
        },
        "confidentialVisitDetails": {
          "$ref": "#/definitions/ConfidentialVisitDetails"
        },
        "visitDocumentsStatus": {
          "$ref": "#/definitions/VisitDocumentsStatus"
        },
        "manualClockTimeEditApproved": {
          "type": "boolean"
        },
        "isDutySheetCompleted": {
          "type": "boolean"
        },
        "timeSheetSubmittedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "timeSheetDeclinedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "timeSheetApprovedAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "hasPlanOfCare": {
          "type": "boolean"
        },
        "checkinMaxDistance": {
          "type": [
            "null",
            "number"
          ]
        },
        "requireSelfieOnClockIn": {
          "type": "boolean"
        },
        "requireSelfieOnClockOut": {
          "type": "boolean"
        }
      },
      "required": [
        "checkInTime",
        "checkOutTime",
        "checkinMaxDistance",
        "clockInTime",
        "clockOutTime",
        "confidentialVisitDetails",
        "dutySheetFillPercentage",
        "endTimeLocal",
        "endTimeUTC",
        "hasPlanOfCare",
        "id",
        "isCaregiverClockEnabled",
        "isDutySheetCompleted",
        "manualClockTimeEditApproved",
        "publicVisitDetails",
        "requireSelfieOnClockIn",
        "requireSelfieOnClockOut",
        "startTimeLocal",
        "startTimeUTC",
        "timeSheetApprovedAt",
        "timeSheetDeclinedAt",
        "timeSheetSubmittedAt",
        "visitDocumentsStatus"
      ]
    },
    "VisitInstanceId": {
      "type": "number"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "PublicVisitInstanceDetails": {
      "type": "object",
      "properties": {
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "agency": {
          "$ref": "#/definitions/Agency"
        },
        "isBillingAgency": {
          "type": "boolean"
        },
        "isMedflytAgency": {
          "type": "boolean"
        },
        "startTime": {
          "$ref": "#/definitions/Instant"
        },
        "startTimeLocal": {
          "$ref": "#/definitions/LocalDateTime"
        },
        "endTime": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        },
        "endTimeLocal": {
          "type": "string",
          "xreviver": "JSJoda.LocalDateTime"
        },
        "isSingleVisit": {
          "description": "Is this a single visit or recurring visit?",
          "type": "boolean"
        },
        "dayTimeParams": {
          "description": "Defines the time slots of the visit over a given week.",
          "anyOf": [
            {
              "$ref": "#/definitions/VisitDayTimeParams"
            },
            {
              "type": "null"
            }
          ]
        },
        "price": {
          "description": "USD, integer cents. \"$10.99\" equals the value 1099",
          "exclusiveMinimum": 0,
          "type": [
            "null",
            "number"
          ]
        },
        "languages": {
          "description": "Must be one of 'Caregiver.ALL_LANGUAGES'",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "generalNotes": {
          "type": "string"
        },
        "location": {
          "$ref": "#/definitions/AddressComponents"
        },
        "timezone": {
          "description": "timezone from the tz database (IANA)",
          "type": "string"
        },
        "createdById": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "createdByFirstName": {
          "type": "string"
        },
        "createdByLastName": {
          "type": "string"
        },
        "flexibleVisitParams": {
          "anyOf": [
            {
              "$ref": "#/definitions/PermanentFlexibleHoursAndDaysPerWeek"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursAndDaysPattern"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursFixedDaysPattern"
            },
            {
              "$ref": "#/definitions/PermanentFlexibleHoursFixedDaysPerWeek"
            },
            {
              "$ref": "#/definitions/PermanentFixedHoursFlexibleDays"
            },
            {
              "$ref": "#/definitions/SingleFlexible"
            },
            {
              "type": "null"
            }
          ]
        },
        "visitLabels": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitLabel"
          }
        },
        "patientId": {
          "$ref": "#/definitions/PatientId"
        },
        "patientInitials": {
          "type": "string"
        },
        "patientAge": {
          "type": [
            "null",
            "number"
          ]
        },
        "patientGender": {
          "anyOf": [
            {
              "enum": [
                "F",
                "M"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "patientAllergies": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/Allergy"
          }
        },
        "patientLanguages": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientRequests": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "patientMedicalNotes": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientTasks": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "certifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverCertification"
          }
        },
        "clockInToleranceMinutes": {
          "type": "number"
        },
        "clockOutToleranceMinutes": {
          "type": "number"
        },
        "staffingPreferences2": {
          "$ref": "#/definitions/VisitStaffingPreferences"
        },
        "patientAdvancedDirectives": {
          "anyOf": [
            {
              "$ref": "#/definitions/PatientAdvancedDirective"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "agency",
        "certifications",
        "clockInToleranceMinutes",
        "clockOutToleranceMinutes",
        "createdAt",
        "createdByFirstName",
        "createdById",
        "createdByLastName",
        "dayTimeParams",
        "flexibleVisitParams",
        "generalNotes",
        "isBillingAgency",
        "isMedflytAgency",
        "isSingleVisit",
        "languages",
        "location",
        "patientAdvancedDirectives",
        "patientAge",
        "patientAllergies",
        "patientGender",
        "patientId",
        "patientInitials",
        "patientLanguages",
        "patientMedicalNotes",
        "patientRequests",
        "patientTasks",
        "price",
        "staffingPreferences2",
        "startTime",
        "startTimeLocal",
        "timezone",
        "visitLabels"
      ]
    },
    "Agency": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AgencyId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "name": {
          "type": "string"
        },
        "logoUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "website": {
          "type": [
            "null",
            "string"
          ]
        },
        "address": {
          "type": [
            "null",
            "string"
          ]
        },
        "officePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "organizationType": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumbers": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/AgencyIvrPhoneNumber"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "isMedflytAgency": {
          "type": "boolean"
        }
      },
      "required": [
        "address",
        "createdAt",
        "id",
        "isMedflytAgency",
        "ivrPhoneNumbers",
        "logoUrl",
        "name",
        "officePhone",
        "organizationType",
        "website"
      ]
    },
    "AgencyId": {
      "type": "number"
    },
    "AgencyIvrPhoneNumber": {
      "type": "object",
      "properties": {
        "ivrPhoneNumber": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "description",
        "ivrPhoneNumber"
      ]
    },
    "VisitDayTimeParams": {
      "type": "object",
      "properties": {
        "dayTimes": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/VisitDayTime"
          }
        }
      },
      "required": [
        "dayTimes"
      ]
    },
    "VisitDayTime": {
      "type": "object",
      "properties": {
        "day": {
          "description": "0 = sunday, 1 = monday, ... , 6 = saturday",
          "type": "integer",
          "minimum": 0,
          "maximum": 6
        },
        "startTime": {
          "$ref": "#/definitions/LocalTime"
        },
        "endTime": {
          "$ref": "#/definitions/LocalTime"
        }
      },
      "required": [
        "day",
        "endTime",
        "startTime"
      ]
    },
    "LocalTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalTime"
    },
    "AddressComponents": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "country": {
          "type": "string"
        },
        "administrativeAreaLevel1": {
          "type": "string"
        },
        "administrativeAreaLevel2": {
          "type": "string"
        },
        "sublocalityLevel1": {
          "type": [
            "null",
            "string"
          ]
        },
        "neighborhood": {
          "type": [
            "null",
            "string"
          ]
        },
        "locality": {
          "type": [
            "null",
            "string"
          ]
        },
        "formatedAddressDetails": {
          "$ref": "#/definitions/FormatedAddressDetails"
        }
      },
      "required": [
        "administrativeAreaLevel1",
        "administrativeAreaLevel2",
        "country",
        "location"
      ]
    },
    "Geo": {
      "type": "object",
      "properties": {
        "lat": {
          "type": "number"
        },
        "lng": {
          "type": "number"
        }
      },
      "required": [
        "lat",
        "lng"
      ]
    },
    "FormatedAddressDetails": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "address1": {
          "type": "string"
        },
        "country": {
          "type": "string"
        },
        "state": {
          "type": "string"
        },
        "county": {
          "type": "string"
        },
        "fullAddress": {
          "type": "string"
        },
        "city": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip5": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip4": {
          "type": [
            "null",
            "string"
          ]
        },
        "street": {
          "type": [
            "null",
            "string"
          ]
        },
        "streetNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "crossStreet": {
          "type": [
            "null",
            "string"
          ]
        },
        "address2": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "address1",
        "country",
        "county",
        "fullAddress",
        "location",
        "state"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "PermanentFlexibleHoursAndDaysPerWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursAndDaysPerWeek"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "amountOfHoursPerWeek": {
          "type": "number"
        },
        "minHoursPerShift": {
          "type": "number"
        },
        "maxHoursPerShift": {
          "type": "number"
        }
      },
      "required": [
        "amountOfHoursPerWeek",
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "maxHoursPerShift",
        "minHoursPerShift",
        "type"
      ]
    },
    "DayOfWeek": {
      "type": "string",
      "xreviver": "JSJoda.DayOfWeek"
    },
    "PermanentFlexibleHoursAndDaysPattern": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursAndDaysPattern"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "flexibleDetails": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "amountOfDays": {
                "type": "number"
              },
              "amountOfHours": {
                "type": "number"
              }
            },
            "required": [
              "amountOfDays",
              "amountOfHours"
            ]
          }
        }
      },
      "required": [
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "flexibleDetails",
        "type"
      ]
    },
    "PermanentFlexibleHoursFixedDaysPattern": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursFixedDaysPattern"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "details": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "day": {
                "$ref": "#/definitions/DayOfWeek"
              },
              "amountOfHours": {
                "type": "number"
              }
            },
            "required": [
              "amountOfHours",
              "day"
            ]
          }
        }
      },
      "required": [
        "details",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "PermanentFlexibleHoursFixedDaysPerWeek": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFlexibleHoursFixedDaysPerWeek"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "amountOfHoursPerWeek": {
          "type": "number"
        },
        "days": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "minHoursPerShift": {
          "type": "number"
        },
        "maxHoursPerShift": {
          "type": "number"
        }
      },
      "required": [
        "amountOfHoursPerWeek",
        "days",
        "excludedDaysFromCaregivers",
        "maxHoursPerShift",
        "minHoursPerShift",
        "type"
      ]
    },
    "PermanentFixedHoursFlexibleDays": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PermanentFixedHoursFlexibleDays"
          ]
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        },
        "daysToChooseFrom": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "day": {
                "$ref": "#/definitions/DayOfWeek"
              },
              "startTime": {
                "$ref": "#/definitions/LocalTime"
              },
              "endTime": {
                "$ref": "#/definitions/LocalTime"
              }
            },
            "required": [
              "day",
              "endTime",
              "startTime"
            ]
          }
        },
        "amountOfDays": {
          "type": "number"
        }
      },
      "required": [
        "amountOfDays",
        "daysToChooseFrom",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "SingleFlexible": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SingleFlexible"
          ]
        },
        "date": {
          "$ref": "#/definitions/LocalDate"
        },
        "amountOfHours": {
          "type": "number"
        },
        "excludedDaysFromCaregivers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayOfWeek"
          }
        }
      },
      "required": [
        "amountOfHours",
        "date",
        "excludedDaysFromCaregivers",
        "type"
      ]
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "VisitLabel": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string"
        },
        "color": {
          "type": "string"
        }
      },
      "required": [
        "color",
        "text"
      ]
    },
    "PatientId": {
      "type": "number"
    },
    "Allergy": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AllergyId"
        },
        "name": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name"
      ]
    },
    "AllergyId": {
      "type": "number"
    },
    "CaregiverCertification": {
      "type": "string"
    },
    "VisitStaffingPreferences": {
      "type": "object",
      "properties": {
        "smoking": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "bedbound": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "cane": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "walker": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "wheelchair": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "kosher": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "halal": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "hoyer": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "pets": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "bedbound",
        "cane",
        "halal",
        "hoyer",
        "kosher",
        "pets",
        "smoking",
        "walker",
        "wheelchair"
      ]
    },
    "PatientAdvancedDirective": {
      "type": "object",
      "properties": {
        "hasDNR": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "hasProxy": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "firstName": {
          "type": [
            "null",
            "string"
          ]
        },
        "lastName": {
          "type": [
            "null",
            "string"
          ]
        },
        "phoneNumber": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "firstName",
        "hasDNR",
        "hasProxy",
        "lastName",
        "phoneNumber"
      ]
    },
    "ConfidentialVisitDetails": {
      "type": "object",
      "properties": {
        "patientName": {
          "type": "string"
        },
        "patientAddress": {
          "type": "string"
        },
        "patientAddress2": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAddressInstructions": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientPhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "patientAlternativePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "caseDetails": {
          "type": "string"
        }
      },
      "required": [
        "caseDetails",
        "patientAddress",
        "patientAddress2",
        "patientAddressInstructions",
        "patientAlternativePhone",
        "patientName",
        "patientPhone"
      ]
    },
    "VisitDocumentsStatus": {
      "type": "object",
      "properties": {
        "total": {
          "type": "number"
        },
        "submitted": {
          "type": "number"
        }
      },
      "required": [
        "submitted",
        "total"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["HRApplicationForm",
{
  "type": "object",
  "properties": {
    "sections": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/HRSection"
      }
    },
    "settings": {
      "$ref": "#/definitions/HRApplicationFormSettings"
    },
    "orientationBundleDueDateId": {
      "$ref": "#/definitions/TrainingCenterBundleDueDateId"
    },
    "caregiverSectionStageId": {
      "anyOf": [
        {
          "$ref": "#/definitions/HRSectionStageId"
        },
        {
          "type": "null"
        }
      ]
    },
    "caregiverSectionStageLabel": {
      "type": [
        "null",
        "string"
      ]
    },
    "showMessageOnVideoThumbnail": {
      "type": "boolean"
    },
    "isCriminalBackgroundCompliant": {
      "type": "boolean"
    },
    "emailVerificationTemplateId": {
      "anyOf": [
        {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        {
          "type": "null"
        }
      ]
    },
    "isInterviewCompliant": {
      "type": [
        "null",
        "boolean"
      ]
    }
  },
  "required": [
    "caregiverSectionStageId",
    "caregiverSectionStageLabel",
    "emailVerificationTemplateId",
    "isCriminalBackgroundCompliant",
    "isInterviewCompliant",
    "orientationBundleDueDateId",
    "sections",
    "settings",
    "showMessageOnVideoThumbnail"
  ],
  "definitions": {
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "HRSection": {
      "type": "object",
      "properties": {
        "data": {
          "$ref": "#/definitions/HRSectionData"
        },
        "subSections": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/HRSubSection"
          }
        }
      },
      "required": [
        "data",
        "subSections"
      ]
    },
    "HRSectionData": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/HRSectionId"
        },
        "title": {
          "type": "string"
        },
        "subtitle": {
          "type": [
            "null",
            "string"
          ]
        },
        "isStop": {
          "type": "boolean"
        },
        "HRSectionStageId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRSectionStageId"
            },
            {
              "type": "null"
            }
          ]
        },
        "HRSectionStageLabel": {
          "type": [
            "null",
            "string"
          ]
        },
        "secondsToComplete": {
          "type": [
            "null",
            "number"
          ]
        },
        "translations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<{title:string;subtitle:string|null;}>"
            },
            {
              "type": "null"
            }
          ]
        },
        "locked": {
          "type": "boolean"
        }
      },
      "required": [
        "HRSectionStageId",
        "HRSectionStageLabel",
        "id",
        "isStop",
        "locked",
        "secondsToComplete",
        "subtitle",
        "title",
        "translations"
      ]
    },
    "HRSectionId": {
      "type": "number"
    },
    "HRSectionStageId": {
      "type": "number"
    },
    "TranslationMapping<{title:string;subtitle:string|null;}>": {
      "type": "object",
      "properties": {
        "Albanian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Arabic": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Armenian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Bengali": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Bulgarian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Cantonese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Chinese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Creole": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Danish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Dutch": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "English": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Estonian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Farsi": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Filipino": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "French": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Fukkianese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Fula/Fulani": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Fuzhounese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Georgian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "German": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Ghana": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Greek": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Hakka": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Hebrew": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Hindi": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Hungarian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Italian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Japanese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Korean": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Krio": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Kyrgyz": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Mandarin": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Pashto": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Persian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Polish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Portuguese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Punjabi": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Romanian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Russian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Shanghainese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Soninke": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Spanish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Swahili": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Tagalog": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Taishanese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Taiwanese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Turkish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Twi": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Ukrainian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Urdu": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Uzbek": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Vietnamese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Yiddish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        }
      }
    },
    "HRSubSection": {
      "type": "object",
      "properties": {
        "data": {
          "$ref": "#/definitions/HRSubSectionData"
        },
        "document": {
          "anyOf": [
            {
              "$ref": "#/definitions/SubsectionDocumentData"
            },
            {
              "type": "null"
            }
          ]
        },
        "questionGroups": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/HRQuestionGroup"
          }
        }
      },
      "required": [
        "data",
        "document",
        "questionGroups"
      ]
    },
    "HRSubSectionData": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/HRSubSectionId"
        },
        "title": {
          "type": "string"
        },
        "subtitle": {
          "type": [
            "null",
            "string"
          ]
        },
        "settings": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRSubSectionSettings"
            },
            {
              "type": "null"
            }
          ]
        },
        "translations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<{title:string;subtitle:string|null;}>_1"
            },
            {
              "type": "null"
            }
          ]
        },
        "shareUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "isCompliant": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "id",
        "isCompliant",
        "settings",
        "shareUrl",
        "subtitle",
        "title",
        "translations"
      ]
    },
    "HRSubSectionId": {
      "type": "number"
    },
    "HRSubSectionSettings": {
      "type": "object",
      "properties": {
        "hideOnMobile": {
          "type": "boolean"
        },
        "testSettings": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRTestSettings"
            },
            {
              "type": "null"
            }
          ]
        },
        "availabilityPlaceholder": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRAvailabilityPlaceholderSettings"
            },
            {
              "type": "null"
            }
          ]
        },
        "hideOnApplication": {
          "type": "boolean"
        }
      },
      "required": [
        "availabilityPlaceholder",
        "testSettings"
      ]
    },
    "HRTestSettings": {
      "type": "object",
      "properties": {
        "testFailText": {
          "type": "string"
        },
        "testSuccessText": {
          "type": "string"
        },
        "testRetryText": {
          "type": "string"
        },
        "maxWrongAnswers": {
          "type": "number"
        },
        "testMaxTries": {
          "type": "number"
        },
        "shouldShowWrongAnswers": {
          "type": "boolean"
        }
      },
      "required": [
        "maxWrongAnswers",
        "shouldShowWrongAnswers",
        "testFailText",
        "testMaxTries",
        "testRetryText",
        "testSuccessText"
      ]
    },
    "HRAvailabilityPlaceholderSettings": {
      "type": "object",
      "properties": {
        "showHoursQuestion": {
          "type": "boolean"
        },
        "showDistanceQuestion": {
          "type": "boolean"
        }
      },
      "required": [
        "showDistanceQuestion",
        "showHoursQuestion"
      ]
    },
    "TranslationMapping<{title:string;subtitle:string|null;}>_1": {
      "type": "object",
      "properties": {
        "Albanian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Arabic": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Armenian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Bengali": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Bulgarian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Cantonese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Chinese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Creole": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Danish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Dutch": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "English": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Estonian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Farsi": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Filipino": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "French": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Fukkianese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Fula/Fulani": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Fuzhounese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Georgian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "German": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Ghana": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Greek": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Hakka": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Hebrew": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Hindi": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Hungarian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Italian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Japanese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Korean": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Krio": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Kyrgyz": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Mandarin": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Pashto": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Persian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Polish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Portuguese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Punjabi": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Romanian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Russian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Shanghainese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Soninke": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Spanish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Swahili": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Tagalog": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Taishanese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Taiwanese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Turkish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Twi": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Ukrainian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Urdu": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Uzbek": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Vietnamese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Yiddish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        }
      }
    },
    "SubsectionDocumentData": {
      "type": "object",
      "properties": {
        "isDocumentGenerated": {
          "type": "boolean"
        },
        "doc": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "doc",
        "isDocumentGenerated"
      ]
    },
    "HRQuestionGroup": {
      "type": "object",
      "properties": {
        "data": {
          "$ref": "#/definitions/HRQuestionGroupData"
        },
        "questions": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "#/definitions/HRQuestion.TextQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.AddressQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.EmailQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.NumericQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.DollarQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.PhoneNumberQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.SSNQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.FullDateQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.BirthDateQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.MonthYearDateQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.YearDateQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.RadioQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.DropDownQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.CheckboxQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.SignatureQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.GeneralSignatureQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.StartAndEndTimeQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.StarQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.Placeholder"
              },
              {
                "$ref": "#/definitions/HRQuestion.DocumentQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.DocumentWithExpiryQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.AmericanTestQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.FreeTextQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.TitelTextQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.PlainTextQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.DownloadableFileQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.Video"
              },
              {
                "$ref": "#/definitions/HRQuestion.InterviewQuestion"
              }
            ]
          }
        }
      },
      "required": [
        "data",
        "questions"
      ]
    },
    "HRQuestionGroupData": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/HRQuestionGroupId"
        },
        "title": {
          "type": "string"
        },
        "subtitle": {
          "type": [
            "null",
            "string"
          ]
        },
        "translations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<{title:string;subtitle:string|null;}>_2"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "id",
        "subtitle",
        "title",
        "translations"
      ]
    },
    "HRQuestionGroupId": {
      "type": "number"
    },
    "TranslationMapping<{title:string;subtitle:string|null;}>_2": {
      "type": "object",
      "properties": {
        "Albanian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Arabic": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Armenian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Bengali": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Bulgarian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Cantonese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Chinese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Creole": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Danish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Dutch": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "English": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Estonian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Farsi": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Filipino": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "French": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Fukkianese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Fula/Fulani": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Fuzhounese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Georgian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "German": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Ghana": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Greek": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Hakka": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Hebrew": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Hindi": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Hungarian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Italian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Japanese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Korean": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Krio": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Kyrgyz": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Mandarin": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Pashto": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Persian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Polish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Portuguese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Punjabi": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Romanian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Russian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Shanghainese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Soninke": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Spanish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Swahili": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Tagalog": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Taishanese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Taiwanese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Turkish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Twi": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Ukrainian": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Urdu": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Uzbek": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Vietnamese": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        },
        "Yiddish": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string"
            },
            "subtitle": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "subtitle",
            "title"
          ]
        }
      }
    },
    "HRQuestion.TextQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Text"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestionId": {
      "type": "number"
    },
    "HRQuestionTemplateId": {
      "type": "string"
    },
    "TranslationMapping<string>": {
      "type": "object",
      "properties": {
        "Albanian": {
          "type": "string"
        },
        "Arabic": {
          "type": "string"
        },
        "Armenian": {
          "type": "string"
        },
        "Bengali": {
          "type": "string"
        },
        "Bulgarian": {
          "type": "string"
        },
        "Cantonese": {
          "type": "string"
        },
        "Chinese": {
          "type": "string"
        },
        "Creole": {
          "type": "string"
        },
        "Danish": {
          "type": "string"
        },
        "Dutch": {
          "type": "string"
        },
        "English": {
          "type": "string"
        },
        "Estonian": {
          "type": "string"
        },
        "Farsi": {
          "type": "string"
        },
        "Filipino": {
          "type": "string"
        },
        "French": {
          "type": "string"
        },
        "Fukkianese": {
          "type": "string"
        },
        "Fula/Fulani": {
          "type": "string"
        },
        "Fuzhounese": {
          "type": "string"
        },
        "Georgian": {
          "type": "string"
        },
        "German": {
          "type": "string"
        },
        "Ghana": {
          "type": "string"
        },
        "Greek": {
          "type": "string"
        },
        "Hakka": {
          "type": "string"
        },
        "Hebrew": {
          "type": "string"
        },
        "Hindi": {
          "type": "string"
        },
        "Hungarian": {
          "type": "string"
        },
        "Italian": {
          "type": "string"
        },
        "Japanese": {
          "type": "string"
        },
        "Korean": {
          "type": "string"
        },
        "Krio": {
          "type": "string"
        },
        "Kyrgyz": {
          "type": "string"
        },
        "Mandarin": {
          "type": "string"
        },
        "Pashto": {
          "type": "string"
        },
        "Persian": {
          "type": "string"
        },
        "Polish": {
          "type": "string"
        },
        "Portuguese": {
          "type": "string"
        },
        "Punjabi": {
          "type": "string"
        },
        "Romanian": {
          "type": "string"
        },
        "Russian": {
          "type": "string"
        },
        "Shanghainese": {
          "type": "string"
        },
        "Soninke": {
          "type": "string"
        },
        "Spanish": {
          "type": "string"
        },
        "Swahili": {
          "type": "string"
        },
        "Tagalog": {
          "type": "string"
        },
        "Taishanese": {
          "type": "string"
        },
        "Taiwanese": {
          "type": "string"
        },
        "Turkish": {
          "type": "string"
        },
        "Twi": {
          "type": "string"
        },
        "Ukrainian": {
          "type": "string"
        },
        "Urdu": {
          "type": "string"
        },
        "Uzbek": {
          "type": "string"
        },
        "Vietnamese": {
          "type": "string"
        },
        "Yiddish": {
          "type": "string"
        }
      }
    },
    "HRQuestion.HRQuestionRejectionStatusRejected": {
      "type": "object",
      "properties": {
        "status": {
          "type": "string",
          "enum": [
            "Rejected"
          ]
        },
        "rejectedAt": {
          "$ref": "#/definitions/Instant"
        },
        "rejectedBy": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "reason": {
          "type": "string"
        }
      },
      "required": [
        "reason",
        "rejectedAt",
        "rejectedBy",
        "status"
      ]
    },
    "HRQuestion.HRQuestionRejectionStatusNotRejected": {
      "type": "object",
      "properties": {
        "status": {
          "type": "string",
          "enum": [
            "Not Rejected"
          ]
        }
      },
      "required": [
        "status"
      ]
    },
    "HRQuestion.AddressQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Address"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.EmailQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Email"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.NumericQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Numeric"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.DollarQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Dollar"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.PhoneNumberQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PhoneNumber"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.SSNQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SSN"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.FullDateQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "FullDate"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.BirthDateQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "BirthDate"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.MonthYearDateQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "MonthYearDate"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.YearDateQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "YearDate"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.RadioQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Radio"
          ]
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "possibleAnswersTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<PossibleAnswer[]>"
            },
            {
              "type": "null"
            }
          ]
        },
        "chosenAnswerId": {
          "type": [
            "null",
            "number"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answerRejectionStatus",
        "chosenAnswerId",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "possibleAnswers",
        "possibleAnswersTranslations",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "PossibleAnswer": {
      "type": "object",
      "properties": {
        "id": {
          "type": "number"
        },
        "text": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "text"
      ]
    },
    "TranslationMapping<PossibleAnswer[]>": {
      "type": "object",
      "properties": {
        "Albanian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Arabic": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Armenian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Bengali": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Bulgarian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Cantonese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Chinese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Creole": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Danish": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Dutch": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "English": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Estonian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Farsi": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Filipino": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "French": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Fukkianese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Fula/Fulani": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Fuzhounese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Georgian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "German": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Ghana": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Greek": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Hakka": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Hebrew": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Hindi": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Hungarian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Italian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Japanese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Korean": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Krio": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Kyrgyz": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Mandarin": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Pashto": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Persian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Polish": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Portuguese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Punjabi": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Romanian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Russian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Shanghainese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Soninke": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Spanish": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Swahili": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Tagalog": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Taishanese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Taiwanese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Turkish": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Twi": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Ukrainian": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Urdu": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Uzbek": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Vietnamese": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "Yiddish": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        }
      }
    },
    "HRQuestion.DropDownQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "DropDown"
          ]
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "possibleAnswersTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<PossibleAnswer[]>"
            },
            {
              "type": "null"
            }
          ]
        },
        "chosenAnswerId": {
          "type": [
            "null",
            "number"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answerRejectionStatus",
        "chosenAnswerId",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "possibleAnswers",
        "possibleAnswersTranslations",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.CheckboxQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Checkbox"
          ]
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "possibleAnswersTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<PossibleAnswer[]>"
            },
            {
              "type": "null"
            }
          ]
        },
        "chosenAnswerIds": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "number"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answerRejectionStatus",
        "chosenAnswerIds",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "possibleAnswers",
        "possibleAnswersTranslations",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.SignatureQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Signature"
          ]
        },
        "answer": {
          "description": "base64 data-url png of signature",
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.GeneralSignatureQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GeneralSignature"
          ]
        },
        "answer": {
          "description": "base64 data-url png of signature",
          "anyOf": [
            {
              "$ref": "#/definitions/GeneralSignatureAnswer"
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "GeneralSignatureAnswer": {
      "type": "object",
      "properties": {
        "signature": {
          "type": [
            "null",
            "string"
          ]
        },
        "generalSignaturePerson": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "generalSignaturePerson",
        "signature"
      ]
    },
    "HRQuestion.StartAndEndTimeQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "StartAndEndTime"
          ]
        },
        "answer": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "startTime": {
                  "type": "number"
                },
                "endTime": {
                  "type": "number"
                }
              },
              "required": [
                "endTime",
                "startTime"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.StarQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Star"
          ]
        },
        "answer": {
          "type": [
            "null",
            "number"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.Placeholder": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Placeholder"
          ]
        },
        "isMandatory": {
          "type": "boolean",
          "enum": [
            false
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.DocumentQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Document"
          ]
        },
        "answer": {
          "description": "data uri",
          "type": [
            "null",
            "string"
          ]
        },
        "documentTypeToUpload": {
          "anyOf": [
            {
              "$ref": "#/definitions/CaregiverDocumentTypeId"
            },
            {
              "type": "null"
            }
          ]
        },
        "documentTypeNameTranslations": {
          "$ref": "#/definitions/TranslationMapping<string>"
        },
        "complianceRejectionData": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Rejected"
                  ]
                },
                "reason": {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              },
              "required": [
                "reason",
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Dismissed"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Approved"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "canUploadFromGallery": {
          "type": "boolean"
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "canUploadFromGallery",
        "documentTypeToUpload",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "CaregiverDocumentTypeId": {
      "type": "number"
    },
    "HRQuestion.DocumentWithExpiryQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "DocumentWithExpiry"
          ]
        },
        "answer": {
          "anyOf": [
            {
              "$ref": "#/definitions/DocumentWithExpiryAnswer"
            },
            {
              "type": "null"
            }
          ]
        },
        "documentTypeToUpload": {
          "anyOf": [
            {
              "$ref": "#/definitions/CaregiverDocumentTypeId"
            },
            {
              "type": "null"
            }
          ]
        },
        "documentTypeNameTranslations": {
          "$ref": "#/definitions/TranslationMapping<string>"
        },
        "complianceRejectionData": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Rejected"
                  ]
                },
                "reason": {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              },
              "required": [
                "reason",
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Dismissed"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Approved"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "documentTypeToUpload",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "DocumentWithExpiryAnswer": {
      "type": "object",
      "properties": {
        "document": {
          "type": "string"
        },
        "expiryDate": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "document",
        "expiryDate"
      ]
    },
    "HRQuestion.AmericanTestQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AmericanTest"
          ]
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "possibleAnswersTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<PossibleAnswer[]>"
            },
            {
              "type": "null"
            }
          ]
        },
        "chosenAnswerId": {
          "type": [
            "null",
            "number"
          ]
        },
        "correctAnswer": {
          "type": "number"
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answerRejectionStatus",
        "chosenAnswerId",
        "correctAnswer",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "possibleAnswers",
        "possibleAnswersTranslations",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.FreeTextQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "FreeText"
          ]
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "possibleAnswersTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<PossibleAnswer[]>"
            },
            {
              "type": "null"
            }
          ]
        },
        "chosenAnswerIds": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "number"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answerRejectionStatus",
        "chosenAnswerIds",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "possibleAnswers",
        "possibleAnswersTranslations",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.TitelTextQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "TitleText"
          ]
        },
        "isMandatory": {
          "type": "boolean",
          "enum": [
            false
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.PlainTextQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PlainText"
          ]
        },
        "isMandatory": {
          "type": "boolean",
          "enum": [
            false
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.DownloadableFileQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "DownloadableFile"
          ]
        },
        "downloaded": {
          "type": "boolean"
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "downloaded",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.Video": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Video"
          ]
        },
        "isMandatory": {
          "type": "boolean",
          "enum": [
            false
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answerRejectionStatus",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRQuestion.InterviewQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Interview"
          ]
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "possibleAnswersTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<PossibleAnswer[]>"
            },
            {
              "type": "null"
            }
          ]
        },
        "chosenAnswerId": {
          "type": [
            "null",
            "number"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId",
          "description": "If question has no template, this will be the HRQuestionId in text format,\nbecause of hr app client reasons."
        },
        "questionText": {
          "type": "string"
        },
        "questionTextTranslations": {
          "anyOf": [
            {
              "$ref": "#/definitions/TranslationMapping<string>"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "hideOnMobile": {
          "type": "boolean"
        },
        "caregiverProfileParam": {
          "type": [
            "null",
            "string"
          ]
        },
        "linkedQuestionTemplate": {
          "type": [
            "null",
            "string"
          ]
        },
        "answerRejectionStatus": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusRejected"
            },
            {
              "$ref": "#/definitions/HRQuestion.HRQuestionRejectionStatusNotRejected"
            }
          ]
        },
        "emailVerificationRejectionStatus": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Verified"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "Pending"
                  ]
                }
              },
              "required": [
                "type"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "isComplianceFollowUp": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "answeredAt": {
          "type": "string",
          "xreviver": "JSJoda.Instant"
        }
      },
      "required": [
        "answer",
        "answerRejectionStatus",
        "chosenAnswerId",
        "emailVerificationRejectionStatus",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "possibleAnswers",
        "possibleAnswersTranslations",
        "questionText",
        "questionTextTranslations",
        "textId",
        "type"
      ]
    },
    "HRApplicationFormSettings": {
      "type": "object",
      "properties": {
        "certificationSettings": {
          "anyOf": [
            {
              "$ref": "#/definitions/CertificationSettingsForHRApp"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "certificationSettings"
      ]
    },
    "CertificationSettingsForHRApp": {
      "type": "object",
      "properties": {
        "locationPayRates": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/HRCertificationPayRate"
          }
        }
      },
      "required": [
        "locationPayRates"
      ]
    },
    "HRCertificationPayRate": {
      "type": "object",
      "properties": {
        "locationGroup": {
          "type": "string"
        },
        "counties": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "rates": {
          "type": "object",
          "properties": {
            "hourlyRate": {
              "type": "number"
            },
            "dailyRate": {
              "type": "number"
            },
            "overtimeRate": {
              "type": "number"
            },
            "visitRate": {
              "type": "number"
            },
            "payRange": {
              "type": [
                "null",
                "string"
              ]
            },
            "baseWage": {
              "type": [
                "null",
                "number"
              ]
            },
            "additionalWage": {
              "type": [
                "null",
                "number"
              ]
            },
            "supplementalWage": {
              "type": [
                "null",
                "number"
              ]
            },
            "workShiftLine1Rate": {
              "type": [
                "null",
                "number"
              ]
            },
            "workShiftLine1Label": {
              "type": [
                "null",
                "string"
              ]
            },
            "workShiftLine2Rate": {
              "type": [
                "null",
                "number"
              ]
            },
            "workShiftLine2Label": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "additionalWage",
            "baseWage",
            "dailyRate",
            "hourlyRate",
            "overtimeRate",
            "payRange",
            "supplementalWage",
            "visitRate",
            "workShiftLine1Label",
            "workShiftLine1Rate",
            "workShiftLine2Label",
            "workShiftLine2Rate"
          ]
        },
        "supplementals": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PayRateSupplemental"
          }
        }
      },
      "required": [
        "counties",
        "locationGroup",
        "rates",
        "supplementals"
      ]
    },
    "PayRateSupplemental": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/PayRateSupplementalId"
        },
        "state": {
          "type": "string"
        },
        "groupName": {
          "type": "string"
        },
        "hourlyRate": {
          "type": "number"
        },
        "type": {
          "type": "string"
        },
        "agencyName": {
          "type": "string"
        },
        "agencyDescription": {
          "type": "string"
        }
      },
      "required": [
        "agencyDescription",
        "agencyName",
        "groupName",
        "hourlyRate",
        "id",
        "state",
        "type"
      ]
    },
    "PayRateSupplementalId": {
      "type": "number"
    },
    "TrainingCenterBundleDueDateId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["HRAnswerResult",
{
  "type": "object",
  "properties": {
    "isSuccessful": {
      "type": "boolean"
    },
    "reason": {
      "type": "string"
    }
  },
  "required": [
    "isSuccessful"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverApplicationBannerResponse",
{
  "type": "object",
  "properties": {
    "show": {
      "type": "boolean"
    },
    "chatAgencyMemberId": {
      "anyOf": [
        {
          "$ref": "#/definitions/AgencyMemberId"
        },
        {
          "type": "null"
        }
      ]
    },
    "onboardingStage": {
      "anyOf": [
        {
          "enum": [
            "generalDetails",
            "interview",
            "landingPage",
            "onboarding1",
            "onboarding2"
          ],
          "type": "string"
        },
        {
          "type": "null"
        }
      ]
    },
    "caregiverStatus": {
      "anyOf": [
        {
          "enum": [
            "ACTIVE",
            "JOIN_REQUEST",
            "ON_HOLD",
            "ON_LEAVE",
            "PENDING",
            "QUIT",
            "REJECTED",
            "SUSPENDED",
            "TERMINATED"
          ],
          "type": "string"
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "caregiverStatus",
    "chatAgencyMemberId",
    "onboardingStage",
    "show"
  ],
  "definitions": {
    "AgencyMemberId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["URLResponse",
{
  "type": "object",
  "properties": {
    "url": {
      "type": "string"
    }
  },
  "required": [
    "url"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["VisitInstanceDutySheet",
{
  "type": "object",
  "properties": {
    "requiredDutyTasks": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/RequiredDutySheetTask"
      }
    },
    "selectedDuties": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/SelectedDutySheetTask"
      }
    }
  },
  "required": [
    "requiredDutyTasks",
    "selectedDuties"
  ],
  "definitions": {
    "RequiredDutySheetTask": {
      "type": "object",
      "properties": {
        "isRequired": {
          "type": "boolean"
        },
        "id": {
          "$ref": "#/definitions/PlanOfCareItemId"
        },
        "name": {
          "type": "string"
        },
        "code": {
          "type": "string"
        }
      },
      "required": [
        "code",
        "id",
        "isRequired",
        "name"
      ]
    },
    "PlanOfCareItemId": {
      "type": "number"
    },
    "SelectedDutySheetTask": {
      "type": "object",
      "properties": {
        "planOfCareItemId": {
          "$ref": "#/definitions/PlanOfCareItemId"
        },
        "notes": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "notes",
        "planOfCareItemId"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverComplianceItemsMobileResponse",
{
  "type": "object",
  "properties": {
    "isCompliant": {
      "type": "boolean"
    },
    "items": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverComplianceItemMobile"
      }
    }
  },
  "required": [
    "isCompliant",
    "items"
  ],
  "definitions": {
    "CaregiverComplianceItemMobile": {
      "type": "object",
      "properties": {
        "documentType": {
          "type": "object",
          "properties": {
            "id": {
              "$ref": "#/definitions/CaregiverDocumentTypeId"
            },
            "name": {
              "type": "string"
            },
            "section": {
              "$ref": "#/definitions/ComplianceDocumentSection"
            },
            "isPassport": {
              "type": "boolean"
            },
            "groupType": {
              "anyOf": [
                {
                  "enum": [
                    "and",
                    "or"
                  ],
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            },
            "children": {
              "type": "array",
              "items": {
                "$ref": "#/definitions/CaregiverDocumentTypeGroupInfo"
              }
            },
            "isFillable": {
              "type": "boolean"
            },
            "fillableUploadAlternative": {
              "anyOf": [
                {
                  "$ref": "#/definitions/CaregiverDocumentTypeId"
                },
                {
                  "type": "null"
                }
              ]
            },
            "adhocType": {
              "anyOf": [
                {
                  "enum": [
                    "flu",
                    "i-9"
                  ],
                  "type": "string"
                },
                {
                  "type": "null"
                }
              ]
            }
          },
          "required": [
            "adhocType",
            "children",
            "fillableUploadAlternative",
            "groupType",
            "id",
            "isFillable",
            "isPassport",
            "name",
            "section"
          ]
        },
        "complianceStatus": {
          "$ref": "#/definitions/ComplianceStatus"
        },
        "dueDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "expiryDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "uploads": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverUploadDocumentMobile"
          }
        },
        "referenceDocumentData": {
          "anyOf": [
            {
              "$ref": "#/definitions/CaregiverComplianceReferenceDocumentData"
            },
            {
              "type": "null"
            }
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "complianceStatus",
        "documentType",
        "dueDate",
        "expiryDate",
        "isHidden",
        "referenceDocumentData",
        "uploads"
      ]
    },
    "CaregiverDocumentTypeId": {
      "type": "number"
    },
    "ComplianceDocumentSection": {
      "enum": [
        "General",
        "I-9",
        "Medical"
      ],
      "type": "string"
    },
    "CaregiverDocumentTypeGroupInfo": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CaregiverDocumentTypeId"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/CaregiverDocumentTypeId"
            },
            {
              "type": "null"
            }
          ]
        },
        "name": {
          "type": "string"
        },
        "groupType": {
          "anyOf": [
            {
              "enum": [
                "and",
                "or"
              ],
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "isPassport": {
          "type": "boolean"
        },
        "isFillable": {
          "type": "boolean"
        },
        "children": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverDocumentTypeGroupInfo"
          }
        }
      },
      "required": [
        "children",
        "groupType",
        "id",
        "isFillable",
        "isPassport",
        "name",
        "parentId"
      ]
    },
    "ComplianceStatus": {
      "enum": [
        "Compliant",
        "Missing",
        "Not Compliant",
        "Not due yet",
        "Pending Uploads",
        "Resolved"
      ],
      "type": "string"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "CaregiverUploadDocumentMobile": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CaregiverDocumentUploadId"
        },
        "url": {
          "type": "string"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "status": {
          "$ref": "#/definitions/UploadedDocumentStatus"
        },
        "rejectReason": {
          "type": [
            "null",
            "string"
          ]
        },
        "documentNamesTrail": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "expiryDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "expires": {
          "type": "boolean"
        }
      },
      "required": [
        "createdAt",
        "documentNamesTrail",
        "expires",
        "expiryDate",
        "id",
        "rejectReason",
        "status",
        "url"
      ]
    },
    "CaregiverDocumentUploadId": {
      "type": "number"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "UploadedDocumentStatus": {
      "enum": [
        "Approved",
        "Dismissed",
        "Pending",
        "Rejected"
      ],
      "type": "string"
    },
    "CaregiverComplianceReferenceDocumentData": {
      "type": "object",
      "properties": {
        "referenceName": {
          "type": [
            "null",
            "string"
          ]
        },
        "referencePhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "referenceLink": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "referenceLink",
        "referenceName",
        "referencePhoneNumber"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverI9FormResponse",
{
  "type": "object",
  "properties": {
    "form": {
      "$ref": "#/definitions/ComplianceFormDocument"
    },
    "questionOptionIdDocumentTypeIdEntries": {
      "type": "array",
      "items": {
        "type": "array",
        "items": [
          {
            "$ref": "#/definitions/ComplianceFormQuestionOptionId"
          },
          {
            "$ref": "#/definitions/CaregiverDocumentTypeId"
          }
        ],
        "minItems": 2,
        "additionalItems": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "$ref": "#/definitions/CaregiverDocumentTypeId"
            }
          ]
        }
      }
    }
  },
  "required": [
    "form",
    "questionOptionIdDocumentTypeIdEntries"
  ],
  "definitions": {
    "CaregiverDocumentTypeId": {
      "type": "number"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "ComplianceFormDocument": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/ComplianceFormDocumentId"
        },
        "documentType": {
          "type": "object",
          "properties": {
            "id": {
              "$ref": "#/definitions/CaregiverDocumentTypeId"
            },
            "name": {
              "type": "string"
            }
          },
          "required": [
            "id",
            "name"
          ]
        },
        "questions": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "#/definitions/ComplianceFormRadioQuestion"
              },
              {
                "$ref": "#/definitions/ComplianceFormTextQuestion"
              },
              {
                "$ref": "#/definitions/ComplianceFormYesNoQuestion"
              },
              {
                "$ref": "#/definitions/ComplianceFormDateQuestion"
              },
              {
                "$ref": "#/definitions/ComplianceFormPhoneNumberQuestion"
              },
              {
                "$ref": "#/definitions/ComplianceFormSignatureQuestion"
              },
              {
                "$ref": "#/definitions/ComplianceFormPlainTextQuestion"
              },
              {
                "$ref": "#/definitions/ComplianceFormDocumentQuestion"
              }
            ]
          }
        }
      },
      "required": [
        "documentType",
        "id",
        "questions"
      ]
    },
    "ComplianceFormDocumentId": {
      "format": "ComplianceFormDocumentId",
      "type": "number"
    },
    "ComplianceFormRadioQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "radio"
          ]
        },
        "options": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/ComplianceFormQuestionOption"
          }
        },
        "value": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "options",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type",
        "value"
      ]
    },
    "ComplianceFormQuestionOption": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionOptionId"
        },
        "title": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "title"
      ]
    },
    "ComplianceFormQuestionOptionId": {
      "format": "ComplianceFormQuestionOptionId",
      "type": "number"
    },
    "ComplianceFormQuestionId": {
      "format": "ComplianceFormQuestionId",
      "type": "number"
    },
    "ComplianceFormTextQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "text"
          ]
        },
        "value": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type",
        "value"
      ]
    },
    "ComplianceFormYesNoQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "yesno"
          ]
        },
        "value": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type",
        "value"
      ]
    },
    "ComplianceFormDateQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "date"
          ]
        },
        "value": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type",
        "value"
      ]
    },
    "ComplianceFormPhoneNumberQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "phone_number"
          ]
        },
        "value": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type",
        "value"
      ]
    },
    "ComplianceFormSignatureQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "signature"
          ]
        },
        "value": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type",
        "value"
      ]
    },
    "ComplianceFormPlainTextQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "plain_text"
          ]
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type"
      ]
    },
    "ComplianceFormDocumentQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "document"
          ]
        },
        "value": {
          "type": [
            "null",
            "string"
          ]
        },
        "isRequired": {
          "type": "boolean"
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "isRequired",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type",
        "value"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverRating",
{
  "type": "object",
  "properties": {
    "rating": {
      "type": "number"
    }
  },
  "required": [
    "rating"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CommCenterGetTicketResponse",
{
  "type": "object",
  "properties": {
    "ticket": {
      "$ref": "#/definitions/CommCenterTicket"
    }
  },
  "required": [
    "ticket"
  ],
  "definitions": {
    "CommCenterTicket": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CommCenterTicketId"
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "status": {
          "$ref": "#/definitions/CommCenterTicketStatus"
        },
        "enableAgencyResponse": {
          "type": "boolean"
        },
        "priority": {
          "$ref": "#/definitions/CommCenterLabelPriority"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "source": {
          "$ref": "#/definitions/CommCenterTicketSource"
        },
        "topic": {
          "$ref": "#/definitions/CommCenterTicketTopic"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterLabel"
            },
            {
              "type": "null"
            }
          ]
        },
        "createdBy": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterTicketCreatedBy.Caregiver"
            },
            {
              "$ref": "#/definitions/CommCenterTicketCreatedBy.AgencyMember"
            },
            {
              "$ref": "#/definitions/CommCenterTicketCreatedBy.System"
            }
          ]
        },
        "relatedCaregiver": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "id": {
                  "$ref": "#/definitions/CaregiverId"
                },
                "name": {
                  "type": "string"
                },
                "status": {
                  "$ref": "#/definitions/CaregiverStatus"
                },
                "onboardingStageDetails": {
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "id": {
                          "$ref": "#/definitions/HRSectionStageId"
                        },
                        "name": {
                          "type": "string"
                        }
                      },
                      "required": [
                        "id",
                        "name"
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              },
              "required": [
                "id",
                "name",
                "onboardingStageDetails",
                "status"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "relatedPatient": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "id": {
                  "$ref": "#/definitions/PatientId"
                },
                "name": {
                  "type": "string"
                },
                "status": {
                  "$ref": "#/definitions/PatientStatus"
                }
              },
              "required": [
                "id",
                "name",
                "status"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "relatedTeam": {
          "type": "object",
          "properties": {
            "id": {
              "$ref": "#/definitions/CommCenterTeamId"
            },
            "name": {
              "type": "string"
            }
          },
          "required": [
            "id",
            "name"
          ]
        },
        "assignedTo": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "id": {
                  "$ref": "#/definitions/CommCenterTeamMemberId"
                },
                "name": {
                  "type": "string"
                }
              },
              "required": [
                "id",
                "name"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "relatedVisitBroadcast": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "id": {
                  "$ref": "#/definitions/VisitBroadcastId"
                },
                "startTime": {
                  "$ref": "#/definitions/LocalDateTime"
                },
                "endTime": {
                  "$ref": "#/definitions/LocalDateTime"
                }
              },
              "required": [
                "endTime",
                "id",
                "startTime"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "relatedVisitInstance": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "id": {
                  "$ref": "#/definitions/VisitInstanceId"
                },
                "startTime": {
                  "$ref": "#/definitions/LocalDateTime"
                },
                "endTime": {
                  "$ref": "#/definitions/LocalDateTime"
                }
              },
              "required": [
                "endTime",
                "id",
                "startTime"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "messages": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CommCenterMessage"
          }
        }
      },
      "required": [
        "agencyId",
        "assignedTo",
        "createdAt",
        "createdBy",
        "enableAgencyResponse",
        "id",
        "label",
        "messages",
        "priority",
        "relatedCaregiver",
        "relatedPatient",
        "relatedTeam",
        "relatedVisitBroadcast",
        "relatedVisitInstance",
        "source",
        "status",
        "topic"
      ]
    },
    "CommCenterTicketId": {
      "type": "number"
    },
    "AgencyId": {
      "type": "number"
    },
    "CommCenterTicketStatus": {
      "enum": [
        "IN PROGRESS",
        "NEW",
        "RESOLVED"
      ],
      "type": "string"
    },
    "CommCenterLabelPriority": {
      "enum": [
        "HIGH",
        "LOW",
        "MEDIUM"
      ],
      "type": "string"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "CommCenterTicketSource": {
      "enum": [
        "MANUAL",
        "MOBILE_CHAT",
        "SYSTEM_TRIGGER"
      ],
      "type": "string"
    },
    "CommCenterTicketTopic": {
      "enum": [
        "Caregiver",
        "Patient"
      ],
      "type": "string"
    },
    "CommCenterLabel": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CommCenterLabelId"
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "name": {
          "type": "string"
        },
        "active": {
          "type": "boolean"
        },
        "parent": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterLabelId"
            },
            {
              "type": "null"
            }
          ]
        },
        "messageActionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterMessageActionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "priority": {
          "$ref": "#/definitions/CommCenterLabelPriority"
        },
        "timeToResolve": {
          "type": "number"
        },
        "assignedTeamId": {
          "$ref": "#/definitions/CommCenterTeamId"
        },
        "iconUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "code": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "active",
        "agencyId",
        "assignedTeamId",
        "code",
        "iconUrl",
        "id",
        "messageActionId",
        "name",
        "parent",
        "priority",
        "timeToResolve"
      ]
    },
    "CommCenterLabelId": {
      "type": "number"
    },
    "CommCenterMessageActionId": {
      "type": "number"
    },
    "CommCenterTeamId": {
      "type": "number"
    },
    "CommCenterTicketCreatedBy.Caregiver": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Caregiver"
          ]
        },
        "id": {
          "$ref": "#/definitions/CaregiverId"
        },
        "name": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name",
        "type"
      ]
    },
    "CaregiverId": {
      "type": "number"
    },
    "CommCenterTicketCreatedBy.AgencyMember": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Agency Member"
          ]
        },
        "id": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "name": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name",
        "type"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "CommCenterTicketCreatedBy.System": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "System"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "CaregiverStatus": {
      "description": "The status of a Caregiver within a specific Agency",
      "enum": [
        "ACTIVE",
        "JOIN_REQUEST",
        "ON_HOLD",
        "ON_LEAVE",
        "PENDING",
        "QUIT",
        "REJECTED",
        "SUSPENDED",
        "TERMINATED"
      ],
      "type": "string"
    },
    "HRSectionStageId": {
      "type": "number"
    },
    "PatientId": {
      "type": "number"
    },
    "PatientStatus": {
      "type": "string"
    },
    "CommCenterTeamMemberId": {
      "type": "number"
    },
    "VisitBroadcastId": {
      "type": "number"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "VisitInstanceId": {
      "type": "number"
    },
    "CommCenterMessage": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CommCenterMessageId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "ticketId": {
          "$ref": "#/definitions/CommCenterTicketId"
        },
        "payload": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "#/definitions/CommCenterMessagePayloadText"
              },
              {
                "$ref": "#/definitions/CommCenterMessagePayloadImage"
              },
              {
                "$ref": "#/definitions/CommCenterMessagePayloadDocument"
              },
              {
                "$ref": "#/definitions/CommCenterMessagePayloadVideo"
              },
              {
                "$ref": "#/definitions/CommCenterMessagePayloadAction"
              },
              {
                "$ref": "#/definitions/CommCenterMessagePayloadOnboardingMessage"
              }
            ]
          }
        },
        "messageActionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterMessageActionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "createdBy": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterMessageCreatedBy.Caregiver"
            },
            {
              "$ref": "#/definitions/CommCenterMessageCreatedBy.AgencyMember"
            },
            {
              "$ref": "#/definitions/CommCenterMessageCreatedBy.System"
            }
          ]
        },
        "labelId": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterLabelId"
            },
            {
              "type": "null"
            }
          ]
        },
        "readAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "createdAt",
        "createdBy",
        "id",
        "labelId",
        "messageActionId",
        "payload",
        "readAt",
        "ticketId"
      ]
    },
    "CommCenterMessageId": {
      "type": "number"
    },
    "CommCenterMessagePayloadText": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "TEXT"
          ]
        },
        "message": {
          "type": "string"
        }
      },
      "required": [
        "message",
        "type"
      ]
    },
    "CommCenterMessagePayloadImage": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "IMAGE"
          ]
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "type",
        "url"
      ]
    },
    "CommCenterMessagePayloadDocument": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "DOCUMENT"
          ]
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "type",
        "url"
      ]
    },
    "CommCenterMessagePayloadVideo": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "VIDEO"
          ]
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "type",
        "url"
      ]
    },
    "CommCenterMessagePayloadAction": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "ACTION"
          ]
        },
        "id": {
          "$ref": "#/definitions/CommCenterMessageActionId"
        },
        "payload": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterMessagePayloadActionText"
            },
            {
              "$ref": "#/definitions/CommCenterMessagePayloadActionImage"
            },
            {
              "$ref": "#/definitions/CommCenterMessagePayloadActionDocument"
            },
            {
              "$ref": "#/definitions/CommCenterMessagePayloadActionVideo"
            },
            {
              "$ref": "#/definitions/CommCenterMessagePayloadActionList"
            }
          ]
        }
      },
      "required": [
        "id",
        "payload",
        "type"
      ]
    },
    "CommCenterMessagePayloadActionText": {
      "type": "object",
      "properties": {
        "payloadType": {
          "type": "string",
          "enum": [
            "TEXT"
          ]
        },
        "text": {
          "type": "string"
        }
      },
      "required": [
        "payloadType",
        "text"
      ]
    },
    "CommCenterMessagePayloadActionImage": {
      "type": "object",
      "properties": {
        "payloadType": {
          "type": "string",
          "enum": [
            "IMAGE"
          ]
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "payloadType",
        "url"
      ]
    },
    "CommCenterMessagePayloadActionDocument": {
      "type": "object",
      "properties": {
        "payloadType": {
          "type": "string",
          "enum": [
            "DOCUMENT"
          ]
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "payloadType",
        "url"
      ]
    },
    "CommCenterMessagePayloadActionVideo": {
      "type": "object",
      "properties": {
        "payloadType": {
          "type": "string",
          "enum": [
            "VIDEO"
          ]
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "payloadType",
        "url"
      ]
    },
    "CommCenterMessagePayloadActionList": {
      "type": "object",
      "properties": {
        "payloadType": {
          "type": "string",
          "enum": [
            "LIST"
          ]
        },
        "items": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "entity": {
                "$ref": "#/definitions/CommCenterMessageActionEntity"
              },
              "id": {
                "description": "Id of the entity\ncan be: Patient/Visit/Label",
                "type": "number"
              },
              "text": {
                "description": "Name or description of the entity\nFor patient it should be name.\nFor label it should be the display text",
                "type": "string"
              },
              "icon": {
                "type": "string"
              },
              "code": {
                "type": "string"
              }
            },
            "required": [
              "entity",
              "id",
              "text"
            ]
          }
        }
      },
      "required": [
        "items",
        "payloadType"
      ]
    },
    "CommCenterMessageActionEntity": {
      "type": "string"
    },
    "CommCenterMessagePayloadOnboardingMessage": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "ONBOARDING_MESSAGE"
          ]
        },
        "payload": {
          "anyOf": [
            {
              "$ref": "#/definitions/RejectedItemOnboardingMessagePayload"
            },
            {
              "$ref": "#/definitions/ApprovedItemOnboardingMessagePayload"
            }
          ]
        }
      },
      "required": [
        "payload",
        "type"
      ]
    },
    "RejectedItemOnboardingMessagePayload": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "REJECTED_ITEM"
          ]
        },
        "item": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "entity": {
                "$ref": "#/definitions/CommCenterMessageActionEntity"
              },
              "id": {
                "type": "number"
              },
              "text": {
                "type": "string"
              }
            },
            "required": [
              "entity",
              "id",
              "text"
            ]
          }
        }
      },
      "required": [
        "item",
        "type"
      ]
    },
    "ApprovedItemOnboardingMessagePayload": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "APPROVED_ITEM"
          ]
        },
        "item": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "entity": {
                "$ref": "#/definitions/CommCenterMessageActionEntity"
              },
              "id": {
                "type": "number"
              },
              "text": {
                "type": "string"
              }
            },
            "required": [
              "entity",
              "id",
              "text"
            ]
          }
        }
      },
      "required": [
        "item",
        "type"
      ]
    },
    "CommCenterMessageCreatedBy.Caregiver": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Caregiver"
          ]
        },
        "id": {
          "$ref": "#/definitions/CaregiverId"
        },
        "name": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name",
        "type"
      ]
    },
    "CommCenterMessageCreatedBy.AgencyMember": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Agency Member"
          ]
        },
        "id": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "name": {
          "type": "string"
        },
        "photoUrl": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "id",
        "name",
        "photoUrl",
        "type"
      ]
    },
    "CommCenterMessageCreatedBy.System": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "System"
          ]
        }
      },
      "required": [
        "type"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CommCenterCaregiverTicketList",
{
  "type": "object",
  "properties": {
    "tickets": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CommCenterTicket"
      }
    }
  },
  "required": [
    "tickets"
  ],
  "definitions": {
    "CommCenterTicket": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CommCenterTicketId"
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "status": {
          "$ref": "#/definitions/CommCenterTicketStatus"
        },
        "enableAgencyResponse": {
          "type": "boolean"
        },
        "priority": {
          "$ref": "#/definitions/CommCenterLabelPriority"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "source": {
          "$ref": "#/definitions/CommCenterTicketSource"
        },
        "topic": {
          "$ref": "#/definitions/CommCenterTicketTopic"
        },
        "label": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterLabel"
            },
            {
              "type": "null"
            }
          ]
        },
        "createdBy": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterTicketCreatedBy.Caregiver"
            },
            {
              "$ref": "#/definitions/CommCenterTicketCreatedBy.AgencyMember"
            },
            {
              "$ref": "#/definitions/CommCenterTicketCreatedBy.System"
            }
          ]
        },
        "relatedCaregiver": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "id": {
                  "$ref": "#/definitions/CaregiverId"
                },
                "name": {
                  "type": "string"
                },
                "status": {
                  "$ref": "#/definitions/CaregiverStatus"
                },
                "onboardingStageDetails": {
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "id": {
                          "$ref": "#/definitions/HRSectionStageId"
                        },
                        "name": {
                          "type": "string"
                        }
                      },
                      "required": [
                        "id",
                        "name"
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              },
              "required": [
                "id",
                "name",
                "onboardingStageDetails",
                "status"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "relatedPatient": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "id": {
                  "$ref": "#/definitions/PatientId"
                },
                "name": {
                  "type": "string"
                },
                "status": {
                  "$ref": "#/definitions/PatientStatus"
                }
              },
              "required": [
                "id",
                "name",
                "status"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "relatedTeam": {
          "type": "object",
          "properties": {
            "id": {
              "$ref": "#/definitions/CommCenterTeamId"
            },
            "name": {
              "type": "string"
            }
          },
          "required": [
            "id",
            "name"
          ]
        },
        "assignedTo": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "id": {
                  "$ref": "#/definitions/CommCenterTeamMemberId"
                },
                "name": {
                  "type": "string"
                }
              },
              "required": [
                "id",
                "name"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "relatedVisitBroadcast": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "id": {
                  "$ref": "#/definitions/VisitBroadcastId"
                },
                "startTime": {
                  "$ref": "#/definitions/LocalDateTime"
                },
                "endTime": {
                  "$ref": "#/definitions/LocalDateTime"
                }
              },
              "required": [
                "endTime",
                "id",
                "startTime"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "relatedVisitInstance": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "id": {
                  "$ref": "#/definitions/VisitInstanceId"
                },
                "startTime": {
                  "$ref": "#/definitions/LocalDateTime"
                },
                "endTime": {
                  "$ref": "#/definitions/LocalDateTime"
                }
              },
              "required": [
                "endTime",
                "id",
                "startTime"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "messages": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CommCenterMessage"
          }
        }
      },
      "required": [
        "agencyId",
        "assignedTo",
        "createdAt",
        "createdBy",
        "enableAgencyResponse",
        "id",
        "label",
        "messages",
        "priority",
        "relatedCaregiver",
        "relatedPatient",
        "relatedTeam",
        "relatedVisitBroadcast",
        "relatedVisitInstance",
        "source",
        "status",
        "topic"
      ]
    },
    "CommCenterTicketId": {
      "type": "number"
    },
    "AgencyId": {
      "type": "number"
    },
    "CommCenterTicketStatus": {
      "enum": [
        "IN PROGRESS",
        "NEW",
        "RESOLVED"
      ],
      "type": "string"
    },
    "CommCenterLabelPriority": {
      "enum": [
        "HIGH",
        "LOW",
        "MEDIUM"
      ],
      "type": "string"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "CommCenterTicketSource": {
      "enum": [
        "MANUAL",
        "MOBILE_CHAT",
        "SYSTEM_TRIGGER"
      ],
      "type": "string"
    },
    "CommCenterTicketTopic": {
      "enum": [
        "Caregiver",
        "Patient"
      ],
      "type": "string"
    },
    "CommCenterLabel": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CommCenterLabelId"
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "name": {
          "type": "string"
        },
        "active": {
          "type": "boolean"
        },
        "parent": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterLabelId"
            },
            {
              "type": "null"
            }
          ]
        },
        "messageActionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterMessageActionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "priority": {
          "$ref": "#/definitions/CommCenterLabelPriority"
        },
        "timeToResolve": {
          "type": "number"
        },
        "assignedTeamId": {
          "$ref": "#/definitions/CommCenterTeamId"
        },
        "iconUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "code": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "active",
        "agencyId",
        "assignedTeamId",
        "code",
        "iconUrl",
        "id",
        "messageActionId",
        "name",
        "parent",
        "priority",
        "timeToResolve"
      ]
    },
    "CommCenterLabelId": {
      "type": "number"
    },
    "CommCenterMessageActionId": {
      "type": "number"
    },
    "CommCenterTeamId": {
      "type": "number"
    },
    "CommCenterTicketCreatedBy.Caregiver": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Caregiver"
          ]
        },
        "id": {
          "$ref": "#/definitions/CaregiverId"
        },
        "name": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name",
        "type"
      ]
    },
    "CaregiverId": {
      "type": "number"
    },
    "CommCenterTicketCreatedBy.AgencyMember": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Agency Member"
          ]
        },
        "id": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "name": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name",
        "type"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    },
    "CommCenterTicketCreatedBy.System": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "System"
          ]
        }
      },
      "required": [
        "type"
      ]
    },
    "CaregiverStatus": {
      "description": "The status of a Caregiver within a specific Agency",
      "enum": [
        "ACTIVE",
        "JOIN_REQUEST",
        "ON_HOLD",
        "ON_LEAVE",
        "PENDING",
        "QUIT",
        "REJECTED",
        "SUSPENDED",
        "TERMINATED"
      ],
      "type": "string"
    },
    "HRSectionStageId": {
      "type": "number"
    },
    "PatientId": {
      "type": "number"
    },
    "PatientStatus": {
      "type": "string"
    },
    "CommCenterTeamMemberId": {
      "type": "number"
    },
    "VisitBroadcastId": {
      "type": "number"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "VisitInstanceId": {
      "type": "number"
    },
    "CommCenterMessage": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CommCenterMessageId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "ticketId": {
          "$ref": "#/definitions/CommCenterTicketId"
        },
        "payload": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "#/definitions/CommCenterMessagePayloadText"
              },
              {
                "$ref": "#/definitions/CommCenterMessagePayloadImage"
              },
              {
                "$ref": "#/definitions/CommCenterMessagePayloadDocument"
              },
              {
                "$ref": "#/definitions/CommCenterMessagePayloadVideo"
              },
              {
                "$ref": "#/definitions/CommCenterMessagePayloadAction"
              },
              {
                "$ref": "#/definitions/CommCenterMessagePayloadOnboardingMessage"
              }
            ]
          }
        },
        "messageActionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterMessageActionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "createdBy": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterMessageCreatedBy.Caregiver"
            },
            {
              "$ref": "#/definitions/CommCenterMessageCreatedBy.AgencyMember"
            },
            {
              "$ref": "#/definitions/CommCenterMessageCreatedBy.System"
            }
          ]
        },
        "labelId": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterLabelId"
            },
            {
              "type": "null"
            }
          ]
        },
        "readAt": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "createdAt",
        "createdBy",
        "id",
        "labelId",
        "messageActionId",
        "payload",
        "readAt",
        "ticketId"
      ]
    },
    "CommCenterMessageId": {
      "type": "number"
    },
    "CommCenterMessagePayloadText": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "TEXT"
          ]
        },
        "message": {
          "type": "string"
        }
      },
      "required": [
        "message",
        "type"
      ]
    },
    "CommCenterMessagePayloadImage": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "IMAGE"
          ]
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "type",
        "url"
      ]
    },
    "CommCenterMessagePayloadDocument": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "DOCUMENT"
          ]
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "type",
        "url"
      ]
    },
    "CommCenterMessagePayloadVideo": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "VIDEO"
          ]
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "type",
        "url"
      ]
    },
    "CommCenterMessagePayloadAction": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "ACTION"
          ]
        },
        "id": {
          "$ref": "#/definitions/CommCenterMessageActionId"
        },
        "payload": {
          "anyOf": [
            {
              "$ref": "#/definitions/CommCenterMessagePayloadActionText"
            },
            {
              "$ref": "#/definitions/CommCenterMessagePayloadActionImage"
            },
            {
              "$ref": "#/definitions/CommCenterMessagePayloadActionDocument"
            },
            {
              "$ref": "#/definitions/CommCenterMessagePayloadActionVideo"
            },
            {
              "$ref": "#/definitions/CommCenterMessagePayloadActionList"
            }
          ]
        }
      },
      "required": [
        "id",
        "payload",
        "type"
      ]
    },
    "CommCenterMessagePayloadActionText": {
      "type": "object",
      "properties": {
        "payloadType": {
          "type": "string",
          "enum": [
            "TEXT"
          ]
        },
        "text": {
          "type": "string"
        }
      },
      "required": [
        "payloadType",
        "text"
      ]
    },
    "CommCenterMessagePayloadActionImage": {
      "type": "object",
      "properties": {
        "payloadType": {
          "type": "string",
          "enum": [
            "IMAGE"
          ]
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "payloadType",
        "url"
      ]
    },
    "CommCenterMessagePayloadActionDocument": {
      "type": "object",
      "properties": {
        "payloadType": {
          "type": "string",
          "enum": [
            "DOCUMENT"
          ]
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "payloadType",
        "url"
      ]
    },
    "CommCenterMessagePayloadActionVideo": {
      "type": "object",
      "properties": {
        "payloadType": {
          "type": "string",
          "enum": [
            "VIDEO"
          ]
        },
        "url": {
          "type": "string"
        }
      },
      "required": [
        "payloadType",
        "url"
      ]
    },
    "CommCenterMessagePayloadActionList": {
      "type": "object",
      "properties": {
        "payloadType": {
          "type": "string",
          "enum": [
            "LIST"
          ]
        },
        "items": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "entity": {
                "$ref": "#/definitions/CommCenterMessageActionEntity"
              },
              "id": {
                "description": "Id of the entity\ncan be: Patient/Visit/Label",
                "type": "number"
              },
              "text": {
                "description": "Name or description of the entity\nFor patient it should be name.\nFor label it should be the display text",
                "type": "string"
              },
              "icon": {
                "type": "string"
              },
              "code": {
                "type": "string"
              }
            },
            "required": [
              "entity",
              "id",
              "text"
            ]
          }
        }
      },
      "required": [
        "items",
        "payloadType"
      ]
    },
    "CommCenterMessageActionEntity": {
      "type": "string"
    },
    "CommCenterMessagePayloadOnboardingMessage": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "ONBOARDING_MESSAGE"
          ]
        },
        "payload": {
          "anyOf": [
            {
              "$ref": "#/definitions/RejectedItemOnboardingMessagePayload"
            },
            {
              "$ref": "#/definitions/ApprovedItemOnboardingMessagePayload"
            }
          ]
        }
      },
      "required": [
        "payload",
        "type"
      ]
    },
    "RejectedItemOnboardingMessagePayload": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "REJECTED_ITEM"
          ]
        },
        "item": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "entity": {
                "$ref": "#/definitions/CommCenterMessageActionEntity"
              },
              "id": {
                "type": "number"
              },
              "text": {
                "type": "string"
              }
            },
            "required": [
              "entity",
              "id",
              "text"
            ]
          }
        }
      },
      "required": [
        "item",
        "type"
      ]
    },
    "ApprovedItemOnboardingMessagePayload": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "APPROVED_ITEM"
          ]
        },
        "item": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "entity": {
                "$ref": "#/definitions/CommCenterMessageActionEntity"
              },
              "id": {
                "type": "number"
              },
              "text": {
                "type": "string"
              }
            },
            "required": [
              "entity",
              "id",
              "text"
            ]
          }
        }
      },
      "required": [
        "item",
        "type"
      ]
    },
    "CommCenterMessageCreatedBy.Caregiver": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Caregiver"
          ]
        },
        "id": {
          "$ref": "#/definitions/CaregiverId"
        },
        "name": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "name",
        "type"
      ]
    },
    "CommCenterMessageCreatedBy.AgencyMember": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Agency Member"
          ]
        },
        "id": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "name": {
          "type": "string"
        },
        "photoUrl": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "id",
        "name",
        "photoUrl",
        "type"
      ]
    },
    "CommCenterMessageCreatedBy.System": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "System"
          ]
        }
      },
      "required": [
        "type"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["ComplianceFormDocumentResponse",
{
  "type": "object",
  "properties": {
    "formDocument": {
      "$ref": "#/definitions/ComplianceFormDocument"
    }
  },
  "required": [
    "formDocument"
  ],
  "definitions": {
    "ComplianceFormDocument": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/ComplianceFormDocumentId"
        },
        "documentType": {
          "type": "object",
          "properties": {
            "id": {
              "$ref": "#/definitions/CaregiverDocumentTypeId"
            },
            "name": {
              "type": "string"
            }
          },
          "required": [
            "id",
            "name"
          ]
        },
        "questions": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "#/definitions/ComplianceFormRadioQuestion"
              },
              {
                "$ref": "#/definitions/ComplianceFormTextQuestion"
              },
              {
                "$ref": "#/definitions/ComplianceFormYesNoQuestion"
              },
              {
                "$ref": "#/definitions/ComplianceFormDateQuestion"
              },
              {
                "$ref": "#/definitions/ComplianceFormPhoneNumberQuestion"
              },
              {
                "$ref": "#/definitions/ComplianceFormSignatureQuestion"
              },
              {
                "$ref": "#/definitions/ComplianceFormPlainTextQuestion"
              },
              {
                "$ref": "#/definitions/ComplianceFormDocumentQuestion"
              }
            ]
          }
        }
      },
      "required": [
        "documentType",
        "id",
        "questions"
      ]
    },
    "ComplianceFormDocumentId": {
      "format": "ComplianceFormDocumentId",
      "type": "number"
    },
    "CaregiverDocumentTypeId": {
      "type": "number"
    },
    "ComplianceFormRadioQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "radio"
          ]
        },
        "options": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/ComplianceFormQuestionOption"
          }
        },
        "value": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "options",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type",
        "value"
      ]
    },
    "ComplianceFormQuestionOption": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionOptionId"
        },
        "title": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "title"
      ]
    },
    "ComplianceFormQuestionOptionId": {
      "format": "ComplianceFormQuestionOptionId",
      "type": "number"
    },
    "ComplianceFormQuestionId": {
      "format": "ComplianceFormQuestionId",
      "type": "number"
    },
    "ComplianceFormTextQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "text"
          ]
        },
        "value": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type",
        "value"
      ]
    },
    "ComplianceFormYesNoQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "yesno"
          ]
        },
        "value": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type",
        "value"
      ]
    },
    "ComplianceFormDateQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "date"
          ]
        },
        "value": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type",
        "value"
      ]
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "ComplianceFormPhoneNumberQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "phone_number"
          ]
        },
        "value": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type",
        "value"
      ]
    },
    "ComplianceFormSignatureQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "signature"
          ]
        },
        "value": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type",
        "value"
      ]
    },
    "ComplianceFormPlainTextQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "plain_text"
          ]
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type"
      ]
    },
    "ComplianceFormDocumentQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "document"
          ]
        },
        "value": {
          "type": [
            "null",
            "string"
          ]
        },
        "isRequired": {
          "type": "boolean"
        },
        "id": {
          "$ref": "#/definitions/ComplianceFormQuestionId"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentOptionId": {
          "anyOf": [
            {
              "$ref": "#/definitions/ComplianceFormQuestionOptionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentBooleanValue": {
          "type": [
            "null",
            "boolean"
          ]
        }
      },
      "required": [
        "description",
        "id",
        "isRequired",
        "parentBooleanValue",
        "parentId",
        "parentOptionId",
        "title",
        "type",
        "value"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["AssignedWithOvertime",
{
  "type": "object",
  "properties": {
    "assignedWithOvertime": {
      "type": "boolean"
    }
  },
  "required": [
    "assignedWithOvertime"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["BankAccountTypesResponse",
{
  "type": "object",
  "properties": {
    "accountTypes": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/BankAccountType"
      }
    }
  },
  "required": [
    "accountTypes"
  ],
  "definitions": {
    "BankAccountType": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/InstaPayBankAccountTypeId"
        },
        "type": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "type"
      ]
    },
    "InstaPayBankAccountTypeId": {
      "format": "InstaPayBankAccountTypeId",
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverUploadVideoResponse",
{
  "type": "object",
  "properties": {
    "videos": {
      "type": "array",
      "items": {
        "type": "string"
      }
    }
  },
  "required": [
    "videos"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverPoints",
{
  "type": "object",
  "properties": {
    "points": {
      "type": "number"
    }
  },
  "required": [
    "points"
  ],
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["HRDocumentTitleTranslations",
{
  "type": "object",
  "properties": {
    "Albanian": {
      "type": "string"
    },
    "Arabic": {
      "type": "string"
    },
    "Armenian": {
      "type": "string"
    },
    "Bengali": {
      "type": "string"
    },
    "Bulgarian": {
      "type": "string"
    },
    "Cantonese": {
      "type": "string"
    },
    "Chinese": {
      "type": "string"
    },
    "Creole": {
      "type": "string"
    },
    "Danish": {
      "type": "string"
    },
    "Dutch": {
      "type": "string"
    },
    "English": {
      "type": "string"
    },
    "Estonian": {
      "type": "string"
    },
    "Farsi": {
      "type": "string"
    },
    "Filipino": {
      "type": "string"
    },
    "French": {
      "type": "string"
    },
    "Fukkianese": {
      "type": "string"
    },
    "Fula/Fulani": {
      "type": "string"
    },
    "Fuzhounese": {
      "type": "string"
    },
    "Georgian": {
      "type": "string"
    },
    "German": {
      "type": "string"
    },
    "Ghana": {
      "type": "string"
    },
    "Greek": {
      "type": "string"
    },
    "Hakka": {
      "type": "string"
    },
    "Hebrew": {
      "type": "string"
    },
    "Hindi": {
      "type": "string"
    },
    "Hungarian": {
      "type": "string"
    },
    "Italian": {
      "type": "string"
    },
    "Japanese": {
      "type": "string"
    },
    "Korean": {
      "type": "string"
    },
    "Krio": {
      "type": "string"
    },
    "Kyrgyz": {
      "type": "string"
    },
    "Mandarin": {
      "type": "string"
    },
    "Pashto": {
      "type": "string"
    },
    "Persian": {
      "type": "string"
    },
    "Polish": {
      "type": "string"
    },
    "Portuguese": {
      "type": "string"
    },
    "Punjabi": {
      "type": "string"
    },
    "Romanian": {
      "type": "string"
    },
    "Russian": {
      "type": "string"
    },
    "Shanghainese": {
      "type": "string"
    },
    "Soninke": {
      "type": "string"
    },
    "Spanish": {
      "type": "string"
    },
    "Swahili": {
      "type": "string"
    },
    "Tagalog": {
      "type": "string"
    },
    "Taishanese": {
      "type": "string"
    },
    "Taiwanese": {
      "type": "string"
    },
    "Turkish": {
      "type": "string"
    },
    "Twi": {
      "type": "string"
    },
    "Ukrainian": {
      "type": "string"
    },
    "Urdu": {
      "type": "string"
    },
    "Uzbek": {
      "type": "string"
    },
    "Vietnamese": {
      "type": "string"
    },
    "Yiddish": {
      "type": "string"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverPaystubsResponse",
{
  "type": "object",
  "properties": {
    "paystubs": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/Paystub"
      }
    }
  },
  "required": [
    "paystubs"
  ],
  "definitions": {
    "Paystub": {
      "type": "object",
      "properties": {
        "checkDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "periodBeginDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "periodEndDate": {
          "$ref": "#/definitions/LocalDate"
        },
        "totalGross": {
          "type": "number"
        },
        "totalHours": {
          "type": "number"
        },
        "totalNet": {
          "type": "number"
        },
        "totalTaxes": {
          "type": "number"
        },
        "totalDeductions": {
          "type": "number"
        },
        "netCheckAmount": {
          "type": "number"
        },
        "netDirectDepositAmount": {
          "type": "number"
        },
        "checkOrVoucherNumber": {
          "type": "number"
        },
        "earnings": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/Earning"
          }
        },
        "deductions": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/Deduction"
          }
        },
        "taxes": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/Tax"
          }
        }
      },
      "required": [
        "checkDate",
        "checkOrVoucherNumber",
        "deductions",
        "earnings",
        "netCheckAmount",
        "netDirectDepositAmount",
        "periodBeginDate",
        "periodEndDate",
        "taxes",
        "totalDeductions",
        "totalGross",
        "totalHours",
        "totalNet",
        "totalTaxes"
      ]
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "Earning": {
      "type": "object",
      "properties": {
        "chargeDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "amount": {
          "type": "number"
        },
        "hours": {
          "type": "number"
        },
        "rate": {
          "type": "number"
        },
        "earningCode": {
          "type": "string"
        },
        "earningDescription": {
          "type": "string"
        }
      },
      "required": [
        "amount",
        "chargeDate",
        "earningCode",
        "earningDescription",
        "hours",
        "rate"
      ]
    },
    "Deduction": {
      "type": "object",
      "properties": {
        "amount": {
          "type": "number"
        },
        "deductionCode": {
          "type": "string"
        },
        "deductionDescription": {
          "type": "string"
        }
      },
      "required": [
        "amount",
        "deductionCode",
        "deductionDescription"
      ]
    },
    "Tax": {
      "type": "object",
      "properties": {
        "taxCode": {
          "type": "string"
        },
        "taxAmount": {
          "type": "number"
        },
        "taxableWages": {
          "type": "number"
        },
        "taxDescription": {
          "type": "string"
        },
        "withholdingType": {
          "type": "string"
        }
      },
      "required": [
        "taxAmount",
        "taxCode",
        "taxDescription",
        "taxableWages",
        "withholdingType"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["ClockinClockoutRecordSelfieCreateParams",
{
  "type": "object",
  "properties": {
    "imageBase64": {
      "type": "string"
    }
  },
  "required": [
    "imageBase64"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["ClockinClockoutCheckAdjustmentStatusResponse",
{
  "type": "object",
  "properties": {
    "result": {
      "anyOf": [
        {
          "type": "object",
          "properties": {
            "status": {
              "type": "string",
              "enum": [
                "SUCCESS"
              ]
            },
            "adjustedUTC": {
              "$ref": "#/definitions/Instant"
            },
            "adjustedLocal": {
              "$ref": "#/definitions/LocalDateTime"
            },
            "offset": {
              "$ref": "#/definitions/Duration"
            }
          },
          "required": [
            "adjustedLocal",
            "adjustedUTC",
            "offset",
            "status"
          ]
        },
        {
          "type": "object",
          "properties": {
            "status": {
              "type": "string",
              "enum": [
                "ERROR"
              ]
            },
            "error": {
              "type": "string",
              "enum": [
                "OUTSIDE_OF_OFFSET"
              ]
            },
            "adjustedLocal": {
              "$ref": "#/definitions/LocalDateTime"
            }
          },
          "required": [
            "adjustedLocal",
            "error",
            "status"
          ]
        },
        {
          "type": "object",
          "properties": {
            "status": {
              "type": "string",
              "enum": [
                "ERROR"
              ]
            },
            "error": {
              "type": "string",
              "enum": [
                "CANT_ADJUST_DAY"
              ]
            },
            "adjustedLocal": {
              "$ref": "#/definitions/LocalDateTime"
            }
          },
          "required": [
            "adjustedLocal",
            "error",
            "status"
          ]
        },
        {
          "type": "object",
          "properties": {
            "status": {
              "type": "string",
              "enum": [
                "ERROR"
              ]
            },
            "error": {
              "type": "string",
              "enum": [
                "VISIT_ALREADY_CLOCKED_IN"
              ]
            },
            "adjustedLocal": {
              "$ref": "#/definitions/LocalDateTime"
            }
          },
          "required": [
            "adjustedLocal",
            "error",
            "status"
          ]
        },
        {
          "type": "object",
          "properties": {
            "status": {
              "type": "string",
              "enum": [
                "ERROR"
              ]
            },
            "error": {
              "type": "string",
              "enum": [
                "VISIT_BACK_TO_BACK"
              ]
            },
            "visitInstanceId": {
              "$ref": "#/definitions/VisitInstanceId"
            },
            "adjustedLocal": {
              "$ref": "#/definitions/LocalDateTime"
            }
          },
          "required": [
            "adjustedLocal",
            "error",
            "status",
            "visitInstanceId"
          ]
        },
        {
          "type": "object",
          "properties": {
            "status": {
              "type": "string",
              "enum": [
                "ERROR"
              ]
            },
            "error": {
              "type": "string",
              "enum": [
                "VISIT_OVERLAPPING"
              ]
            },
            "visitInstanceId": {
              "$ref": "#/definitions/VisitInstanceId"
            },
            "adjustedLocal": {
              "$ref": "#/definitions/LocalDateTime"
            }
          },
          "required": [
            "adjustedLocal",
            "error",
            "status",
            "visitInstanceId"
          ]
        }
      ]
    }
  },
  "required": [
    "result"
  ],
  "definitions": {
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    },
    "Duration": {
      "type": "string",
      "xreviver": "JSJoda.Duration"
    },
    "VisitInstanceId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverStaffingPreferencesResponse",
{
  "type": "object",
  "properties": {
    "sections": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverStaffingPreferencesSection"
      }
    }
  },
  "required": [
    "sections"
  ],
  "definitions": {
    "CaregiverStaffingPreferencesSection": {
      "type": "object",
      "properties": {
        "title": {
          "$ref": "#/definitions/SectionTitle"
        },
        "layoutOrder": {
          "type": "number"
        },
        "preferences": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "#/definitions/StaffingPreferenceSelect"
              },
              {
                "$ref": "#/definitions/StaffingPreferenceSwitch"
              },
              {
                "$ref": "#/definitions/StaffingPreferenceMultiSelect"
              },
              {
                "$ref": "#/definitions/StaffingPreferenceText"
              }
            ]
          }
        }
      },
      "required": [
        "layoutOrder",
        "preferences",
        "title"
      ]
    },
    "SectionTitle": {
      "enum": [
        "About Me",
        "Cases",
        "Culture",
        "Household",
        "Language",
        "Patient",
        "Smoking",
        "Transport"
      ],
      "type": "string"
    },
    "StaffingPreferenceSelect": {
      "type": "object",
      "properties": {
        "questionType": {
          "type": "string",
          "enum": [
            "Select"
          ]
        },
        "label": {
          "type": "string"
        },
        "type": {
          "$ref": "#/definitions/CaregiverPreferenceSelectTypes"
        },
        "options": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "title": {
                "type": "string"
              },
              "value": {
                "type": [
                  "string",
                  "number"
                ]
              }
            },
            "required": [
              "title",
              "value"
            ]
          }
        },
        "answer": {
          "type": [
            "null",
            "string",
            "number"
          ]
        }
      },
      "required": [
        "answer",
        "label",
        "options",
        "questionType",
        "type"
      ]
    },
    "CaregiverPreferenceSelectTypes": {
      "enum": [
        "main_language",
        "public_transprotation_time_limit",
        "transportation_type",
        "work_times"
      ],
      "type": "string"
    },
    "StaffingPreferenceSwitch": {
      "type": "object",
      "properties": {
        "questionType": {
          "type": "string",
          "enum": [
            "Switch"
          ]
        },
        "label": {
          "type": "string"
        },
        "type": {
          "$ref": "#/definitions/CaregiverPreferenceBooleanTypes"
        },
        "answer": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "label",
        "questionType",
        "type"
      ]
    },
    "CaregiverPreferenceBooleanTypes": {
      "enum": [
        "smoking_caregiver",
        "studying",
        "work_with_bedbound",
        "work_with_halal",
        "work_with_hoyer_lift",
        "work_with_kids",
        "work_with_kosher",
        "work_with_pets",
        "work_with_shabat",
        "work_with_smoking_patient",
        "work_with_walking_asistant"
      ],
      "type": "string"
    },
    "StaffingPreferenceMultiSelect": {
      "type": "object",
      "properties": {
        "questionType": {
          "type": "string",
          "enum": [
            "MultiSelect"
          ]
        },
        "label": {
          "type": "string"
        },
        "type": {
          "$ref": "#/definitions/CaregiverPreferenceMultiSelectTypes"
        },
        "options": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "title": {
                "type": "string"
              },
              "value": {
                "type": "string"
              }
            },
            "required": [
              "title",
              "value"
            ]
          }
        },
        "answer": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "answer",
        "label",
        "options",
        "questionType",
        "type"
      ]
    },
    "CaregiverPreferenceMultiSelectTypes": {
      "enum": [
        "cases_length",
        "languages",
        "patients_types"
      ],
      "type": "string"
    },
    "StaffingPreferenceText": {
      "type": "object",
      "properties": {
        "questionType": {
          "type": "string",
          "enum": [
            "Text"
          ]
        },
        "label": {
          "type": "string"
        },
        "type": {
          "$ref": "#/definitions/CaregiverPreferenceTextTypes"
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "answer",
        "label",
        "questionType",
        "type"
      ]
    },
    "CaregiverPreferenceTextTypes": {
      "enum": [
        "additional_info",
        "studying_times"
      ],
      "type": "string"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["UpdateCaregiverStaffingPreferenceRequest",
{
  "type": "object",
  "properties": {
    "changes": {
      "$ref": "#/definitions/Partial<{workWithKids:boolean|null;workWithSmokingPatient:boolean|null;smokingCaregiver:boolean|null;workWithPets:boolean|null;workWithBedbound:boolean|null;workWithWalkingAsistant:boolean|null;workWithKosher:boolean|null;workWithHalal:boolean|null;workWithHoyerLift:boolean|null;workWithShabat:boolean|null;languages:string[]|null;mainLanguage:string|null;transportationType:string|null;publicTransprotationTimeLimit:number|null;casesLength:string[]|null;patientsTypes:string[]|null;studying:boolean|null;studyingTimes:string|null;additionalInfo:string|null;workTimes:string|null;}>"
    }
  },
  "required": [
    "changes"
  ],
  "definitions": {
    "Partial<{workWithKids:boolean|null;workWithSmokingPatient:boolean|null;smokingCaregiver:boolean|null;workWithPets:boolean|null;workWithBedbound:boolean|null;workWithWalkingAsistant:boolean|null;workWithKosher:boolean|null;workWithHalal:boolean|null;workWithHoyerLift:boolean|null;workWithShabat:boolean|null;languages:string[]|null;mainLanguage:string|null;transportationType:string|null;publicTransprotationTimeLimit:number|null;casesLength:string[]|null;patientsTypes:string[]|null;studying:boolean|null;studyingTimes:string|null;additionalInfo:string|null;workTimes:string|null;}>": {
      "description": "Make all properties in T optional",
      "type": "object",
      "properties": {
        "workWithKids": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "workWithSmokingPatient": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "smokingCaregiver": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "workWithPets": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "workWithBedbound": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "workWithWalkingAsistant": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "workWithKosher": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "workWithHalal": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "workWithHoyerLift": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "workWithShabat": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "languages": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "mainLanguage": {
          "type": [
            "null",
            "string"
          ]
        },
        "transportationType": {
          "type": [
            "null",
            "string"
          ]
        },
        "publicTransprotationTimeLimit": {
          "type": [
            "null",
            "number"
          ]
        },
        "casesLength": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "patientsTypes": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "studying": {
          "type": [
            "null",
            "boolean"
          ]
        },
        "studyingTimes": {
          "type": [
            "null",
            "string"
          ]
        },
        "additionalInfo": {
          "type": [
            "null",
            "string"
          ]
        },
        "workTimes": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverBankInformationWithEmailResponse",
{
  "type": "object",
  "properties": {
    "bankAccountInfoWithMail": {
      "anyOf": [
        {
          "$ref": "#/definitions/CaregiverBankInformationWithEmail"
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "bankAccountInfoWithMail"
  ],
  "definitions": {
    "CaregiverBankInformationWithEmail": {
      "type": "object",
      "properties": {
        "email": {
          "type": [
            "null",
            "string"
          ]
        },
        "routingNumber": {
          "type": "string"
        },
        "accountNumber": {
          "type": "string"
        },
        "bankAccountTypeId": {
          "$ref": "#/definitions/InstaPayBankAccountTypeId"
        },
        "bankId": {
          "$ref": "#/definitions/InstaPayBankId"
        },
        "hasAgreedToTerms": {
          "type": "boolean"
        }
      },
      "required": [
        "accountNumber",
        "bankAccountTypeId",
        "bankId",
        "email",
        "hasAgreedToTerms",
        "routingNumber"
      ]
    },
    "InstaPayBankAccountTypeId": {
      "format": "InstaPayBankAccountTypeId",
      "type": "number"
    },
    "InstaPayBankId": {
      "format": "InstaPayBankId",
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverPaystubPdfResponse",
{
  "type": "object",
  "properties": {
    "url": {
      "type": "string"
    }
  },
  "required": [
    "url"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverRankOverview",
{
  "type": "object",
  "properties": {
    "rank": {
      "type": "object",
      "properties": {
        "from": {
          "anyOf": [
            {
              "$ref": "#/definitions/CaregiverRankProgression"
            },
            {
              "type": "null"
            }
          ]
        },
        "to": {
          "$ref": "#/definitions/CaregiverRankProgression"
        }
      },
      "required": [
        "from",
        "to"
      ]
    },
    "ranks": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/definitions/CareMomentsRankId"
          },
          "title": {
            "type": "string"
          },
          "icon": {
            "type": "string"
          },
          "wage": {
            "type": "number"
          },
          "requiredPoints": {
            "type": "number"
          }
        },
        "required": [
          "icon",
          "id",
          "requiredPoints",
          "title",
          "wage"
        ]
      }
    }
  },
  "required": [
    "rank",
    "ranks"
  ],
  "definitions": {
    "CaregiverRankProgression": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CareMomentsRankId"
        },
        "points": {
          "type": "number"
        },
        "nextRankPercents": {
          "type": "number"
        }
      },
      "required": [
        "id",
        "nextRankPercents",
        "points"
      ]
    },
    "CareMomentsRankId": {
      "format": "CareMomentsRankId",
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["GetCaregiverRaffleResponse",
{
  "type": "object",
  "properties": {
    "tokens": {
      "type": "number"
    },
    "shiftsPerToken": {
      "type": "number"
    },
    "shiftsToNextToken": {
      "type": "number"
    },
    "raffleEndsAt": {
      "$ref": "#/definitions/Instant"
    },
    "winnerCaregiverId": {
      "anyOf": [
        {
          "$ref": "#/definitions/CaregiverId"
        },
        {
          "type": "null"
        }
      ]
    },
    "previousWinners": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/RafflePreviousWinner"
      }
    },
    "participants": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/RaffleParticipant"
      }
    },
    "prize": {
      "$ref": "#/definitions/RafflePrize"
    },
    "participationStatus": {
      "anyOf": [
        {
          "type": "object",
          "properties": {
            "isParticipating": {
              "type": "boolean",
              "enum": [
                true
              ]
            }
          },
          "required": [
            "isParticipating"
          ]
        },
        {
          "type": "object",
          "properties": {
            "isParticipating": {
              "type": "boolean",
              "enum": [
                false
              ]
            },
            "reason": {
              "type": "string",
              "enum": [
                "NOT_ENOUGH_SHIFTS"
              ]
            },
            "numRequiredShiftsLeft": {
              "type": "number"
            }
          },
          "required": [
            "isParticipating",
            "numRequiredShiftsLeft",
            "reason"
          ]
        },
        {
          "type": "object",
          "properties": {
            "isParticipating": {
              "type": "boolean",
              "enum": [
                false
              ]
            },
            "reason": {
              "enum": [
                "NO_CALL_NO_SHOW",
                "NO_TOKENS",
                "RECENTLY_WON"
              ],
              "type": "string"
            }
          },
          "required": [
            "isParticipating",
            "reason"
          ]
        }
      ]
    }
  },
  "required": [
    "participants",
    "participationStatus",
    "previousWinners",
    "prize",
    "raffleEndsAt",
    "shiftsPerToken",
    "shiftsToNextToken",
    "tokens",
    "winnerCaregiverId"
  ],
  "definitions": {
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "CaregiverId": {
      "type": "number"
    },
    "RafflePreviousWinner": {
      "type": "object",
      "properties": {
        "avatar": {
          "type": [
            "null",
            "string"
          ]
        },
        "name": {
          "type": "string"
        },
        "prize": {
          "type": "string"
        }
      },
      "required": [
        "avatar",
        "name",
        "prize"
      ]
    },
    "RaffleParticipant": {
      "type": "object",
      "properties": {
        "caregiverId": {
          "$ref": "#/definitions/CaregiverId"
        },
        "avatar": {
          "type": [
            "null",
            "string"
          ]
        },
        "name": {
          "type": "string"
        },
        "tokens": {
          "type": "number"
        }
      },
      "required": [
        "avatar",
        "caregiverId",
        "name",
        "tokens"
      ]
    },
    "RafflePrize": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "image": {
          "type": "string"
        }
      },
      "required": [
        "image",
        "name"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["GetPatientScheduleByTaskInstanceResponse",
{
  "type": "object",
  "properties": {
    "visitInstances": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/definitions/VisitInstanceId"
          },
          "startDateTime": {
            "$ref": "#/definitions/LocalDateTime"
          },
          "endDateTime": {
            "$ref": "#/definitions/LocalDateTime"
          },
          "caregiverName": {
            "type": "string"
          },
          "caregiverPhoneNumber": {
            "type": [
              "null",
              "string"
            ]
          }
        },
        "required": [
          "caregiverName",
          "caregiverPhoneNumber",
          "endDateTime",
          "id",
          "startDateTime"
        ]
      }
    }
  },
  "required": [
    "visitInstances"
  ],
  "definitions": {
    "VisitInstanceId": {
      "type": "number"
    },
    "LocalDateTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalDateTime"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["TelephonyCaregiverCreateOutboundCallRequest",
{
  "type": "object",
  "properties": {
    "source": {
      "type": "string"
    },
    "destination": {
      "type": "string"
    }
  },
  "required": [
    "destination",
    "source"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientPrimaryPhysician",
{
  "type": "object",
  "properties": {
    "physician": {
      "anyOf": [
        {
          "type": "object",
          "properties": {
            "id": {
              "$ref": "#/definitions/PhysicianId"
            },
            "firstName": {
              "type": "string"
            },
            "lastName": {
              "type": "string"
            },
            "faxNumber": {
              "type": [
                "null",
                "string"
              ]
            },
            "npi": {
              "type": [
                "null",
                "string"
              ]
            },
            "phone": {
              "type": [
                "null",
                "string"
              ]
            },
            "address": {
              "type": [
                "null",
                "string"
              ]
            }
          },
          "required": [
            "address",
            "faxNumber",
            "firstName",
            "id",
            "lastName",
            "npi",
            "phone"
          ]
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "physician"
  ],
  "definitions": {
    "PhysicianId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["PatientAvailablePhysicians",
{
  "type": "object",
  "properties": {
    "physicians": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "id": {
            "$ref": "#/definitions/PhysicianId"
          },
          "firstName": {
            "type": "string"
          },
          "lastName": {
            "type": "string"
          },
          "address": {
            "type": [
              "null",
              "string"
            ]
          },
          "npi": {
            "type": [
              "null",
              "string"
            ]
          },
          "fax": {
            "type": [
              "null",
              "string"
            ]
          }
        },
        "required": [
          "address",
          "fax",
          "firstName",
          "id",
          "lastName",
          "npi"
        ]
      }
    }
  },
  "required": [
    "physicians"
  ],
  "definitions": {
    "PhysicianId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["NewPhysicianParams",
{
  "type": "object",
  "properties": {
    "firstName": {
      "type": "string"
    },
    "lastName": {
      "type": "string"
    },
    "npi": {
      "type": [
        "null",
        "string"
      ]
    },
    "fax": {
      "type": "string"
    },
    "address": {
      "type": [
        "null",
        "string"
      ]
    },
    "phone": {
      "type": [
        "null",
        "string"
      ]
    }
  },
  "required": [
    "address",
    "fax",
    "firstName",
    "lastName",
    "npi",
    "phone"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["NewPhysicianCreated",
{
  "type": "object",
  "properties": {
    "id": {
      "$ref": "#/definitions/PhysicianId"
    }
  },
  "required": [
    "id"
  ],
  "definitions": {
    "PhysicianId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["GetPatientTimeSlotsResponse",
{
  "type": "object",
  "properties": {
    "slots": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "day": {
            "$ref": "#/definitions/LocalDate"
          },
          "timeSlots": {
            "type": "array",
            "items": {
              "type": "object",
              "properties": {
                "from": {
                  "$ref": "#/definitions/LocalTime"
                },
                "to": {
                  "$ref": "#/definitions/LocalTime"
                }
              },
              "required": [
                "from",
                "to"
              ]
            }
          }
        },
        "required": [
          "day",
          "timeSlots"
        ]
      }
    },
    "note": {
      "type": [
        "null",
        "string"
      ]
    }
  },
  "required": [
    "note",
    "slots"
  ],
  "definitions": {
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "LocalTime": {
      "type": "string",
      "xreviver": "JSJoda.LocalTime"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CheckIfAllDocumentsSubmittedResponse",
{
  "type": "object",
  "properties": {
    "allSubmitted": {
      "type": "boolean"
    }
  },
  "required": [
    "allSubmitted"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["OutsourcingAgencyDataResponse",
{
  "type": "object",
  "properties": {
    "agencyData": {
      "anyOf": [
        {
          "$ref": "#/definitions/Agency"
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "agencyData"
  ],
  "definitions": {
    "Agency": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AgencyId"
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "name": {
          "type": "string"
        },
        "logoUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "website": {
          "type": [
            "null",
            "string"
          ]
        },
        "address": {
          "type": [
            "null",
            "string"
          ]
        },
        "officePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "organizationType": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "ivrPhoneNumbers": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "$ref": "#/definitions/AgencyIvrPhoneNumber"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "isMedflytAgency": {
          "type": "boolean"
        }
      },
      "required": [
        "address",
        "createdAt",
        "id",
        "isMedflytAgency",
        "ivrPhoneNumbers",
        "logoUrl",
        "name",
        "officePhone",
        "organizationType",
        "website"
      ]
    },
    "AgencyId": {
      "type": "number"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "AgencyIvrPhoneNumber": {
      "type": "object",
      "properties": {
        "ivrPhoneNumber": {
          "type": "string"
        },
        "description": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "description",
        "ivrPhoneNumber"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["MobileLiveUpdateResponse",
{
  "anyOf": [
    {
      "type": "object",
      "properties": {
        "shouldUpdate": {
          "type": "boolean",
          "enum": [
            true
          ]
        },
        "downloadUrl": {
          "type": "string"
        },
        "newVersionString": {
          "type": "string"
        }
      },
      "required": [
        "downloadUrl",
        "newVersionString",
        "shouldUpdate"
      ]
    },
    {
      "type": "object",
      "properties": {
        "shouldUpdate": {
          "type": "boolean",
          "enum": [
            false
          ]
        }
      },
      "required": [
        "shouldUpdate"
      ]
    }
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["NearFutureCaregiversResponse",
{
  "type": "object",
  "properties": {
    "caregivers": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/NearFutureCaregiver"
      }
    }
  },
  "required": [
    "caregivers"
  ],
  "definitions": {
    "NearFutureCaregiver": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CaregiverId"
        },
        "firstName": {
          "type": "string"
        },
        "lastName": {
          "type": "string"
        },
        "phoneNumber": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "firstName",
        "id",
        "lastName",
        "phoneNumber"
      ]
    },
    "CaregiverId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["GetTaskUnscheduleReasonsResponse",
{
  "type": "object",
  "properties": {
    "reasons": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/UnscheduleReason"
      }
    }
  },
  "required": [
    "reasons"
  ],
  "definitions": {
    "UnscheduleReason": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/NotePredefinedAnswerId"
        },
        "text": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "text"
      ]
    },
    "NotePredefinedAnswerId": {
      "format": "NotePredefinedAnswerId",
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CheckForOtherNursingQuestionsOnDocumentsResponse",
{
  "type": "object",
  "properties": {
    "documentsToBeRegenerated": {
      "type": "array",
      "items": {
        "type": "string"
      }
    }
  },
  "required": [
    "documentsToBeRegenerated"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}]

  ];
};
